function _typeof(e) {
    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    })(e)
}! function(e, t) {
    "use strict";
    "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && "object" == _typeof(module.exports) ? module.exports = e.document ? t(e, !0) : function(e) {
        if (!e.document) throw new Error("jQuery requires a window with a document");
        return t(e)
    } : t(e)
}("undefined" != typeof window ? window : this, function(C, e) {
    "use strict";

    function m(e) {
        return null != e && e === e.window
    }
    var t = [],
        i = Object.getPrototypeOf,
        a = t.slice,
        g = t.flat ? function(e) {
            return t.flat.call(e)
        } : function(e) {
            return t.concat.apply([], e)
        },
        l = t.push,
        o = t.indexOf,
        n = {},
        r = n.toString,
        v = n.hasOwnProperty,
        s = v.toString,
        c = s.call(Object),
        y = {},
        w = function(e) {
            return "function" == typeof e && "number" != typeof e.nodeType
        },
        S = C.document,
        u = {
            type: !0,
            src: !0,
            nonce: !0,
            noModule: !0
        };

    function b(e, t, n) {
        var i, o, r = (n = n || S).createElement("script");
        if (r.text = e, t)
            for (i in u)(o = t[i] || t.getAttribute && t.getAttribute(i)) && r.setAttribute(i, o);
        n.head.appendChild(r).parentNode.removeChild(r)
    }

    function x(e) {
        return null == e ? e + "" : "object" == _typeof(e) || "function" == typeof e ? n[r.call(e)] || "object" : _typeof(e)
    }
    var d = "3.5.1",
        k = function e(t, n) {
            return new e.fn.init(t, n)
        };

    function p(e) {
        var t = !!e && "length" in e && e.length,
            n = x(e);
        return !w(e) && !m(e) && ("array" === n || 0 === t || "number" == typeof t && 0 < t && t - 1 in e)
    }
    k.fn = k.prototype = {
        jquery: d,
        constructor: k,
        length: 0,
        toArray: function() {
            return a.call(this)
        },
        get: function(e) {
            return null == e ? a.call(this) : e < 0 ? this[e + this.length] : this[e]
        },
        pushStack: function(e) {
            var t = k.merge(this.constructor(), e);
            return t.prevObject = this, t
        },
        each: function(e) {
            return k.each(this, e)
        },
        map: function(n) {
            return this.pushStack(k.map(this, function(e, t) {
                return n.call(e, t, e)
            }))
        },
        slice: function() {
            return this.pushStack(a.apply(this, arguments))
        },
        first: function() {
            return this.eq(0)
        },
        last: function() {
            return this.eq(-1)
        },
        even: function() {
            return this.pushStack(k.grep(this, function(e, t) {
                return (t + 1) % 2
            }))
        },
        odd: function() {
            return this.pushStack(k.grep(this, function(e, t) {
                return t % 2
            }))
        },
        eq: function(e) {
            var t = this.length,
                n = +e + (e < 0 ? t : 0);
            return this.pushStack(0 <= n && n < t ? [this[n]] : [])
        },
        end: function() {
            return this.prevObject || this.constructor()
        },
        push: l,
        sort: t.sort,
        splice: t.splice
    }, k.extend = k.fn.extend = function() {
        var e, t, n, i, o, r, s = arguments[0] || {},
            a = 1,
            l = arguments.length,
            c = !1;
        for ("boolean" == typeof s && (c = s, s = arguments[a] || {}, a++), "object" == _typeof(s) || w(s) || (s = {}), a === l && (s = this, a--); a < l; a++)
            if (null != (e = arguments[a]))
                for (t in e) i = e[t], "__proto__" !== t && s !== i && (c && i && (k.isPlainObject(i) || (o = Array.isArray(i))) ? (n = s[t], r = o && !Array.isArray(n) ? [] : o || k.isPlainObject(n) ? n : {}, o = !1, s[t] = k.extend(c, r, i)) : void 0 !== i && (s[t] = i));
        return s
    }, k.extend({
        expando: "jQuery" + (d + Math.random()).replace(/\D/g, ""),
        isReady: !0,
        error: function(e) {
            throw new Error(e)
        },
        noop: function() {},
        isPlainObject: function(e) {
            var t, n;
            return !(!e || "[object Object]" !== r.call(e) || (t = i(e)) && ("function" != typeof(n = v.call(t, "constructor") && t.constructor) || s.call(n) !== c))
        },
        isEmptyObject: function(e) {
            var t;
            for (t in e) return !1;
            return !0
        },
        globalEval: function(e, t, n) {
            b(e, {
                nonce: t && t.nonce
            }, n)
        },
        each: function(e, t) {
            var n, i = 0;
            if (p(e))
                for (n = e.length; i < n && !1 !== t.call(e[i], i, e[i]); i++);
            else
                for (i in e)
                    if (!1 === t.call(e[i], i, e[i])) break;
            return e
        },
        makeArray: function(e, t) {
            var n = t || [];
            return null != e && (p(Object(e)) ? k.merge(n, "string" == typeof e ? [e] : e) : l.call(n, e)), n
        },
        inArray: function(e, t, n) {
            return null == t ? -1 : o.call(t, e, n)
        },
        merge: function(e, t) {
            for (var n = +t.length, i = 0, o = e.length; i < n; i++) e[o++] = t[i];
            return e.length = o, e
        },
        grep: function(e, t, n) {
            for (var i = [], o = 0, r = e.length, s = !n; o < r; o++) !t(e[o], o) != s && i.push(e[o]);
            return i
        },
        map: function(e, t, n) {
            var i, o, r = 0,
                s = [];
            if (p(e))
                for (i = e.length; r < i; r++) null != (o = t(e[r], r, n)) && s.push(o);
            else
                for (r in e) null != (o = t(e[r], r, n)) && s.push(o);
            return g(s)
        },
        guid: 1,
        support: y
    }), "function" == typeof Symbol && (k.fn[Symbol.iterator] = t[Symbol.iterator]), k.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
        n["[object " + t + "]"] = t.toLowerCase()
    });
    var f = function(n) {
        function d(e, t) {
            var n = "0x" + e.slice(1) - 65536;
            return t || (n < 0 ? String.fromCharCode(65536 + n) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320))
        }

        function o() {
            T()
        }
        var e, f, b, r, s, h, p, m, x, l, c, T, C, a, S, g, u, v, y, k = "sizzle" + +new Date,
            w = n.document,
            A = 0,
            i = 0,
            _ = le(),
            $ = le(),
            E = le(),
            D = le(),
            z = function(e, t) {
                return e === t && (c = !0), 0
            },
            O = {}.hasOwnProperty,
            t = [],
            L = t.pop,
            I = t.push,
            P = t.push,
            M = t.slice,
            j = function(e, t) {
                for (var n = 0, i = e.length; n < i; n++)
                    if (e[n] === t) return n;
                return -1
            },
            N = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
            q = "[\\x20\\t\\r\\n\\f]",
            H = "(?:\\\\[\\da-fA-F]{1,6}" + q + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
            R = "\\[" + q + "*(" + H + ")(?:" + q + "*([*^$|!~]?=)" + q + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + H + "))|)" + q + "*\\]",
            F = ":(" + H + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + R + ")*)|.*)\\)|)",
            W = new RegExp(q + "+", "g"),
            U = new RegExp("^" + q + "+|((?:^|[^\\\\])(?:\\\\.)*)" + q + "+$", "g"),
            B = new RegExp("^" + q + "*," + q + "*"),
            Z = new RegExp("^" + q + "*([>+~]|" + q + ")" + q + "*"),
            G = new RegExp(q + "|>"),
            X = new RegExp(F),
            Y = new RegExp("^" + H + "$"),
            K = {
                ID: new RegExp("^#(" + H + ")"),
                CLASS: new RegExp("^\\.(" + H + ")"),
                TAG: new RegExp("^(" + H + "|[*])"),
                ATTR: new RegExp("^" + R),
                PSEUDO: new RegExp("^" + F),
                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + q + "*(even|odd|(([+-]|)(\\d*)n|)" + q + "*(?:([+-]|)" + q + "*(\\d+)|))" + q + "*\\)|)", "i"),
                bool: new RegExp("^(?:" + N + ")$", "i"),
                needsContext: new RegExp("^" + q + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + q + "*((?:-\\d)?\\d*)" + q + "*\\)|)(?=[^-]|$)", "i")
            },
            V = /HTML$/i,
            Q = /^(?:input|select|textarea|button)$/i,
            J = /^h\d$/i,
            ee = /^[^{]+\{\s*\[native \w/,
            te = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
            ne = /[+~]/,
            ie = new RegExp("\\\\[\\da-fA-F]{1,6}" + q + "?|\\\\([^\\r\\n\\f])", "g"),
            oe = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
            re = function(e, t) {
                return t ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
            },
            se = be(function(e) {
                return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
            }, {
                dir: "parentNode",
                next: "legend"
            });
        try {
            P.apply(t = M.call(w.childNodes), w.childNodes), t[w.childNodes.length].nodeType
        } catch (e) {
            P = {
                apply: t.length ? function(e, t) {
                    I.apply(e, M.call(t))
                } : function(e, t) {
                    for (var n = e.length, i = 0; e[n++] = t[i++];);
                    e.length = n - 1
                }
            }
        }

        function ae(e, t, n, i) {
            var o, r, s, a, l, c, u, d = t && t.ownerDocument,
                p = t ? t.nodeType : 9;
            if (n = n || [], "string" != typeof e || !e || 1 !== p && 9 !== p && 11 !== p) return n;
            if (!i && (T(t), t = t || C, S)) {
                if (11 !== p && (l = te.exec(e)))
                    if (o = l[1]) {
                        if (9 === p) {
                            if (!(s = t.getElementById(o))) return n;
                            if (s.id === o) return n.push(s), n
                        } else if (d && (s = d.getElementById(o)) && y(t, s) && s.id === o) return n.push(s), n
                    } else {
                        if (l[2]) return P.apply(n, t.getElementsByTagName(e)), n;
                        if ((o = l[3]) && f.getElementsByClassName && t.getElementsByClassName) return P.apply(n, t.getElementsByClassName(o)), n
                    } if (f.qsa && !D[e + " "] && (!g || !g.test(e)) && (1 !== p || "object" !== t.nodeName.toLowerCase())) {
                    if (u = e, d = t, 1 === p && (G.test(e) || Z.test(e))) {
                        for ((d = ne.test(e) && ve(t.parentNode) || t) === t && f.scope || ((a = t.getAttribute("id")) ? a = a.replace(oe, re) : t.setAttribute("id", a = k)), r = (c = h(e)).length; r--;) c[r] = (a ? "#" + a : ":scope") + " " + we(c[r]);
                        u = c.join(",")
                    }
                    try {
                        return P.apply(n, d.querySelectorAll(u)), n
                    } catch (t) {
                        D(e, !0)
                    } finally {
                        a === k && t.removeAttribute("id")
                    }
                }
            }
            return m(e.replace(U, "$1"), t, n, i)
        }

        function le() {
            var i = [];
            return function e(t, n) {
                return i.push(t + " ") > b.cacheLength && delete e[i.shift()], e[t + " "] = n
            }
        }

        function ce(e) {
            return e[k] = !0, e
        }

        function ue(e) {
            var t = C.createElement("fieldset");
            try {
                return !!e(t)
            } catch (e) {
                return !1
            } finally {
                t.parentNode && t.parentNode.removeChild(t), t = null
            }
        }

        function de(e, t) {
            for (var n = e.split("|"), i = n.length; i--;) b.attrHandle[n[i]] = t
        }

        function pe(e, t) {
            var n = t && e,
                i = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
            if (i) return i;
            if (n)
                for (; n = n.nextSibling;)
                    if (n === t) return -1;
            return e ? 1 : -1
        }

        function fe(t) {
            return function(e) {
                return "input" === e.nodeName.toLowerCase() && e.type === t
            }
        }

        function he(n) {
            return function(e) {
                var t = e.nodeName.toLowerCase();
                return ("input" === t || "button" === t) && e.type === n
            }
        }

        function me(t) {
            return function(e) {
                return "form" in e ? e.parentNode && !1 === e.disabled ? "label" in e ? "label" in e.parentNode ? e.parentNode.disabled === t : e.disabled === t : e.isDisabled === t || e.isDisabled !== !t && se(e) === t : e.disabled === t : "label" in e && e.disabled === t
            }
        }

        function ge(s) {
            return ce(function(r) {
                return r = +r, ce(function(e, t) {
                    for (var n, i = s([], e.length, r), o = i.length; o--;) e[n = i[o]] && (e[n] = !(t[n] = e[n]))
                })
            })
        }

        function ve(e) {
            return e && void 0 !== e.getElementsByTagName && e
        }
        for (e in f = ae.support = {}, s = ae.isXML = function(e) {
                var t = e.namespaceURI,
                    n = (e.ownerDocument || e).documentElement;
                return !V.test(t || n && n.nodeName || "HTML")
            }, T = ae.setDocument = function(e) {
                var t, n, i = e ? e.ownerDocument || e : w;
                return i != C && 9 === i.nodeType && i.documentElement && (a = (C = i).documentElement, S = !s(C), w != C && (n = C.defaultView) && n.top !== n && (n.addEventListener ? n.addEventListener("unload", o, !1) : n.attachEvent && n.attachEvent("onunload", o)), f.scope = ue(function(e) {
                    return a.appendChild(e).appendChild(C.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length
                }), f.attributes = ue(function(e) {
                    return e.className = "i", !e.getAttribute("className")
                }), f.getElementsByTagName = ue(function(e) {
                    return e.appendChild(C.createComment("")), !e.getElementsByTagName("*").length
                }), f.getElementsByClassName = ee.test(C.getElementsByClassName), f.getById = ue(function(e) {
                    return a.appendChild(e).id = k, !C.getElementsByName || !C.getElementsByName(k).length
                }), f.getById ? (b.filter.ID = function(e) {
                    var t = e.replace(ie, d);
                    return function(e) {
                        return e.getAttribute("id") === t
                    }
                }, b.find.ID = function(e, t) {
                    if (void 0 !== t.getElementById && S) {
                        var n = t.getElementById(e);
                        return n ? [n] : []
                    }
                }) : (b.filter.ID = function(e) {
                    var n = e.replace(ie, d);
                    return function(e) {
                        var t = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                        return t && t.value === n
                    }
                }, b.find.ID = function(e, t) {
                    if (void 0 !== t.getElementById && S) {
                        var n, i, o, r = t.getElementById(e);
                        if (r) {
                            if ((n = r.getAttributeNode("id")) && n.value === e) return [r];
                            for (o = t.getElementsByName(e), i = 0; r = o[i++];)
                                if ((n = r.getAttributeNode("id")) && n.value === e) return [r]
                        }
                        return []
                    }
                }), b.find.TAG = f.getElementsByTagName ? function(e, t) {
                    return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : f.qsa ? t.querySelectorAll(e) : void 0
                } : function(e, t) {
                    var n, i = [],
                        o = 0,
                        r = t.getElementsByTagName(e);
                    if ("*" !== e) return r;
                    for (; n = r[o++];) 1 === n.nodeType && i.push(n);
                    return i
                }, b.find.CLASS = f.getElementsByClassName && function(e, t) {
                    if (void 0 !== t.getElementsByClassName && S) return t.getElementsByClassName(e)
                }, u = [], g = [], (f.qsa = ee.test(C.querySelectorAll)) && (ue(function(e) {
                    var t;
                    a.appendChild(e).innerHTML = "<a id='" + k + "'></a><select id='" + k + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + q + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || g.push("\\[" + q + "*(?:value|" + N + ")"), e.querySelectorAll("[id~=" + k + "-]").length || g.push("~="), (t = C.createElement("input")).setAttribute("name", ""), e.appendChild(t), e.querySelectorAll("[name='']").length || g.push("\\[" + q + "*name" + q + "*=" + q + "*(?:''|\"\")"), e.querySelectorAll(":checked").length || g.push(":checked"), e.querySelectorAll("a#" + k + "+*").length || g.push(".#.+[+~]"), e.querySelectorAll("\\\f"), g.push("[\\r\\n\\f]")
                }), ue(function(e) {
                    e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    var t = C.createElement("input");
                    t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && g.push("name" + q + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), a.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), g.push(",.*:")
                })), (f.matchesSelector = ee.test(v = a.matches || a.webkitMatchesSelector || a.mozMatchesSelector || a.oMatchesSelector || a.msMatchesSelector)) && ue(function(e) {
                    f.disconnectedMatch = v.call(e, "*"), v.call(e, "[s!='']:x"), u.push("!=", F)
                }), g = g.length && new RegExp(g.join("|")), u = u.length && new RegExp(u.join("|")), t = ee.test(a.compareDocumentPosition), y = t || ee.test(a.contains) ? function(e, t) {
                    var n = 9 === e.nodeType ? e.documentElement : e,
                        i = t && t.parentNode;
                    return e === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(i)))
                } : function(e, t) {
                    if (t)
                        for (; t = t.parentNode;)
                            if (t === e) return !0;
                    return !1
                }, z = t ? function(e, t) {
                    if (e === t) return c = !0, 0;
                    var n = !e.compareDocumentPosition - !t.compareDocumentPosition;
                    return n || (1 & (n = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !f.sortDetached && t.compareDocumentPosition(e) === n ? e == C || e.ownerDocument == w && y(w, e) ? -1 : t == C || t.ownerDocument == w && y(w, t) ? 1 : l ? j(l, e) - j(l, t) : 0 : 4 & n ? -1 : 1)
                } : function(e, t) {
                    if (e === t) return c = !0, 0;
                    var n, i = 0,
                        o = e.parentNode,
                        r = t.parentNode,
                        s = [e],
                        a = [t];
                    if (!o || !r) return e == C ? -1 : t == C ? 1 : o ? -1 : r ? 1 : l ? j(l, e) - j(l, t) : 0;
                    if (o === r) return pe(e, t);
                    for (n = e; n = n.parentNode;) s.unshift(n);
                    for (n = t; n = n.parentNode;) a.unshift(n);
                    for (; s[i] === a[i];) i++;
                    return i ? pe(s[i], a[i]) : s[i] == w ? -1 : a[i] == w ? 1 : 0
                }), C
            }, ae.matches = function(e, t) {
                return ae(e, null, null, t)
            }, ae.matchesSelector = function(e, t) {
                if (T(e), f.matchesSelector && S && !D[t + " "] && (!u || !u.test(t)) && (!g || !g.test(t))) try {
                    var n = v.call(e, t);
                    if (n || f.disconnectedMatch || e.document && 11 !== e.document.nodeType) return n
                } catch (e) {
                    D(t, !0)
                }
                return 0 < ae(t, C, null, [e]).length
            }, ae.contains = function(e, t) {
                return (e.ownerDocument || e) != C && T(e), y(e, t)
            }, ae.attr = function(e, t) {
                (e.ownerDocument || e) != C && T(e);
                var n = b.attrHandle[t.toLowerCase()],
                    i = n && O.call(b.attrHandle, t.toLowerCase()) ? n(e, t, !S) : void 0;
                return void 0 !== i ? i : f.attributes || !S ? e.getAttribute(t) : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
            }, ae.escape = function(e) {
                return (e + "").replace(oe, re)
            }, ae.error = function(e) {
                throw new Error("Syntax error, unrecognized expression: " + e)
            }, ae.uniqueSort = function(e) {
                var t, n = [],
                    i = 0,
                    o = 0;
                if (c = !f.detectDuplicates, l = !f.sortStable && e.slice(0), e.sort(z), c) {
                    for (; t = e[o++];) t === e[o] && (i = n.push(o));
                    for (; i--;) e.splice(n[i], 1)
                }
                return l = null, e
            }, r = ae.getText = function(e) {
                var t, n = "",
                    i = 0,
                    o = e.nodeType;
                if (o) {
                    if (1 === o || 9 === o || 11 === o) {
                        if ("string" == typeof e.textContent) return e.textContent;
                        for (e = e.firstChild; e; e = e.nextSibling) n += r(e)
                    } else if (3 === o || 4 === o) return e.nodeValue
                } else
                    for (; t = e[i++];) n += r(t);
                return n
            }, (b = ae.selectors = {
                cacheLength: 50,
                createPseudo: ce,
                match: K,
                attrHandle: {},
                find: {},
                relative: {
                    ">": {
                        dir: "parentNode",
                        first: !0
                    },
                    " ": {
                        dir: "parentNode"
                    },
                    "+": {
                        dir: "previousSibling",
                        first: !0
                    },
                    "~": {
                        dir: "previousSibling"
                    }
                },
                preFilter: {
                    ATTR: function(e) {
                        return e[1] = e[1].replace(ie, d), e[3] = (e[3] || e[4] || e[5] || "").replace(ie, d), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                    },
                    CHILD: function(e) {
                        return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || ae.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && ae.error(e[0]), e
                    },
                    PSEUDO: function(e) {
                        var t, n = !e[6] && e[2];
                        return K.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = h(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3))
                    }
                },
                filter: {
                    TAG: function(e) {
                        var t = e.replace(ie, d).toLowerCase();
                        return "*" === e ? function() {
                            return !0
                        } : function(e) {
                            return e.nodeName && e.nodeName.toLowerCase() === t
                        }
                    },
                    CLASS: function(e) {
                        var t = _[e + " "];
                        return t || (t = new RegExp("(^|" + q + ")" + e + "(" + q + "|$)")) && _(e, function(e) {
                            return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                        })
                    },
                    ATTR: function(n, i, o) {
                        return function(e) {
                            var t = ae.attr(e, n);
                            return null == t ? "!=" === i : !i || (t += "", "=" === i ? t === o : "!=" === i ? t !== o : "^=" === i ? o && 0 === t.indexOf(o) : "*=" === i ? o && -1 < t.indexOf(o) : "$=" === i ? o && t.slice(-o.length) === o : "~=" === i ? -1 < (" " + t.replace(W, " ") + " ").indexOf(o) : "|=" === i && (t === o || t.slice(0, o.length + 1) === o + "-"))
                        }
                    },
                    CHILD: function(h, e, t, m, g) {
                        var v = "nth" !== h.slice(0, 3),
                            y = "last" !== h.slice(-4),
                            w = "of-type" === e;
                        return 1 === m && 0 === g ? function(e) {
                            return !!e.parentNode
                        } : function(e, t, n) {
                            var i, o, r, s, a, l, c = v != y ? "nextSibling" : "previousSibling",
                                u = e.parentNode,
                                d = w && e.nodeName.toLowerCase(),
                                p = !n && !w,
                                f = !1;
                            if (u) {
                                if (v) {
                                    for (; c;) {
                                        for (s = e; s = s[c];)
                                            if (w ? s.nodeName.toLowerCase() === d : 1 === s.nodeType) return !1;
                                        l = c = "only" === h && !l && "nextSibling"
                                    }
                                    return !0
                                }
                                if (l = [y ? u.firstChild : u.lastChild], y && p) {
                                    for (f = (a = (i = (o = (r = (s = u)[k] || (s[k] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[h] || [])[0] === A && i[1]) && i[2], s = a && u.childNodes[a]; s = ++a && s && s[c] || (f = a = 0) || l.pop();)
                                        if (1 === s.nodeType && ++f && s === e) {
                                            o[h] = [A, a, f];
                                            break
                                        }
                                } else if (p && (f = a = (i = (o = (r = (s = e)[k] || (s[k] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[h] || [])[0] === A && i[1]), !1 === f)
                                    for (;
                                        (s = ++a && s && s[c] || (f = a = 0) || l.pop()) && ((w ? s.nodeName.toLowerCase() !== d : 1 !== s.nodeType) || !++f || (p && ((o = (r = s[k] || (s[k] = {}))[s.uniqueID] || (r[s.uniqueID] = {}))[h] = [A, f]), s !== e)););
                                return (f -= g) === m || f % m == 0 && 0 <= f / m
                            }
                        }
                    },
                    PSEUDO: function(e, r) {
                        var t, s = b.pseudos[e] || b.setFilters[e.toLowerCase()] || ae.error("unsupported pseudo: " + e);
                        return s[k] ? s(r) : 1 < s.length ? (t = [e, e, "", r], b.setFilters.hasOwnProperty(e.toLowerCase()) ? ce(function(e, t) {
                            for (var n, i = s(e, r), o = i.length; o--;) e[n = j(e, i[o])] = !(t[n] = i[o])
                        }) : function(e) {
                            return s(e, 0, t)
                        }) : s
                    }
                },
                pseudos: {
                    not: ce(function(e) {
                        var i = [],
                            o = [],
                            a = p(e.replace(U, "$1"));
                        return a[k] ? ce(function(e, t, n, i) {
                            for (var o, r = a(e, null, i, []), s = e.length; s--;)(o = r[s]) && (e[s] = !(t[s] = o))
                        }) : function(e, t, n) {
                            return i[0] = e, a(i, null, n, o), i[0] = null, !o.pop()
                        }
                    }),
                    has: ce(function(t) {
                        return function(e) {
                            return 0 < ae(t, e).length
                        }
                    }),
                    contains: ce(function(t) {
                        return t = t.replace(ie, d),
                            function(e) {
                                return -1 < (e.textContent || r(e)).indexOf(t)
                            }
                    }),
                    lang: ce(function(n) {
                        return Y.test(n || "") || ae.error("unsupported lang: " + n), n = n.replace(ie, d).toLowerCase(),
                            function(e) {
                                var t;
                                do {
                                    if (t = S ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang")) return (t = t.toLowerCase()) === n || 0 === t.indexOf(n + "-")
                                } while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1
                            }
                    }),
                    target: function(e) {
                        var t = n.location && n.location.hash;
                        return t && t.slice(1) === e.id
                    },
                    root: function(e) {
                        return e === a
                    },
                    focus: function(e) {
                        return e === C.activeElement && (!C.hasFocus || C.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                    },
                    enabled: me(!1),
                    disabled: me(!0),
                    checked: function(e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && !!e.checked || "option" === t && !!e.selected
                    },
                    selected: function(e) {
                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                    },
                    empty: function(e) {
                        for (e = e.firstChild; e; e = e.nextSibling)
                            if (e.nodeType < 6) return !1;
                        return !0
                    },
                    parent: function(e) {
                        return !b.pseudos.empty(e)
                    },
                    header: function(e) {
                        return J.test(e.nodeName)
                    },
                    input: function(e) {
                        return Q.test(e.nodeName)
                    },
                    button: function(e) {
                        var t = e.nodeName.toLowerCase();
                        return "input" === t && "button" === e.type || "button" === t
                    },
                    text: function(e) {
                        var t;
                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase())
                    },
                    first: ge(function() {
                        return [0]
                    }),
                    last: ge(function(e, t) {
                        return [t - 1]
                    }),
                    eq: ge(function(e, t, n) {
                        return [n < 0 ? n + t : n]
                    }),
                    even: ge(function(e, t) {
                        for (var n = 0; n < t; n += 2) e.push(n);
                        return e
                    }),
                    odd: ge(function(e, t) {
                        for (var n = 1; n < t; n += 2) e.push(n);
                        return e
                    }),
                    lt: ge(function(e, t, n) {
                        for (var i = n < 0 ? n + t : t < n ? t : n; 0 <= --i;) e.push(i);
                        return e
                    }),
                    gt: ge(function(e, t, n) {
                        for (var i = n < 0 ? n + t : n; ++i < t;) e.push(i);
                        return e
                    })
                }
            }).pseudos.nth = b.pseudos.eq, {
                radio: !0,
                checkbox: !0,
                file: !0,
                password: !0,
                image: !0
            }) b.pseudos[e] = fe(e);
        for (e in {
                submit: !0,
                reset: !0
            }) b.pseudos[e] = he(e);

        function ye() {}

        function we(e) {
            for (var t = 0, n = e.length, i = ""; t < n; t++) i += e[t].value;
            return i
        }

        function be(a, e, t) {
            var l = e.dir,
                c = e.next,
                u = c || l,
                d = t && "parentNode" === u,
                p = i++;
            return e.first ? function(e, t, n) {
                for (; e = e[l];)
                    if (1 === e.nodeType || d) return a(e, t, n);
                return !1
            } : function(e, t, n) {
                var i, o, r, s = [A, p];
                if (n) {
                    for (; e = e[l];)
                        if ((1 === e.nodeType || d) && a(e, t, n)) return !0
                } else
                    for (; e = e[l];)
                        if (1 === e.nodeType || d)
                            if (o = (r = e[k] || (e[k] = {}))[e.uniqueID] || (r[e.uniqueID] = {}), c && c === e.nodeName.toLowerCase()) e = e[l] || e;
                            else {
                                if ((i = o[u]) && i[0] === A && i[1] === p) return s[2] = i[2];
                                if ((o[u] = s)[2] = a(e, t, n)) return !0
                            } return !1
            }
        }

        function xe(o) {
            return 1 < o.length ? function(e, t, n) {
                for (var i = o.length; i--;)
                    if (!o[i](e, t, n)) return !1;
                return !0
            } : o[0]
        }

        function Te(e, t, n, i, o) {
            for (var r, s = [], a = 0, l = e.length, c = null != t; a < l; a++)(r = e[a]) && (n && !n(r, i, o) || (s.push(r), c && t.push(a)));
            return s
        }

        function Ce(f, h, m, g, v, e) {
            return g && !g[k] && (g = Ce(g)), v && !v[k] && (v = Ce(v, e)), ce(function(e, t, n, i) {
                var o, r, s, a = [],
                    l = [],
                    c = t.length,
                    u = e || function(e, t, n) {
                        for (var i = 0, o = t.length; i < o; i++) ae(e, t[i], n);
                        return n
                    }(h || "*", n.nodeType ? [n] : n, []),
                    d = !f || !e && h ? u : Te(u, a, f, n, i),
                    p = m ? v || (e ? f : c || g) ? [] : t : d;
                if (m && m(d, p, n, i), g)
                    for (o = Te(p, l), g(o, [], n, i), r = o.length; r--;)(s = o[r]) && (p[l[r]] = !(d[l[r]] = s));
                if (e) {
                    if (v || f) {
                        if (v) {
                            for (o = [], r = p.length; r--;)(s = p[r]) && o.push(d[r] = s);
                            v(null, p = [], o, i)
                        }
                        for (r = p.length; r--;)(s = p[r]) && -1 < (o = v ? j(e, s) : a[r]) && (e[o] = !(t[o] = s))
                    }
                } else p = Te(p === t ? p.splice(c, p.length) : p), v ? v(null, t, p, i) : P.apply(t, p)
            })
        }

        function Se(e) {
            for (var o, t, n, i = e.length, r = b.relative[e[0].type], s = r || b.relative[" "], a = r ? 1 : 0, l = be(function(e) {
                    return e === o
                }, s, !0), c = be(function(e) {
                    return -1 < j(o, e)
                }, s, !0), u = [function(e, t, n) {
                    var i = !r && (n || t !== x) || ((o = t).nodeType ? l : c)(e, t, n);
                    return o = null, i
                }]; a < i; a++)
                if (t = b.relative[e[a].type]) u = [be(xe(u), t)];
                else {
                    if ((t = b.filter[e[a].type].apply(null, e[a].matches))[k]) {
                        for (n = ++a; n < i && !b.relative[e[n].type]; n++);
                        return Ce(1 < a && xe(u), 1 < a && we(e.slice(0, a - 1).concat({
                            value: " " === e[a - 2].type ? "*" : ""
                        })).replace(U, "$1"), t, a < n && Se(e.slice(a, n)), n < i && Se(e = e.slice(n)), n < i && we(e))
                    }
                    u.push(t)
                } return xe(u)
        }
        return ye.prototype = b.filters = b.pseudos, b.setFilters = new ye, h = ae.tokenize = function(e, t) {
            var n, i, o, r, s, a, l, c = $[e + " "];
            if (c) return t ? 0 : c.slice(0);
            for (s = e, a = [], l = b.preFilter; s;) {
                for (r in n && !(i = B.exec(s)) || (i && (s = s.slice(i[0].length) || s), a.push(o = [])), n = !1, (i = Z.exec(s)) && (n = i.shift(), o.push({
                        value: n,
                        type: i[0].replace(U, " ")
                    }), s = s.slice(n.length)), b.filter) !(i = K[r].exec(s)) || l[r] && !(i = l[r](i)) || (n = i.shift(), o.push({
                    value: n,
                    type: r,
                    matches: i
                }), s = s.slice(n.length));
                if (!n) break
            }
            return t ? s.length : s ? ae.error(e) : $(e, a).slice(0)
        }, p = ae.compile = function(e, t) {
            var n, g, v, y, w, i, o = [],
                r = [],
                s = E[e + " "];
            if (!s) {
                for (n = (t = t || h(e)).length; n--;)(s = Se(t[n]))[k] ? o.push(s) : r.push(s);
                (s = E(e, (g = r, y = 0 < (v = o).length, w = 0 < g.length, i = function(e, t, n, i, o) {
                    var r, s, a, l = 0,
                        c = "0",
                        u = e && [],
                        d = [],
                        p = x,
                        f = e || w && b.find.TAG("*", o),
                        h = A += null == p ? 1 : Math.random() || .1,
                        m = f.length;
                    for (o && (x = t == C || t || o); c !== m && null != (r = f[c]); c++) {
                        if (w && r) {
                            for (s = 0, t || r.ownerDocument == C || (T(r), n = !S); a = g[s++];)
                                if (a(r, t || C, n)) {
                                    i.push(r);
                                    break
                                } o && (A = h)
                        }
                        y && ((r = !a && r) && l--, e && u.push(r))
                    }
                    if (l += c, y && c !== l) {
                        for (s = 0; a = v[s++];) a(u, d, t, n);
                        if (e) {
                            if (0 < l)
                                for (; c--;) u[c] || d[c] || (d[c] = L.call(i));
                            d = Te(d)
                        }
                        P.apply(i, d), o && !e && 0 < d.length && 1 < l + v.length && ae.uniqueSort(i)
                    }
                    return o && (A = h, x = p), u
                }, y ? ce(i) : i))).selector = e
            }
            return s
        }, m = ae.select = function(e, t, n, i) {
            var o, r, s, a, l, c = "function" == typeof e && e,
                u = !i && h(e = c.selector || e);
            if (n = n || [], 1 === u.length) {
                if (2 < (r = u[0] = u[0].slice(0)).length && "ID" === (s = r[0]).type && 9 === t.nodeType && S && b.relative[r[1].type]) {
                    if (!(t = (b.find.ID(s.matches[0].replace(ie, d), t) || [])[0])) return n;
                    c && (t = t.parentNode), e = e.slice(r.shift().value.length)
                }
                for (o = K.needsContext.test(e) ? 0 : r.length; o-- && (s = r[o], !b.relative[a = s.type]);)
                    if ((l = b.find[a]) && (i = l(s.matches[0].replace(ie, d), ne.test(r[0].type) && ve(t.parentNode) || t))) {
                        if (r.splice(o, 1), !(e = i.length && we(r))) return P.apply(n, i), n;
                        break
                    }
            }
            return (c || p(e, u))(i, t, !S, n, !t || ne.test(e) && ve(t.parentNode) || t), n
        }, f.sortStable = k.split("").sort(z).join("") === k, f.detectDuplicates = !!c, T(), f.sortDetached = ue(function(e) {
            return 1 & e.compareDocumentPosition(C.createElement("fieldset"))
        }), ue(function(e) {
            return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
        }) || de("type|href|height|width", function(e, t, n) {
            if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2)
        }), f.attributes && ue(function(e) {
            return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
        }) || de("value", function(e, t, n) {
            if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue
        }), ue(function(e) {
            return null == e.getAttribute("disabled")
        }) || de(N, function(e, t, n) {
            var i;
            if (!n) return !0 === e[t] ? t.toLowerCase() : (i = e.getAttributeNode(t)) && i.specified ? i.value : null
        }), ae
    }(C);
    k.find = f, k.expr = f.selectors, k.expr[":"] = k.expr.pseudos, k.uniqueSort = k.unique = f.uniqueSort, k.text = f.getText, k.isXMLDoc = f.isXML, k.contains = f.contains, k.escapeSelector = f.escape;

    function h(e, t, n) {
        for (var i = [], o = void 0 !== n;
            (e = e[t]) && 9 !== e.nodeType;)
            if (1 === e.nodeType) {
                if (o && k(e).is(n)) break;
                i.push(e)
            } return i
    }

    function T(e, t) {
        for (var n = []; e; e = e.nextSibling) 1 === e.nodeType && e !== t && n.push(e);
        return n
    }
    var A = k.expr.match.needsContext;

    function _(e, t) {
        return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase()
    }
    var $ = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

    function E(e, n, i) {
        return w(n) ? k.grep(e, function(e, t) {
            return !!n.call(e, t, e) !== i
        }) : n.nodeType ? k.grep(e, function(e) {
            return e === n !== i
        }) : "string" != typeof n ? k.grep(e, function(e) {
            return -1 < o.call(n, e) !== i
        }) : k.filter(n, e, i)
    }
    k.filter = function(e, t, n) {
        var i = t[0];
        return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === i.nodeType ? k.find.matchesSelector(i, e) ? [i] : [] : k.find.matches(e, k.grep(t, function(e) {
            return 1 === e.nodeType
        }))
    }, k.fn.extend({
        find: function(e) {
            var t, n, i = this.length,
                o = this;
            if ("string" != typeof e) return this.pushStack(k(e).filter(function() {
                for (t = 0; t < i; t++)
                    if (k.contains(o[t], this)) return !0
            }));
            for (n = this.pushStack([]), t = 0; t < i; t++) k.find(e, o[t], n);
            return 1 < i ? k.uniqueSort(n) : n
        },
        filter: function(e) {
            return this.pushStack(E(this, e || [], !1))
        },
        not: function(e) {
            return this.pushStack(E(this, e || [], !0))
        },
        is: function(e) {
            return !!E(this, "string" == typeof e && A.test(e) ? k(e) : e || [], !1).length
        }
    });
    var D, z = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
    (k.fn.init = function(e, t, n) {
        var i, o;
        if (!e) return this;
        if (n = n || D, "string" != typeof e) return e.nodeType ? (this[0] = e, this.length = 1, this) : w(e) ? void 0 !== n.ready ? n.ready(e) : e(k) : k.makeArray(e, this);
        if (!(i = "<" === e[0] && ">" === e[e.length - 1] && 3 <= e.length ? [null, e, null] : z.exec(e)) || !i[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
        if (i[1]) {
            if (t = t instanceof k ? t[0] : t, k.merge(this, k.parseHTML(i[1], t && t.nodeType ? t.ownerDocument || t : S, !0)), $.test(i[1]) && k.isPlainObject(t))
                for (i in t) w(this[i]) ? this[i](t[i]) : this.attr(i, t[i]);
            return this
        }
        return (o = S.getElementById(i[2])) && (this[0] = o, this.length = 1), this
    }).prototype = k.fn, D = k(S);
    var O = /^(?:parents|prev(?:Until|All))/,
        L = {
            children: !0,
            contents: !0,
            next: !0,
            prev: !0
        };

    function I(e, t) {
        for (;
            (e = e[t]) && 1 !== e.nodeType;);
        return e
    }
    k.fn.extend({
        has: function(e) {
            var t = k(e, this),
                n = t.length;
            return this.filter(function() {
                for (var e = 0; e < n; e++)
                    if (k.contains(this, t[e])) return !0
            })
        },
        closest: function(e, t) {
            var n, i = 0,
                o = this.length,
                r = [],
                s = "string" != typeof e && k(e);
            if (!A.test(e))
                for (; i < o; i++)
                    for (n = this[i]; n && n !== t; n = n.parentNode)
                        if (n.nodeType < 11 && (s ? -1 < s.index(n) : 1 === n.nodeType && k.find.matchesSelector(n, e))) {
                            r.push(n);
                            break
                        } return this.pushStack(1 < r.length ? k.uniqueSort(r) : r)
        },
        index: function(e) {
            return e ? "string" == typeof e ? o.call(k(e), this[0]) : o.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        },
        add: function(e, t) {
            return this.pushStack(k.uniqueSort(k.merge(this.get(), k(e, t))))
        },
        addBack: function(e) {
            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
        }
    }), k.each({
        parent: function(e) {
            var t = e.parentNode;
            return t && 11 !== t.nodeType ? t : null
        },
        parents: function(e) {
            return h(e, "parentNode")
        },
        parentsUntil: function(e, t, n) {
            return h(e, "parentNode", n)
        },
        next: function(e) {
            return I(e, "nextSibling")
        },
        prev: function(e) {
            return I(e, "previousSibling")
        },
        nextAll: function(e) {
            return h(e, "nextSibling")
        },
        prevAll: function(e) {
            return h(e, "previousSibling")
        },
        nextUntil: function(e, t, n) {
            return h(e, "nextSibling", n)
        },
        prevUntil: function(e, t, n) {
            return h(e, "previousSibling", n)
        },
        siblings: function(e) {
            return T((e.parentNode || {}).firstChild, e)
        },
        children: function(e) {
            return T(e.firstChild)
        },
        contents: function(e) {
            return null != e.contentDocument && i(e.contentDocument) ? e.contentDocument : (_(e, "template") && (e = e.content || e), k.merge([], e.childNodes))
        }
    }, function(i, o) {
        k.fn[i] = function(e, t) {
            var n = k.map(this, o, e);
            return "Until" !== i.slice(-5) && (t = e), t && "string" == typeof t && (n = k.filter(t, n)), 1 < this.length && (L[i] || k.uniqueSort(n), O.test(i) && n.reverse()), this.pushStack(n)
        }
    });
    var P = /[^\x20\t\r\n\f]+/g;

    function M(e) {
        return e
    }

    function j(e) {
        throw e
    }

    function N(e, t, n, i) {
        var o;
        try {
            e && w(o = e.promise) ? o.call(e).done(t).fail(n) : e && w(o = e.then) ? o.call(e, t, n) : t.apply(void 0, [e].slice(i))
        } catch (e) {
            n.apply(void 0, [e])
        }
    }
    k.Callbacks = function(i) {
        var n;
        i = "string" == typeof i ? (n = {}, k.each(i.match(P) || [], function(e, t) {
            n[t] = !0
        }), n) : k.extend({}, i);

        function o() {
            for (s = s || i.once, t = r = !0; l.length; c = -1)
                for (e = l.shift(); ++c < a.length;) !1 === a[c].apply(e[0], e[1]) && i.stopOnFalse && (c = a.length, e = !1);
            i.memory || (e = !1), r = !1, s && (a = e ? [] : "")
        }
        var r, e, t, s, a = [],
            l = [],
            c = -1,
            u = {
                add: function() {
                    return a && (e && !r && (c = a.length - 1, l.push(e)), function n(e) {
                        k.each(e, function(e, t) {
                            w(t) ? i.unique && u.has(t) || a.push(t) : t && t.length && "string" !== x(t) && n(t)
                        })
                    }(arguments), e && !r && o()), this
                },
                remove: function() {
                    return k.each(arguments, function(e, t) {
                        for (var n; - 1 < (n = k.inArray(t, a, n));) a.splice(n, 1), n <= c && c--
                    }), this
                },
                has: function(e) {
                    return e ? -1 < k.inArray(e, a) : 0 < a.length
                },
                empty: function() {
                    return a = a && [], this
                },
                disable: function() {
                    return s = l = [], a = e = "", this
                },
                disabled: function() {
                    return !a
                },
                lock: function() {
                    return s = l = [], e || r || (a = e = ""), this
                },
                locked: function() {
                    return !!s
                },
                fireWith: function(e, t) {
                    return s || (t = [e, (t = t || []).slice ? t.slice() : t], l.push(t), r || o()), this
                },
                fire: function() {
                    return u.fireWith(this, arguments), this
                },
                fired: function() {
                    return !!t
                }
            };
        return u
    }, k.extend({
        Deferred: function(e) {
            var r = [
                    ["notify", "progress", k.Callbacks("memory"), k.Callbacks("memory"), 2],
                    ["resolve", "done", k.Callbacks("once memory"), k.Callbacks("once memory"), 0, "resolved"],
                    ["reject", "fail", k.Callbacks("once memory"), k.Callbacks("once memory"), 1, "rejected"]
                ],
                o = "pending",
                s = {
                    state: function() {
                        return o
                    },
                    always: function() {
                        return a.done(arguments).fail(arguments), this
                    },
                    catch: function(e) {
                        return s.then(null, e)
                    },
                    pipe: function() {
                        var o = arguments;
                        return k.Deferred(function(i) {
                            k.each(r, function(e, t) {
                                var n = w(o[t[4]]) && o[t[4]];
                                a[t[1]](function() {
                                    var e = n && n.apply(this, arguments);
                                    e && w(e.promise) ? e.promise().progress(i.notify).done(i.resolve).fail(i.reject) : i[t[0] + "With"](this, n ? [e] : arguments)
                                })
                            }), o = null
                        }).promise()
                    },
                    then: function(t, n, i) {
                        var l = 0;

                        function c(o, r, s, a) {
                            return function() {
                                function e() {
                                    var e, t;
                                    if (!(o < l)) {
                                        if ((e = s.apply(n, i)) === r.promise()) throw new TypeError("Thenable self-resolution");
                                        t = e && ("object" == _typeof(e) || "function" == typeof e) && e.then, w(t) ? a ? t.call(e, c(l, r, M, a), c(l, r, j, a)) : (l++, t.call(e, c(l, r, M, a), c(l, r, j, a), c(l, r, M, r.notifyWith))) : (s !== M && (n = void 0, i = [e]), (a || r.resolveWith)(n, i))
                                    }
                                }
                                var n = this,
                                    i = arguments,
                                    t = a ? e : function() {
                                        try {
                                            e()
                                        } catch (e) {
                                            k.Deferred.exceptionHook && k.Deferred.exceptionHook(e, t.stackTrace), l <= o + 1 && (s !== j && (n = void 0, i = [e]), r.rejectWith(n, i))
                                        }
                                    };
                                o ? t() : (k.Deferred.getStackHook && (t.stackTrace = k.Deferred.getStackHook()), C.setTimeout(t))
                            }
                        }
                        return k.Deferred(function(e) {
                            r[0][3].add(c(0, e, w(i) ? i : M, e.notifyWith)), r[1][3].add(c(0, e, w(t) ? t : M)), r[2][3].add(c(0, e, w(n) ? n : j))
                        }).promise()
                    },
                    promise: function(e) {
                        return null != e ? k.extend(e, s) : s
                    }
                },
                a = {};
            return k.each(r, function(e, t) {
                var n = t[2],
                    i = t[5];
                s[t[1]] = n.add, i && n.add(function() {
                    o = i
                }, r[3 - e][2].disable, r[3 - e][3].disable, r[0][2].lock, r[0][3].lock), n.add(t[3].fire), a[t[0]] = function() {
                    return a[t[0] + "With"](this === a ? void 0 : this, arguments), this
                }, a[t[0] + "With"] = n.fireWith
            }), s.promise(a), e && e.call(a, a), a
        },
        when: function(e) {
            function t(t) {
                return function(e) {
                    o[t] = this, r[t] = 1 < arguments.length ? a.call(arguments) : e, --n || s.resolveWith(o, r)
                }
            }
            var n = arguments.length,
                i = n,
                o = Array(i),
                r = a.call(arguments),
                s = k.Deferred();
            if (n <= 1 && (N(e, s.done(t(i)).resolve, s.reject, !n), "pending" === s.state() || w(r[i] && r[i].then))) return s.then();
            for (; i--;) N(r[i], t(i), s.reject);
            return s.promise()
        }
    });
    var q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    k.Deferred.exceptionHook = function(e, t) {
        C.console && C.console.warn && e && q.test(e.name) && C.console.warn("jQuery.Deferred exception: " + e.message, e.stack, t)
    }, k.readyException = function(e) {
        C.setTimeout(function() {
            throw e
        })
    };
    var H = k.Deferred();

    function R() {
        S.removeEventListener("DOMContentLoaded", R), C.removeEventListener("load", R), k.ready()
    }
    k.fn.ready = function(e) {
        return H.then(e).catch(function(e) {
            k.readyException(e)
        }), this
    }, k.extend({
        isReady: !1,
        readyWait: 1,
        ready: function(e) {
            (!0 === e ? --k.readyWait : k.isReady) || (k.isReady = !0) !== e && 0 < --k.readyWait || H.resolveWith(S, [k])
        }
    }), k.ready.then = H.then, "complete" === S.readyState || "loading" !== S.readyState && !S.documentElement.doScroll ? C.setTimeout(k.ready) : (S.addEventListener("DOMContentLoaded", R), C.addEventListener("load", R));

    function F(e, t, n, i, o, r, s) {
        var a = 0,
            l = e.length,
            c = null == n;
        if ("object" === x(n))
            for (a in o = !0, n) F(e, t, a, n[a], !0, r, s);
        else if (void 0 !== i && (o = !0, w(i) || (s = !0), c && (t = s ? (t.call(e, i), null) : (c = t, function(e, t, n) {
                return c.call(k(e), n)
            })), t))
            for (; a < l; a++) t(e[a], n, s ? i : i.call(e[a], a, t(e[a], n)));
        return o ? e : c ? t.call(e) : l ? t(e[0], n) : r
    }
    var W = /^-ms-/,
        U = /-([a-z])/g;

    function B(e, t) {
        return t.toUpperCase()
    }

    function Z(e) {
        return e.replace(W, "ms-").replace(U, B)
    }

    function G(e) {
        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
    }

    function X() {
        this.expando = k.expando + X.uid++
    }
    X.uid = 1, X.prototype = {
        cache: function(e) {
            var t = e[this.expando];
            return t || (t = {}, G(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                value: t,
                configurable: !0
            }))), t
        },
        set: function(e, t, n) {
            var i, o = this.cache(e);
            if ("string" == typeof t) o[Z(t)] = n;
            else
                for (i in t) o[Z(i)] = t[i];
            return o
        },
        get: function(e, t) {
            return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][Z(t)]
        },
        access: function(e, t, n) {
            return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t)
        },
        remove: function(e, t) {
            var n, i = e[this.expando];
            if (void 0 !== i) {
                if (void 0 !== t) {
                    n = (t = Array.isArray(t) ? t.map(Z) : (t = Z(t)) in i ? [t] : t.match(P) || []).length;
                    for (; n--;) delete i[t[n]]
                }
                void 0 !== t && !k.isEmptyObject(i) || (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
            }
        },
        hasData: function(e) {
            var t = e[this.expando];
            return void 0 !== t && !k.isEmptyObject(t)
        }
    };
    var Y = new X,
        K = new X,
        V = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
        Q = /[A-Z]/g;

    function J(e, t, n) {
        var i, o;
        if (void 0 === n && 1 === e.nodeType)
            if (i = "data-" + t.replace(Q, "-$&").toLowerCase(), "string" == typeof(n = e.getAttribute(i))) {
                try {
                    n = "true" === (o = n) || "false" !== o && ("null" === o ? null : o === +o + "" ? +o : V.test(o) ? JSON.parse(o) : o)
                } catch (e) {}
                K.set(e, t, n)
            } else n = void 0;
        return n
    }
    k.extend({
        hasData: function(e) {
            return K.hasData(e) || Y.hasData(e)
        },
        data: function(e, t, n) {
            return K.access(e, t, n)
        },
        removeData: function(e, t) {
            K.remove(e, t)
        },
        _data: function(e, t, n) {
            return Y.access(e, t, n)
        },
        _removeData: function(e, t) {
            Y.remove(e, t)
        }
    }), k.fn.extend({
        data: function(n, e) {
            var t, i, o, r = this[0],
                s = r && r.attributes;
            if (void 0 !== n) return "object" == _typeof(n) ? this.each(function() {
                K.set(this, n)
            }) : F(this, function(e) {
                var t;
                if (r && void 0 === e) return void 0 !== (t = K.get(r, n)) || void 0 !== (t = J(r, n)) ? t : void 0;
                this.each(function() {
                    K.set(this, n, e)
                })
            }, null, e, 1 < arguments.length, null, !0);
            if (this.length && (o = K.get(r), 1 === r.nodeType && !Y.get(r, "hasDataAttrs"))) {
                for (t = s.length; t--;) s[t] && 0 === (i = s[t].name).indexOf("data-") && (i = Z(i.slice(5)), J(r, i, o[i]));
                Y.set(r, "hasDataAttrs", !0)
            }
            return o
        },
        removeData: function(e) {
            return this.each(function() {
                K.remove(this, e)
            })
        }
    }), k.extend({
        queue: function(e, t, n) {
            var i;
            if (e) return t = (t || "fx") + "queue", i = Y.get(e, t), n && (!i || Array.isArray(n) ? i = Y.access(e, t, k.makeArray(n)) : i.push(n)), i || []
        },
        dequeue: function(e, t) {
            t = t || "fx";
            var n = k.queue(e, t),
                i = n.length,
                o = n.shift(),
                r = k._queueHooks(e, t);
            "inprogress" === o && (o = n.shift(), i--), o && ("fx" === t && n.unshift("inprogress"), delete r.stop, o.call(e, function() {
                k.dequeue(e, t)
            }, r)), !i && r && r.empty.fire()
        },
        _queueHooks: function(e, t) {
            var n = t + "queueHooks";
            return Y.get(e, n) || Y.access(e, n, {
                empty: k.Callbacks("once memory").add(function() {
                    Y.remove(e, [t + "queue", n])
                })
            })
        }
    }), k.fn.extend({
        queue: function(t, n) {
            var e = 2;
            return "string" != typeof t && (n = t, t = "fx", e--), arguments.length < e ? k.queue(this[0], t) : void 0 === n ? this : this.each(function() {
                var e = k.queue(this, t, n);
                k._queueHooks(this, t), "fx" === t && "inprogress" !== e[0] && k.dequeue(this, t)
            })
        },
        dequeue: function(e) {
            return this.each(function() {
                k.dequeue(this, e)
            })
        },
        clearQueue: function(e) {
            return this.queue(e || "fx", [])
        },
        promise: function(e, t) {
            function n() {
                --o || r.resolveWith(s, [s])
            }
            var i, o = 1,
                r = k.Deferred(),
                s = this,
                a = this.length;
            for ("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;)(i = Y.get(s[a], e + "queueHooks")) && i.empty && (o++, i.empty.add(n));
            return n(), r.promise(t)
        }
    });
    var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
        te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"),
        ne = ["Top", "Right", "Bottom", "Left"],
        ie = S.documentElement,
        oe = function(e) {
            return k.contains(e.ownerDocument, e)
        },
        re = {
            composed: !0
        };
    ie.getRootNode && (oe = function(e) {
        return k.contains(e.ownerDocument, e) || e.getRootNode(re) === e.ownerDocument
    });

    function se(e, t) {
        return "none" === (e = t || e).style.display || "" === e.style.display && oe(e) && "none" === k.css(e, "display")
    }

    function ae(e, t, n, i) {
        var o, r, s = 20,
            a = i ? function() {
                return i.cur()
            } : function() {
                return k.css(e, t, "")
            },
            l = a(),
            c = n && n[3] || (k.cssNumber[t] ? "" : "px"),
            u = e.nodeType && (k.cssNumber[t] || "px" !== c && +l) && te.exec(k.css(e, t));
        if (u && u[3] !== c) {
            for (l /= 2, c = c || u[3], u = +l || 1; s--;) k.style(e, t, u + c), (1 - r) * (1 - (r = a() / l || .5)) <= 0 && (s = 0), u /= r;
            u *= 2, k.style(e, t, u + c), n = n || []
        }
        return n && (u = +u || +l || 0, o = n[1] ? u + (n[1] + 1) * n[2] : +n[2], i && (i.unit = c, i.start = u, i.end = o)), o
    }
    var le = {};

    function ce(e, t) {
        for (var n, i, o, r, s, a, l = [], c = 0, u = e.length; c < u; c++)(i = e[c]).style && (n = i.style.display, t ? ("none" === n && (l[c] = Y.get(i, "display") || null, l[c] || (i.style.display = "")), "" === i.style.display && se(i) && (l[c] = (a = r = o = void 0, r = i.ownerDocument, s = i.nodeName, (a = le[s]) || (o = r.body.appendChild(r.createElement(s)), a = k.css(o, "display"), o.parentNode.removeChild(o), "none" === a && (a = "block"), le[s] = a)))) : "none" !== n && (l[c] = "none", Y.set(i, "display", n)));
        for (c = 0; c < u; c++) null != l[c] && (e[c].style.display = l[c]);
        return e
    }
    k.fn.extend({
        show: function() {
            return ce(this, !0)
        },
        hide: function() {
            return ce(this)
        },
        toggle: function(e) {
            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                se(this) ? k(this).show() : k(this).hide()
            })
        }
    });
    var ue, de, pe = /^(?:checkbox|radio)$/i,
        fe = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
        he = /^$|^module$|\/(?:java|ecma)script/i;
    ue = S.createDocumentFragment().appendChild(S.createElement("div")), (de = S.createElement("input")).setAttribute("type", "radio"), de.setAttribute("checked", "checked"), de.setAttribute("name", "t"), ue.appendChild(de), y.checkClone = ue.cloneNode(!0).cloneNode(!0).lastChild.checked, ue.innerHTML = "<textarea>x</textarea>", y.noCloneChecked = !!ue.cloneNode(!0).lastChild.defaultValue, ue.innerHTML = "<option></option>", y.option = !!ue.lastChild;
    var me = {
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };

    function ge(e, t) {
        var n;
        return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && _(e, t) ? k.merge([e], n) : n
    }

    function ve(e, t) {
        for (var n = 0, i = e.length; n < i; n++) Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"))
    }
    me.tbody = me.tfoot = me.colgroup = me.caption = me.thead, me.th = me.td, y.option || (me.optgroup = me.option = [1, "<select multiple='multiple'>", "</select>"]);
    var ye = /<|&#?\w+;/;

    function we(e, t, n, i, o) {
        for (var r, s, a, l, c, u, d = t.createDocumentFragment(), p = [], f = 0, h = e.length; f < h; f++)
            if ((r = e[f]) || 0 === r)
                if ("object" === x(r)) k.merge(p, r.nodeType ? [r] : r);
                else if (ye.test(r)) {
            for (s = s || d.appendChild(t.createElement("div")), a = (fe.exec(r) || ["", ""])[1].toLowerCase(), l = me[a] || me._default, s.innerHTML = l[1] + k.htmlPrefilter(r) + l[2], u = l[0]; u--;) s = s.lastChild;
            k.merge(p, s.childNodes), (s = d.firstChild).textContent = ""
        } else p.push(t.createTextNode(r));
        for (d.textContent = "", f = 0; r = p[f++];)
            if (i && -1 < k.inArray(r, i)) o && o.push(r);
            else if (c = oe(r), s = ge(d.appendChild(r), "script"), c && ve(s), n)
            for (u = 0; r = s[u++];) he.test(r.type || "") && n.push(r);
        return d
    }
    var be = /^key/,
        xe = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
        Te = /^([^.]*)(?:\.(.+)|)/;

    function Ce() {
        return !0
    }

    function Se() {
        return !1
    }

    function ke(e, t) {
        return e === function() {
            try {
                return S.activeElement
            } catch (e) {}
        }() == ("focus" === t)
    }

    function Ae(e, t, n, i, o, r) {
        var s, a;
        if ("object" == _typeof(t)) {
            for (a in "string" != typeof n && (i = i || n, n = void 0), t) Ae(e, a, n, i, t[a], r);
            return e
        }
        if (null == i && null == o ? (o = n, i = n = void 0) : null == o && ("string" == typeof n ? (o = i, i = void 0) : (o = i, i = n, n = void 0)), !1 === o) o = Se;
        else if (!o) return e;
        return 1 === r && (s = o, (o = function(e) {
            return k().off(e), s.apply(this, arguments)
        }).guid = s.guid || (s.guid = k.guid++)), e.each(function() {
            k.event.add(this, t, o, i, n)
        })
    }

    function _e(e, o, r) {
        r ? (Y.set(e, o, !1), k.event.add(e, o, {
            namespace: !1,
            handler: function(e) {
                var t, n, i = Y.get(this, o);
                if (1 & e.isTrigger && this[o]) {
                    if (i.length)(k.event.special[o] || {}).delegateType && e.stopPropagation();
                    else if (i = a.call(arguments), Y.set(this, o, i), t = r(this, o), this[o](), i !== (n = Y.get(this, o)) || t ? Y.set(this, o, !1) : n = {}, i !== n) return e.stopImmediatePropagation(), e.preventDefault(), n.value
                } else i.length && (Y.set(this, o, {
                    value: k.event.trigger(k.extend(i[0], k.Event.prototype), i.slice(1), this)
                }), e.stopImmediatePropagation())
            }
        })) : void 0 === Y.get(e, o) && k.event.add(e, o, Ce)
    }
    k.event = {
        global: {},
        add: function(t, e, n, i, o) {
            var r, s, a, l, c, u, d, p, f, h, m, g = Y.get(t);
            if (G(t))
                for (n.handler && (n = (r = n).handler, o = r.selector), o && k.find.matchesSelector(ie, o), n.guid || (n.guid = k.guid++), (l = g.events) || (l = g.events = Object.create(null)), (s = g.handle) || (s = g.handle = function(e) {
                        return void 0 !== k && k.event.triggered !== e.type ? k.event.dispatch.apply(t, arguments) : void 0
                    }), c = (e = (e || "").match(P) || [""]).length; c--;) f = m = (a = Te.exec(e[c]) || [])[1], h = (a[2] || "").split(".").sort(), f && (d = k.event.special[f] || {}, f = (o ? d.delegateType : d.bindType) || f, d = k.event.special[f] || {}, u = k.extend({
                    type: f,
                    origType: m,
                    data: i,
                    handler: n,
                    guid: n.guid,
                    selector: o,
                    needsContext: o && k.expr.match.needsContext.test(o),
                    namespace: h.join(".")
                }, r), (p = l[f]) || ((p = l[f] = []).delegateCount = 0, d.setup && !1 !== d.setup.call(t, i, h, s) || t.addEventListener && t.addEventListener(f, s)), d.add && (d.add.call(t, u), u.handler.guid || (u.handler.guid = n.guid)), o ? p.splice(p.delegateCount++, 0, u) : p.push(u), k.event.global[f] = !0)
        },
        remove: function(e, t, n, i, o) {
            var r, s, a, l, c, u, d, p, f, h, m, g = Y.hasData(e) && Y.get(e);
            if (g && (l = g.events)) {
                for (c = (t = (t || "").match(P) || [""]).length; c--;)
                    if (f = m = (a = Te.exec(t[c]) || [])[1], h = (a[2] || "").split(".").sort(), f) {
                        for (d = k.event.special[f] || {}, p = l[f = (i ? d.delegateType : d.bindType) || f] || [], a = a[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = p.length; r--;) u = p[r], !o && m !== u.origType || n && n.guid !== u.guid || a && !a.test(u.namespace) || i && i !== u.selector && ("**" !== i || !u.selector) || (p.splice(r, 1), u.selector && p.delegateCount--, d.remove && d.remove.call(e, u));
                        s && !p.length && (d.teardown && !1 !== d.teardown.call(e, h, g.handle) || k.removeEvent(e, f, g.handle), delete l[f])
                    } else
                        for (f in l) k.event.remove(e, f + t[c], n, i, !0);
                k.isEmptyObject(l) && Y.remove(e, "handle events")
            }
        },
        dispatch: function(e) {
            var t, n, i, o, r, s, a = new Array(arguments.length),
                l = k.event.fix(e),
                c = (Y.get(this, "events") || Object.create(null))[l.type] || [],
                u = k.event.special[l.type] || {};
            for (a[0] = l, t = 1; t < arguments.length; t++) a[t] = arguments[t];
            if (l.delegateTarget = this, !u.preDispatch || !1 !== u.preDispatch.call(this, l)) {
                for (s = k.event.handlers.call(this, l, c), t = 0;
                    (o = s[t++]) && !l.isPropagationStopped();)
                    for (l.currentTarget = o.elem, n = 0;
                        (r = o.handlers[n++]) && !l.isImmediatePropagationStopped();) l.rnamespace && !1 !== r.namespace && !l.rnamespace.test(r.namespace) || (l.handleObj = r, l.data = r.data, void 0 !== (i = ((k.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, a)) && !1 === (l.result = i) && (l.preventDefault(), l.stopPropagation()));
                return u.postDispatch && u.postDispatch.call(this, l), l.result
            }
        },
        handlers: function(e, t) {
            var n, i, o, r, s, a = [],
                l = t.delegateCount,
                c = e.target;
            if (l && c.nodeType && !("click" === e.type && 1 <= e.button))
                for (; c !== this; c = c.parentNode || this)
                    if (1 === c.nodeType && ("click" !== e.type || !0 !== c.disabled)) {
                        for (r = [], s = {}, n = 0; n < l; n++) void 0 === s[o = (i = t[n]).selector + " "] && (s[o] = i.needsContext ? -1 < k(o, this).index(c) : k.find(o, this, null, [c]).length), s[o] && r.push(i);
                        r.length && a.push({
                            elem: c,
                            handlers: r
                        })
                    } return c = this, l < t.length && a.push({
                elem: c,
                handlers: t.slice(l)
            }), a
        },
        addProp: function(t, e) {
            Object.defineProperty(k.Event.prototype, t, {
                enumerable: !0,
                configurable: !0,
                get: w(e) ? function() {
                    if (this.originalEvent) return e(this.originalEvent)
                } : function() {
                    if (this.originalEvent) return this.originalEvent[t]
                },
                set: function(e) {
                    Object.defineProperty(this, t, {
                        enumerable: !0,
                        configurable: !0,
                        writable: !0,
                        value: e
                    })
                }
            })
        },
        fix: function(e) {
            return e[k.expando] ? e : new k.Event(e)
        },
        special: {
            load: {
                noBubble: !0
            },
            click: {
                setup: function(e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && _(t, "input") && _e(t, "click", Ce), !1
                },
                trigger: function(e) {
                    var t = this || e;
                    return pe.test(t.type) && t.click && _(t, "input") && _e(t, "click"), !0
                },
                _default: function(e) {
                    var t = e.target;
                    return pe.test(t.type) && t.click && _(t, "input") && Y.get(t, "click") || _(t, "a")
                }
            },
            beforeunload: {
                postDispatch: function(e) {
                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                }
            }
        }
    }, k.removeEvent = function(e, t, n) {
        e.removeEventListener && e.removeEventListener(t, n)
    }, k.Event = function(e, t) {
        if (!(this instanceof k.Event)) return new k.Event(e, t);
        e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Ce : Se, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && k.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[k.expando] = !0
    }, k.Event.prototype = {
        constructor: k.Event,
        isDefaultPrevented: Se,
        isPropagationStopped: Se,
        isImmediatePropagationStopped: Se,
        isSimulated: !1,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = Ce, e && !this.isSimulated && e.preventDefault()
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = Ce, e && !this.isSimulated && e.stopPropagation()
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = Ce, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation()
        }
    }, k.each({
        altKey: !0,
        bubbles: !0,
        cancelable: !0,
        changedTouches: !0,
        ctrlKey: !0,
        detail: !0,
        eventPhase: !0,
        metaKey: !0,
        pageX: !0,
        pageY: !0,
        shiftKey: !0,
        view: !0,
        char: !0,
        code: !0,
        charCode: !0,
        key: !0,
        keyCode: !0,
        button: !0,
        buttons: !0,
        clientX: !0,
        clientY: !0,
        offsetX: !0,
        offsetY: !0,
        pointerId: !0,
        pointerType: !0,
        screenX: !0,
        screenY: !0,
        targetTouches: !0,
        toElement: !0,
        touches: !0,
        which: function(e) {
            var t = e.button;
            return null == e.which && be.test(e.type) ? null != e.charCode ? e.charCode : e.keyCode : !e.which && void 0 !== t && xe.test(e.type) ? 1 & t ? 1 : 2 & t ? 3 : 4 & t ? 2 : 0 : e.which
        }
    }, k.event.addProp), k.each({
        focus: "focusin",
        blur: "focusout"
    }, function(e, t) {
        k.event.special[e] = {
            setup: function() {
                return _e(this, e, ke), !1
            },
            trigger: function() {
                return _e(this, e), !0
            },
            delegateType: t
        }
    }), k.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(e, o) {
        k.event.special[e] = {
            delegateType: o,
            bindType: o,
            handle: function(e) {
                var t, n = e.relatedTarget,
                    i = e.handleObj;
                return n && (n === this || k.contains(this, n)) || (e.type = i.origType, t = i.handler.apply(this, arguments), e.type = o), t
            }
        }
    }), k.fn.extend({
        on: function(e, t, n, i) {
            return Ae(this, e, t, n, i)
        },
        one: function(e, t, n, i) {
            return Ae(this, e, t, n, i, 1)
        },
        off: function(e, t, n) {
            var i, o;
            if (e && e.preventDefault && e.handleObj) return i = e.handleObj, k(e.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
            if ("object" != _typeof(e)) return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = Se), this.each(function() {
                k.event.remove(this, e, n, t)
            });
            for (o in e) this.off(o, t, e[o]);
            return this
        }
    });
    var $e = /<script|<style|<link/i,
        Ee = /checked\s*(?:[^=]|=\s*.checked.)/i,
        De = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

    function ze(e, t) {
        return _(e, "table") && _(11 !== t.nodeType ? t : t.firstChild, "tr") && k(e).children("tbody")[0] || e
    }

    function Oe(e) {
        return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
    }

    function Le(e) {
        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e
    }

    function Ie(e, t) {
        var n, i, o, r, s, a;
        if (1 === t.nodeType) {
            if (Y.hasData(e) && (a = Y.get(e).events))
                for (o in Y.remove(t, "handle events"), a)
                    for (n = 0, i = a[o].length; n < i; n++) k.event.add(t, o, a[o][n]);
            K.hasData(e) && (r = K.access(e), s = k.extend({}, r), K.set(t, s))
        }
    }

    function Pe(n, i, o, r) {
        i = g(i);
        var e, t, s, a, l, c, u = 0,
            d = n.length,
            p = d - 1,
            f = i[0],
            h = w(f);
        if (h || 1 < d && "string" == typeof f && !y.checkClone && Ee.test(f)) return n.each(function(e) {
            var t = n.eq(e);
            h && (i[0] = f.call(this, e, t.html())), Pe(t, i, o, r)
        });
        if (d && (t = (e = we(i, n[0].ownerDocument, !1, n, r)).firstChild, 1 === e.childNodes.length && (e = t), t || r)) {
            for (a = (s = k.map(ge(e, "script"), Oe)).length; u < d; u++) l = e, u !== p && (l = k.clone(l, !0, !0), a && k.merge(s, ge(l, "script"))), o.call(n[u], l, u);
            if (a)
                for (c = s[s.length - 1].ownerDocument, k.map(s, Le), u = 0; u < a; u++) l = s[u], he.test(l.type || "") && !Y.access(l, "globalEval") && k.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? k._evalUrl && !l.noModule && k._evalUrl(l.src, {
                    nonce: l.nonce || l.getAttribute("nonce")
                }, c) : b(l.textContent.replace(De, ""), l, c))
        }
        return n
    }

    function Me(e, t, n) {
        for (var i, o = t ? k.filter(t, e) : e, r = 0; null != (i = o[r]); r++) n || 1 !== i.nodeType || k.cleanData(ge(i)), i.parentNode && (n && oe(i) && ve(ge(i, "script")), i.parentNode.removeChild(i));
        return e
    }
    k.extend({
        htmlPrefilter: function(e) {
            return e
        },
        clone: function(e, t, n) {
            var i, o, r, s, a, l, c, u = e.cloneNode(!0),
                d = oe(e);
            if (!(y.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || k.isXMLDoc(e)))
                for (s = ge(u), i = 0, o = (r = ge(e)).length; i < o; i++) a = r[i], "input" === (c = (l = s[i]).nodeName.toLowerCase()) && pe.test(a.type) ? l.checked = a.checked : "input" !== c && "textarea" !== c || (l.defaultValue = a.defaultValue);
            if (t)
                if (n)
                    for (r = r || ge(e), s = s || ge(u), i = 0, o = r.length; i < o; i++) Ie(r[i], s[i]);
                else Ie(e, u);
            return 0 < (s = ge(u, "script")).length && ve(s, !d && ge(e, "script")), u
        },
        cleanData: function(e) {
            for (var t, n, i, o = k.event.special, r = 0; void 0 !== (n = e[r]); r++)
                if (G(n)) {
                    if (t = n[Y.expando]) {
                        if (t.events)
                            for (i in t.events) o[i] ? k.event.remove(n, i) : k.removeEvent(n, i, t.handle);
                        n[Y.expando] = void 0
                    }
                    n[K.expando] && (n[K.expando] = void 0)
                }
        }
    }), k.fn.extend({
        detach: function(e) {
            return Me(this, e, !0)
        },
        remove: function(e) {
            return Me(this, e)
        },
        text: function(e) {
            return F(this, function(e) {
                return void 0 === e ? k.text(this) : this.empty().each(function() {
                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                })
            }, null, e, arguments.length)
        },
        append: function() {
            return Pe(this, arguments, function(e) {
                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || ze(this, e).appendChild(e)
            })
        },
        prepend: function() {
            return Pe(this, arguments, function(e) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var t = ze(this, e);
                    t.insertBefore(e, t.firstChild)
                }
            })
        },
        before: function() {
            return Pe(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this)
            })
        },
        after: function() {
            return Pe(this, arguments, function(e) {
                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
            })
        },
        empty: function() {
            for (var e, t = 0; null != (e = this[t]); t++) 1 === e.nodeType && (k.cleanData(ge(e, !1)), e.textContent = "");
            return this
        },
        clone: function(e, t) {
            return e = null != e && e, t = null == t ? e : t, this.map(function() {
                return k.clone(this, e, t)
            })
        },
        html: function(e) {
            return F(this, function(e) {
                var t = this[0] || {},
                    n = 0,
                    i = this.length;
                if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                if ("string" == typeof e && !$e.test(e) && !me[(fe.exec(e) || ["", ""])[1].toLowerCase()]) {
                    e = k.htmlPrefilter(e);
                    try {
                        for (; n < i; n++) 1 === (t = this[n] || {}).nodeType && (k.cleanData(ge(t, !1)), t.innerHTML = e);
                        t = 0
                    } catch (e) {}
                }
                t && this.empty().append(e)
            }, null, e, arguments.length)
        },
        replaceWith: function() {
            var n = [];
            return Pe(this, arguments, function(e) {
                var t = this.parentNode;
                k.inArray(this, n) < 0 && (k.cleanData(ge(this)), t && t.replaceChild(e, this))
            }, n)
        }
    }), k.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(e, s) {
        k.fn[e] = function(e) {
            for (var t, n = [], i = k(e), o = i.length - 1, r = 0; r <= o; r++) t = r === o ? this : this.clone(!0), k(i[r])[s](t), l.apply(n, t.get());
            return this.pushStack(n)
        }
    });

    function je(e, t, n) {
        var i, o, r = {};
        for (o in t) r[o] = e.style[o], e.style[o] = t[o];
        for (o in i = n.call(e), t) e.style[o] = r[o];
        return i
    }
    var Ne, qe, He, Re, Fe, We, Ue, Be, Ze = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"),
        Ge = function(e) {
            var t = e.ownerDocument.defaultView;
            return t && t.opener || (t = C), t.getComputedStyle(e)
        },
        Xe = new RegExp(ne.join("|"), "i");

    function Ye(e, t, n) {
        var i, o, r, s, a = e.style;
        return (n = n || Ge(e)) && ("" !== (s = n.getPropertyValue(t) || n[t]) || oe(e) || (s = k.style(e, t)), !y.pixelBoxStyles() && Ze.test(s) && Xe.test(t) && (i = a.width, o = a.minWidth, r = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = i, a.minWidth = o, a.maxWidth = r)), void 0 !== s ? s + "" : s
    }

    function Ke(e, t) {
        return {
            get: function() {
                if (!e()) return (this.get = t).apply(this, arguments);
                delete this.get
            }
        }
    }

    function Ve() {
        if (Be) {
            Ue.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", Be.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", ie.appendChild(Ue).appendChild(Be);
            var e = C.getComputedStyle(Be);
            Ne = "1%" !== e.top, We = 12 === Qe(e.marginLeft), Be.style.right = "60%", Re = 36 === Qe(e.right), qe = 36 === Qe(e.width), Be.style.position = "absolute", He = 12 === Qe(Be.offsetWidth / 3), ie.removeChild(Ue), Be = null
        }
    }

    function Qe(e) {
        return Math.round(parseFloat(e))
    }
    Ue = S.createElement("div"), (Be = S.createElement("div")).style && (Be.style.backgroundClip = "content-box", Be.cloneNode(!0).style.backgroundClip = "", y.clearCloneStyle = "content-box" === Be.style.backgroundClip, k.extend(y, {
        boxSizingReliable: function() {
            return Ve(), qe
        },
        pixelBoxStyles: function() {
            return Ve(), Re
        },
        pixelPosition: function() {
            return Ve(), Ne
        },
        reliableMarginLeft: function() {
            return Ve(), We
        },
        scrollboxSize: function() {
            return Ve(), He
        },
        reliableTrDimensions: function() {
            var e, t, n, i;
            return null == Fe && (e = S.createElement("table"), t = S.createElement("tr"), n = S.createElement("div"), e.style.cssText = "position:absolute;left:-11111px", t.style.height = "1px", n.style.height = "9px", ie.appendChild(e).appendChild(t).appendChild(n), i = C.getComputedStyle(t), Fe = 3 < parseInt(i.height), ie.removeChild(e)), Fe
        }
    }));
    var Je = ["Webkit", "Moz", "ms"],
        et = S.createElement("div").style,
        tt = {};

    function nt(e) {
        return k.cssProps[e] || tt[e] || (e in et ? e : tt[e] = function(e) {
            for (var t = e[0].toUpperCase() + e.slice(1), n = Je.length; n--;)
                if ((e = Je[n] + t) in et) return e
        }(e) || e)
    }
    var it = /^(none|table(?!-c[ea]).+)/,
        ot = /^--/,
        rt = {
            position: "absolute",
            visibility: "hidden",
            display: "block"
        },
        st = {
            letterSpacing: "0",
            fontWeight: "400"
        };

    function at(e, t, n) {
        var i = te.exec(t);
        return i ? Math.max(0, i[2] - (n || 0)) + (i[3] || "px") : t
    }

    function lt(e, t, n, i, o, r) {
        var s = "width" === t ? 1 : 0,
            a = 0,
            l = 0;
        if (n === (i ? "border" : "content")) return 0;
        for (; s < 4; s += 2) "margin" === n && (l += k.css(e, n + ne[s], !0, o)), i ? ("content" === n && (l -= k.css(e, "padding" + ne[s], !0, o)), "margin" !== n && (l -= k.css(e, "border" + ne[s] + "Width", !0, o))) : (l += k.css(e, "padding" + ne[s], !0, o), "padding" !== n ? l += k.css(e, "border" + ne[s] + "Width", !0, o) : a += k.css(e, "border" + ne[s] + "Width", !0, o));
        return !i && 0 <= r && (l += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - r - l - a - .5)) || 0), l
    }

    function ct(e, t, n) {
        var i = Ge(e),
            o = (!y.boxSizingReliable() || n) && "border-box" === k.css(e, "boxSizing", !1, i),
            r = o,
            s = Ye(e, t, i),
            a = "offset" + t[0].toUpperCase() + t.slice(1);
        if (Ze.test(s)) {
            if (!n) return s;
            s = "auto"
        }
        return (!y.boxSizingReliable() && o || !y.reliableTrDimensions() && _(e, "tr") || "auto" === s || !parseFloat(s) && "inline" === k.css(e, "display", !1, i)) && e.getClientRects().length && (o = "border-box" === k.css(e, "boxSizing", !1, i), (r = a in e) && (s = e[a])), (s = parseFloat(s) || 0) + lt(e, t, n || (o ? "border" : "content"), r, i, s) + "px"
    }

    function ut(e, t, n, i, o) {
        return new ut.prototype.init(e, t, n, i, o)
    }
    k.extend({
        cssHooks: {
            opacity: {
                get: function(e, t) {
                    if (t) {
                        var n = Ye(e, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            animationIterationCount: !0,
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            gridArea: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnStart: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowStart: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {},
        style: function(e, t, n, i) {
            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                var o, r, s, a = Z(t),
                    l = ot.test(t),
                    c = e.style;
                if (l || (t = nt(a)), s = k.cssHooks[t] || k.cssHooks[a], void 0 === n) return s && "get" in s && void 0 !== (o = s.get(e, !1, i)) ? o : c[t];
                "string" === (r = _typeof(n)) && (o = te.exec(n)) && o[1] && (n = ae(e, t, o), r = "number"), null != n && n == n && ("number" !== r || l || (n += o && o[3] || (k.cssNumber[a] ? "" : "px")), y.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (c[t] = "inherit"), s && "set" in s && void 0 === (n = s.set(e, n, i)) || (l ? c.setProperty(t, n) : c[t] = n))
            }
        },
        css: function(e, t, n, i) {
            var o, r, s, a = Z(t);
            return ot.test(t) || (t = nt(a)), (s = k.cssHooks[t] || k.cssHooks[a]) && "get" in s && (o = s.get(e, !0, n)), void 0 === o && (o = Ye(e, t, i)), "normal" === o && t in st && (o = st[t]), "" === n || n ? (r = parseFloat(o), !0 === n || isFinite(r) ? r || 0 : o) : o
        }
    }), k.each(["height", "width"], function(e, l) {
        k.cssHooks[l] = {
            get: function(e, t, n) {
                if (t) return !it.test(k.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? ct(e, l, n) : je(e, rt, function() {
                    return ct(e, l, n)
                })
            },
            set: function(e, t, n) {
                var i, o = Ge(e),
                    r = !y.scrollboxSize() && "absolute" === o.position,
                    s = (r || n) && "border-box" === k.css(e, "boxSizing", !1, o),
                    a = n ? lt(e, l, n, s, o) : 0;
                return s && r && (a -= Math.ceil(e["offset" + l[0].toUpperCase() + l.slice(1)] - parseFloat(o[l]) - lt(e, l, "border", !1, o) - .5)), a && (i = te.exec(t)) && "px" !== (i[3] || "px") && (e.style[l] = t, t = k.css(e, l)), at(0, t, a)
            }
        }
    }), k.cssHooks.marginLeft = Ke(y.reliableMarginLeft, function(e, t) {
        if (t) return (parseFloat(Ye(e, "marginLeft")) || e.getBoundingClientRect().left - je(e, {
            marginLeft: 0
        }, function() {
            return e.getBoundingClientRect().left
        })) + "px"
    }), k.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(o, r) {
        k.cssHooks[o + r] = {
            expand: function(e) {
                for (var t = 0, n = {}, i = "string" == typeof e ? e.split(" ") : [e]; t < 4; t++) n[o + ne[t] + r] = i[t] || i[t - 2] || i[0];
                return n
            }
        }, "margin" !== o && (k.cssHooks[o + r].set = at)
    }), k.fn.extend({
        css: function(e, t) {
            return F(this, function(e, t, n) {
                var i, o, r = {},
                    s = 0;
                if (Array.isArray(t)) {
                    for (i = Ge(e), o = t.length; s < o; s++) r[t[s]] = k.css(e, t[s], !1, i);
                    return r
                }
                return void 0 !== n ? k.style(e, t, n) : k.css(e, t)
            }, e, t, 1 < arguments.length)
        }
    }), ((k.Tween = ut).prototype = {
        constructor: ut,
        init: function(e, t, n, i, o, r) {
            this.elem = e, this.prop = n, this.easing = o || k.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = i, this.unit = r || (k.cssNumber[n] ? "" : "px")
        },
        cur: function() {
            var e = ut.propHooks[this.prop];
            return e && e.get ? e.get(this) : ut.propHooks._default.get(this)
        },
        run: function(e) {
            var t, n = ut.propHooks[this.prop];
            return this.options.duration ? this.pos = t = k.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : ut.propHooks._default.set(this), this
        }
    }).init.prototype = ut.prototype, (ut.propHooks = {
        _default: {
            get: function(e) {
                var t;
                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = k.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0
            },
            set: function(e) {
                k.fx.step[e.prop] ? k.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !k.cssHooks[e.prop] && null == e.elem.style[nt(e.prop)] ? e.elem[e.prop] = e.now : k.style(e.elem, e.prop, e.now + e.unit)
            }
        }
    }).scrollTop = ut.propHooks.scrollLeft = {
        set: function(e) {
            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
        }
    }, k.easing = {
        linear: function(e) {
            return e
        },
        swing: function(e) {
            return .5 - Math.cos(e * Math.PI) / 2
        },
        _default: "swing"
    }, k.fx = ut.prototype.init, k.fx.step = {};
    var dt, pt, ft, ht, mt = /^(?:toggle|show|hide)$/,
        gt = /queueHooks$/;

    function vt() {
        pt && (!1 === S.hidden && C.requestAnimationFrame ? C.requestAnimationFrame(vt) : C.setTimeout(vt, k.fx.interval), k.fx.tick())
    }

    function yt() {
        return C.setTimeout(function() {
            dt = void 0
        }), dt = Date.now()
    }

    function wt(e, t) {
        var n, i = 0,
            o = {
                height: e
            };
        for (t = t ? 1 : 0; i < 4; i += 2 - t) o["margin" + (n = ne[i])] = o["padding" + n] = e;
        return t && (o.opacity = o.width = e), o
    }

    function bt(e, t, n) {
        for (var i, o = (xt.tweeners[t] || []).concat(xt.tweeners["*"]), r = 0, s = o.length; r < s; r++)
            if (i = o[r].call(n, t, e)) return i
    }

    function xt(r, e, t) {
        var n, s, i = 0,
            o = xt.prefilters.length,
            a = k.Deferred().always(function() {
                delete l.elem
            }),
            l = function() {
                if (s) return !1;
                for (var e = dt || yt(), t = Math.max(0, c.startTime + c.duration - e), n = 1 - (t / c.duration || 0), i = 0, o = c.tweens.length; i < o; i++) c.tweens[i].run(n);
                return a.notifyWith(r, [c, n, t]), n < 1 && o ? t : (o || a.notifyWith(r, [c, 1, 0]), a.resolveWith(r, [c]), !1)
            },
            c = a.promise({
                elem: r,
                props: k.extend({}, e),
                opts: k.extend(!0, {
                    specialEasing: {},
                    easing: k.easing._default
                }, t),
                originalProperties: e,
                originalOptions: t,
                startTime: dt || yt(),
                duration: t.duration,
                tweens: [],
                createTween: function(e, t) {
                    var n = k.Tween(r, c.opts, e, t, c.opts.specialEasing[e] || c.opts.easing);
                    return c.tweens.push(n), n
                },
                stop: function(e) {
                    var t = 0,
                        n = e ? c.tweens.length : 0;
                    if (s) return this;
                    for (s = !0; t < n; t++) c.tweens[t].run(1);
                    return e ? (a.notifyWith(r, [c, 1, 0]), a.resolveWith(r, [c, e])) : a.rejectWith(r, [c, e]), this
                }
            }),
            u = c.props;
        for (function(e, t) {
                var n, i, o, r, s;
                for (n in e)
                    if (o = t[i = Z(n)], r = e[n], Array.isArray(r) && (o = r[1], r = e[n] = r[0]), n !== i && (e[i] = r, delete e[n]), (s = k.cssHooks[i]) && "expand" in s)
                        for (n in r = s.expand(r), delete e[i], r) n in e || (e[n] = r[n], t[n] = o);
                    else t[i] = o
            }(u, c.opts.specialEasing); i < o; i++)
            if (n = xt.prefilters[i].call(c, r, u, c.opts)) return w(n.stop) && (k._queueHooks(c.elem, c.opts.queue).stop = n.stop.bind(n)), n;
        return k.map(u, bt, c), w(c.opts.start) && c.opts.start.call(r, c), c.progress(c.opts.progress).done(c.opts.done, c.opts.complete).fail(c.opts.fail).always(c.opts.always), k.fx.timer(k.extend(l, {
            elem: r,
            anim: c,
            queue: c.opts.queue
        })), c
    }
    k.Animation = k.extend(xt, {
        tweeners: {
            "*": [function(e, t) {
                var n = this.createTween(e, t);
                return ae(n.elem, e, te.exec(t), n), n
            }]
        },
        tweener: function(e, t) {
            for (var n, i = 0, o = (e = w(e) ? (t = e, ["*"]) : e.match(P)).length; i < o; i++) n = e[i], xt.tweeners[n] = xt.tweeners[n] || [], xt.tweeners[n].unshift(t)
        },
        prefilters: [function(e, t, n) {
            var i, o, r, s, a, l, c, u, d = "width" in t || "height" in t,
                p = this,
                f = {},
                h = e.style,
                m = e.nodeType && se(e),
                g = Y.get(e, "fxshow");
            for (i in n.queue || (null == (s = k._queueHooks(e, "fx")).unqueued && (s.unqueued = 0, a = s.empty.fire, s.empty.fire = function() {
                    s.unqueued || a()
                }), s.unqueued++, p.always(function() {
                    p.always(function() {
                        s.unqueued--, k.queue(e, "fx").length || s.empty.fire()
                    })
                })), t)
                if (o = t[i], mt.test(o)) {
                    if (delete t[i], r = r || "toggle" === o, o === (m ? "hide" : "show")) {
                        if ("show" !== o || !g || void 0 === g[i]) continue;
                        m = !0
                    }
                    f[i] = g && g[i] || k.style(e, i)
                } if ((l = !k.isEmptyObject(t)) || !k.isEmptyObject(f))
                for (i in d && 1 === e.nodeType && (n.overflow = [h.overflow, h.overflowX, h.overflowY], null == (c = g && g.display) && (c = Y.get(e, "display")), "none" === (u = k.css(e, "display")) && (c ? u = c : (ce([e], !0), c = e.style.display || c, u = k.css(e, "display"), ce([e]))), ("inline" === u || "inline-block" === u && null != c) && "none" === k.css(e, "float") && (l || (p.done(function() {
                        h.display = c
                    }), null == c && (u = h.display, c = "none" === u ? "" : u)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", p.always(function() {
                        h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2]
                    })), l = !1, f) l || (g ? "hidden" in g && (m = g.hidden) : g = Y.access(e, "fxshow", {
                    display: c
                }), r && (g.hidden = !m), m && ce([e], !0), p.done(function() {
                    for (i in m || ce([e]), Y.remove(e, "fxshow"), f) k.style(e, i, f[i])
                })), l = bt(m ? g[i] : 0, i, p), i in g || (g[i] = l.start, m && (l.end = l.start, l.start = 0))
        }],
        prefilter: function(e, t) {
            t ? xt.prefilters.unshift(e) : xt.prefilters.push(e)
        }
    }), k.speed = function(e, t, n) {
        var i = e && "object" == _typeof(e) ? k.extend({}, e) : {
            complete: n || !n && t || w(e) && e,
            duration: e,
            easing: n && t || t && !w(t) && t
        };
        return k.fx.off ? i.duration = 0 : "number" != typeof i.duration && (i.duration in k.fx.speeds ? i.duration = k.fx.speeds[i.duration] : i.duration = k.fx.speeds._default), null != i.queue && !0 !== i.queue || (i.queue = "fx"), i.old = i.complete, i.complete = function() {
            w(i.old) && i.old.call(this), i.queue && k.dequeue(this, i.queue)
        }, i
    }, k.fn.extend({
        fadeTo: function(e, t, n, i) {
            return this.filter(se).css("opacity", 0).show().end().animate({
                opacity: t
            }, e, n, i)
        },
        animate: function(t, e, n, i) {
            function o() {
                var e = xt(this, k.extend({}, t), s);
                (r || Y.get(this, "finish")) && e.stop(!0)
            }
            var r = k.isEmptyObject(t),
                s = k.speed(e, n, i);
            return o.finish = o, r || !1 === s.queue ? this.each(o) : this.queue(s.queue, o)
        },
        stop: function(o, e, r) {
            function s(e) {
                var t = e.stop;
                delete e.stop, t(r)
            }
            return "string" != typeof o && (r = e, e = o, o = void 0), e && this.queue(o || "fx", []), this.each(function() {
                var e = !0,
                    t = null != o && o + "queueHooks",
                    n = k.timers,
                    i = Y.get(this);
                if (t) i[t] && i[t].stop && s(i[t]);
                else
                    for (t in i) i[t] && i[t].stop && gt.test(t) && s(i[t]);
                for (t = n.length; t--;) n[t].elem !== this || null != o && n[t].queue !== o || (n[t].anim.stop(r), e = !1, n.splice(t, 1));
                !e && r || k.dequeue(this, o)
            })
        },
        finish: function(s) {
            return !1 !== s && (s = s || "fx"), this.each(function() {
                var e, t = Y.get(this),
                    n = t[s + "queue"],
                    i = t[s + "queueHooks"],
                    o = k.timers,
                    r = n ? n.length : 0;
                for (t.finish = !0, k.queue(this, s, []), i && i.stop && i.stop.call(this, !0), e = o.length; e--;) o[e].elem === this && o[e].queue === s && (o[e].anim.stop(!0), o.splice(e, 1));
                for (e = 0; e < r; e++) n[e] && n[e].finish && n[e].finish.call(this);
                delete t.finish
            })
        }
    }), k.each(["toggle", "show", "hide"], function(e, i) {
        var o = k.fn[i];
        k.fn[i] = function(e, t, n) {
            return null == e || "boolean" == typeof e ? o.apply(this, arguments) : this.animate(wt(i, !0), e, t, n)
        }
    }), k.each({
        slideDown: wt("show"),
        slideUp: wt("hide"),
        slideToggle: wt("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(e, i) {
        k.fn[e] = function(e, t, n) {
            return this.animate(i, e, t, n)
        }
    }), k.timers = [], k.fx.tick = function() {
        var e, t = 0,
            n = k.timers;
        for (dt = Date.now(); t < n.length; t++)(e = n[t])() || n[t] !== e || n.splice(t--, 1);
        n.length || k.fx.stop(), dt = void 0
    }, k.fx.timer = function(e) {
        k.timers.push(e), k.fx.start()
    }, k.fx.interval = 13, k.fx.start = function() {
        pt || (pt = !0, vt())
    }, k.fx.stop = function() {
        pt = null
    }, k.fx.speeds = {
        slow: 600,
        fast: 200,
        _default: 400
    }, k.fn.delay = function(i, e) {
        return i = k.fx && k.fx.speeds[i] || i, e = e || "fx", this.queue(e, function(e, t) {
            var n = C.setTimeout(e, i);
            t.stop = function() {
                C.clearTimeout(n)
            }
        })
    }, ft = S.createElement("input"), ht = S.createElement("select").appendChild(S.createElement("option")), ft.type = "checkbox", y.checkOn = "" !== ft.value, y.optSelected = ht.selected, (ft = S.createElement("input")).value = "t", ft.type = "radio", y.radioValue = "t" === ft.value;
    var Tt, Ct = k.expr.attrHandle;
    k.fn.extend({
        attr: function(e, t) {
            return F(this, k.attr, e, t, 1 < arguments.length)
        },
        removeAttr: function(e) {
            return this.each(function() {
                k.removeAttr(this, e)
            })
        }
    }), k.extend({
        attr: function(e, t, n) {
            var i, o, r = e.nodeType;
            if (3 !== r && 8 !== r && 2 !== r) return void 0 === e.getAttribute ? k.prop(e, t, n) : (1 === r && k.isXMLDoc(e) || (o = k.attrHooks[t.toLowerCase()] || (k.expr.match.bool.test(t) ? Tt : void 0)), void 0 !== n ? null === n ? void k.removeAttr(e, t) : o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : (e.setAttribute(t, n + ""), n) : !(o && "get" in o && null !== (i = o.get(e, t))) && null == (i = k.find.attr(e, t)) ? void 0 : i)
        },
        attrHooks: {
            type: {
                set: function(e, t) {
                    if (!y.radioValue && "radio" === t && _(e, "input")) {
                        var n = e.value;
                        return e.setAttribute("type", t), n && (e.value = n), t
                    }
                }
            }
        },
        removeAttr: function(e, t) {
            var n, i = 0,
                o = t && t.match(P);
            if (o && 1 === e.nodeType)
                for (; n = o[i++];) e.removeAttribute(n)
        }
    }), Tt = {
        set: function(e, t, n) {
            return !1 === t ? k.removeAttr(e, n) : e.setAttribute(n, n), n
        }
    }, k.each(k.expr.match.bool.source.match(/\w+/g), function(e, t) {
        var s = Ct[t] || k.find.attr;
        Ct[t] = function(e, t, n) {
            var i, o, r = t.toLowerCase();
            return n || (o = Ct[r], Ct[r] = i, i = null != s(e, t, n) ? r : null, Ct[r] = o), i
        }
    });
    var St = /^(?:input|select|textarea|button)$/i,
        kt = /^(?:a|area)$/i;

    function At(e) {
        return (e.match(P) || []).join(" ")
    }

    function _t(e) {
        return e.getAttribute && e.getAttribute("class") || ""
    }

    function $t(e) {
        return Array.isArray(e) ? e : "string" == typeof e && e.match(P) || []
    }
    k.fn.extend({
        prop: function(e, t) {
            return F(this, k.prop, e, t, 1 < arguments.length)
        },
        removeProp: function(e) {
            return this.each(function() {
                delete this[k.propFix[e] || e]
            })
        }
    }), k.extend({
        prop: function(e, t, n) {
            var i, o, r = e.nodeType;
            if (3 !== r && 8 !== r && 2 !== r) return 1 === r && k.isXMLDoc(e) || (t = k.propFix[t] || t, o = k.propHooks[t]), void 0 !== n ? o && "set" in o && void 0 !== (i = o.set(e, n, t)) ? i : e[t] = n : o && "get" in o && null !== (i = o.get(e, t)) ? i : e[t]
        },
        propHooks: {
            tabIndex: {
                get: function(e) {
                    var t = k.find.attr(e, "tabindex");
                    return t ? parseInt(t, 10) : St.test(e.nodeName) || kt.test(e.nodeName) && e.href ? 0 : -1
                }
            }
        },
        propFix: {
            for: "htmlFor",
            class: "className"
        }
    }), y.optSelected || (k.propHooks.selected = {
        get: function(e) {
            var t = e.parentNode;
            return t && t.parentNode && t.parentNode.selectedIndex, null
        },
        set: function(e) {
            var t = e.parentNode;
            t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex)
        }
    }), k.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function() {
        k.propFix[this.toLowerCase()] = this
    }), k.fn.extend({
        addClass: function(t) {
            var e, n, i, o, r, s, a, l = 0;
            if (w(t)) return this.each(function(e) {
                k(this).addClass(t.call(this, e, _t(this)))
            });
            if ((e = $t(t)).length)
                for (; n = this[l++];)
                    if (o = _t(n), i = 1 === n.nodeType && " " + At(o) + " ") {
                        for (s = 0; r = e[s++];) i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                        o !== (a = At(i)) && n.setAttribute("class", a)
                    } return this
        },
        removeClass: function(t) {
            var e, n, i, o, r, s, a, l = 0;
            if (w(t)) return this.each(function(e) {
                k(this).removeClass(t.call(this, e, _t(this)))
            });
            if (!arguments.length) return this.attr("class", "");
            if ((e = $t(t)).length)
                for (; n = this[l++];)
                    if (o = _t(n), i = 1 === n.nodeType && " " + At(o) + " ") {
                        for (s = 0; r = e[s++];)
                            for (; - 1 < i.indexOf(" " + r + " ");) i = i.replace(" " + r + " ", " ");
                        o !== (a = At(i)) && n.setAttribute("class", a)
                    } return this
        },
        toggleClass: function(o, t) {
            var r = _typeof(o),
                s = "string" === r || Array.isArray(o);
            return "boolean" == typeof t && s ? t ? this.addClass(o) : this.removeClass(o) : w(o) ? this.each(function(e) {
                k(this).toggleClass(o.call(this, e, _t(this), t), t)
            }) : this.each(function() {
                var e, t, n, i;
                if (s)
                    for (t = 0, n = k(this), i = $t(o); e = i[t++];) n.hasClass(e) ? n.removeClass(e) : n.addClass(e);
                else void 0 !== o && "boolean" !== r || ((e = _t(this)) && Y.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", !e && !1 !== o && Y.get(this, "__className__") || ""))
            })
        },
        hasClass: function(e) {
            var t, n, i = 0;
            for (t = " " + e + " "; n = this[i++];)
                if (1 === n.nodeType && -1 < (" " + At(_t(n)) + " ").indexOf(t)) return !0;
            return !1
        }
    });
    var Et = /\r/g;
    k.fn.extend({
        val: function(n) {
            var i, e, o, t = this[0];
            return arguments.length ? (o = w(n), this.each(function(e) {
                var t;
                1 === this.nodeType && (null == (t = o ? n.call(this, e, k(this).val()) : n) ? t = "" : "number" == typeof t ? t += "" : Array.isArray(t) && (t = k.map(t, function(e) {
                    return null == e ? "" : e + ""
                })), (i = k.valHooks[this.type] || k.valHooks[this.nodeName.toLowerCase()]) && "set" in i && void 0 !== i.set(this, t, "value") || (this.value = t))
            })) : t ? (i = k.valHooks[t.type] || k.valHooks[t.nodeName.toLowerCase()]) && "get" in i && void 0 !== (e = i.get(t, "value")) ? e : "string" == typeof(e = t.value) ? e.replace(Et, "") : null == e ? "" : e : void 0
        }
    }), k.extend({
        valHooks: {
            option: {
                get: function(e) {
                    var t = k.find.attr(e, "value");
                    return null != t ? t : At(k.text(e))
                }
            },
            select: {
                get: function(e) {
                    var t, n, i, o = e.options,
                        r = e.selectedIndex,
                        s = "select-one" === e.type,
                        a = s ? null : [],
                        l = s ? r + 1 : o.length;
                    for (i = r < 0 ? l : s ? r : 0; i < l; i++)
                        if (((n = o[i]).selected || i === r) && !n.disabled && (!n.parentNode.disabled || !_(n.parentNode, "optgroup"))) {
                            if (t = k(n).val(), s) return t;
                            a.push(t)
                        } return a
                },
                set: function(e, t) {
                    for (var n, i, o = e.options, r = k.makeArray(t), s = o.length; s--;)((i = o[s]).selected = -1 < k.inArray(k.valHooks.option.get(i), r)) && (n = !0);
                    return n || (e.selectedIndex = -1), r
                }
            }
        }
    }), k.each(["radio", "checkbox"], function() {
        k.valHooks[this] = {
            set: function(e, t) {
                if (Array.isArray(t)) return e.checked = -1 < k.inArray(k(e).val(), t)
            }
        }, y.checkOn || (k.valHooks[this].get = function(e) {
            return null === e.getAttribute("value") ? "on" : e.value
        })
    }), y.focusin = "onfocusin" in C;

    function Dt(e) {
        e.stopPropagation()
    }
    var zt = /^(?:focusinfocus|focusoutblur)$/;
    k.extend(k.event, {
        trigger: function(e, t, n, i) {
            var o, r, s, a, l, c, u, d, p = [n || S],
                f = v.call(e, "type") ? e.type : e,
                h = v.call(e, "namespace") ? e.namespace.split(".") : [];
            if (r = d = s = n = n || S, 3 !== n.nodeType && 8 !== n.nodeType && !zt.test(f + k.event.triggered) && (-1 < f.indexOf(".") && (f = (h = f.split(".")).shift(), h.sort()), l = f.indexOf(":") < 0 && "on" + f, (e = e[k.expando] ? e : new k.Event(f, "object" == _typeof(e) && e)).isTrigger = i ? 2 : 3, e.namespace = h.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = n), t = null == t ? [e] : k.makeArray(t, [e]), u = k.event.special[f] || {}, i || !u.trigger || !1 !== u.trigger.apply(n, t))) {
                if (!i && !u.noBubble && !m(n)) {
                    for (a = u.delegateType || f, zt.test(a + f) || (r = r.parentNode); r; r = r.parentNode) p.push(r), s = r;
                    s === (n.ownerDocument || S) && p.push(s.defaultView || s.parentWindow || C)
                }
                for (o = 0;
                    (r = p[o++]) && !e.isPropagationStopped();) d = r, e.type = 1 < o ? a : u.bindType || f, (c = (Y.get(r, "events") || Object.create(null))[e.type] && Y.get(r, "handle")) && c.apply(r, t), (c = l && r[l]) && c.apply && G(r) && (e.result = c.apply(r, t), !1 === e.result && e.preventDefault());
                return e.type = f, i || e.isDefaultPrevented() || u._default && !1 !== u._default.apply(p.pop(), t) || !G(n) || l && w(n[f]) && !m(n) && ((s = n[l]) && (n[l] = null), k.event.triggered = f, e.isPropagationStopped() && d.addEventListener(f, Dt), n[f](), e.isPropagationStopped() && d.removeEventListener(f, Dt), k.event.triggered = void 0, s && (n[l] = s)), e.result
            }
        },
        simulate: function(e, t, n) {
            var i = k.extend(new k.Event, n, {
                type: e,
                isSimulated: !0
            });
            k.event.trigger(i, null, t)
        }
    }), k.fn.extend({
        trigger: function(e, t) {
            return this.each(function() {
                k.event.trigger(e, t, this)
            })
        },
        triggerHandler: function(e, t) {
            var n = this[0];
            if (n) return k.event.trigger(e, t, n, !0)
        }
    }), y.focusin || k.each({
        focus: "focusin",
        blur: "focusout"
    }, function(n, i) {
        function o(e) {
            k.event.simulate(i, e.target, k.event.fix(e))
        }
        k.event.special[i] = {
            setup: function() {
                var e = this.ownerDocument || this.document || this,
                    t = Y.access(e, i);
                t || e.addEventListener(n, o, !0), Y.access(e, i, (t || 0) + 1)
            },
            teardown: function() {
                var e = this.ownerDocument || this.document || this,
                    t = Y.access(e, i) - 1;
                t ? Y.access(e, i, t) : (e.removeEventListener(n, o, !0), Y.remove(e, i))
            }
        }
    });
    var Ot = C.location,
        Lt = {
            guid: Date.now()
        },
        It = /\?/;
    k.parseXML = function(e) {
        var t;
        if (!e || "string" != typeof e) return null;
        try {
            t = (new C.DOMParser).parseFromString(e, "text/xml")
        } catch (e) {
            t = void 0
        }
        return t && !t.getElementsByTagName("parsererror").length || k.error("Invalid XML: " + e), t
    };
    var Pt = /\[\]$/,
        Mt = /\r?\n/g,
        jt = /^(?:submit|button|image|reset|file)$/i,
        Nt = /^(?:input|select|textarea|keygen)/i;

    function qt(n, e, i, o) {
        var t;
        if (Array.isArray(e)) k.each(e, function(e, t) {
            i || Pt.test(n) ? o(n, t) : qt(n + "[" + ("object" == _typeof(t) && null != t ? e : "") + "]", t, i, o)
        });
        else if (i || "object" !== x(e)) o(n, e);
        else
            for (t in e) qt(n + "[" + t + "]", e[t], i, o)
    }
    k.param = function(e, t) {
        function n(e, t) {
            var n = w(t) ? t() : t;
            o[o.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n)
        }
        var i, o = [];
        if (null == e) return "";
        if (Array.isArray(e) || e.jquery && !k.isPlainObject(e)) k.each(e, function() {
            n(this.name, this.value)
        });
        else
            for (i in e) qt(i, e[i], t, n);
        return o.join("&")
    }, k.fn.extend({
        serialize: function() {
            return k.param(this.serializeArray())
        },
        serializeArray: function() {
            return this.map(function() {
                var e = k.prop(this, "elements");
                return e ? k.makeArray(e) : this
            }).filter(function() {
                var e = this.type;
                return this.name && !k(this).is(":disabled") && Nt.test(this.nodeName) && !jt.test(e) && (this.checked || !pe.test(e))
            }).map(function(e, t) {
                var n = k(this).val();
                return null == n ? null : Array.isArray(n) ? k.map(n, function(e) {
                    return {
                        name: t.name,
                        value: e.replace(Mt, "\r\n")
                    }
                }) : {
                    name: t.name,
                    value: n.replace(Mt, "\r\n")
                }
            }).get()
        }
    });
    var Ht = /%20/g,
        Rt = /#.*$/,
        Ft = /([?&])_=[^&]*/,
        Wt = /^(.*?):[ \t]*([^\r\n]*)$/gm,
        Ut = /^(?:GET|HEAD)$/,
        Bt = /^\/\//,
        Zt = {},
        Gt = {},
        Xt = "*/".concat("*"),
        Yt = S.createElement("a");

    function Kt(r) {
        return function(e, t) {
            "string" != typeof e && (t = e, e = "*");
            var n, i = 0,
                o = e.toLowerCase().match(P) || [];
            if (w(t))
                for (; n = o[i++];) "+" === n[0] ? (n = n.slice(1) || "*", (r[n] = r[n] || []).unshift(t)) : (r[n] = r[n] || []).push(t)
        }
    }

    function Vt(t, o, r, s) {
        var a = {},
            l = t === Gt;

        function c(e) {
            var i;
            return a[e] = !0, k.each(t[e] || [], function(e, t) {
                var n = t(o, r, s);
                return "string" != typeof n || l || a[n] ? l ? !(i = n) : void 0 : (o.dataTypes.unshift(n), c(n), !1)
            }), i
        }
        return c(o.dataTypes[0]) || !a["*"] && c("*")
    }

    function Qt(e, t) {
        var n, i, o = k.ajaxSettings.flatOptions || {};
        for (n in t) void 0 !== t[n] && ((o[n] ? e : i = i || {})[n] = t[n]);
        return i && k.extend(!0, e, i), e
    }
    Yt.href = Ot.href, k.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Ot.href,
            type: "GET",
            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ot.protocol),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": Xt,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            converters: {
                "* text": String,
                "text html": !0,
                "text json": JSON.parse,
                "text xml": k.parseXML
            },
            flatOptions: {
                url: !0,
                context: !0
            }
        },
        ajaxSetup: function(e, t) {
            return t ? Qt(Qt(e, k.ajaxSettings), t) : Qt(k.ajaxSettings, e)
        },
        ajaxPrefilter: Kt(Zt),
        ajaxTransport: Kt(Gt),
        ajax: function(e, t) {
            "object" == _typeof(e) && (t = e, e = void 0), t = t || {};
            var u, d, p, n, f, i, h, m, o, r, g = k.ajaxSetup({}, t),
                v = g.context || g,
                y = g.context && (v.nodeType || v.jquery) ? k(v) : k.event,
                w = k.Deferred(),
                b = k.Callbacks("once memory"),
                x = g.statusCode || {},
                s = {},
                a = {},
                l = "canceled",
                T = {
                    readyState: 0,
                    getResponseHeader: function(e) {
                        var t;
                        if (h) {
                            if (!n)
                                for (n = {}; t = Wt.exec(p);) n[t[1].toLowerCase() + " "] = (n[t[1].toLowerCase() + " "] || []).concat(t[2]);
                            t = n[e.toLowerCase() + " "]
                        }
                        return null == t ? null : t.join(", ")
                    },
                    getAllResponseHeaders: function() {
                        return h ? p : null
                    },
                    setRequestHeader: function(e, t) {
                        return null == h && (e = a[e.toLowerCase()] = a[e.toLowerCase()] || e, s[e] = t), this
                    },
                    overrideMimeType: function(e) {
                        return null == h && (g.mimeType = e), this
                    },
                    statusCode: function(e) {
                        var t;
                        if (e)
                            if (h) T.always(e[T.status]);
                            else
                                for (t in e) x[t] = [x[t], e[t]];
                        return this
                    },
                    abort: function(e) {
                        var t = e || l;
                        return u && u.abort(t), c(0, t), this
                    }
                };
            if (w.promise(T), g.url = ((e || g.url || Ot.href) + "").replace(Bt, Ot.protocol + "//"), g.type = t.method || t.type || g.method || g.type, g.dataTypes = (g.dataType || "*").toLowerCase().match(P) || [""], null == g.crossDomain) {
                i = S.createElement("a");
                try {
                    i.href = g.url, i.href = i.href, g.crossDomain = Yt.protocol + "//" + Yt.host != i.protocol + "//" + i.host
                } catch (e) {
                    g.crossDomain = !0
                }
            }
            if (g.data && g.processData && "string" != typeof g.data && (g.data = k.param(g.data, g.traditional)), Vt(Zt, g, t, T), h) return T;
            for (o in (m = k.event && g.global) && 0 == k.active++ && k.event.trigger("ajaxStart"), g.type = g.type.toUpperCase(), g.hasContent = !Ut.test(g.type), d = g.url.replace(Rt, ""), g.hasContent ? g.data && g.processData && 0 === (g.contentType || "").indexOf("application/x-www-form-urlencoded") && (g.data = g.data.replace(Ht, "+")) : (r = g.url.slice(d.length), g.data && (g.processData || "string" == typeof g.data) && (d += (It.test(d) ? "&" : "?") + g.data, delete g.data), !1 === g.cache && (d = d.replace(Ft, "$1"), r = (It.test(d) ? "&" : "?") + "_=" + Lt.guid++ + r), g.url = d + r), g.ifModified && (k.lastModified[d] && T.setRequestHeader("If-Modified-Since", k.lastModified[d]), k.etag[d] && T.setRequestHeader("If-None-Match", k.etag[d])), (g.data && g.hasContent && !1 !== g.contentType || t.contentType) && T.setRequestHeader("Content-Type", g.contentType), T.setRequestHeader("Accept", g.dataTypes[0] && g.accepts[g.dataTypes[0]] ? g.accepts[g.dataTypes[0]] + ("*" !== g.dataTypes[0] ? ", " + Xt + "; q=0.01" : "") : g.accepts["*"]), g.headers) T.setRequestHeader(o, g.headers[o]);
            if (g.beforeSend && (!1 === g.beforeSend.call(v, T, g) || h)) return T.abort();
            if (l = "abort", b.add(g.complete), T.done(g.success), T.fail(g.error), u = Vt(Gt, g, t, T)) {
                if (T.readyState = 1, m && y.trigger("ajaxSend", [T, g]), h) return T;
                g.async && 0 < g.timeout && (f = C.setTimeout(function() {
                    T.abort("timeout")
                }, g.timeout));
                try {
                    h = !1, u.send(s, c)
                } catch (e) {
                    if (h) throw e;
                    c(-1, e)
                }
            } else c(-1, "No Transport");

            function c(e, t, n, i) {
                var o, r, s, a, l, c = t;
                h || (h = !0, f && C.clearTimeout(f), u = void 0, p = i || "", T.readyState = 0 < e ? 4 : 0, o = 200 <= e && e < 300 || 304 === e, n && (a = function(e, t, n) {
                    for (var i, o, r, s, a = e.contents, l = e.dataTypes;
                        "*" === l[0];) l.shift(), void 0 === i && (i = e.mimeType || t.getResponseHeader("Content-Type"));
                    if (i)
                        for (o in a)
                            if (a[o] && a[o].test(i)) {
                                l.unshift(o);
                                break
                            } if (l[0] in n) r = l[0];
                    else {
                        for (o in n) {
                            if (!l[0] || e.converters[o + " " + l[0]]) {
                                r = o;
                                break
                            }
                            s = s || o
                        }
                        r = r || s
                    }
                    if (r) return r !== l[0] && l.unshift(r), n[r]
                }(g, T, n)), !o && -1 < k.inArray("script", g.dataTypes) && (g.converters["text script"] = function() {}), a = function(e, t, n, i) {
                    var o, r, s, a, l, c = {},
                        u = e.dataTypes.slice();
                    if (u[1])
                        for (s in e.converters) c[s.toLowerCase()] = e.converters[s];
                    for (r = u.shift(); r;)
                        if (e.responseFields[r] && (n[e.responseFields[r]] = t), !l && i && e.dataFilter && (t = e.dataFilter(t, e.dataType)), l = r, r = u.shift())
                            if ("*" === r) r = l;
                            else if ("*" !== l && l !== r) {
                        if (!(s = c[l + " " + r] || c["* " + r]))
                            for (o in c)
                                if ((a = o.split(" "))[1] === r && (s = c[l + " " + a[0]] || c["* " + a[0]])) {
                                    !0 === s ? s = c[o] : !0 !== c[o] && (r = a[0], u.unshift(a[1]));
                                    break
                                } if (!0 !== s)
                            if (s && e.throws) t = s(t);
                            else try {
                                t = s(t)
                            } catch (e) {
                                return {
                                    state: "parsererror",
                                    error: s ? e : "No conversion from " + l + " to " + r
                                }
                            }
                    }
                    return {
                        state: "success",
                        data: t
                    }
                }(g, a, T, o), o ? (g.ifModified && ((l = T.getResponseHeader("Last-Modified")) && (k.lastModified[d] = l), (l = T.getResponseHeader("etag")) && (k.etag[d] = l)), 204 === e || "HEAD" === g.type ? c = "nocontent" : 304 === e ? c = "notmodified" : (c = a.state, r = a.data, o = !(s = a.error))) : (s = c, !e && c || (c = "error", e < 0 && (e = 0))), T.status = e, T.statusText = (t || c) + "", o ? w.resolveWith(v, [r, c, T]) : w.rejectWith(v, [T, c, s]), T.statusCode(x), x = void 0, m && y.trigger(o ? "ajaxSuccess" : "ajaxError", [T, g, o ? r : s]), b.fireWith(v, [T, c]), m && (y.trigger("ajaxComplete", [T, g]), --k.active || k.event.trigger("ajaxStop")))
            }
            return T
        },
        getJSON: function(e, t, n) {
            return k.get(e, t, n, "json")
        },
        getScript: function(e, t) {
            return k.get(e, void 0, t, "script")
        }
    }), k.each(["get", "post"], function(e, o) {
        k[o] = function(e, t, n, i) {
            return w(t) && (i = i || n, n = t, t = void 0), k.ajax(k.extend({
                url: e,
                type: o,
                dataType: i,
                data: t,
                success: n
            }, k.isPlainObject(e) && e))
        }
    }), k.ajaxPrefilter(function(e) {
        var t;
        for (t in e.headers) "content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "")
    }), k._evalUrl = function(e, t, n) {
        return k.ajax({
            url: e,
            type: "GET",
            dataType: "script",
            cache: !0,
            async: !1,
            global: !1,
            converters: {
                "text script": function() {}
            },
            dataFilter: function(e) {
                k.globalEval(e, t, n)
            }
        })
    }, k.fn.extend({
        wrapAll: function(e) {
            var t;
            return this[0] && (w(e) && (e = e.call(this[0])), t = k(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                return e
            }).append(this)), this
        },
        wrapInner: function(n) {
            return w(n) ? this.each(function(e) {
                k(this).wrapInner(n.call(this, e))
            }) : this.each(function() {
                var e = k(this),
                    t = e.contents();
                t.length ? t.wrapAll(n) : e.append(n)
            })
        },
        wrap: function(t) {
            var n = w(t);
            return this.each(function(e) {
                k(this).wrapAll(n ? t.call(this, e) : t)
            })
        },
        unwrap: function(e) {
            return this.parent(e).not("body").each(function() {
                k(this).replaceWith(this.childNodes)
            }), this
        }
    }), k.expr.pseudos.hidden = function(e) {
        return !k.expr.pseudos.visible(e)
    }, k.expr.pseudos.visible = function(e) {
        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
    }, k.ajaxSettings.xhr = function() {
        try {
            return new C.XMLHttpRequest
        } catch (e) {}
    };
    var Jt = {
            0: 200,
            1223: 204
        },
        en = k.ajaxSettings.xhr();
    y.cors = !!en && "withCredentials" in en, y.ajax = en = !!en, k.ajaxTransport(function(o) {
        var r, s;
        if (y.cors || en && !o.crossDomain) return {
            send: function(e, t) {
                var n, i = o.xhr();
                if (i.open(o.type, o.url, o.async, o.username, o.password), o.xhrFields)
                    for (n in o.xhrFields) i[n] = o.xhrFields[n];
                for (n in o.mimeType && i.overrideMimeType && i.overrideMimeType(o.mimeType), o.crossDomain || e["X-Requested-With"] || (e["X-Requested-With"] = "XMLHttpRequest"), e) i.setRequestHeader(n, e[n]);
                r = function(e) {
                    return function() {
                        r && (r = s = i.onload = i.onerror = i.onabort = i.ontimeout = i.onreadystatechange = null, "abort" === e ? i.abort() : "error" === e ? "number" != typeof i.status ? t(0, "error") : t(i.status, i.statusText) : t(Jt[i.status] || i.status, i.statusText, "text" !== (i.responseType || "text") || "string" != typeof i.responseText ? {
                            binary: i.response
                        } : {
                            text: i.responseText
                        }, i.getAllResponseHeaders()))
                    }
                }, i.onload = r(), s = i.onerror = i.ontimeout = r("error"), void 0 !== i.onabort ? i.onabort = s : i.onreadystatechange = function() {
                    4 === i.readyState && C.setTimeout(function() {
                        r && s()
                    })
                }, r = r("abort");
                try {
                    i.send(o.hasContent && o.data || null)
                } catch (e) {
                    if (r) throw e
                }
            },
            abort: function() {
                r && r()
            }
        }
    }), k.ajaxPrefilter(function(e) {
        e.crossDomain && (e.contents.script = !1)
    }), k.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(e) {
                return k.globalEval(e), e
            }
        }
    }), k.ajaxPrefilter("script", function(e) {
        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
    }), k.ajaxTransport("script", function(n) {
        var i, o;
        if (n.crossDomain || n.scriptAttrs) return {
            send: function(e, t) {
                i = k("<script>").attr(n.scriptAttrs || {}).prop({
                    charset: n.scriptCharset,
                    src: n.url
                }).on("load error", o = function(e) {
                    i.remove(), o = null, e && t("error" === e.type ? 404 : 200, e.type)
                }), S.head.appendChild(i[0])
            },
            abort: function() {
                o && o()
            }
        }
    });
    var tn, nn = [],
        on = /(=)\?(?=&|$)|\?\?/;
    k.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var e = nn.pop() || k.expando + "_" + Lt.guid++;
            return this[e] = !0, e
        }
    }), k.ajaxPrefilter("json jsonp", function(e, t, n) {
        var i, o, r, s = !1 !== e.jsonp && (on.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && on.test(e.data) && "data");
        if (s || "jsonp" === e.dataTypes[0]) return i = e.jsonpCallback = w(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, s ? e[s] = e[s].replace(on, "$1" + i) : !1 !== e.jsonp && (e.url += (It.test(e.url) ? "&" : "?") + e.jsonp + "=" + i), e.converters["script json"] = function() {
            return r || k.error(i + " was not called"), r[0]
        }, e.dataTypes[0] = "json", o = C[i], C[i] = function() {
            r = arguments
        }, n.always(function() {
            void 0 === o ? k(C).removeProp(i) : C[i] = o, e[i] && (e.jsonpCallback = t.jsonpCallback, nn.push(i)), r && w(o) && o(r[0]), r = o = void 0
        }), "script"
    }), y.createHTMLDocument = ((tn = S.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === tn.childNodes.length), k.parseHTML = function(e, t, n) {
        return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (y.createHTMLDocument ? ((i = (t = S.implementation.createHTMLDocument("")).createElement("base")).href = S.location.href, t.head.appendChild(i)) : t = S), r = !n && [], (o = $.exec(e)) ? [t.createElement(o[1])] : (o = we([e], t, r), r && r.length && k(r).remove(), k.merge([], o.childNodes)));
        var i, o, r
    }, k.fn.load = function(e, t, n) {
        var i, o, r, s = this,
            a = e.indexOf(" ");
        return -1 < a && (i = At(e.slice(a)), e = e.slice(0, a)), w(t) ? (n = t, t = void 0) : t && "object" == _typeof(t) && (o = "POST"), 0 < s.length && k.ajax({
            url: e,
            type: o || "GET",
            dataType: "html",
            data: t
        }).done(function(e) {
            r = arguments, s.html(i ? k("<div>").append(k.parseHTML(e)).find(i) : e)
        }).always(n && function(e, t) {
            s.each(function() {
                n.apply(this, r || [e.responseText, t, e])
            })
        }), this
    }, k.expr.pseudos.animated = function(t) {
        return k.grep(k.timers, function(e) {
            return t === e.elem
        }).length
    }, k.offset = {
        setOffset: function(e, t, n) {
            var i, o, r, s, a, l, c = k.css(e, "position"),
                u = k(e),
                d = {};
            "static" === c && (e.style.position = "relative"), a = u.offset(), r = k.css(e, "top"), l = k.css(e, "left"), o = ("absolute" === c || "fixed" === c) && -1 < (r + l).indexOf("auto") ? (s = (i = u.position()).top, i.left) : (s = parseFloat(r) || 0, parseFloat(l) || 0), w(t) && (t = t.call(e, n, k.extend({}, a))), null != t.top && (d.top = t.top - a.top + s), null != t.left && (d.left = t.left - a.left + o), "using" in t ? t.using.call(e, d) : ("number" == typeof d.top && (d.top += "px"), "number" == typeof d.left && (d.left += "px"), u.css(d))
        }
    }, k.fn.extend({
        offset: function(t) {
            if (arguments.length) return void 0 === t ? this : this.each(function(e) {
                k.offset.setOffset(this, t, e)
            });
            var e, n, i = this[0];
            return i ? i.getClientRects().length ? (e = i.getBoundingClientRect(), n = i.ownerDocument.defaultView, {
                top: e.top + n.pageYOffset,
                left: e.left + n.pageXOffset
            }) : {
                top: 0,
                left: 0
            } : void 0
        },
        position: function() {
            if (this[0]) {
                var e, t, n, i = this[0],
                    o = {
                        top: 0,
                        left: 0
                    };
                if ("fixed" === k.css(i, "position")) t = i.getBoundingClientRect();
                else {
                    for (t = this.offset(), n = i.ownerDocument, e = i.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === k.css(e, "position");) e = e.parentNode;
                    e && e !== i && 1 === e.nodeType && ((o = k(e).offset()).top += k.css(e, "borderTopWidth", !0), o.left += k.css(e, "borderLeftWidth", !0))
                }
                return {
                    top: t.top - o.top - k.css(i, "marginTop", !0),
                    left: t.left - o.left - k.css(i, "marginLeft", !0)
                }
            }
        },
        offsetParent: function() {
            return this.map(function() {
                for (var e = this.offsetParent; e && "static" === k.css(e, "position");) e = e.offsetParent;
                return e || ie
            })
        }
    }), k.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(t, o) {
        var r = "pageYOffset" === o;
        k.fn[t] = function(e) {
            return F(this, function(e, t, n) {
                var i;
                if (m(e) ? i = e : 9 === e.nodeType && (i = e.defaultView), void 0 === n) return i ? i[o] : e[t];
                i ? i.scrollTo(r ? i.pageXOffset : n, r ? n : i.pageYOffset) : e[t] = n
            }, t, e, arguments.length)
        }
    }), k.each(["top", "left"], function(e, n) {
        k.cssHooks[n] = Ke(y.pixelPosition, function(e, t) {
            if (t) return t = Ye(e, n), Ze.test(t) ? k(e).position()[n] + "px" : t
        })
    }), k.each({
        Height: "height",
        Width: "width"
    }, function(s, a) {
        k.each({
            padding: "inner" + s,
            content: a,
            "": "outer" + s
        }, function(i, r) {
            k.fn[r] = function(e, t) {
                var n = arguments.length && (i || "boolean" != typeof e),
                    o = i || (!0 === e || !0 === t ? "margin" : "border");
                return F(this, function(e, t, n) {
                    var i;
                    return m(e) ? 0 === r.indexOf("outer") ? e["inner" + s] : e.document.documentElement["client" + s] : 9 === e.nodeType ? (i = e.documentElement, Math.max(e.body["scroll" + s], i["scroll" + s], e.body["offset" + s], i["offset" + s], i["client" + s])) : void 0 === n ? k.css(e, t, o) : k.style(e, t, n, o)
                }, a, n ? e : void 0, n)
            }
        })
    }), k.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function(e, t) {
        k.fn[t] = function(e) {
            return this.on(t, e)
        }
    }), k.fn.extend({
        bind: function(e, t, n) {
            return this.on(e, null, t, n)
        },
        unbind: function(e, t) {
            return this.off(e, null, t)
        },
        delegate: function(e, t, n, i) {
            return this.on(t, e, n, i)
        },
        undelegate: function(e, t, n) {
            return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n)
        },
        hover: function(e, t) {
            return this.mouseenter(e).mouseleave(t || e)
        }
    }), k.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, n) {
        k.fn[n] = function(e, t) {
            return 0 < arguments.length ? this.on(n, null, e, t) : this.trigger(n)
        }
    });
    var rn = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
    k.proxy = function(e, t) {
        var n, i, o;
        if ("string" == typeof t && (n = e[t], t = e, e = n), w(e)) return i = a.call(arguments, 2), (o = function() {
            return e.apply(t || this, i.concat(a.call(arguments)))
        }).guid = e.guid = e.guid || k.guid++, o
    }, k.holdReady = function(e) {
        e ? k.readyWait++ : k.ready(!0)
    }, k.isArray = Array.isArray, k.parseJSON = JSON.parse, k.nodeName = _, k.isFunction = w, k.isWindow = m, k.camelCase = Z, k.type = x, k.now = Date.now, k.isNumeric = function(e) {
        var t = k.type(e);
        return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e))
    }, k.trim = function(e) {
        return null == e ? "" : (e + "").replace(rn, "")
    }, "function" == typeof define && define.amd && define("jquery", [], function() {
        return k
    });
    var sn = C.jQuery,
        an = C.$;
    return k.noConflict = function(e) {
        return C.$ === k && (C.$ = an), e && C.jQuery === k && (C.jQuery = sn), k
    }, void 0 === e && (C.jQuery = C.$ = k), k
}), theme.jQuery = $,
    function(p) {
        var e, t, n, i, o, r, s, a, l, c, u, d, f, h, m, g, v, y, w, b, x, T, C, S, k, A, _, $, E, D, z, O, L, I, P, M, j, N, q, H, R, F, W, U, B, Z, G, X, Y, K, V, Q, J, ee, te, ne, ie, oe, re, se, ae, le, ce, ue, de, pe, fe, he, me, ge, ve, ye, we, be, xe, Te;
        p = jQuery = p;

        function Ce() {
            i(n.lazySizes), n.removeEventListener("lazyunveilread", Ce, !0)
        }

        function Se() {
            r(o.lazySizes), o.removeEventListener("lazyunveilread", Se, !0)
        }

        function ke() {
            a(s.lazySizes), s.removeEventListener("lazyunveilread", ke, !0)
        }

        function Ae() {
            c(l.lazySizes), l.removeEventListener("lazyunveilread", Ae, !0)
        }

        function _e() {
            d(u.lazySizes), u.removeEventListener("lazyunveilread", _e, !0)
        }

        function $e(e, t, n) {
            var i = y.createElement(e);
            return t && (i.id = re + t), n && (i.style.cssText = n), v(i)
        }

        function Ee() {
            return w.innerHeight ? w.innerHeight : v(w).height()
        }

        function De(e, n) {
            n !== Object(n) && (n = {}), this.cache = {}, this.el = e, this.value = function(e) {
                var t;
                return void 0 === this.cache[e] && (void 0 !== (t = v(this.el).attr("data-cbox-" + e)) ? this.cache[e] = t : void 0 !== n[e] ? this.cache[e] = n[e] : void 0 !== ie[e] && (this.cache[e] = ie[e])), this.cache[e]
            }, this.get = function(e) {
                var t = this.value(e);
                return v.isFunction(t) ? t.call(this.el, this) : t
            }
        }

        function ze(e) {
            var t = $.length,
                n = (B + e) % t;
            return n < 0 ? t + n : n
        }

        function Oe(e, t) {
            return Math.round((/%/.test(e) ? ("x" === t ? E.width() : Ee()) / 100 : 1) * parseInt(e, 10))
        }

        function Le(e, t) {
            return e.get("photo") || e.get("photoRegex").test(t)
        }

        function Ie(e, t) {
            return e.get("retinaUrl") && 1 < w.devicePixelRatio ? t.replace(e.get("photoRegex"), e.get("retinaSuffix")) : t
        }

        function Pe(e) {
            "contains" in x[0] && !x[0].contains(e.target) && e.target !== b[0] && (e.stopPropagation(), x.focus())
        }

        function Me(e) {
            Me.str !== e && (x.add(b).removeClass(Me.str).addClass(e), Me.str = e)
        }

        function je(e) {
            v(y).trigger(e), fe.triggerHandler(e)
        }

        function Ne(e) {
            var t, n;
            if (!Y) {
                if (t = v(e).data(oe), H = new De(e, t), n = H.get("rel"), B = 0, n && !1 !== n && "nofollow" !== n ? ($ = v("." + se).filter(function() {
                        return new De(this, v.data(this, oe)).get("rel") === n
                    }), -1 === (B = $.index(H.el)) && ($ = $.add(H.el), B = $.length - 1)) : $ = v(H.el), !G) {
                    G = X = !0, Me(H.get("className")), x.css({
                        visibility: "hidden",
                        display: "block",
                        opacity: ""
                    }), D = $e(he, "LoadedContent", "width:0; height:0; overflow:hidden; visibility:hidden"), C.css({
                        width: "",
                        height: ""
                    }).append(D), R = S.height() + _.height() + C.outerHeight(!0) - C.height(), F = k.width() + A.width() + C.outerWidth(!0) - C.width(), W = D.outerHeight(!0), U = D.outerWidth(!0);
                    var i = Oe(H.get("initialWidth"), "x"),
                        o = Oe(H.get("initialHeight"), "y"),
                        r = H.get("maxWidth"),
                        s = H.get("maxHeight");
                    H.w = Math.max((!1 !== r ? Math.min(i, Oe(r, "x")) : i) - U - F, 0), H.h = Math.max((!1 !== s ? Math.min(o, Oe(s, "y")) : o) - W - R, 0), D.css({
                        width: "",
                        height: H.h
                    }), V.position(), je(ae), H.get("onOpen"), q.add(L).hide(), x.focus(), H.get("trapFocus") && y.addEventListener && (y.addEventListener("focus", Pe, !0), fe.one(de, function() {
                        y.removeEventListener("focus", Pe, !0)
                    })), H.get("returnFocus") && fe.one(de, function() {
                        v(H.el).focus()
                    })
                }
                var a = parseFloat(H.get("opacity"));
                b.css({
                        opacity: a == a ? a : "",
                        cursor: H.get("overlayClose") ? "pointer" : "",
                        visibility: "visible"
                    }).show(), H.get("closeButton") ? N.html(H.get("close")).appendTo(C) : N.appendTo("<div/>"),
                    function() {
                        var e, t, n, i = V.prep,
                            o = ++me;
                        if (Z = !(X = !0), je(pe), je(le), H.get("onLoad"), H.h = H.get("height") ? Oe(H.get("height"), "y") - W - R : H.get("innerHeight") && Oe(H.get("innerHeight"), "y"), H.w = H.get("width") ? Oe(H.get("width"), "x") - U - F : H.get("innerWidth") && Oe(H.get("innerWidth"), "x"), H.mw = H.w, H.mh = H.h, H.get("maxWidth") && (H.mw = Oe(H.get("maxWidth"), "x") - U - F, H.mw = H.w && H.w < H.mw ? H.w : H.mw), H.get("maxHeight") && (H.mh = Oe(H.get("maxHeight"), "y") - W - R, H.mh = H.h && H.h < H.mh ? H.h : H.mh), e = H.get("href"), K = setTimeout(function() {
                                O.show()
                            }, 100), H.get("inline")) {
                            var r = v(e).eq(0);
                            n = v("<div>").hide().insertBefore(r), fe.one(pe, function() {
                                n.replaceWith(r)
                            }), i(r)
                        } else H.get("iframe") ? i(" ") : H.get("html") ? i(H.get("html")) : Le(H, e) ? (e = Ie(H, e), Z = H.get("createImg"), v(Z).addClass(re + "Photo").bind("error." + re, function() {
                            i($e(he, "Error").html(H.get("imgError")))
                        }).one("load", function() {
                            o === me && setTimeout(function() {
                                var e;
                                H.get("retinaImage") && 1 < w.devicePixelRatio && (Z.height = Z.height / w.devicePixelRatio, Z.width = Z.width / w.devicePixelRatio), H.get("scalePhotos") && (t = function() {
                                    Z.height -= Z.height * e, Z.width -= Z.width * e
                                }, H.mw && Z.width > H.mw && (e = (Z.width - H.mw) / Z.width, t()), H.mh && Z.height > H.mh && (e = (Z.height - H.mh) / Z.height, t())), H.h && (Z.style.marginTop = Math.max(H.mh - Z.height, 0) / 2 + "px"), $[1] && (H.get("loop") || $[B + 1]) && (Z.style.cursor = "pointer", v(Z).bind("click." + re, function() {
                                    V.next()
                                })), Z.style.width = Z.width + "px", Z.style.height = Z.height + "px", i(Z)
                            }, 1)
                        }), Z.src = e) : e && z.load(e, H.get("data"), function(e, t) {
                            o === me && i("error" === t ? $e(he, "Error").html(H.get("xhrError")) : v(this).contents())
                        })
                    }()
            }
        }

        function qe() {
            x || (Q = !1, E = v(w), x = $e(he).attr({
                id: oe,
                class: !1 === v.support.opacity ? re + "IE" : "",
                role: "dialog",
                tabindex: "-1"
            }).hide(), b = $e(he, "Overlay").hide(), O = v([$e(he, "LoadingOverlay")[0], $e(he, "LoadingGraphic")[0]]), T = $e(he, "Wrapper"), C = $e(he, "Content").append(L = $e(he, "Title"), I = $e(he, "Current"), j = v('<button type="button" aria-label="' + theme.strings.previous + '"/>').attr({
                id: re + "Previous"
            }), M = v('<button type="button" aria-label="' + theme.strings.next + '"/>').attr({
                id: re + "Next"
            }), P = v('<button type="button" aria-label="' + theme.strings.slideshow + '"/>').attr({
                id: re + "Slideshow"
            }), O), N = v('<button type="button" aria-label="' + theme.strings.close + '"/>').attr({
                id: re + "Close"
            }), T.append($e(he).append($e(he, "TopLeft"), S = $e(he, "TopCenter"), $e(he, "TopRight")), $e(he, !1, "clear:left").append(k = $e(he, "MiddleLeft"), C, A = $e(he, "MiddleRight")), $e(he, !1, "clear:left").append($e(he, "BottomLeft"), _ = $e(he, "BottomCenter"), $e(he, "BottomRight"))).find("div div").css({
                float: "left"
            }), z = $e(he, !1, "position:absolute; width:9999px; visibility:hidden; display:none; max-width:none;"), q = M.add(j).add(I).add(P)), y.body && !x.parent().length && v(y.body).append(b, x.append(T, z))
        }

        function He() {
            clearTimeout(ee)
        }

        function Re() {
            (H.get("loop") || $[B + 1]) && (He(), ee = setTimeout(V.next, H.get("slideshowSpeed")))
        }

        function Fe() {
            P.html(H.get("slideshowStop")).unbind(ne).one(ne, We), fe.bind(ce, Re).bind(le, He), x.removeClass(te + "off").addClass(te + "on")
        }

        function We() {
            He(), fe.unbind(ce, Re).unbind(le, He), P.html(H.get("slideshowStart")).unbind(ne).one(ne, function() {
                V.next(), Fe()
            }), x.removeClass(te + "on").addClass(te + "off")
        }

        function Ue() {
            J = !1, P.hide(), He(), fe.unbind(ce, Re).unbind(le, He), x.removeClass(te + "off " + te + "on")
        }! function(p, f, h) {
            function m(e, t) {
                return _typeof(e) === t
            }

            function g(e) {
                return "function" != typeof f.createElement ? f.createElement(e) : b ? f.createElementNS.call(f, "http://www.w3.org/2000/svg", e) : f.createElement.apply(f, arguments)
            }

            function v(e, t, n, i) {
                var o, r, s, a, l, c = "modernizr",
                    u = g("div"),
                    d = ((l = f.body) || ((l = g(b ? "svg" : "body")).fake = !0), l);
                if (parseInt(n, 10))
                    for (; n--;)(s = g("div")).id = i ? i[n] : c + (n + 1), u.appendChild(s);
                return (o = g("style")).type = "text/css", o.id = "s" + c, (d.fake ? d : u).appendChild(o), d.appendChild(u), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(f.createTextNode(e)), u.id = c, d.fake && (d.style.background = "", d.style.overflow = "hidden", a = w.style.overflow, w.style.overflow = "hidden", w.appendChild(d)), r = t(u, e), d.fake ? (d.parentNode.removeChild(d), w.style.overflow = a, w.offsetHeight) : u.parentNode.removeChild(u), !!r
            }

            function a(e, t) {
                return function() {
                    return e.apply(t, arguments)
                }
            }

            function y(e) {
                return e.replace(/([A-Z])/g, function(e, t) {
                    return "-" + t.toLowerCase()
                }).replace(/^ms-/, "-ms-")
            }

            function l(e, t, n, i) {
                function o() {
                    s && (delete k.style, delete k.modElem)
                }
                if (i = !m(i, "undefined") && i, !m(n, "undefined")) {
                    var r = function(e, t) {
                        var n = e.length;
                        if ("CSS" in p && "supports" in p.CSS) {
                            for (; n--;)
                                if (p.CSS.supports(y(e[n]), t)) return !0;
                            return !1
                        }
                        if ("CSSSupportsRule" in p) {
                            for (var i = []; n--;) i.push("(" + y(e[n]) + ":" + t + ")");
                            return v("@supports (" + (i = i.join(" or ")) + ") { #modernizr { position: absolute; } }", function(e) {
                                return "absolute" == getComputedStyle(e, null).position
                            })
                        }
                        return h
                    }(e, n);
                    if (!m(r, "undefined")) return r
                }
                for (var s, a, l, c, u, d = ["modernizr", "tspan", "samp"]; !k.style && d.length;) s = !0, k.modElem = g(d.shift()), k.style = k.modElem.style;
                for (l = e.length, a = 0; a < l; a++)
                    if (c = e[a], u = k.style[c], ~("" + c).indexOf("-") && (c = c.replace(/([a-z])-([a-z])/g, function(e, t, n) {
                            return t + n.toUpperCase()
                        }).replace(/^-/, "")), k.style[c] !== h) {
                        if (i || m(n, "undefined")) return o(), "pfx" != t || c;
                        try {
                            k.style[c] = n
                        } catch (e) {}
                        if (k.style[c] != u) return o(), "pfx" != t || c
                    } return o(), !1
            }

            function i(e, t, n, i, o) {
                var r = e.charAt(0).toUpperCase() + e.slice(1),
                    s = (e + " " + T.join(r + " ") + r).split(" ");
                return m(t, "string") || m(t, "undefined") ? l(s, t, i, o) : function(e, t, n) {
                    var i;
                    for (var o in e)
                        if (e[o] in t) return !1 === n ? e[o] : m(i = t[e[o]], "function") ? a(i, n || t) : i;
                    return !1
                }(s = (e + " " + x.join(r + " ") + r).split(" "), t, n)
            }

            function o(e, t, n) {
                return i(e, h, h, t, n)
            }
            var c = [],
                u = [],
                e = {
                    _version: "3.3.1",
                    _config: {
                        classPrefix: "",
                        enableClasses: !0,
                        enableJSClass: !0,
                        usePrefixes: !0
                    },
                    _q: [],
                    on: function(e, t) {
                        var n = this;
                        setTimeout(function() {
                            t(n[e])
                        }, 0)
                    },
                    addTest: function(e, t, n) {
                        u.push({
                            name: e,
                            fn: t,
                            options: n
                        })
                    },
                    addAsyncTest: function(e) {
                        u.push({
                            name: null,
                            fn: e
                        })
                    }
                },
                d = function() {};
            d.prototype = e, (d = new d).addTest("svg", !!f.createElementNS && !!f.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);
            var n = e._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];
            e._prefixes = n;
            var w = f.documentElement,
                b = "svg" === w.nodeName.toLowerCase(),
                t = "Moz O ms Webkit",
                x = e._config.usePrefixes ? t.toLowerCase().split(" ") : [];
            e._domPrefixes = x;
            var r = "CSS" in p && "supports" in p.CSS,
                s = "supportsCSS" in p;
            d.addTest("supports", r || s), d.addTest("placeholder", "placeholder" in g("input") && "placeholder" in g("textarea"));
            var T = e._config.usePrefixes ? t.split(" ") : [];
            e._cssomPrefixes = T;
            var C = e.testStyles = v;
            d.addTest("touchevents", function() {
                var t;
                if ("ontouchstart" in p || p.DocumentTouch && f instanceof DocumentTouch) t = !0;
                else {
                    var e = ["@media (", n.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");
                    C(e, function(e) {
                        t = 9 === e.offsetTop
                    })
                }
                return t
            });
            var S = {
                elem: g("modernizr")
            };
            d._q.push(function() {
                delete S.elem
            });
            var k = {
                style: S.elem.style
            };
            d._q.unshift(function() {
                    delete k.style
                }), e.testProp = function(e, t, n) {
                    return l([e], h, t, n)
                }, e.testAllProps = i, e.testAllProps = o, d.addTest("csstransforms", function() {
                    return -1 === navigator.userAgent.indexOf("Android 2.") && o("transform", "scale(1)", !0)
                }), d.addTest("csstransforms3d", function() {
                    var t = !!o("perspective", "1px", !0),
                        e = d._config.usePrefixes;
                    if (t && (!e || "webkitPerspective" in w.style)) {
                        var n;
                        d.supports ? n = "@supports (perspective: 1px)" : (n = "@media (transform-3d)", e && (n += ",(-webkit-transform-3d)")), C("#modernizr{width:0;height:0}" + (n += "{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}"), function(e) {
                            t = 7 === e.offsetWidth && 18 === e.offsetHeight
                        })
                    }
                    return t
                }), d.addTest("flexbox", o("flexBasis", "1px", !0)),
                function() {
                    var e, t, n, i, o, r;
                    for (var s in u)
                        if (u.hasOwnProperty(s)) {
                            if (e = [], (t = u[s]).name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))
                                for (n = 0; n < t.options.aliases.length; n++) e.push(t.options.aliases[n].toLowerCase());
                            for (i = m(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++) 1 === (r = e[o].split(".")).length ? d[r[0]] = i : (!d[r[0]] || d[r[0]] instanceof Boolean || (d[r[0]] = new Boolean(d[r[0]])), d[r[0]][r[1]] = i), c.push((i ? "" : "no-") + r.join("-"))
                        }
                }(),
                function(e) {
                    var t = w.className,
                        n = d._config.classPrefix || "";
                    if (b && (t = t.baseVal), d._config.enableJSClass) {
                        var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
                        t = t.replace(i, "$1" + n + "js$2")
                    }
                    d._config.enableClasses && (t += " " + n + e.join(" " + n), b ? w.className.baseVal = t : w.className = t)
                }(c), delete e.addTest, delete e.addAsyncTest;
            for (var A = 0; A < d._q.length; A++) d._q[A]();
            p.Modernizr = d
        }(window, document), e = window, t = function(l, j) {
                "use strict";
                if (j.getElementsByClassName) {
                    var N, q, H = j.documentElement,
                        c = l.Date,
                        o = l.HTMLPictureElement,
                        u = "addEventListener",
                        R = "getAttribute",
                        F = l[u],
                        W = l.setTimeout,
                        d = l.requestAnimationFrame || W,
                        p = l.requestIdleCallback,
                        U = /^picture$/i,
                        r = ["load", "error", "lazyincluded", "_lazyloaded"],
                        i = {},
                        B = Array.prototype.forEach,
                        Z = function e(t, n) {
                            return i[n] || (i[n] = new RegExp("(\\s|^)" + n + "(\\s|$)")), i[n].test(t[R]("class") || "") && i[n]
                        },
                        G = function e(t, n) {
                            Z(t, n) || t.setAttribute("class", (t[R]("class") || "").trim() + " " + n)
                        },
                        X = function e(t, n) {
                            var i;
                            (i = Z(t, n)) && t.setAttribute("class", (t[R]("class") || "").replace(i, " "))
                        },
                        Y = function e(t, n, i) {
                            var o = i ? u : "removeEventListener";
                            i && e(t, n), r.forEach(function(e) {
                                t[o](e, n)
                            })
                        },
                        K = function e(t, n, i, o, r) {
                            var s = j.createEvent("CustomEvent");
                            return i || (i = {}), i.instance = N, s.initCustomEvent(n, !o, !r, i), t.dispatchEvent(s), s
                        },
                        V = function e(t, n) {
                            var i;
                            !o && (i = l.picturefill || q.pf) ? i({
                                reevaluate: !0,
                                elements: [t]
                            }) : n && n.src && (t.src = n.src)
                        },
                        Q = function e(t, n) {
                            return (getComputedStyle(t, null) || {})[n]
                        },
                        s = function e(t, n, i) {
                            for (i = i || t.offsetWidth; i < q.minSize && n && !t._lazysizesWidth;) {
                                i = n.offsetWidth, n = n.parentNode
                            }
                            return i
                        },
                        J = function() {
                            var i, o, n = [],
                                r = [],
                                s = n,
                                a = function e() {
                                    var t = s;
                                    for (s = n.length ? r : n, i = !0, o = !1; t.length;) {
                                        t.shift()()
                                    }
                                    i = !1
                                },
                                e = function e(t, n) {
                                    i && !n ? t.apply(this, arguments) : (s.push(t), o || (o = !0, (j.hidden ? W : d)(a)))
                                };
                            return e._lsFlush = a, e
                        }(),
                        ee = function e(n, t) {
                            return t ? function() {
                                J(n)
                            } : function() {
                                var e = this,
                                    t = arguments;
                                J(function() {
                                    n.apply(e, t)
                                })
                            }
                        },
                        e = function e(t) {
                            var n, i = 0,
                                o = 125,
                                r = q.ricTimeout,
                                s = function e() {
                                    n = !1, i = c.now(), t()
                                },
                                a = p && q.ricTimeout ? function() {
                                    p(s, {
                                        timeout: r
                                    }), r !== q.ricTimeout && (r = q.ricTimeout)
                                } : ee(function() {
                                    W(s)
                                }, !0);
                            return function(e) {
                                var t;
                                (e = e === !0) && (r = 33), n || (n = !0, t = o - (c.now() - i), 0 > t && (t = 0), e || 9 > t && p ? a() : W(a, t))
                            }
                        },
                        te = function e(t) {
                            var n, i, o = 99,
                                r = function e() {
                                    n = null, t()
                                },
                                s = function e() {
                                    var t = c.now() - i;
                                    o > t ? W(e, o - t) : (p || r)(r)
                                };
                            return function() {
                                i = c.now(), n || (n = W(s, o))
                            }
                        };
                    ! function() {
                        var e, t = {
                            lazyClass: "lazyload",
                            loadedClass: "lazyloaded",
                            loadingClass: "lazyloading",
                            preloadClass: "lazypreload",
                            errorClass: "lazyerror",
                            autosizesClass: "lazyautosizes",
                            srcAttr: "data-src",
                            srcsetAttr: "data-srcset",
                            sizesAttr: "data-sizes",
                            minSize: 40,
                            customMedia: {},
                            init: !0,
                            expFactor: 1.5,
                            hFac: .8,
                            loadMode: 2,
                            loadHidden: !0,
                            ricTimeout: 300
                        };
                        q = l.lazySizesConfig || l.lazysizesConfig || {};
                        for (e in t) {
                            e in q || (q[e] = t[e])
                        }
                        l.lazySizesConfig = q, W(function() {
                            q.init && n()
                        })
                    }();
                    var t = function() {
                            var d, p, f, h, n, m, g, v, y, w, b, x, T, C, s = /^img$/i,
                                S = /^iframe$/i,
                                k = "onscroll" in l && !/glebot/.test(navigator.userAgent),
                                A = 0,
                                _ = 0,
                                $ = 0,
                                E = -1,
                                D = function e(t) {
                                    $--, t && t.target && Y(t.target, e), (!t || 0 > $ || !t.target) && ($ = 0)
                                },
                                z = function e(t, n) {
                                    var i, o = t,
                                        r = "hidden" == Q(j.body, "visibility") || "hidden" != Q(t, "visibility");
                                    for (v -= n, b += n, y -= n, w += n; r && (o = o.offsetParent) && o != j.body && o != H;) {
                                        r = (Q(o, "opacity") || 1) > 0, r && "visible" != Q(o, "overflow") && (i = o.getBoundingClientRect(), r = w > i.left && y < i.right && b > i.top - 1 && v < i.bottom + 1)
                                    }
                                    return r
                                },
                                t = function e() {
                                    var t, n, i, o, r, s, a, l, c, u = N.elements;
                                    if ((h = q.loadMode) && 8 > $ && (t = u.length)) {
                                        n = 0, E++, null == T && ("expand" in q || (q.expand = H.clientHeight > 500 && H.clientWidth > 500 ? 500 : 370), x = q.expand, T = x * q.expFactor), T > _ && 1 > $ && E > 2 && h > 2 && !j.hidden ? (_ = T, E = 0) : _ = h > 1 && E > 1 && 6 > $ ? x : A;
                                        for (; t > n; n++) {
                                            if (u[n] && !u[n]._lazyRace)
                                                if (k) {
                                                    if ((l = u[n][R]("data-expand")) && (s = 1 * l) || (s = _), c !== s && (m = innerWidth + s * C, g = innerHeight + s, a = -1 * s, c = s), i = u[n].getBoundingClientRect(), (b = i.bottom) >= a && (v = i.top) <= g && (w = i.right) >= a * C && (y = i.left) <= m && (b || w || y || v) && (q.loadHidden || "hidden" != Q(u[n], "visibility")) && (p && 3 > $ && !l && (3 > h || 4 > E) || z(u[n], s))) {
                                                        if (M(u[n]), r = !0, $ > 9) break
                                                    } else !r && p && !o && 4 > $ && 4 > E && h > 2 && (d[0] || q.preloadAfterLoad) && (d[0] || !l && (b || w || y || v || "auto" != u[n][R](q.sizesAttr))) && (o = d[0] || u[n])
                                                } else M(u[n])
                                        }
                                        o && !r && M(o)
                                    }
                                },
                                i = e(t),
                                O = function e(t) {
                                    G(t.target, q.loadedClass), X(t.target, q.loadingClass), Y(t.target, L), K(t.target, "lazyloaded")
                                },
                                o = ee(O),
                                L = function e(t) {
                                    o({
                                        target: t.target
                                    })
                                },
                                I = function e(t, n) {
                                    try {
                                        t.contentWindow.location.replace(n)
                                    } catch (e) {
                                        t.src = n
                                    }
                                },
                                P = function e(t) {
                                    var n, i = t[R](q.srcsetAttr);
                                    (n = q.customMedia[t[R]("data-media") || t[R]("media")]) && t.setAttribute("media", n), i && t.setAttribute("srcset", i)
                                },
                                a = ee(function(e, t, n, i, o) {
                                    var r, s, a, l, c, u;
                                    (c = K(e, "lazybeforeunveil", t)).defaultPrevented || (i && (n ? G(e, q.autosizesClass) : e.setAttribute("sizes", i)), s = e[R](q.srcsetAttr), r = e[R](q.srcAttr), o && (a = e.parentNode, l = a && U.test(a.nodeName || "")), u = t.firesLoad || "src" in e && (s || r || l), c = {
                                        target: e
                                    }, u && (Y(e, D, !0), clearTimeout(f), f = W(D, 2500), G(e, q.loadingClass), Y(e, L, !0)), l && B.call(a.getElementsByTagName("source"), P), s ? e.setAttribute("srcset", s) : r && !l && (S.test(e.nodeName) ? I(e, r) : e.src = r), o && (s || l) && V(e, {
                                        src: r
                                    })), e._lazyRace && delete e._lazyRace, X(e, q.lazyClass), J(function() {
                                        (!u || e.complete && e.naturalWidth > 1) && (u ? D(c) : $--, O(c))
                                    }, !0)
                                }),
                                M = function e(t) {
                                    var n, i = s.test(t.nodeName),
                                        o = i && (t[R](q.sizesAttr) || t[R]("sizes")),
                                        r = "auto" == o;
                                    (!r && p || !i || !t[R]("src") && !t.srcset || t.complete || Z(t, q.errorClass) || !Z(t, q.lazyClass)) && (n = K(t, "lazyunveilread").detail, r && ne.updateElem(t, !0, t.offsetWidth), t._lazyRace = !0, $++, a(t, n, r, o, i))
                                },
                                r = function e() {
                                    if (!p) {
                                        if (c.now() - n < 999) return void W(e, 999);
                                        var t = te(function() {
                                            q.loadMode = 3, i()
                                        });
                                        p = !0, q.loadMode = 3, i(), F("scroll", function() {
                                            3 == q.loadMode && (q.loadMode = 2), t()
                                        }, !0)
                                    }
                                };
                            return {
                                _: function e() {
                                    n = c.now(), N.elements = j.getElementsByClassName(q.lazyClass), d = j.getElementsByClassName(q.lazyClass + " " + q.preloadClass), C = q.hFac, F("scroll", i, !0), F("resize", i, !0), l.MutationObserver ? new MutationObserver(i).observe(H, {
                                        childList: !0,
                                        subtree: !0,
                                        attributes: !0
                                    }) : (H[u]("DOMNodeInserted", i, !0), H[u]("DOMAttrModified", i, !0), setInterval(i, 999)), F("hashchange", i, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function(e) {
                                        j[u](e, i, !0)
                                    }), /d$|^c/.test(j.readyState) ? r() : (F("load", r), j[u]("DOMContentLoaded", i), W(r, 2e4)), N.elements.length ? (t(), J._lsFlush()) : i()
                                },
                                checkElems: i,
                                unveil: M
                            }
                        }(),
                        ne = function() {
                            var i, r = ee(function(e, t, n, i) {
                                    var o, r, s;
                                    if (e._lazysizesWidth = i, i += "px", e.setAttribute("sizes", i), U.test(t.nodeName || ""))
                                        for (o = t.getElementsByTagName("source"), r = 0, s = o.length; s > r; r++) {
                                            o[r].setAttribute("sizes", i)
                                        }
                                    n.detail.dataAttr || V(e, n.detail)
                                }),
                                o = function e(t, n, i) {
                                    var e, o = t.parentNode;
                                    o && (i = s(t, o, i), e = K(t, "lazybeforesizes", {
                                        width: i,
                                        dataAttr: !!n
                                    }), e.defaultPrevented || (i = e.detail.width, i && i !== t._lazysizesWidth && r(t, o, e, i)))
                                },
                                e = function e() {
                                    var t, n = i.length;
                                    if (n)
                                        for (t = 0; n > t; t++) {
                                            o(i[t])
                                        }
                                },
                                t = te(e);
                            return {
                                _: function e() {
                                    i = j.getElementsByClassName(q.autosizesClass), F("resize", t)
                                },
                                checkElems: t,
                                updateElem: o
                            }
                        }(),
                        n = function e() {
                            e.i || (e.i = !0, ne._(), t._())
                        };
                    return N = {
                        cfg: q,
                        autoSizer: ne,
                        loader: t,
                        init: n,
                        uP: V,
                        aC: G,
                        rC: X,
                        hC: Z,
                        fire: K,
                        gW: s,
                        rAF: J
                    }
                }
            }(e, e.document), e.lazySizes = t, "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports && (module.exports = t), n = window, i = (i = function(d, c, h) {
                "use strict";

                function m(e, t, n) {
                    var i, o, r, s = 0,
                        a = 0,
                        l = n;
                    if (e) {
                        if ("container" === t.ratio) {
                            for (s = l.scrollWidth, a = l.scrollHeight; !(s && a || l === c);) s = (l = l.parentNode).scrollWidth, a = l.scrollHeight;
                            s && a && (t.ratio = a / s)
                        }
                        i = e, o = t, (r = []).srcset = [], o.absUrl && (C.setAttribute("href", i), i = C.href), i = ((o.prefix || "") + i + (o.postfix || "")).replace(f, function(e, t) {
                            return u[_typeof(o[t])] ? o[t] : e
                        }), o.widths.forEach(function(e) {
                            var t = o.widthmap[e] || e,
                                n = {
                                    u: i.replace(b, t).replace(p, o.ratio ? Math.round(e * o.ratio) : ""),
                                    w: e
                                };
                            r.push(n), r.srcset.push(n.c = n.u + " " + e + "w")
                        }), (e = r).isPicture = t.isPicture, S && "IMG" == n.nodeName.toUpperCase() ? n.removeAttribute(y.srcsetAttr) : n.setAttribute(y.srcsetAttr, e.srcset.join(", ")), Object.defineProperty(n, "_lazyrias", {
                            value: e,
                            writable: !0
                        })
                    }
                }

                function g(e, t) {
                    var n = function(o, e) {
                        var t, n, i, r, s = d.getComputedStyle(o);
                        for (t in n = o.parentNode, r = {
                                isPicture: !(!n || !l.test(n.nodeName || ""))
                            }, i = function(e, t) {
                                var n = o.getAttribute("data-" + e);
                                if (!n) {
                                    var i = s.getPropertyValue("--ls-" + e);
                                    i && (n = i.trim())
                                }
                                if (n) {
                                    if ("true" == n) n = !0;
                                    else if ("false" == n) n = !1;
                                    else if (a.test(n)) n = parseFloat(n);
                                    else if ("function" == typeof w[e]) n = w[e](o, n);
                                    else if (x.test(n)) try {
                                        n = JSON.parse(n)
                                    } catch (e) {}
                                    r[e] = n
                                } else e in w && "function" != typeof w[e] ? r[e] = w[e] : t && "function" == typeof w[e] && (r[e] = w[e](o, n))
                            }, w) i(t);
                        return e.replace(f, function(e, t) {
                            t in r || i(t, !0)
                        }), r
                    }(e, t);
                    return w.modifyOptions.call(e, {
                        target: e,
                        details: n,
                        detail: n
                    }), h.fire(e, "lazyriasmodifyoptions", n), n
                }

                function v(e) {
                    return e.getAttribute(e.getAttribute("data-srcattr") || w.srcAttr) || e.getAttribute(y.srcsetAttr) || e.getAttribute(y.srcAttr) || e.getAttribute("data-pfsrcset") || ""
                }
                var y, w, u = {
                        string: 1,
                        number: 1
                    },
                    a = /^\-*\+*\d+\.*\d*$/,
                    l = /^picture$/i,
                    b = /\s*\{\s*width\s*\}\s*/i,
                    p = /\s*\{\s*height\s*\}\s*/i,
                    f = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
                    x = /^\[.*\]|\{.*\}$/,
                    T = /^(?:auto|\d+(px)?)$/,
                    C = c.createElement("a"),
                    e = c.createElement("img"),
                    S = "srcset" in e && !("sizes" in e),
                    k = !!d.HTMLPictureElement && !S;
                ! function() {
                    var e, t = {
                        prefix: "",
                        postfix: "",
                        srcAttr: "data-src",
                        absUrl: !1,
                        modifyOptions: function() {},
                        widthmap: {},
                        ratio: !1
                    };
                    for (e in (y = h && h.cfg || d.lazySizesConfig) || (y = {}, d.lazySizesConfig = y), y.supportsType || (y.supportsType = function(e) {
                            return !e
                        }), y.rias || (y.rias = {}), "widths" in (w = y.rias) || (w.widths = [], function(e) {
                            for (var t, n = 0; !t || t < 3e3;) 30 < (n += 5) && (n += 1), t = 36 * n, e.push(t)
                        }(w.widths)), t) e in w || (w[e] = t[e])
                }(), addEventListener("lazybeforesizes", function(e) {
                    var t, n, i, o, r, s, a, l, c, u, d, p, f;
                    if (e.detail.instance == h && (t = e.target, e.detail.dataAttr && !e.defaultPrevented && !w.disabled && (c = t.getAttribute(y.sizesAttr) || t.getAttribute("sizes")) && T.test(c))) {
                        if (i = g(t, n = v(t)), d = b.test(i.prefix) || b.test(i.postfix), i.isPicture && (o = t.parentNode))
                            for (s = 0, a = (r = o.getElementsByTagName("source")).length; s < a; s++)(d || b.test(l = v(r[s]))) && (m(l, i, r[s]), p = !0);
                        d || b.test(n) ? (m(n, i, t), p = !0) : p && ((f = []).srcset = [], f.isPicture = !0, Object.defineProperty(t, "_lazyrias", {
                            value: f,
                            writable: !0
                        })), p && (k ? t.removeAttribute(y.srcAttr) : "auto" != c && (u = {
                            width: parseInt(c, 10)
                        }, A({
                            target: t,
                            detail: u
                        })))
                    }
                }, !0);
                var i, A = (i = function(e) {
                    if (e.detail.instance == h) {
                        var t, n = e.target;
                        return !S && (d.respimage || d.picturefill || lazySizesConfig.pf) ? void c.removeEventListener("lazybeforesizes", i) : void(("_lazyrias" in n || e.detail.dataAttr && $(n, !0)) && ((t = o(n, e.detail.width)) && t.u && n._lazyrias.cur != t.u && (n._lazyrias.cur = t.u, t.cached = !0, h.rAF(function() {
                            n.setAttribute(y.srcAttr, t.u), n.setAttribute("src", t.u)
                        }))))
                    }
                }, k ? i = function() {} : addEventListener("lazybeforesizes", i), i);

                function _(e, t) {
                    return e.w - t.w
                }

                function $(e, t) {
                    var n;
                    return !e._lazyrias && h.pWS && (n = h.pWS(e.getAttribute(y.srcsetAttr || ""))).length && (Object.defineProperty(e, "_lazyrias", {
                        value: n,
                        writable: !0
                    }), t && e.parentNode && (n.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())), e._lazyrias
                }

                function o(e, t) {
                    var n, i, o, r, s, a, l, c, u;
                    if ((s = e._lazyrias).isPicture && d.matchMedia)
                        for (i = 0, n = e.parentNode.getElementsByTagName("source"), o = n.length; i < o; i++)
                            if ($(n[i]) && !n[i].getAttribute("type") && (!(r = n[i].getAttribute("media")) || (matchMedia(r) || {}).matches)) {
                                s = n[i]._lazyrias;
                                break
                            } return (!s.w || s.w < t) && (s.w = t, s.d = (l = e, c = d.devicePixelRatio || 1, u = h.getX && h.getX(l), Math.min(u || c, 2.4, c)), a = function(e) {
                        for (var t, n, i = e.length, o = e[i - 1], r = 0; r < i; r++)
                            if (o = e[r], o.d = o.w / e.w, o.d >= e.d) {
                                !o.cached && (t = e[r - 1]) && t.d > e.d - .13 * Math.pow(e.d, 2.2) && (n = Math.pow(t.d - .6, 1.6), t.cached && (t.d += .15 * n), t.d + (o.d - e.d) * n > e.d && (o = t));
                                break
                            } return o
                    }(s.sort(_))), a
                }
            }).bind(null, n, n.document), "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? i(require("lazysizes")) : n.lazySizes ? Ce() : n.addEventListener("lazyunveilread", Ce, !0),
            function(t, e) {
                "use strict";
                if (t.addEventListener) {
                    var l, s = /^picture$/i,
                        n = e.documentElement,
                        o = (g = /(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g, function(e) {
                            return m = [], e.replace(g, h), m
                        }),
                        c = function(e, t) {
                            var n, i, o, r;
                            if (!e[t] && (r = e.parentNode || {}, e[t] = f(e, t), e[t].isImg = !0, s.test(r.nodeName || "")))
                                for (e[t].picture = !0, i = 0, o = (n = r.getElementsByTagName("source")).length; i < o; i++) f(n[i], t).isImg = !1;
                            return e[t]
                        },
                        a = {
                            _lazyOptimumx: function(e, t, n) {
                                var i, o, r, s, a, l, c;
                                for (i = 0; i < e.cands.length; i++)
                                    if ((o = e.cands[i]).d = (o.w || 1) / t, !(e.index >= i)) {
                                        if (!(o.d <= n) && (r = e.cands[i - 1], s = o.d, a = n, c = l = void 0, r && r.d && (c = .7 < a ? .6 : .4, r.d >= a || ((l = Math.pow(r.d - c, 1.6) || .1) < .1 ? l = .1 : 3 < l && (l = 3), !(r.d + (s - a) * l < a))))) break;
                                        e.cSrcset.push(o.c), e.index = i
                                    }
                            }
                        },
                        u = function(e, t, n, i, o) {
                            var r, s, a, l, c = e[o];
                            if (c.width = t, c.picture && (s = e.parentNode))
                                for (l = 0, a = (r = s.getElementsByTagName("source")).length; l < a; l++) p(r[l], t, n, i, o);
                            p(e, t, n, i, o)
                        },
                        d = function(e) {
                            var t = e.getAttribute("data-optimumx") || e.getAttribute("data-maxdpr");
                            return !t && l.constrainPixelDensity && (t = "auto"), t = t && ("auto" == t ? l.getOptimumX(e) : parseFloat(t, 10))
                        },
                        i = function e() {
                            t.lazySizes && !t.lazySizes.getOptimumX && (lazySizes.getX = d, lazySizes.pWS = o, n.removeEventListener("lazybeforeunveil", e))
                        };
                    n.addEventListener("lazybeforeunveil", i), setTimeout(i), (l = t.lazySizes && lazySizes.cfg || t.lazySizesConfig) || (l = {}, t.lazySizesConfig = l), "function" != typeof l.getOptimumX && (l.getOptimumX = function() {
                        var e = t.devicePixelRatio || 1;
                        return 2.6 < e ? e *= .6 : 1.9 < e ? e *= .8 : e -= .01, Math.min(Math.round(100 * e) / 100, 2)
                    }), t.devicePixelRatio && addEventListener("lazybeforesizes", function(e) {
                        var t, n, i, o, r = e.target,
                            s = e.detail,
                            a = s.dataAttr;
                        e.defaultPrevented || !(t = d(r)) || t >= devicePixelRatio || (!a || !r._lazyOptimumx || s.reloaded || l.unloadedClass && lazySizes.hC(r, l.unloadedClass) || (r._lazyOptimumx = null), n = c(r, "_lazyOptimumx"), (i = s.width) && (n.width || 0) < i && (o = a ? lazySizes.cfg.srcsetAttr : "srcset", lazySizes.rAF(function() {
                            u(r, i, t, o, "_lazyOptimumx")
                        })))
                    })
                }

                function p(e, t, n, i, o) {
                    var r, s = e[o];
                    s && (r = s.index, a[o](s, t, n), s.dirty && r == s.index || (s.cSrcset.join(", "), e.setAttribute(i, s.cSrcset.join(", ")), s.dirty = !0))
                }

                function r(e, t) {
                    return e.w - t.w
                }

                function f(e, t) {
                    var n = {
                            srcset: e.getAttribute(lazySizes.cfg.srcsetAttr) || ""
                        },
                        i = o(n.srcset);
                    return Object.defineProperty(e, t, {
                        value: n,
                        writable: !0
                    }), n.cands = i, n.index = 0, n.dirty = !1, i[0] && i[0].w ? (i.sort(r), n.cSrcset = [i[n.index].c]) : (n.cSrcset = n.srcset ? [n.srcset] : [], n.cands = []), n
                }

                function h(e, t, n, i, o, r, s, a) {
                    m.push({
                        c: t,
                        u: n,
                        w: +("w" == a ? s : i)
                    })
                }
                var m, g
            }(window, document), o = window, r = (r = function(e, t, i) {
                "use strict";
                var o, r;
                "srcset" in t.createElement("img") && (o = /^img$/i, r = function(e) {
                    e.target.style.backgroundSize = "", e.target.style.backgroundImage = "", e.target.removeEventListener(e.type, r)
                }, t.addEventListener("lazybeforeunveil", function(e) {
                    if (e.detail.instance == i) {
                        var t = e.target;
                        if (o.test(t.nodeName)) {
                            var n = t.getAttribute("src");
                            n && (t.style.backgroundSize = "100% 100%", t.style.backgroundImage = "url(" + n + ")", t.removeAttribute("src"), t.addEventListener("load", r))
                        }
                    }
                }, !1))
            }).bind(null, o, o.document), "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? r(require("lazysizes")) : o.lazySizes ? Se() : o.addEventListener("lazyunveilread", Se, !0), s = window, a = (a = function(a, e, n) {
                "use strict";
                if (a.addEventListener) {
                    var l = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                        s = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
                        c = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
                        u = /^picture$/i,
                        d = {
                            getParent: function(e, t) {
                                var n = e,
                                    i = e.parentNode;
                                return t && "prev" != t || !i || !u.test(i.nodeName || "") || (i = i.parentNode), "self" != t && (n = "prev" == t ? e.previousElementSibling : t && (i.closest || a.jQuery) && (i.closest ? i.closest(t) : jQuery(i).closest(t)[0]) || i), n
                            },
                            getFit: function(e) {
                                var t, n, i = getComputedStyle(e, null) || {},
                                    o = i.content || i.fontFamily,
                                    r = {
                                        fit: e._lazysizesParentFit || e.getAttribute("data-parent-fit")
                                    };
                                return !r.fit && o && (t = o.match(s)) && (r.fit = t[1]), r.fit ? (!(n = e._lazysizesParentContainer || e.getAttribute("data-parent-container")) && o && (t = o.match(c)) && (n = t[1]), r.parent = d.getParent(e, n)) : r.fit = i.objectFit, r
                            },
                            getImageRatio: function(e) {
                                var t, n, i, o, r = e.parentNode,
                                    s = r && u.test(r.nodeName || "") ? r.querySelectorAll("source, img") : [e];
                                for (t = 0; t < s.length; t++)
                                    if (n = (e = s[t]).getAttribute(lazySizesConfig.srcsetAttr) || e.getAttribute("srcset") || e.getAttribute("data-pfsrcset") || e.getAttribute("data-risrcset") || "", i = e._lsMedia || e.getAttribute("media"), i = lazySizesConfig.customMedia[e.getAttribute("data-media") || i] || i, n && (!i || (a.matchMedia && matchMedia(i) || {}).matches)) {
                                        !(o = parseFloat(e.getAttribute("data-aspectratio"))) && n.match(l) && (o = "w" == RegExp.$2 ? RegExp.$1 / RegExp.$3 : RegExp.$3 / RegExp.$1);
                                        break
                                    } return o
                            },
                            calculateSize: function(e, t) {
                                var n, i, o, r, s = this.getFit(e),
                                    a = s.fit,
                                    l = s.parent;
                                return "width" == a || ("contain" == a || "cover" == a) && (o = this.getImageRatio(e)) ? (l ? t = l.clientWidth : l = e, r = t, "width" == a ? r = t : 40 < (i = l.clientHeight) && (n = t / i) && ("cover" == a && n < o || "contain" == a && o < n) && (r = t * (o / n)), r) : t
                            }
                        };
                    n.parentFit = d, e.addEventListener("lazybeforesizes", function(e) {
                        if (!e.defaultPrevented && e.detail.instance == n) {
                            var t = e.target;
                            e.detail.width = d.calculateSize(t, e.detail.width)
                        }
                    })
                }
            }).bind(null, s, s.document), "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? a(require("lazysizes")) : s.lazySizes ? ke() : s.addEventListener("lazyunveilread", ke, !0), l = window, c = (c = function(d, r, p) {
                "use strict";
                var i, s, a, t, o, n, l, f, c, h, m = p && p.cfg || d.lazySizesConfig,
                    e = r.createElement("img"),
                    u = "sizes" in e && "srcset" in e,
                    g = /\s+\d+h/g,
                    v = (s = /\s+(\d+)(w|h)\s+(\d+)(w|h)/, a = Array.prototype.forEach, function(e) {
                        function n(e) {
                            var t, n, i = e.getAttribute(lazySizesConfig.srcsetAttr);
                            i && (!(n = i.match(s)) || (t = "w" == n[2] ? n[1] / n[3] : n[3] / n[1]) && e.setAttribute("data-aspectratio", t), e.setAttribute(lazySizesConfig.srcsetAttr, i.replace(g, "")))
                        }

                        function t(e) {
                            var t = e.target.parentNode;
                            t && "PICTURE" == t.nodeName && a.call(t.getElementsByTagName("source"), n), n(e.target)
                        }

                        function i() {
                            o.currentSrc && r.removeEventListener("lazybeforeunveil", t)
                        }
                        var o = r.createElement("img");
                        e[1] && (r.addEventListener("lazybeforeunveil", t), o.onload = i, o.onerror = i, o.srcset = "data:,a 1w 1h", o.complete && i())
                    });
                if (m || (m = {}, d.lazySizesConfig = m), m.supportsType || (m.supportsType = function(e) {
                        return !e
                    }), !d.picturefill && !m.pf) {
                    if (d.HTMLPictureElement && u) return r.msElementsFromPoint && v(navigator.userAgent.match(/Edge\/(\d+)/)), void(m.pf = function() {});
                    m.pf = function(e) {
                        var t, n;
                        if (!d.picturefill)
                            for (t = 0, n = e.elements.length; t < n; t++) i(e.elements[t])
                    }, f = /^\s*\d+\.*\d*px\s*$/, n = /(([^,\s].[^\s]+)\s+(\d+)w)/g, l = /\s/, h = function(e) {
                        return d.matchMedia ? (h = function(e) {
                            return !e || (matchMedia(e) || {}).matches
                        })(e) : !e
                    }, T.parse = c = function(e) {
                        return o = [], (e = e.trim()).replace(g, "").replace(n, C), o.length || !e || l.test(e) || o.push({
                            c: e,
                            u: e,
                            w: 99
                        }), o
                    }, i = T, m.loadedClass && m.loadingClass && (t = [], ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(e) {
                        t.push(e + m.loadedClass), t.push(e + m.loadingClass)
                    }), m.pf({
                        elements: r.querySelectorAll(t.join(", "))
                    }))
                }

                function y(e, t) {
                    return e.w - t.w
                }

                function w() {
                    function e() {
                        var e, t;
                        for (e = 0, t = n.length; e < t; e++) i(n[e])
                    }
                    var t, n;
                    w.init || (w.init = !0, addEventListener("resize", (n = r.getElementsByClassName("lazymatchmedia"), function() {
                        clearTimeout(t), t = setTimeout(e, 66)
                    })))
                }

                function b(e, t) {
                    var n, i = e.getAttribute("srcset") || e.getAttribute(m.srcsetAttr);
                    !i && t && (i = e._lazypolyfill ? e._lazypolyfill._set : e.getAttribute(m.srcAttr) || e.getAttribute("src")), e._lazypolyfill && e._lazypolyfill._set == i || (n = c(i || ""), t && e.parentNode && (n.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase(), n.isPicture && d.matchMedia && (p.aC(e, "lazymatchmedia"), w())), n._set = i, Object.defineProperty(e, "_lazypolyfill", {
                        value: n,
                        writable: !0
                    }))
                }

                function x(e) {
                    var t, n, i, o, r, s, a, l, c, u;
                    if (b(o = e, !0), (r = o._lazypolyfill).isPicture)
                        for (n = 0, i = (t = e.parentNode.getElementsByTagName("source")).length; n < i; n++)
                            if (m.supportsType(t[n].getAttribute("type"), e) && h(t[n].getAttribute("media"))) {
                                o = t[n], b(o), r = o._lazypolyfill;
                                break
                            } return 1 < r.length ? (a = o.getAttribute("sizes") || "", a = f.test(a) && parseInt(a, 10) || p.gW(e, e.parentNode), r.d = (l = e, c = d.devicePixelRatio || 1, u = p.getX && p.getX(l), Math.min(u || c, 2.5, c)), !r.src || !r.w || r.w < a ? (r.w = a, s = function(e) {
                        for (var t, n, i = e.length, o = e[i - 1], r = 0; r < i; r++)
                            if ((o = e[r]).d = o.w / e.w, o.d >= e.d) {
                                !o.cached && (t = e[r - 1]) && t.d > e.d - .13 * Math.pow(e.d, 2.2) && (n = Math.pow(t.d - .6, 1.6), t.cached && (t.d += .15 * n), t.d + (o.d - e.d) * n > e.d && (o = t));
                                break
                            } return o
                    }(r.sort(y)), r.src = s) : s = r.src) : s = r[0], s
                }

                function T(e) {
                    if (!u || !e.parentNode || "PICTURE" == e.parentNode.nodeName.toUpperCase()) {
                        var t = x(e);
                        t && t.u && e._lazypolyfill.cur != t.u && (e._lazypolyfill.cur = t.u, t.cached = !0, e.setAttribute(m.srcAttr, t.u), e.setAttribute("src", t.u))
                    }
                }

                function C(e, t, n, i) {
                    o.push({
                        c: t,
                        u: n,
                        w: +i
                    })
                }
            }).bind(null, l, l.document), "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? c(require("lazysizes"), require("../fix-ios-sizes/fix-ios-sizes")) : l.lazySizes ? Ae() : l.addEventListener("lazyunveilread", Ae, !0), u = window, d = (d = function(e, d, p) {
                "use strict";
                if (e.addEventListener) {
                    var f = /\s+/g,
                        h = /\s*\|\s+|\s+\|\s*/g,
                        m = /^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,
                        o = /\(|\)|'/,
                        r = {
                            contain: 1,
                            cover: 1
                        },
                        g = function(e) {
                            if (e.target._lazybgset) {
                                var t = e.target,
                                    n = t._lazybgset,
                                    i = t.currentSrc || t.src;
                                i && (n.style.backgroundImage = "url(" + (o.test(i) ? JSON.stringify(i) : i) + ")"), t._lazybgsetLoading && (p.fire(n, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading)
                            }
                        };
                    addEventListener("lazybeforeunveil", function(e) {
                        var t, n, i, o, r, s, a, l, c, u;
                        !e.defaultPrevented && (t = e.target.getAttribute("data-bgset")) && (i = e.target, (n = d.createElement("img")).alt = "", n._lazybgsetLoading = !0, e.detail.firesLoad = !0, o = t, r = i, s = n, a = d.createElement("picture"), l = r.getAttribute(lazySizesConfig.sizesAttr), c = r.getAttribute("data-ratio"), u = r.getAttribute("data-optimumx"), r._lazybgset && r._lazybgset.parentNode == r && r.removeChild(r._lazybgset), Object.defineProperty(s, "_lazybgset", {
                            value: r,
                            writable: !0
                        }), Object.defineProperty(r, "_lazybgset", {
                            value: a,
                            writable: !0
                        }), o = o.replace(f, " ").split(h), a.style.display = "none", s.className = lazySizesConfig.lazyClass, 1 != o.length || l || (l = "auto"), o.forEach(function(e) {
                            var t = d.createElement("source");
                            l && "auto" != l && t.setAttribute("sizes", l), e.match(m) && (t.setAttribute(lazySizesConfig.srcsetAttr, RegExp.$1), RegExp.$2 && t.setAttribute("media", lazySizesConfig.customMedia[RegExp.$2] || RegExp.$2)), a.appendChild(t)
                        }), l && (s.setAttribute(lazySizesConfig.sizesAttr, l), r.removeAttribute(lazySizesConfig.sizesAttr), r.removeAttribute("sizes")), u && s.setAttribute("data-optimumx", u), c && s.setAttribute("data-ratio", c), a.appendChild(s), r.appendChild(a), setTimeout(function() {
                            p.loader.unveil(n), p.rAF(function() {
                                p.fire(n, "_lazyloaded", {}, !0, !0), n.complete && g({
                                    target: n
                                })
                            })
                        }))
                    }), d.addEventListener("load", g, !0), e.addEventListener("lazybeforesizes", function(e) {
                        if (e.detail.instance == p && e.target._lazybgset && e.detail.dataAttr) {
                            var t = e.target._lazybgset,
                                n = (i = t, o = (getComputedStyle(i) || {
                                    getPropertyValue: function() {}
                                }).getPropertyValue("background-size"), !r[o] && r[i.style.backgroundSize] && (o = i.style.backgroundSize), o);
                            r[n] && (e.target._lazysizesParentFit = n, p.rAF(function() {
                                e.target.setAttribute("data-parent-fit", n), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit
                            }))
                        }
                        var i, o
                    }, !0), d.documentElement.addEventListener("lazybeforesizes", function(e) {
                        var t, n;
                        !e.defaultPrevented && e.target._lazybgset && e.detail.instance == p && (e.detail.width = (t = e.target._lazybgset, n = p.gW(t, t.parentNode), (!t._lazysizesWidth || n > t._lazysizesWidth) && (t._lazysizesWidth = n), t._lazysizesWidth))
                    })
                }
            }).bind(null, u, u.document), "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? d(require("lazysizes")) : u.lazySizes ? _e() : u.addEventListener("lazyunveilread", _e, !0), document.addEventListener("lazyloaded", function(e) {
                e.target.parentElement.className = e.target.parentElement.className.replace("lazyload--placeholder", "")
            }), f = this, h = function() {
                "use strict";
                return function(f, i, e, t) {
                    var h = {
                        features: null,
                        bind: function(e, t, n, i) {
                            var o = (i ? "remove" : "add") + "EventListener";
                            t = t.split(" ");
                            for (var r = 0; r < t.length; r++) t[r] && e[o](t[r], n, !1)
                        },
                        isArray: function(e) {
                            return e instanceof Array
                        },
                        createEl: function(e, t) {
                            var n = document.createElement(t || "div");
                            return e && (n.className = e), n
                        },
                        getScrollY: function() {
                            var e = window.pageYOffset;
                            return void 0 !== e ? e : document.documentElement.scrollTop
                        },
                        unbind: function(e, t, n) {
                            h.bind(e, t, n, !0)
                        },
                        removeClass: function(e, t) {
                            var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
                            e.className = e.className.replace(n, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
                        },
                        addClass: function(e, t) {
                            h.hasClass(e, t) || (e.className += (e.className ? " " : "") + t)
                        },
                        hasClass: function(e, t) {
                            return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className)
                        },
                        getChildByClass: function(e, t) {
                            for (var n = e.firstChild; n;) {
                                if (h.hasClass(n, t)) return n;
                                n = n.nextSibling
                            }
                        },
                        arraySearch: function(e, t, n) {
                            for (var i = e.length; i--;)
                                if (e[i][n] === t) return i;
                            return -1
                        },
                        extend: function(e, t, n) {
                            for (var i in t)
                                if (t.hasOwnProperty(i)) {
                                    if (n && e.hasOwnProperty(i)) continue;
                                    e[i] = t[i]
                                }
                        },
                        easing: {
                            sine: {
                                out: function(e) {
                                    return Math.sin(e * (Math.PI / 2))
                                },
                                inOut: function(e) {
                                    return -(Math.cos(Math.PI * e) - 1) / 2
                                }
                            },
                            cubic: {
                                out: function(e) {
                                    return --e * e * e + 1
                                }
                            }
                        },
                        detectFeatures: function() {
                            if (h.features) return h.features;
                            var e = h.createEl().style,
                                t = "",
                                n = {};
                            if (n.oldIE = document.all && !document.addEventListener, n.touch = "ontouchstart" in window, window.requestAnimationFrame && (n.raf = window.requestAnimationFrame, n.caf = window.cancelAnimationFrame), n.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled, !n.pointerEvent) {
                                var i = navigator.userAgent;
                                if (/iP(hone|od)/.test(navigator.platform)) {
                                    var o = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                                    o && 0 < o.length && (1 <= (o = parseInt(o[1], 10)) && o < 8 && (n.isOldIOSPhone = !0))
                                }
                                var r = i.match(/Android\s([0-9\.]*)/),
                                    s = r ? r[1] : 0;
                                1 <= (s = parseFloat(s)) && (s < 4.4 && (n.isOldAndroid = !0), n.androidVersion = s), n.isMobileOpera = /opera mini|opera mobi/i.test(i)
                            }
                            for (var a, l, c = ["transform", "perspective", "animationName"], u = ["", "webkit", "Moz", "ms", "O"], d = 0; d < 4; d++) {
                                t = u[d];
                                for (var p = 0; p < 3; p++) a = c[p], l = t + (t ? a.charAt(0).toUpperCase() + a.slice(1) : a), !n[a] && l in e && (n[a] = l);
                                t && !n.raf && (t = t.toLowerCase(), n.raf = window[t + "RequestAnimationFrame"], n.raf && (n.caf = window[t + "CancelAnimationFrame"] || window[t + "CancelRequestAnimationFrame"]))
                            }
                            if (!n.raf) {
                                var f = 0;
                                n.raf = function(e) {
                                    var t = (new Date).getTime(),
                                        n = Math.max(0, 16 - (t - f)),
                                        i = window.setTimeout(function() {
                                            e(t + n)
                                        }, n);
                                    return f = t + n, i
                                }, n.caf = function(e) {
                                    clearTimeout(e)
                                }
                            }
                            return n.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, h.features = n
                        }
                    };
                    h.detectFeatures(), h.features.oldIE && (h.bind = function(e, t, n, i) {
                        t = t.split(" ");
                        for (var o, r = (i ? "detach" : "attach") + "Event", s = function() {
                                n.handleEvent.call(n)
                            }, a = 0; a < t.length; a++)
                            if (o = t[a])
                                if ("object" == _typeof(n) && n.handleEvent) {
                                    if (i) {
                                        if (!n["oldIE" + o]) return !1
                                    } else n["oldIE" + o] = s;
                                    e[r]("on" + o, n["oldIE" + o])
                                } else e[r]("on" + o, n)
                    });
                    var m = this,
                        g = {
                            allowPanToNext: !0,
                            spacing: .12,
                            bgOpacity: 1,
                            mouseUsed: !1,
                            loop: !0,
                            pinchToClose: !0,
                            closeOnScroll: !0,
                            closeOnVerticalDrag: !0,
                            verticalDragRange: .75,
                            hideAnimationDuration: 333,
                            showAnimationDuration: 333,
                            showHideOpacity: !1,
                            focus: !0,
                            escKey: !0,
                            arrowKeys: !0,
                            mainScrollEndFriction: .35,
                            panEndFriction: .35,
                            isClickableElement: function(e) {
                                return "A" === e.tagName
                            },
                            getDoubleTapZoom: function(e, t) {
                                return e || t.initialZoomLevel < .7 ? 1 : 1.33
                            },
                            maxSpreadZoom: 1.33,
                            modal: !0,
                            scaleMode: "fit"
                        };
                    h.extend(g, t);

                    function n() {
                        return {
                            x: 0,
                            y: 0
                        }
                    }

                    function o(e, t) {
                        h.extend(m, t.publicMethods), Qe.push(e)
                    }

                    function l(e) {
                        var t = Bt();
                        return t - 1 < e ? e - t : e < 0 ? t + e : e
                    }

                    function r(e, t) {
                        return tt[e] || (tt[e] = []), tt[e].push(t)
                    }

                    function v(e) {
                        var t = tt[e];
                        if (t) {
                            var n = Array.prototype.slice.call(arguments);
                            n.shift();
                            for (var i = 0; i < t.length; i++) t[i].apply(m, n)
                        }
                    }

                    function u() {
                        return (new Date).getTime()
                    }

                    function y(e) {
                        He = e, m.bg.style.opacity = e * g.bgOpacity
                    }

                    function s(e, t, n, i, o) {
                        (!et || o && o !== m.currItem) && (i /= o ? o.fitRatio : m.currItem.fitRatio), e[le] = Q + t + "px, " + n + "px" + J + " scale(" + i + ")"
                    }

                    function d(e, t) {
                        if (!g.loop && t) {
                            var n = U + (Ye.x * Ge - e) / Ye.x,
                                i = Math.round(e - xt.x);
                            (n < 0 && 0 < i || n >= Bt() - 1 && i < 0) && (e = xt.x + i * g.mainScrollEndFriction)
                        }
                        xt.x = e, ot(e, B)
                    }

                    function p(e, t) {
                        var n = Tt[e] - Xe[e];
                        return Ue[e] + We[e] + n - t / V * n
                    }

                    function w(e, t) {
                        e.x = t.x, e.y = t.y, t.id && (e.id = t.id)
                    }

                    function b(e) {
                        e.x = Math.round(e.x), e.y = Math.round(e.y)
                    }

                    function a() {
                        rt && (h.unbind(document, "mousemove", a), h.addClass(f, "pswp--has_mouse"), g.mouseUsed = !0, v("mouseUsed")), rt = setTimeout(function() {
                            rt = null
                        }, 100)
                    }

                    function x(e, t) {
                        var n = Kt(m.currItem, Ze, e);
                        return t && (Ie = n), n
                    }

                    function T(e) {
                        return (e = e || m.currItem).initialZoomLevel
                    }

                    function C(e) {
                        return 0 < (e = e || m.currItem).w ? g.maxSpreadZoom : 1
                    }

                    function S(e, t, n, i) {
                        return i === m.currItem.initialZoomLevel ? (n[e] = m.currItem.initialPosition[e], !0) : (n[e] = p(e, i), n[e] > t.min[e] ? (n[e] = t.min[e], !0) : n[e] < t.max[e] && (n[e] = t.max[e], !0))
                    }

                    function c(e) {
                        var t = "";
                        g.escKey && 27 === e.keyCode ? t = "close" : g.arrowKeys && (37 === e.keyCode ? t = "prev" : 39 === e.keyCode && (t = "next")), t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : e.returnValue = !1, m[t]()))
                    }

                    function k(e) {
                        e && ($e || _e || Me || Ce) && (e.preventDefault(), e.stopPropagation())
                    }

                    function A() {
                        m.setScrollOffset(0, h.getScrollY())
                    }

                    function _(e) {
                        st[e] && (st[e].raf && pe(st[e].raf), at--, delete st[e])
                    }

                    function $(e) {
                        st[e] && _(e), st[e] || (at++, st[e] = {})
                    }

                    function E() {
                        for (var e in st) st.hasOwnProperty(e) && _(e)
                    }

                    function D(t, n, i, o, r, s, a) {
                        var l, c = u();
                        $(t),
                            function e() {
                                if (st[t]) {
                                    if (l = u() - c, o <= l) return _(t), s(i), void(a && a());
                                    s((i - n) * r(l / o) + n), st[t].raf = de(e)
                                }
                            }()
                    }

                    function z(e, t) {
                        return vt.x = Math.abs(e.x - t.x), vt.y = Math.abs(e.y - t.y), Math.sqrt(vt.x * vt.x + vt.y * vt.y)
                    }

                    function O(e, t) {
                        return kt.prevent = ! function e(t, n) {
                            return !(!t || t === document) && !(t.getAttribute("class") && -1 < t.getAttribute("class").indexOf("pswp__scroll-wrap")) && (n(t) ? t : e(t.parentNode, n))
                        }(e.target, g.isClickableElement), v("preventDragEvent", e, t, kt), kt.prevent
                    }

                    function L(e, t) {
                        return t.x = e.pageX, t.y = e.pageY, t.id = e.identifier, t
                    }

                    function I(e, t, n) {
                        n.x = .5 * (e.x + t.x), n.y = .5 * (e.y + t.y)
                    }

                    function P() {
                        var e = Be.y - m.currItem.initialPosition.y;
                        return 1 - Math.abs(e / (Ze.y / 2))
                    }

                    function M(e) {
                        for (; 0 < $t.length;) $t.pop();
                        return ce ? (Fe = 0, ht.forEach(function(e) {
                            0 === Fe ? $t[0] = e : 1 === Fe && ($t[1] = e), Fe++
                        })) : -1 < e.type.indexOf("touch") ? e.touches && 0 < e.touches.length && ($t[0] = L(e.touches[0], At), 1 < e.touches.length && ($t[1] = L(e.touches[1], _t))) : (At.x = e.pageX, At.y = e.pageY, At.id = "", $t[0] = At), $t
                    }

                    function j(e, t) {
                        var n, i, o, r, s = Be[e] + t[e],
                            a = 0 < t[e],
                            l = xt.x + t.x,
                            c = xt.x - mt.x;
                        return n = s > Ie.min[e] || s < Ie.max[e] ? g.panEndFriction : 1, s = Be[e] + t[e] * n, !g.allowPanToNext && K !== m.currItem.initialZoomLevel || (Pe ? "h" !== je || "x" !== e || _e || (a ? (s > Ie.min[e] && (n = g.panEndFriction, Ie.min[e], i = Ie.min[e] - Ue[e]), (i <= 0 || c < 0) && 1 < Bt() ? (r = l, c < 0 && l > mt.x && (r = mt.x)) : Ie.min.x !== Ie.max.x && (o = s)) : (s < Ie.max[e] && (n = g.panEndFriction, Ie.max[e], i = Ue[e] - Ie.max[e]), (i <= 0 || 0 < c) && 1 < Bt() ? (r = l, 0 < c && l < mt.x && (r = mt.x)) : Ie.min.x !== Ie.max.x && (o = s))) : r = l, "x" !== e) ? void(Me || De || K > m.currItem.fitRatio && (Be[e] += t[e] * n)) : (void 0 !== r && (d(r, !0), De = r !== mt.x), Ie.min.x !== Ie.max.x && (void 0 !== o ? Be.x = o : De || (Be.x += t.x * n)), void 0 !== r)
                    }

                    function N(e) {
                        if (!("mousedown" === e.type && 0 < e.button)) {
                            if (Wt) return void e.preventDefault();
                            if (!Se || "mousedown" !== e.type) {
                                if (O(e, !0) && e.preventDefault(), v("pointerDown"), ce) {
                                    var t = h.arraySearch(ht, e.pointerId, "id");
                                    t < 0 && (t = ht.length), ht[t] = {
                                        x: e.pageX,
                                        y: e.pageY,
                                        id: e.pointerId
                                    }
                                }
                                var n = M(e),
                                    i = n.length;
                                ze = null, E(), ke && 1 !== i || (ke = Ne = !0, h.bind(window, G, m), Te = Re = qe = Ce = De = $e = Ae = _e = !1, je = null, v("firstTouchStart", n), w(Ue, Be), We.x = We.y = 0, w(pt, n[0]), w(ft, pt), mt.x = Ye.x * Ge, gt = [{
                                    x: pt.x,
                                    y: pt.y
                                }], be = we = u(), x(K, !0), St(), function e() {
                                    ke && (Ee = de(e), Et())
                                }()), !Oe && 1 < i && !Me && !De && (V = K, Oe = Ae = !(_e = !1), We.y = We.x = 0, w(Ue, Be), w(ct, n[0]), w(ut, n[1]), I(ct, ut, Ct), Tt.x = Math.abs(Ct.x) - Be.x, Tt.y = Math.abs(Ct.y) - Be.y, Le = z(ct, ut))
                            }
                        }
                    }

                    function q(e) {
                        if (e.preventDefault(), ce) {
                            var t = h.arraySearch(ht, e.pointerId, "id");
                            if (-1 < t) {
                                var n = ht[t];
                                n.x = e.pageX, n.y = e.pageY
                            }
                        }
                        if (ke) {
                            var i = M(e);
                            if (je || $e || Oe) ze = i;
                            else if (xt.x !== Ye.x * Ge) je = "h";
                            else {
                                var o = Math.abs(i[0].x - pt.x) - Math.abs(i[0].y - pt.y);
                                10 <= Math.abs(o) && (je = 0 < o ? "h" : "v", ze = i)
                            }
                        }
                    }

                    function H(e) {
                        if (ve.isOldAndroid) {
                            if (Se && "mouseup" === e.type) return; - 1 < e.type.indexOf("touch") && (clearTimeout(Se), Se = setTimeout(function() {
                                Se = 0
                            }, 600))
                        }
                        var t;
                        if (v("pointerUp"), O(e, !1) && e.preventDefault(), ce) {
                            var n = h.arraySearch(ht, e.pointerId, "id");
                            if (-1 < n)
                                if (t = ht.splice(n, 1)[0], navigator.pointerEnabled) t.type = e.pointerType || "mouse";
                                else {
                                    t.type = {
                                        4: "mouse",
                                        2: "touch",
                                        3: "pen"
                                    } [e.pointerType], t.type || (t.type = e.pointerType || "mouse")
                                }
                        }
                        var i, o = M(e),
                            r = o.length;
                        if ("mouseup" === e.type && (r = 0), 2 === r) return !(ze = null);
                        1 === r && w(ft, o[0]), 0 !== r || je || Me || (t || ("mouseup" === e.type ? t = {
                            x: e.pageX,
                            y: e.pageY,
                            type: "mouse"
                        } : e.changedTouches && e.changedTouches[0] && (t = {
                            x: e.changedTouches[0].pageX,
                            y: e.changedTouches[0].pageY,
                            type: "touch"
                        })), v("touchRelease", e, t));
                        var s = -1;
                        if (0 === r && (ke = !1, h.unbind(window, G, m), St(), Oe ? s = 0 : -1 !== bt && (s = u() - bt)), bt = 1 === r ? u() : -1, i = -1 !== s && s < 150 ? "zoom" : "swipe", Oe && r < 2 && (Oe = !1, 1 === r && (i = "zoomPointerUp"), v("zoomGestureEnded")), ze = null, $e || _e || Me || Ce)
                            if (E(), (xe = xe || Dt()).calculateSwipeSpeed("x"), Ce) {
                                if (P() < g.verticalDragRange) m.close();
                                else {
                                    var a = Be.y,
                                        l = He;
                                    D("verticalDrag", 0, 1, 300, h.easing.cubic.out, function(e) {
                                        Be.y = (m.currItem.initialPosition.y - a) * e + a, y((1 - l) * e + l), nt()
                                    }), v("onVerticalDrag", 1)
                                }
                            } else {
                                if ((De || Me) && 0 === r) {
                                    if (Ot(i, xe)) return;
                                    i = "zoomPointerUp"
                                }
                                if (!Me) return "swipe" !== i ? void It() : void(!De && K > m.currItem.fitRatio && zt(xe))
                            }
                    }
                    var R, F, W, U, B, Z, G, X, Y, K, V, Q, J, ee, te, ne, ie, oe, re, se, ae, le, ce, ue, de, pe, fe, he, me, ge, ve, ye, we, be, xe, Te, Ce, Se, ke, Ae, _e, $e, Ee, De, ze, Oe, Le, Ie, Pe, Me, je, Ne, qe, He, Re, Fe, We = n(),
                        Ue = n(),
                        Be = n(),
                        Ze = {},
                        Ge = 0,
                        Xe = {},
                        Ye = n(),
                        Ke = 0,
                        Ve = !0,
                        Qe = [],
                        Je = {},
                        et = !1,
                        tt = {},
                        nt = function(e) {
                            Pe && (e && (K > m.currItem.fitRatio ? et || (Vt(m.currItem, !1, !0), et = !0) : et && (Vt(m.currItem), et = !1)), s(Pe, Be.x, Be.y, K))
                        },
                        it = function(e) {
                            e.container && s(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e)
                        },
                        ot = function(e, t) {
                            t[le] = Q + e + "px, 0px" + J
                        },
                        rt = null,
                        st = {},
                        at = 0,
                        lt = {
                            shout: v,
                            listen: r,
                            viewportSize: Ze,
                            options: g,
                            isMainScrollAnimating: function() {
                                return Me
                            },
                            getZoomLevel: function() {
                                return K
                            },
                            getCurrentIndex: function() {
                                return U
                            },
                            isDragging: function() {
                                return ke
                            },
                            isZooming: function() {
                                return Oe
                            },
                            setScrollOffset: function(e, t) {
                                Xe.x = e, ge = Xe.y = t, v("updateScrollOffset", Xe)
                            },
                            applyZoomPan: function(e, t, n, i) {
                                Be.x = t, Be.y = n, K = e, nt(i)
                            },
                            init: function() {
                                if (!R && !F) {
                                    var e;
                                    m.framework = h, m.template = f, m.bg = h.getChildByClass(f, "pswp__bg"), fe = f.className, R = !0, ve = h.detectFeatures(), de = ve.raf, pe = ve.caf, le = ve.transform, me = ve.oldIE, m.scrollWrap = h.getChildByClass(f, "pswp__scroll-wrap"), m.container = h.getChildByClass(m.scrollWrap, "pswp__container"), B = m.container.style, m.itemHolders = ne = [{
                                            el: m.container.children[0],
                                            wrap: 0,
                                            index: -1
                                        }, {
                                            el: m.container.children[1],
                                            wrap: 0,
                                            index: -1
                                        }, {
                                            el: m.container.children[2],
                                            wrap: 0,
                                            index: -1
                                        }], ne[0].el.style.display = ne[2].el.style.display = "none",
                                        function() {
                                            if (le) {
                                                var e = ve.perspective && !ue;
                                                return Q = "translate" + (e ? "3d(" : "("), J = ve.perspective ? ", 0px)" : ")"
                                            }
                                            le = "left", h.addClass(f, "pswp--ie"), ot = function(e, t) {
                                                t.left = e + "px"
                                            }, it = function(e) {
                                                var t = 1 < e.fitRatio ? 1 : e.fitRatio,
                                                    n = e.container.style,
                                                    i = t * e.w,
                                                    o = t * e.h;
                                                n.width = i + "px", n.height = o + "px", n.left = e.initialPosition.x + "px", n.top = e.initialPosition.y + "px"
                                            }, nt = function() {
                                                if (Pe) {
                                                    var e = Pe,
                                                        t = m.currItem,
                                                        n = 1 < t.fitRatio ? 1 : t.fitRatio,
                                                        i = n * t.w,
                                                        o = n * t.h;
                                                    e.width = i + "px", e.height = o + "px", e.left = Be.x + "px", e.top = Be.y + "px"
                                                }
                                            }
                                        }(), Y = {
                                            resize: m.updateSize,
                                            orientationchange: function() {
                                                clearTimeout(ye), ye = setTimeout(function() {
                                                    Ze.x !== m.scrollWrap.clientWidth && m.updateSize()
                                                }, 500)
                                            },
                                            scroll: A,
                                            keydown: c,
                                            click: k
                                        };
                                    var t = ve.isOldIOSPhone || ve.isOldAndroid || ve.isMobileOpera;
                                    for (ve.animationName && ve.transform && !t || (g.showAnimationDuration = g.hideAnimationDuration = 0), e = 0; e < Qe.length; e++) m["init" + Qe[e]]();
                                    if (i)(m.ui = new i(m, h)).init();
                                    v("firstUpdate"), U = U || g.index || 0, (isNaN(U) || U < 0 || U >= Bt()) && (U = 0), m.currItem = Ut(U), (ve.isOldIOSPhone || ve.isOldAndroid) && (Ve = !1), f.setAttribute("aria-hidden", "false"), g.modal && (Ve ? f.style.position = "fixed" : (f.style.position = "absolute", f.style.top = h.getScrollY() + "px")), void 0 === ge && (v("initialLayout"), ge = he = h.getScrollY());
                                    var n = "pswp--open ";
                                    for (g.mainClass && (n += g.mainClass + " "), g.showHideOpacity && (n += "pswp--animate_opacity "), n += ue ? "pswp--touch" : "pswp--notouch", n += ve.animationName ? " pswp--css_animation" : "", n += ve.svg ? " pswp--svg" : "", h.addClass(f, n), m.updateSize(), Z = -1, Ke = null, e = 0; e < 3; e++) ot((e + Z) * Ye.x, ne[e].el.style);
                                    me || h.bind(m.scrollWrap, X, m), r("initialZoomInEnd", function() {
                                        m.setContent(ne[0], U - 1), m.setContent(ne[2], U + 1), ne[0].el.style.display = ne[2].el.style.display = "block", g.focus && f.focus(), h.bind(document, "keydown", m), ve.transform && h.bind(m.scrollWrap, "click", m), g.mouseUsed || h.bind(document, "mousemove", a), h.bind(window, "resize scroll orientationchange", m), v("bindEvents")
                                    }), m.setContent(ne[1], U), m.updateCurrItem(), v("afterInit"), Ve || (ee = setInterval(function() {
                                        at || ke || Oe || K !== m.currItem.initialZoomLevel || m.updateSize()
                                    }, 1e3)), h.addClass(f, "pswp--visible")
                                }
                            },
                            close: function() {
                                R && (F = !(R = !1), v("close"), h.unbind(window, "resize scroll orientationchange", m), h.unbind(window, "scroll", Y.scroll), h.unbind(document, "keydown", m), h.unbind(document, "mousemove", a), ve.transform && h.unbind(m.scrollWrap, "click", m), ke && h.unbind(window, G, m), clearTimeout(ye), v("unbindEvents"), Zt(m.currItem, null, !0, m.destroy))
                            },
                            destroy: function() {
                                v("destroy"), Ht && clearTimeout(Ht), f.setAttribute("aria-hidden", "true"), f.className = fe, ee && clearInterval(ee), h.unbind(m.scrollWrap, X, m), h.unbind(window, "scroll", m), St(), E(), tt = null
                            },
                            panTo: function(e, t, n) {
                                n || (e > Ie.min.x ? e = Ie.min.x : e < Ie.max.x && (e = Ie.max.x), t > Ie.min.y ? t = Ie.min.y : t < Ie.max.y && (t = Ie.max.y)), Be.x = e, Be.y = t, nt()
                            },
                            handleEvent: function(e) {
                                e = e || window.event, Y[e.type] && Y[e.type](e)
                            },
                            goTo: function(e) {
                                var t = (e = l(e)) - U;
                                Ke = t, U = e, m.currItem = Ut(U), Ge -= t, d(Ye.x * Ge), E(), Me = !1, m.updateCurrItem()
                            },
                            next: function() {
                                m.goTo(U + 1)
                            },
                            prev: function() {
                                m.goTo(U - 1)
                            },
                            updateCurrZoomItem: function(e) {
                                if (e && v("beforeChange", 0), ne[1].el.children.length) {
                                    var t = ne[1].el.children[0];
                                    Pe = h.hasClass(t, "pswp__zoom-wrap") ? t.style : null
                                } else Pe = null;
                                Ie = m.currItem.bounds, V = K = m.currItem.initialZoomLevel, Be.x = Ie.center.x, Be.y = Ie.center.y, e && v("afterChange")
                            },
                            invalidateCurrItems: function() {
                                te = !0;
                                for (var e = 0; e < 3; e++) ne[e].item && (ne[e].item.needsUpdate = !0)
                            },
                            updateCurrItem: function(e) {
                                if (0 !== Ke) {
                                    var t, n = Math.abs(Ke);
                                    if (!(e && n < 2)) {
                                        m.currItem = Ut(U), et = !1, v("beforeChange", Ke), 3 <= n && (Z += Ke + (0 < Ke ? -3 : 3), n = 3);
                                        for (var i = 0; i < n; i++) 0 < Ke ? (t = ne.shift(), ne[2] = t, ot((++Z + 2) * Ye.x, t.el.style), m.setContent(t, U - n + i + 1 + 1)) : (t = ne.pop(), ne.unshift(t), ot(--Z * Ye.x, t.el.style), m.setContent(t, U + n - i - 1 - 1));
                                        if (Pe && 1 === Math.abs(Ke)) {
                                            var o = Ut(ie);
                                            o.initialZoomLevel !== K && (Kt(o, Ze), Vt(o), it(o))
                                        }
                                        Ke = 0, m.updateCurrZoomItem(), ie = U, v("afterChange")
                                    }
                                }
                            },
                            updateSize: function(e) {
                                if (!Ve && g.modal) {
                                    var t = h.getScrollY();
                                    if (ge !== t && (f.style.top = t + "px", ge = t), !e && Je.x === window.innerWidth && Je.y === window.innerHeight) return;
                                    Je.x = window.innerWidth, Je.y = window.innerHeight, f.style.height = Je.y + "px"
                                }
                                if (Ze.x = m.scrollWrap.clientWidth, Ze.y = m.scrollWrap.clientHeight, A(), Ye.x = Ze.x + Math.round(Ze.x * g.spacing), Ye.y = Ze.y, d(Ye.x * Ge), v("beforeResize"), void 0 !== Z) {
                                    for (var n, i, o, r = 0; r < 3; r++) n = ne[r], ot((r + Z) * Ye.x, n.el.style), o = U + r - 1, g.loop && 2 < Bt() && (o = l(o)), (i = Ut(o)) && (te || i.needsUpdate || !i.bounds) ? (m.cleanSlide(i), m.setContent(n, o), 1 === r && (m.currItem = i, m.updateCurrZoomItem(!0)), i.needsUpdate = !1) : -1 === n.index && 0 <= o && m.setContent(n, o), i && i.container && (Kt(i, Ze), Vt(i), it(i));
                                    te = !1
                                }
                                V = K = m.currItem.initialZoomLevel, (Ie = m.currItem.bounds) && (Be.x = Ie.center.x, Be.y = Ie.center.y, nt(!0)), v("resize")
                            },
                            zoomTo: function(t, e, n, i, o) {
                                e && (V = K, Tt.x = Math.abs(e.x) - Be.x, Tt.y = Math.abs(e.y) - Be.y, w(Ue, Be));
                                var r = x(t, !1),
                                    s = {};
                                S("x", r, s, t), S("y", r, s, t);
                                var a = K,
                                    l = Be.x,
                                    c = Be.y;
                                b(s);

                                function u(e) {
                                    1 === e ? (K = t, Be.x = s.x, Be.y = s.y) : (K = (t - a) * e + a, Be.x = (s.x - l) * e + l, Be.y = (s.y - c) * e + c), o && o(e), nt(1 === e)
                                }
                                n ? D("customZoomTo", 0, 1, n, i || h.easing.sine.inOut, u) : u(1)
                            }
                        },
                        ct = {},
                        ut = {},
                        dt = {},
                        pt = {},
                        ft = {},
                        ht = [],
                        mt = {},
                        gt = [],
                        vt = {},
                        yt = 0,
                        wt = n(),
                        bt = 0,
                        xt = n(),
                        Tt = n(),
                        Ct = n(),
                        St = function() {
                            Ee && (pe(Ee), Ee = null)
                        },
                        kt = {},
                        At = {},
                        _t = {},
                        $t = [],
                        Et = function() {
                            if (ze) {
                                var e = ze.length;
                                if (0 !== e)
                                    if (w(ct, ze[0]), dt.x = ct.x - pt.x, dt.y = ct.y - pt.y, Oe && 1 < e) {
                                        if (pt.x = ct.x, pt.y = ct.y, !dt.x && !dt.y && (l = ze[1], c = ut, l.x === c.x && l.y === c.y)) return;
                                        w(ut, ze[1]), _e || (_e = !0, v("zoomGestureStarted"));
                                        var t = z(ct, ut),
                                            n = Lt(t);
                                        n > m.currItem.initialZoomLevel + m.currItem.initialZoomLevel / 15 && (Re = !0);
                                        var i = 1,
                                            o = T(),
                                            r = C();
                                        if (n < o)
                                            if (g.pinchToClose && !Re && V <= m.currItem.initialZoomLevel) {
                                                var s = 1 - (o - n) / (o / 1.2);
                                                y(s), v("onPinchClose", s), qe = !0
                                            } else 1 < (i = (o - n) / o) && (i = 1), n = o - i * (o / 3);
                                        else r < n && (1 < (i = (n - r) / (6 * o)) && (i = 1), n = r + i * o);
                                        i < 0 && (i = 0), I(ct, ut, wt), We.x += wt.x - Ct.x, We.y += wt.y - Ct.y, w(Ct, wt), Be.x = p("x", n), Be.y = p("y", n), Te = K < n, K = n, nt()
                                    } else {
                                        if (!je) return;
                                        if (Ne && (Ne = !1, 10 <= Math.abs(dt.x) && (dt.x -= ze[0].x - ft.x), 10 <= Math.abs(dt.y) && (dt.y -= ze[0].y - ft.y)), pt.x = ct.x, pt.y = ct.y, 0 === dt.x && 0 === dt.y) return;
                                        if ("v" === je && g.closeOnVerticalDrag && "fit" === g.scaleMode && K === m.currItem.initialZoomLevel) {
                                            We.y += dt.y, Be.y += dt.y;
                                            var a = P();
                                            return Ce = !0, v("onVerticalDrag", a), y(a), void nt()
                                        }(function(e, t, n) {
                                            if (50 < e - be) {
                                                var i = 2 < gt.length ? gt.shift() : {};
                                                i.x = t, i.y = n, gt.push(i), be = e
                                            }
                                        })(u(), ct.x, ct.y), $e = !0, Ie = m.currItem.bounds, j("x", dt) || (j("y", dt), b(Be), nt())
                                    }
                            }
                            var l, c
                        },
                        Dt = function() {
                            var t, n, i = {
                                lastFlickOffset: {},
                                lastFlickDist: {},
                                lastFlickSpeed: {},
                                slowDownRatio: {},
                                slowDownRatioReverse: {},
                                speedDecelerationRatio: {},
                                speedDecelerationRatioAbs: {},
                                distanceOffset: {},
                                backAnimDestination: {},
                                backAnimStarted: {},
                                calculateSwipeSpeed: function(e) {
                                    n = 1 < gt.length ? (t = u() - be + 50, gt[gt.length - 2][e]) : (t = u() - we, ft[e]), i.lastFlickOffset[e] = pt[e] - n, i.lastFlickDist[e] = Math.abs(i.lastFlickOffset[e]), 20 < i.lastFlickDist[e] ? i.lastFlickSpeed[e] = i.lastFlickOffset[e] / t : i.lastFlickSpeed[e] = 0, Math.abs(i.lastFlickSpeed[e]) < .1 && (i.lastFlickSpeed[e] = 0), i.slowDownRatio[e] = .95, i.slowDownRatioReverse[e] = 1 - i.slowDownRatio[e], i.speedDecelerationRatio[e] = 1
                                },
                                calculateOverBoundsAnimOffset: function(t, e) {
                                    i.backAnimStarted[t] || (Be[t] > Ie.min[t] ? i.backAnimDestination[t] = Ie.min[t] : Be[t] < Ie.max[t] && (i.backAnimDestination[t] = Ie.max[t]), void 0 !== i.backAnimDestination[t] && (i.slowDownRatio[t] = .7, i.slowDownRatioReverse[t] = 1 - i.slowDownRatio[t], i.speedDecelerationRatioAbs[t] < .05 && (i.lastFlickSpeed[t] = 0, i.backAnimStarted[t] = !0, D("bounceZoomPan" + t, Be[t], i.backAnimDestination[t], e || 300, h.easing.sine.out, function(e) {
                                        Be[t] = e, nt()
                                    }))))
                                },
                                calculateAnimOffset: function(e) {
                                    i.backAnimStarted[e] || (i.speedDecelerationRatio[e] = i.speedDecelerationRatio[e] * (i.slowDownRatio[e] + i.slowDownRatioReverse[e] - i.slowDownRatioReverse[e] * i.timeDiff / 10), i.speedDecelerationRatioAbs[e] = Math.abs(i.lastFlickSpeed[e] * i.speedDecelerationRatio[e]), i.distanceOffset[e] = i.lastFlickSpeed[e] * i.speedDecelerationRatio[e] * i.timeDiff, Be[e] += i.distanceOffset[e])
                                },
                                panAnimLoop: function() {
                                    if (st.zoomPan && (st.zoomPan.raf = de(i.panAnimLoop), i.now = u(), i.timeDiff = i.now - i.lastNow, i.lastNow = i.now, i.calculateAnimOffset("x"), i.calculateAnimOffset("y"), nt(), i.calculateOverBoundsAnimOffset("x"), i.calculateOverBoundsAnimOffset("y"), i.speedDecelerationRatioAbs.x < .05 && i.speedDecelerationRatioAbs.y < .05)) return Be.x = Math.round(Be.x), Be.y = Math.round(Be.y), nt(), void _("zoomPan")
                                }
                            };
                            return i
                        },
                        zt = function(e) {
                            return e.calculateSwipeSpeed("y"), Ie = m.currItem.bounds, e.backAnimDestination = {}, e.backAnimStarted = {}, Math.abs(e.lastFlickSpeed.x) <= .05 && Math.abs(e.lastFlickSpeed.y) <= .05 ? (e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0, e.calculateOverBoundsAnimOffset("x"), e.calculateOverBoundsAnimOffset("y"), !0) : ($("zoomPan"), e.lastNow = u(), void e.panAnimLoop())
                        },
                        Ot = function(e, t) {
                            var n, i, o;
                            if (Me || (yt = U), "swipe" === e) {
                                var r = pt.x - ft.x,
                                    s = t.lastFlickDist.x < 10;
                                30 < r && (s || 20 < t.lastFlickOffset.x) ? i = -1 : r < -30 && (s || t.lastFlickOffset.x < -20) && (i = 1)
                            }
                            i && ((U += i) < 0 ? (U = g.loop ? Bt() - 1 : 0, o = !0) : U >= Bt() && (U = g.loop ? 0 : Bt() - 1, o = !0), o && !g.loop || (Ke += i, Ge -= i, n = !0));
                            var a, l = Ye.x * Ge,
                                c = Math.abs(l - xt.x);
                            return a = n || l > xt.x == 0 < t.lastFlickSpeed.x ? (a = 0 < Math.abs(t.lastFlickSpeed.x) ? c / Math.abs(t.lastFlickSpeed.x) : 333, a = Math.min(a, 400), Math.max(a, 250)) : 333, yt === U && (n = !1), Me = !0, v("mainScrollAnimStart"), D("mainScroll", xt.x, l, a, h.easing.cubic.out, d, function() {
                                E(), Me = !1, yt = -1, !n && yt === U || m.updateCurrItem(), v("mainScrollAnimComplete")
                            }), n && m.updateCurrItem(!0), n
                        },
                        Lt = function(e) {
                            return 1 / Le * e * V
                        },
                        It = function() {
                            var e = K,
                                t = T(),
                                n = C();
                            K < t ? e = t : n < K && (e = n);
                            var i, o = He;
                            return qe && !Te && !Re && K < t ? m.close() : (qe && (i = function(e) {
                                y((1 - o) * e + o)
                            }), m.zoomTo(e, 0, 200, h.easing.cubic.out, i)), !0
                        };
                    o("Gestures", {
                        publicMethods: {
                            initGestures: function() {
                                function e(e, t, n, i, o) {
                                    oe = e + t, re = e + n, se = e + i, ae = o ? e + o : ""
                                }(ce = ve.pointerEvent) && ve.touch && (ve.touch = !1), ce ? navigator.pointerEnabled ? e("pointer", "down", "move", "up", "cancel") : e("MSPointer", "Down", "Move", "Up", "Cancel") : ve.touch ? (e("touch", "start", "move", "end", "cancel"), ue = !0) : e("mouse", "down", "move", "up"), G = re + " " + se + " " + ae, X = oe, ce && !ue && (ue = 1 < navigator.maxTouchPoints || 1 < navigator.msMaxTouchPoints), m.likelyTouchDevice = ue, Y[oe] = N, Y[re] = q, Y[se] = H, ae && (Y[ae] = Y[se]), ve.touch && (X += " mousedown", G += " mousemove mouseup", Y.mousedown = Y[oe], Y.mousemove = Y[re], Y.mouseup = Y[se]), ue || (g.allowPanToNext = !1)
                            }
                        }
                    });

                    function Pt() {
                        return {
                            center: {
                                x: 0,
                                y: 0
                            },
                            max: {
                                x: 0,
                                y: 0
                            },
                            min: {
                                x: 0,
                                y: 0
                            }
                        }
                    }

                    function Mt(e, t, n, i, o, r) {
                        t.loadError || i && (t.imageAppended = !0, Vt(t, i, t === m.currItem && et), n.appendChild(i), r && setTimeout(function() {
                            t && t.loaded && t.placeholder && (t.placeholder.style.display = "none", t.placeholder = null)
                        }, 500))
                    }

                    function jt(e) {
                        function t() {
                            e.loading = !1, e.loaded = !0, e.loadComplete ? e.loadComplete(e) : e.img = null, n.onload = n.onerror = null, n = null
                        }
                        e.loading = !0, e.loaded = !1;
                        var n = e.img = h.createEl("pswp__img", "img");
                        return n.onload = t, n.onerror = function() {
                            e.loadError = !0, t()
                        }, n.src = e.src, n
                    }

                    function Nt(e, t) {
                        return e.src && e.loadError && e.container && (t && (e.container.innerHTML = ""), e.container.innerHTML = g.errorMsg.replace("%url%", e.src), 1)
                    }

                    function qt() {
                        if (Xt.length) {
                            for (var e, t = 0; t < Xt.length; t++)(e = Xt[t]).holder.index === e.index && Mt(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
                            Xt = []
                        }
                    }
                    var Ht, Rt, Ft, Wt, Ut, Bt, Zt = function(s, e, a, t) {
                            var l;
                            Ht && clearTimeout(Ht), Ft = Wt = !0, s.initialLayout ? (l = s.initialLayout, s.initialLayout = null) : l = g.getThumbBoundsFn && g.getThumbBoundsFn(U);

                            function c() {
                                _("initialZoom"), a ? (m.template.removeAttribute("style"), m.bg.removeAttribute("style")) : (y(1), e && (e.style.display = "block"), h.addClass(f, "pswp--animated-in"), v("initialZoom" + (a ? "OutEnd" : "InEnd"))), t && t(), Wt = !1
                            }
                            var u = a ? g.hideAnimationDuration : g.showAnimationDuration;
                            if (!u || !l || void 0 === l.x) return v("initialZoom" + (a ? "Out" : "In")), K = s.initialZoomLevel, w(Be, s.initialPosition), nt(), f.style.opacity = a ? 0 : 1, y(1), void(u ? setTimeout(function() {
                                c()
                            }, u) : c());
                            var d, p;
                            d = W, p = !m.currItem.src || m.currItem.loadError || g.showHideOpacity, s.miniImg && (s.miniImg.style.webkitBackfaceVisibility = "hidden"), a || (K = l.w / s.w, Be.x = l.x, Be.y = l.y - he, m[p ? "template" : "bg"].style.opacity = .001, nt()), $("initialZoom"), a && !d && h.removeClass(f, "pswp--animated-in"), p && (a ? h[(d ? "remove" : "add") + "Class"](f, "pswp--animate_opacity") : setTimeout(function() {
                                h.addClass(f, "pswp--animate_opacity")
                            }, 30)), Ht = setTimeout(function() {
                                if (v("initialZoom" + (a ? "Out" : "In")), a) {
                                    var t = l.w / s.w,
                                        n = Be.x,
                                        i = Be.y,
                                        o = K,
                                        r = He,
                                        e = function(e) {
                                            1 === e ? (K = t, Be.x = l.x, Be.y = l.y - ge) : (K = (t - o) * e + o, Be.x = (l.x - n) * e + n, Be.y = (l.y - ge - i) * e + i), nt(), p ? f.style.opacity = 1 - e : y(r - e * r)
                                        };
                                    d ? D("initialZoom", 0, 1, u, h.easing.cubic.out, e, c) : (e(1), Ht = setTimeout(c, u + 20))
                                } else K = s.initialZoomLevel, w(Be, s.initialPosition), nt(), y(1), p ? f.style.opacity = 1 : y(1), Ht = setTimeout(c, u + 20)
                            }, a ? 25 : 90)
                        },
                        Gt = {},
                        Xt = [],
                        Yt = {
                            index: 0,
                            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                            forceProgressiveLoading: !1,
                            preload: [1, 1],
                            getNumItemsFn: function() {
                                return Rt.length
                            }
                        },
                        Kt = function(e, t, n) {
                            if (!e.src || e.loadError) return e.w = e.h = 0, e.initialZoomLevel = e.fitRatio = 1, e.bounds = Pt(), e.initialPosition = e.bounds.center, e.bounds;
                            var i, o, r, s, a = !n;
                            if (a && (e.vGap || (e.vGap = {
                                    top: 0,
                                    bottom: 0
                                }), v("parseVerticalMargin", e)), Gt.x = t.x, Gt.y = t.y - e.vGap.top - e.vGap.bottom, a) {
                                var l = Gt.x / e.w,
                                    c = Gt.y / e.h;
                                e.fitRatio = l < c ? l : c;
                                var u = g.scaleMode;
                                "orig" === u ? n = 1 : "fit" === u && (n = e.fitRatio), 1 < n && (n = 1), e.initialZoomLevel = n, e.bounds || (e.bounds = Pt())
                            }
                            return n ? (o = (i = e).w * n, r = e.h * n, (s = i.bounds).center.x = Math.round((Gt.x - o) / 2), s.center.y = Math.round((Gt.y - r) / 2) + i.vGap.top, s.max.x = o > Gt.x ? Math.round(Gt.x - o) : s.center.x, s.max.y = r > Gt.y ? Math.round(Gt.y - r) + i.vGap.top : s.center.y, s.min.x = o > Gt.x ? 0 : s.center.x, s.min.y = r > Gt.y ? i.vGap.top : s.center.y, a && n === e.initialZoomLevel && (e.initialPosition = e.bounds.center), e.bounds) : void 0
                        },
                        Vt = function(e, t, n) {
                            if (e.src) {
                                t = t || e.container.lastChild;
                                var i = n ? e.w : Math.round(e.w * e.fitRatio),
                                    o = n ? e.h : Math.round(e.h * e.fitRatio);
                                e.placeholder && !e.loaded && (e.placeholder.style.width = i + "px", e.placeholder.style.height = o + "px"), t.style.width = i + "px", t.style.height = o + "px"
                            }
                        };
                    o("Controller", {
                        publicMethods: {
                            lazyLoadItem: function(e) {
                                e = l(e);
                                var t = Ut(e);
                                t && (!t.loaded && !t.loading || te) && (v("gettingData", e, t), t.src && jt(t))
                            },
                            initController: function() {
                                h.extend(g, Yt, !0), m.items = Rt = e, Ut = m.getItemAt, Bt = g.getNumItemsFn, g.loop, Bt() < 3 && (g.loop = !1), r("beforeChange", function(e) {
                                    var t, n = g.preload,
                                        i = null === e || 0 <= e,
                                        o = Math.min(n[0], Bt()),
                                        r = Math.min(n[1], Bt());
                                    for (t = 1; t <= (i ? r : o); t++) m.lazyLoadItem(U + t);
                                    for (t = 1; t <= (i ? o : r); t++) m.lazyLoadItem(U - t)
                                }), r("initialLayout", function() {
                                    m.currItem.initialLayout = g.getThumbBoundsFn && g.getThumbBoundsFn(U)
                                }), r("mainScrollAnimComplete", qt), r("initialZoomInEnd", qt), r("destroy", function() {
                                    for (var e, t = 0; t < Rt.length; t++)(e = Rt[t]).container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
                                    Xt = null
                                })
                            },
                            getItemAt: function(e) {
                                return 0 <= e && void 0 !== Rt[e] && Rt[e]
                            },
                            allowProgressiveImg: function() {
                                return g.forceProgressiveLoading || !ue || g.mouseUsed || 1200 < screen.width
                            },
                            setContent: function(t, n) {
                                g.loop && (n = l(n));
                                var e = m.getItemAt(t.index);
                                e && (e.container = null);
                                var i, o = m.getItemAt(n);
                                if (o) {
                                    v("gettingData", n, o), t.index = n;
                                    var r = (t.item = o).container = h.createEl("pswp__zoom-wrap");
                                    if (!o.src && o.html && (o.html.tagName ? r.appendChild(o.html) : r.innerHTML = o.html), Nt(o), Kt(o, Ze), !o.src || o.loadError || o.loaded) o.src && !o.loadError && ((i = h.createEl("pswp__img", "img")).style.opacity = 1, i.src = o.src, Vt(o, i), Mt(0, o, r, i));
                                    else {
                                        if (o.loadComplete = function(e) {
                                                if (R) {
                                                    if (t && t.index === n) {
                                                        if (Nt(e, !0)) return e.loadComplete = e.img = null, Kt(e, Ze), it(e), void(t.index === U && m.updateCurrZoomItem());
                                                        e.imageAppended ? !Wt && e.placeholder && (e.placeholder.style.display = "none", e.placeholder = null) : ve.transform && (Me || Wt) ? Xt.push({
                                                            item: e,
                                                            baseDiv: r,
                                                            img: e.img,
                                                            index: n,
                                                            holder: t,
                                                            clearPlaceholder: !0
                                                        }) : Mt(0, e, r, e.img, 0, !0)
                                                    }
                                                    e.loadComplete = null, e.img = null, v("imageLoadComplete", n, e)
                                                }
                                            }, h.features.transform) {
                                            var s = "pswp__img pswp__img--placeholder";
                                            s += o.msrc ? "" : " pswp__img--placeholder--blank";
                                            var a = h.createEl(s, o.msrc ? "img" : "");
                                            o.msrc && (a.src = o.msrc), Vt(o, a), r.appendChild(a), o.placeholder = a
                                        }
                                        o.loading || jt(o), m.allowProgressiveImg() && (!Ft && ve.transform ? Xt.push({
                                            item: o,
                                            baseDiv: r,
                                            img: o.img,
                                            index: n,
                                            holder: t
                                        }) : Mt(0, o, r, o.img, 0, !0))
                                    }
                                    Ft || n !== U ? it(o) : (Pe = r.style, Zt(o, i || o.img)), t.el.innerHTML = "", t.el.appendChild(r)
                                } else t.el.innerHTML = ""
                            },
                            cleanSlide: function(e) {
                                e.img && (e.img.onload = e.img.onerror = null), e.loaded = e.loading = e.img = e.imageAppended = !1
                            }
                        }
                    });

                    function Qt(e, t, n) {
                        var i = document.createEvent("CustomEvent"),
                            o = {
                                origEvent: e,
                                target: e.target,
                                releasePoint: t,
                                pointerType: n || "touch"
                            };
                        i.initCustomEvent("pswpTap", !0, !0, o), e.target.dispatchEvent(i)
                    }
                    var Jt, en, tn = {};
                    o("Tap", {
                        publicMethods: {
                            initTap: function() {
                                r("firstTouchStart", m.onTapStart), r("touchRelease", m.onTapRelease), r("destroy", function() {
                                    tn = {}, Jt = null
                                })
                            },
                            onTapStart: function(e) {
                                1 < e.length && (clearTimeout(Jt), Jt = null)
                            },
                            onTapRelease: function(e, t) {
                                if (t && !$e && !Ae && !at) {
                                    var n = t;
                                    if (Jt && (clearTimeout(Jt), Jt = null, i = n, o = tn, Math.abs(i.x - o.x) < 25 && Math.abs(i.y - o.y) < 25)) return void v("doubleTap", n);
                                    if ("mouse" === t.type) return void Qt(e, t, "mouse");
                                    if ("BUTTON" === e.target.tagName.toUpperCase() || h.hasClass(e.target, "pswp__single-tap")) return void Qt(e, t);
                                    w(tn, n), Jt = setTimeout(function() {
                                        Qt(e, t), Jt = null
                                    }, 300)
                                }
                                var i, o
                            }
                        }
                    }), o("DesktopZoom", {
                        publicMethods: {
                            initDesktopZoom: function() {
                                me || (ue ? r("mouseUsed", function() {
                                    m.setupDesktopZoom()
                                }) : m.setupDesktopZoom(!0))
                            },
                            setupDesktopZoom: function(e) {
                                en = {};
                                var t = "wheel mousewheel DOMMouseScroll";
                                r("bindEvents", function() {
                                    h.bind(f, t, m.handleMouseWheel)
                                }), r("unbindEvents", function() {
                                    en && h.unbind(f, t, m.handleMouseWheel)
                                }), m.mouseZoomedIn = !1;

                                function n() {
                                    m.mouseZoomedIn && (h.removeClass(f, "pswp--zoomed-in"), m.mouseZoomedIn = !1), K < 1 ? h.addClass(f, "pswp--zoom-allowed") : h.removeClass(f, "pswp--zoom-allowed"), o()
                                }
                                var i, o = function() {
                                    i && (h.removeClass(f, "pswp--dragging"), i = !1)
                                };
                                r("resize", n), r("afterChange", n), r("pointerDown", function() {
                                    m.mouseZoomedIn && (i = !0, h.addClass(f, "pswp--dragging"))
                                }), r("pointerUp", o), e || n()
                            },
                            handleMouseWheel: function(e) {
                                if (K <= m.currItem.fitRatio) return g.modal && (!g.closeOnScroll || at || ke ? e.preventDefault() : le && 2 < Math.abs(e.deltaY) && (W = !0, m.close())), !0;
                                if (e.stopPropagation(), en.x = 0, "deltaX" in e) 1 === e.deltaMode ? (en.x = 18 * e.deltaX, en.y = 18 * e.deltaY) : (en.x = e.deltaX, en.y = e.deltaY);
                                else if ("wheelDelta" in e) e.wheelDeltaX && (en.x = -.16 * e.wheelDeltaX), e.wheelDeltaY ? en.y = -.16 * e.wheelDeltaY : en.y = -.16 * e.wheelDelta;
                                else {
                                    if (!("detail" in e)) return;
                                    en.y = e.detail
                                }
                                x(K, !0);
                                var t = Be.x - en.x,
                                    n = Be.y - en.y;
                                (g.modal || t <= Ie.min.x && t >= Ie.max.x && n <= Ie.min.y && n >= Ie.max.y) && e.preventDefault(), m.panTo(t, n)
                            },
                            toggleDesktopZoom: function(e) {
                                e = e || {
                                    x: Ze.x / 2 + Xe.x,
                                    y: Ze.y / 2 + Xe.y
                                };
                                var t = g.getDoubleTapZoom(!0, m.currItem),
                                    n = K === t;
                                m.mouseZoomedIn = !n, m.zoomTo(n ? m.currItem.initialZoomLevel : t, e, 333), h[(n ? "remove" : "add") + "Class"](f, "pswp--zoomed-in")
                            }
                        }
                    });

                    function nn() {
                        return vn.hash.substring(1)
                    }

                    function on() {
                        an && clearTimeout(an), cn && clearTimeout(cn)
                    }

                    function rn() {
                        var e = nn(),
                            t = {};
                        if (e.length < 5) return t;
                        var n, i = e.split("&");
                        for (n = 0; n < i.length; n++)
                            if (i[n]) {
                                var o = i[n].split("=");
                                o.length < 2 || (t[o[0]] = o[1])
                            } if (g.galleryPIDs) {
                            var r = t.pid;
                            for (n = t.pid = 0; n < Rt.length; n++)
                                if (Rt[n].pid === r) {
                                    t.pid = n;
                                    break
                                }
                        } else t.pid = parseInt(t.pid, 10) - 1;
                        return t.pid < 0 && (t.pid = 0), t
                    }

                    function sn() {
                        if (cn && clearTimeout(cn), at || ke) cn = setTimeout(sn, 500);
                        else {
                            un ? clearTimeout(ln) : un = !0;
                            var e = U + 1,
                                t = Ut(U);
                            t.hasOwnProperty("pid") && (e = t.pid);
                            var n = fn + "&gid=" + g.galleryUID + "&pid=" + e;
                            hn || -1 === vn.hash.indexOf(n) && (gn = !0);
                            var i = vn.href.split("#")[0] + "#" + n;
                            yn ? "#" + n !== window.location.hash && history[hn ? "replaceState" : "pushState"]("", document.title, i) : hn ? vn.replace(i) : vn.hash = n, hn = !0, ln = setTimeout(function() {
                                un = !1
                            }, 60)
                        }
                    }
                    var an, ln, cn, un, dn, pn, fn, hn, mn, gn, vn, yn, wn = {
                        history: !0,
                        galleryUID: 1
                    };
                    o("History", {
                        publicMethods: {
                            initHistory: function() {
                                if (h.extend(g, wn, !0), g.history) {
                                    vn = window.location, hn = mn = gn = !1, fn = nn(), yn = "pushState" in history, -1 < fn.indexOf("gid=") && (fn = (fn = fn.split("&gid=")[0]).split("?gid=")[0]), r("afterChange", m.updateURL), r("unbindEvents", function() {
                                        h.unbind(window, "hashchange", m.onHashChange)
                                    });
                                    var e = function() {
                                        pn = !0, mn || (gn ? history.back() : fn ? vn.hash = fn : yn ? history.pushState("", document.title, vn.pathname + vn.search) : vn.hash = ""), on()
                                    };
                                    r("unbindEvents", function() {
                                        W && e()
                                    }), r("destroy", function() {
                                        pn || e()
                                    }), r("firstUpdate", function() {
                                        U = rn().pid
                                    });
                                    var t = fn.indexOf("pid="); - 1 < t && ("&" === (fn = fn.substring(0, t)).slice(-1) && (fn = fn.slice(0, -1))), setTimeout(function() {
                                        R && h.bind(window, "hashchange", m.onHashChange)
                                    }, 40)
                                }
                            },
                            onHashChange: function() {
                                return nn() === fn ? (mn = !0, void m.close()) : void(un || (dn = !0, m.goTo(rn().pid), dn = !1))
                            },
                            updateURL: function() {
                                on(), dn || (hn ? an = setTimeout(sn, 800) : sn())
                            }
                        }
                    }), h.extend(m, lt)
                }
            }, "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? module.exports = h() : f.PhotoSwipe = h(), m = this, g = function() {
                "use strict";
                return function(o, a) {
                    function e(e) {
                        if (_) return !0;
                        e = e || window.event, A.timeToIdle && A.mouseUsed && !b && j();
                        for (var t, n, i = (e.target || e.srcElement).getAttribute("class") || "", o = 0; o < q.length; o++)(t = q[o]).onTap && -1 < i.indexOf("pswp__" + t.name) && (t.onTap(), n = !0);
                        if (n) {
                            e.stopPropagation && e.stopPropagation(), _ = !0;
                            var r = a.features.isOldAndroid ? 600 : 30;
                            setTimeout(function() {
                                _ = !1
                            }, r)
                        }
                    }

                    function n(e, t, n) {
                        a[(n ? "add" : "remove") + "Class"](e, "pswp__" + t)
                    }

                    function i() {
                        var e = 1 === A.getNumItemsFn();
                        e !== k && (n(f, "ui--one-slide", e), k = e)
                    }

                    function t() {
                        n(y, "share-modal--hidden", L)
                    }

                    function r() {
                        return (L = !L) ? (a.removeClass(y, "pswp__share-modal--fade-in"), setTimeout(function() {
                            L && t()
                        }, 300)) : (t(), setTimeout(function() {
                            L || a.addClass(y, "pswp__share-modal--fade-in")
                        }, 30)), L || P(), 0
                    }

                    function s(e) {
                        var t = (e = e || window.event).target || e.srcElement;
                        return o.shout("shareLinkClick", e, t), !(!t.href || !t.hasAttribute("download") && (window.open(t.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), L || r(), 1))
                    }

                    function l(e) {
                        for (var t = 0; t < A.closeElClasses.length; t++)
                            if (a.hasClass(e, "pswp__" + A.closeElClasses[t])) return !0
                    }

                    function c(e) {
                        var t = (e = e || window.event).relatedTarget || e.toElement;
                        t && "HTML" !== t.nodeName || (clearTimeout(E), E = setTimeout(function() {
                            D.setIdle(!0)
                        }, A.timeToIdleOutside))
                    }

                    function u(e) {
                        var t = e.vGap;
                        if (!o.likelyTouchDevice || A.mouseUsed || screen.width > A.fitControlsWidth) {
                            var n = A.barsSize;
                            if (A.captionEl && "auto" === n.bottom)
                                if (m || ((m = a.createEl("pswp__caption pswp__caption--fake")).appendChild(a.createEl("pswp__caption__center")), f.insertBefore(m, h), a.addClass(f, "pswp__ui--fit")), A.addCaptionHTMLFn(e, m, !0)) {
                                    var i = m.clientHeight;
                                    t.bottom = parseInt(i, 10) || 44
                                } else t.bottom = n.top;
                            else t.bottom = "auto" === n.bottom ? 0 : n.bottom;
                            t.top = n.top
                        } else t.top = t.bottom = 0
                    }

                    function d() {
                        function e(e) {
                            if (e)
                                for (var t = e.length, n = 0; n < t; n++) {
                                    o = e[n], r = o.className;
                                    for (var i = 0; i < q.length; i++) s = q[i], -1 < r.indexOf("pswp__" + s.name) && (A[s.option] ? (a.removeClass(o, "pswp__element--disabled"), s.onInit && s.onInit(o)) : a.addClass(o, "pswp__element--disabled"))
                                }
                        }
                        var o, r, s;
                        e(f.children);
                        var t = a.getChildByClass(f, "pswp__top-bar");
                        t && e(t.children)
                    }
                    var p, f, h, m, g, v, y, w, b, x, T, C, S, k, A, _, $, E, D = this,
                        z = !1,
                        O = !0,
                        L = !0,
                        I = {
                            barsSize: {
                                top: 44,
                                bottom: "auto"
                            },
                            closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
                            timeToIdle: 4e3,
                            timeToIdleOutside: 1e3,
                            loadingIndicatorDelay: 1e3,
                            addCaptionHTMLFn: function(e, t) {
                                return e.title ? (t.children[0].innerHTML = e.title, !0) : (t.children[0].innerHTML = "", !1)
                            },
                            closeEl: !0,
                            captionEl: !0,
                            fullscreenEl: !0,
                            zoomEl: !0,
                            shareEl: !0,
                            counterEl: !0,
                            arrowEl: !0,
                            preloaderEl: !0,
                            tapToClose: !1,
                            tapToToggleControls: !0,
                            clickToCloseNonZoomable: !0,
                            shareButtons: [{
                                id: "facebook",
                                label: "Share on Facebook",
                                url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
                            }, {
                                id: "twitter",
                                label: "Tweet",
                                url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
                            }, {
                                id: "pinterest",
                                label: "Pin it",
                                url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                            }, {
                                id: "download",
                                label: "Download image",
                                url: "{{raw_image_url}}",
                                download: !0
                            }],
                            getImageURLForShare: function() {
                                return o.currItem.src || ""
                            },
                            getPageURLForShare: function() {
                                return window.location.href
                            },
                            getTextForShare: function() {
                                return o.currItem.title || ""
                            },
                            indexIndicatorSep: " / ",
                            fitControlsWidth: 1200
                        },
                        P = function() {
                            for (var e, t, n, i, o = "", r = 0; r < A.shareButtons.length; r++) e = A.shareButtons[r], t = A.getImageURLForShare(e), n = A.getPageURLForShare(e), i = A.getTextForShare(e), o += '<a href="' + e.url.replace("{{url}}", encodeURIComponent(n)).replace("{{image_url}}", encodeURIComponent(t)).replace("{{raw_image_url}}", t).replace("{{text}}", encodeURIComponent(i)) + '" target="_blank" class="pswp__share--' + e.id + '"' + (e.download ? "download" : "") + ">" + e.label + "</a>", A.parseShareButtonOut && (o = A.parseShareButtonOut(e, o));
                            y.children[0].innerHTML = o, y.children[0].onclick = s
                        },
                        M = 0,
                        j = function() {
                            clearTimeout(E), M = 0, b && D.setIdle(!1)
                        },
                        N = function(e) {
                            C !== e && (n(T, "preloader--active", !e), C = e)
                        },
                        q = [{
                            name: "caption",
                            option: "captionEl",
                            onInit: function(e) {
                                h = e
                            }
                        }, {
                            name: "share-modal",
                            option: "shareEl",
                            onInit: function(e) {
                                y = e
                            },
                            onTap: function() {
                                r()
                            }
                        }, {
                            name: "button--share",
                            option: "shareEl",
                            onInit: function(e) {
                                v = e
                            },
                            onTap: function() {
                                r()
                            }
                        }, {
                            name: "button--zoom",
                            option: "zoomEl",
                            onTap: o.toggleDesktopZoom
                        }, {
                            name: "counter",
                            option: "counterEl",
                            onInit: function(e) {
                                g = e
                            }
                        }, {
                            name: "button--close",
                            option: "closeEl",
                            onTap: o.close
                        }, {
                            name: "button--arrow--left",
                            option: "arrowEl",
                            onTap: o.prev
                        }, {
                            name: "button--arrow--right",
                            option: "arrowEl",
                            onTap: o.next
                        }, {
                            name: "button--fs",
                            option: "fullscreenEl",
                            onTap: function() {
                                p.isFullscreen() ? p.exit() : p.enter()
                            }
                        }, {
                            name: "preloader",
                            option: "preloaderEl",
                            onInit: function(e) {
                                T = e
                            }
                        }];
                    D.init = function() {
                        var t;
                        a.extend(o.options, I, !0), A = o.options, f = a.getChildByClass(o.scrollWrap, "pswp__ui"), (x = o.listen)("onVerticalDrag", function(e) {
                            O && e < .95 ? D.hideControls() : !O && .95 <= e && D.showControls()
                        }), x("onPinchClose", function(e) {
                            O && e < .9 ? (D.hideControls(), t = !0) : t && !O && .9 < e && D.showControls()
                        }), x("zoomGestureEnded", function() {
                            (t = !1) && !O && D.showControls()
                        }), x("beforeChange", D.update), x("doubleTap", function(e) {
                            var t = o.currItem.initialZoomLevel;
                            o.getZoomLevel() !== t ? o.zoomTo(t, e, 333) : o.zoomTo(A.getDoubleTapZoom(!1, o.currItem), e, 333)
                        }), x("preventDragEvent", function(e, t, n) {
                            var i = e.target || e.srcElement;
                            i && i.getAttribute("class") && -1 < e.type.indexOf("mouse") && (0 < i.getAttribute("class").indexOf("__caption") || /(SMALL|STRONG|EM)/i.test(i.tagName)) && (n.prevent = !1)
                        }), x("bindEvents", function() {
                            a.bind(f, "pswpTap click", e), a.bind(o.scrollWrap, "pswpTap", D.onGlobalTap), o.likelyTouchDevice || a.bind(o.scrollWrap, "mouseover", D.onMouseOver)
                        }), x("unbindEvents", function() {
                            L || r(), $ && clearInterval($), a.unbind(document, "mouseout", c), a.unbind(document, "mousemove", j), a.unbind(f, "pswpTap click", e), a.unbind(o.scrollWrap, "pswpTap", D.onGlobalTap), a.unbind(o.scrollWrap, "mouseover", D.onMouseOver), p && (a.unbind(document, p.eventK, D.updateFullscreen), p.isFullscreen() && (A.hideAnimationDuration = 0, p.exit()), p = null)
                        }), x("destroy", function() {
                            A.captionEl && (m && f.removeChild(m), a.removeClass(h, "pswp__caption--empty")), y && (y.children[0].onclick = null), a.removeClass(f, "pswp__ui--over-close"), a.addClass(f, "pswp__ui--hidden"), D.setIdle(!1)
                        }), A.showAnimationDuration || a.removeClass(f, "pswp__ui--hidden"), x("initialZoomIn", function() {
                            A.showAnimationDuration && a.removeClass(f, "pswp__ui--hidden")
                        }), x("initialZoomOut", function() {
                            a.addClass(f, "pswp__ui--hidden")
                        }), x("parseVerticalMargin", u), d(), A.shareEl && v && y && (L = !0), i(), A.timeToIdle && x("mouseUsed", function() {
                            a.bind(document, "mousemove", j), a.bind(document, "mouseout", c), $ = setInterval(function() {
                                2 === ++M && D.setIdle(!0)
                            }, A.timeToIdle / 2)
                        }), A.fullscreenEl && !a.features.isOldAndroid && ((p = p || D.getFullscreenAPI()) ? (a.bind(document, p.eventK, D.updateFullscreen), D.updateFullscreen(), a.addClass(o.template, "pswp--supports-fs")) : a.removeClass(o.template, "pswp--supports-fs")), A.preloaderEl && (N(!0), x("beforeChange", function() {
                            clearTimeout(S), S = setTimeout(function() {
                                o.currItem && o.currItem.loading ? o.allowProgressiveImg() && (!o.currItem.img || o.currItem.img.naturalWidth) || N(!1) : N(!0)
                            }, A.loadingIndicatorDelay)
                        }), x("imageLoadComplete", function(e, t) {
                            o.currItem === t && N(!0)
                        }))
                    }, D.setIdle = function(e) {
                        n(f, "ui--idle", b = e)
                    }, D.update = function() {
                        z = !(!O || !o.currItem) && (D.updateIndexIndicator(), A.captionEl && (A.addCaptionHTMLFn(o.currItem, h), n(h, "caption--empty", !o.currItem.title)), !0), L || r(), i()
                    }, D.updateFullscreen = function(e) {
                        e && setTimeout(function() {
                            o.setScrollOffset(0, a.getScrollY())
                        }, 50), a[(p.isFullscreen() ? "add" : "remove") + "Class"](o.template, "pswp--fs")
                    }, D.updateIndexIndicator = function() {
                        A.counterEl && (g.innerHTML = o.getCurrentIndex() + 1 + A.indexIndicatorSep + A.getNumItemsFn())
                    }, D.onGlobalTap = function(e) {
                        var t = (e = e || window.event).target || e.srcElement;
                        if (!_)
                            if (e.detail && "mouse" === e.detail.pointerType) {
                                if (l(t)) return void o.close();
                                a.hasClass(t, "pswp__img") && (1 === o.getZoomLevel() && o.getZoomLevel() <= o.currItem.fitRatio ? A.clickToCloseNonZoomable && o.close() : o.toggleDesktopZoom(e.detail.releasePoint))
                            } else if (A.tapToToggleControls && (O ? D.hideControls() : D.showControls()), A.tapToClose && (a.hasClass(t, "pswp__img") || l(t))) return void o.close()
                    }, D.onMouseOver = function(e) {
                        var t = (e = e || window.event).target || e.srcElement;
                        n(f, "ui--over-close", l(t))
                    }, D.hideControls = function() {
                        a.addClass(f, "pswp__ui--hidden"), O = !1
                    }, D.showControls = function() {
                        O = !0, z || D.update(), a.removeClass(f, "pswp__ui--hidden")
                    }, D.supportsFullscreen = function() {
                        var e = document;
                        return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen)
                    }, D.getFullscreenAPI = function() {
                        var e, t = document.documentElement,
                            n = "fullscreenchange";
                        return t.requestFullscreen ? e = {
                            enterK: "requestFullscreen",
                            exitK: "exitFullscreen",
                            elementK: "fullscreenElement",
                            eventK: n
                        } : t.mozRequestFullScreen ? e = {
                            enterK: "mozRequestFullScreen",
                            exitK: "mozCancelFullScreen",
                            elementK: "mozFullScreenElement",
                            eventK: "moz" + n
                        } : t.webkitRequestFullscreen ? e = {
                            enterK: "webkitRequestFullscreen",
                            exitK: "webkitExitFullscreen",
                            elementK: "webkitFullscreenElement",
                            eventK: "webkit" + n
                        } : t.msRequestFullscreen && (e = {
                            enterK: "msRequestFullscreen",
                            exitK: "msExitFullscreen",
                            elementK: "msFullscreenElement",
                            eventK: "MSFullscreenChange"
                        }), e && (e.enter = function() {
                            return w = A.closeOnScroll, A.closeOnScroll = !1, "webkitRequestFullscreen" !== this.enterK ? o.template[this.enterK]() : void o.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
                        }, e.exit = function() {
                            return A.closeOnScroll = w, document[this.exitK]()
                        }, e.isFullscreen = function() {
                            return document[this.elementK]
                        }), e
                    }
                }
            }, "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? module.exports = g() : m.PhotoSwipeUI_Default = g(),
            function(e) {
                "use strict";
                "undefined" != typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
            }(function(c) {
                "use strict";
                var o, r = window.Slick || {};
                o = 0, (r = function(e, t) {
                    var n, i = this;
                    i.defaults = {
                        accessibility: !0,
                        adaptiveHeight: !1,
                        appendArrows: c(e),
                        appendDots: c(e),
                        arrows: !0,
                        asNavFor: null,
                        prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + theme.strings.previous + '" tabindex="0" role="button">' + theme.strings.previous + "</button>",
                        nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + theme.strings.next + '" tabindex="0" role="button">' + theme.strings.next + "</button>",
                        autoplay: !1,
                        autoplaySpeed: 3e3,
                        centerMode: !1,
                        centerPadding: "50px",
                        cssEase: "ease",
                        customPaging: function(e, t) {
                            return c('<button type="button" data-role="none" role="button" tabindex="0" />').text(t + 1)
                        },
                        dots: !1,
                        dotsClass: "slick-dots",
                        draggable: !0,
                        easing: "linear",
                        edgeFriction: .35,
                        fade: !1,
                        focusOnSelect: !1,
                        infinite: !0,
                        initialSlide: 0,
                        lazyLoad: "ondemand",
                        mobileFirst: !1,
                        pauseOnHover: !0,
                        pauseOnFocus: !0,
                        pauseOnDotsHover: !1,
                        respondTo: "window",
                        responsive: null,
                        rows: 1,
                        rtl: !1,
                        slide: "",
                        slidesPerRow: 1,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 500,
                        swipe: !0,
                        swipeToSlide: !1,
                        touchMove: !0,
                        touchThreshold: 5,
                        useCSS: !0,
                        useTransform: !0,
                        variableWidth: !1,
                        vertical: !1,
                        verticalSwiping: !1,
                        waitForAnimate: !0,
                        zIndex: 1e3
                    }, i.initials = {
                        animating: !1,
                        dragging: !1,
                        autoPlayTimer: null,
                        currentDirection: 0,
                        currentLeft: null,
                        currentSlide: 0,
                        direction: 1,
                        $dots: null,
                        listWidth: null,
                        listHeight: null,
                        loadIndex: 0,
                        $nextArrow: null,
                        $prevArrow: null,
                        slideCount: null,
                        slideWidth: null,
                        $slideTrack: null,
                        $slides: null,
                        sliding: !1,
                        slideOffset: 0,
                        swipeLeft: null,
                        $list: null,
                        touchObject: {},
                        transformsEnabled: !1,
                        unslicked: !1
                    }, c.extend(i, i.initials), i.activeBreakpoint = null, i.animType = null, i.animProp = null, i.breakpoints = [], i.breakpointSettings = [], i.cssTransitions = !1, i.focussed = !1, i.interrupted = !1, i.hidden = "hidden", i.paused = !0, i.positionProp = null, i.respondTo = null, i.rowCount = 1, i.shouldClick = !0, i.$slider = c(e), i.$slidesCache = null, i.transformType = null, i.transitionType = null, i.visibilityChange = "visibilitychange", i.windowWidth = 0, i.windowTimer = null, n = c(e).data("slick") || {}, i.options = c.extend({}, i.defaults, t, n), i.currentSlide = i.options.initialSlide, i.originalSettings = i.options, void 0 !== document.mozHidden ? (i.hidden = "mozHidden", i.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (i.hidden = "webkitHidden", i.visibilityChange = "webkitvisibilitychange"), i.autoPlay = c.proxy(i.autoPlay, i), i.autoPlayClear = c.proxy(i.autoPlayClear, i), i.autoPlayIterator = c.proxy(i.autoPlayIterator, i), i.changeSlide = c.proxy(i.changeSlide, i), i.clickHandler = c.proxy(i.clickHandler, i), i.selectHandler = c.proxy(i.selectHandler, i), i.setPosition = c.proxy(i.setPosition, i), i.swipeHandler = c.proxy(i.swipeHandler, i), i.dragHandler = c.proxy(i.dragHandler, i), i.keyHandler = c.proxy(i.keyHandler, i), i.instanceUid = o++, i.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, i.registerBreakpoints(), i.init(!0)
                }).prototype.activateADA = function() {
                    this.$slideTrack.find(".slick-active").attr({
                        "aria-hidden": "false"
                    }).find("a, input, button, select").attr({
                        tabindex: "0"
                    })
                }, r.prototype.addSlide = r.prototype.slickAdd = function(e, t, n) {
                    var i = this;
                    if ("boolean" == typeof t) n = t, t = null;
                    else if (t < 0 || t >= i.slideCount) return !1;
                    i.unload(), "number" == typeof t ? 0 === t && 0 === i.$slides.length ? c(e).appendTo(i.$slideTrack) : n ? c(e).insertBefore(i.$slides.eq(t)) : c(e).insertAfter(i.$slides.eq(t)) : !0 === n ? c(e).prependTo(i.$slideTrack) : c(e).appendTo(i.$slideTrack), i.$slides = i.$slideTrack.children(this.options.slide), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.append(i.$slides), i.$slides.each(function(e, t) {
                        c(t).attr("data-slick-index", e)
                    }), i.$slidesCache = i.$slides, i.reinit()
                }, r.prototype.animateHeight = function() {
                    if (1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical) {
                        var e = this.$slides.eq(this.currentSlide).outerHeight(!0);
                        this.$list.animate({
                            height: e
                        }, this.options.speed)
                    }
                }, r.prototype.animateSlide = function(e, t) {
                    var n = {},
                        i = this;
                    i.animateHeight(), !0 === i.options.rtl && !1 === i.options.vertical && (e = -e), !1 === i.transformsEnabled ? !1 === i.options.vertical ? i.$slideTrack.animate({
                        left: e
                    }, i.options.speed, i.options.easing, t) : i.$slideTrack.animate({
                        top: e
                    }, i.options.speed, i.options.easing, t) : !1 === i.cssTransitions ? (!0 === i.options.rtl && (i.currentLeft = -i.currentLeft), c({
                        animStart: i.currentLeft
                    }).animate({
                        animStart: e
                    }, {
                        duration: i.options.speed,
                        easing: i.options.easing,
                        step: function(e) {
                            e = Math.ceil(e), !1 === i.options.vertical ? n[i.animType] = "translate(" + e + "px, 0px)" : n[i.animType] = "translate(0px," + e + "px)", i.$slideTrack.css(n)
                        },
                        complete: function() {
                            t && t.call()
                        }
                    })) : (i.applyTransition(), e = Math.ceil(e), !1 === i.options.vertical ? n[i.animType] = "translate3d(" + e + "px, 0px, 0px)" : n[i.animType] = "translate3d(0px," + e + "px, 0px)", i.$slideTrack.css(n), t && setTimeout(function() {
                        i.disableTransition(), t.call()
                    }, i.options.speed))
                }, r.prototype.getNavTarget = function() {
                    var e = this.options.asNavFor;
                    return e && null !== e && (e = c(e).not(this.$slider)), e
                }, r.prototype.asNavFor = function(t) {
                    var e = this.getNavTarget();
                    null !== e && "object" == _typeof(e) && e.each(function() {
                        var e = c(this).slick("getSlick");
                        e.unslicked || e.slideHandler(t, !0)
                    })
                }, r.prototype.applyTransition = function(e) {
                    var t = this,
                        n = {};
                    !1 === t.options.fade ? n[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : n[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase, !1 === t.options.fade ? t.$slideTrack.css(n) : t.$slides.eq(e).css(n)
                }, r.prototype.autoPlay = function() {
                    this.autoPlayClear(), this.slideCount > this.options.slidesToShow && (this.autoPlayTimer = setInterval(this.autoPlayIterator, this.options.autoplaySpeed))
                }, r.prototype.autoPlayClear = function() {
                    this.autoPlayTimer && clearInterval(this.autoPlayTimer)
                }, r.prototype.autoPlayIterator = function() {
                    var e = this,
                        t = e.currentSlide + e.options.slidesToScroll;
                    e.paused || e.interrupted || e.focussed || (!1 === e.options.infinite && (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : 0 === e.direction && (t = e.currentSlide - e.options.slidesToScroll, e.currentSlide - 1 == 0 && (e.direction = 1))), e.slideHandler(t))
                }, r.prototype.buildArrows = function() {
                    var e = this;
                    !0 === e.options.arrows && (e.$prevArrow = c(e.options.prevArrow).addClass("slick-arrow"), e.$nextArrow = c(e.options.nextArrow).addClass("slick-arrow"), e.slideCount > e.options.slidesToShow ? (e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.prependTo(e.options.appendArrows), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.appendTo(e.options.appendArrows), !0 !== e.options.infinite && e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({
                        "aria-disabled": "true",
                        tabindex: "-1"
                    }))
                }, r.prototype.buildDots = function() {
                    var e, t, n = this;
                    if (!0 === n.options.dots && n.slideCount > n.options.slidesToShow) {
                        for (n.$slider.addClass("slick-dotted"), t = c("<ul />").addClass(n.options.dotsClass), e = 0; e <= n.getDotCount(); e += 1) t.append(c("<li />").append(n.options.customPaging.call(this, n, e)));
                        n.$dots = t.appendTo(n.options.appendDots), n.$dots.find("li").first().addClass("slick-active").attr("aria-hidden", "false")
                    }
                }, r.prototype.buildOut = function() {
                    var e = this;
                    e.$slides = e.$slider.children(e.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), e.slideCount = e.$slides.length, e.$slides.each(function(e, t) {
                        c(t).attr("data-slick-index", e).data("originalStyling", c(t).attr("style") || "")
                    }), e.$slider.addClass("slick-slider"), e.$slideTrack = 0 === e.slideCount ? c('<div class="slick-track" aria-label="'.concat(theme.strings.imageSlider ? theme.strings.imageSlider : "", '"/>')).appendTo(e.$slider) : e.$slides.wrapAll('<div class="slick-track" aria-label="'.concat(theme.strings.imageSlider ? theme.strings.imageSlider : "", '"/>')).parent(), e.$list = e.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(), e.$slideTrack.css("opacity", 0), !0 !== e.options.centerMode && !0 !== e.options.swipeToSlide || (e.options.slidesToScroll = 1), c("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"), e.setupInfinite(), e.buildArrows(), e.buildDots(), e.updateDots(), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), !0 === e.options.draggable && e.$list.addClass("draggable")
                }, r.prototype.buildRows = function() {
                    var e, t, n, i, o, r, s, a = this;
                    if (i = document.createDocumentFragment(), r = a.$slider.children(), 1 < a.options.rows) {
                        for (s = a.options.slidesPerRow * a.options.rows, o = Math.ceil(r.length / s), e = 0; e < o; e++) {
                            var l = document.createElement("div");
                            for (t = 0; t < a.options.rows; t++) {
                                var c = document.createElement("div");
                                for (n = 0; n < a.options.slidesPerRow; n++) {
                                    var u = e * s + (t * a.options.slidesPerRow + n);
                                    r.get(u) && c.appendChild(r.get(u))
                                }
                                l.appendChild(c)
                            }
                            i.appendChild(l)
                        }
                        a.$slider.empty().append(i), a.$slider.children().children().children().css({
                            width: 100 / a.options.slidesPerRow + "%",
                            display: "inline-block"
                        })
                    }
                }, r.prototype.checkResponsive = function(e, t) {
                    var n, i, o, r = this,
                        s = !1,
                        a = r.$slider.width(),
                        l = window.innerWidth || c(window).width();
                    if ("window" === r.respondTo ? o = l : "slider" === r.respondTo ? o = a : "min" === r.respondTo && (o = Math.min(l, a)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
                        for (n in i = null, r.breakpoints) r.breakpoints.hasOwnProperty(n) && (!1 === r.originalSettings.mobileFirst ? o < r.breakpoints[n] && (i = r.breakpoints[n]) : o > r.breakpoints[n] && (i = r.breakpoints[n]));
                        null !== i ? null !== r.activeBreakpoint && i === r.activeBreakpoint && !t || (r.activeBreakpoint = i, "unslick" === r.breakpointSettings[i] ? r.unslick(i) : (r.options = c.extend({}, r.originalSettings, r.breakpointSettings[i]), !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e)), s = i) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === e && (r.currentSlide = r.options.initialSlide), r.refresh(e), s = i), e || !1 === s || r.$slider.trigger("breakpoint", [r, s])
                    }
                }, r.prototype.changeSlide = function(e, t) {
                    var n, i, o = this,
                        r = c(e.currentTarget);
                    switch (r.is("a") && e.preventDefault(), r.is("li") || (r = r.closest("li")), n = o.slideCount % o.options.slidesToScroll != 0 ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll, e.data.message) {
                        case "previous":
                            i = 0 == n ? o.options.slidesToScroll : o.options.slidesToShow - n, o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - i, !1, t);
                            break;
                        case "next":
                            i = 0 == n ? o.options.slidesToScroll : n, o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + i, !1, t);
                            break;
                        case "index":
                            var s = 0 === e.data.index ? 0 : e.data.index || r.index() * o.options.slidesToScroll;
                            o.slideHandler(o.checkNavigable(s), !1, t), r.children().trigger("focus");
                            break;
                        default:
                            return
                    }
                }, r.prototype.checkNavigable = function(e) {
                    var t, n;
                    if (n = 0, e > (t = this.getNavigableIndexes())[t.length - 1]) e = t[t.length - 1];
                    else
                        for (var i in t) {
                            if (e < t[i]) {
                                e = n;
                                break
                            }
                            n = t[i]
                        }
                    return e
                }, r.prototype.cleanUpEvents = function() {
                    var e = this;
                    e.options.dots && null !== e.$dots && c("li", e.$dots).off("click.slick", e.changeSlide).off("mouseenter.slick", c.proxy(e.interrupt, e, !0)).off("mouseleave.slick", c.proxy(e.interrupt, e, !1)), e.$slider.off("focus.slick blur.slick"), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide), e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)), e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler), e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler), e.$list.off("touchend.slick mouseup.slick", e.swipeHandler), e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler), e.$list.off("click.slick", e.clickHandler), c(document).off(e.visibilityChange, e.visibility), e.cleanUpSlideEvents(), !0 === e.options.accessibility && e.$list.off("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && c(e.$slideTrack).children().off("click.slick", e.selectHandler), c(window).off("orientationchange.slick.slick-" + e.instanceUid, e.orientationChange), c(window).off("resize.slick.slick-" + e.instanceUid, e.resize), c("[draggable!=true]", e.$slideTrack).off("dragstart", e.preventDefault), c(window).off("load.slick.slick-" + e.instanceUid, e.setPosition), c(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition)
                }, r.prototype.cleanUpSlideEvents = function() {
                    this.$list.off("mouseenter.slick", c.proxy(this.interrupt, this, !0)), this.$list.off("mouseleave.slick", c.proxy(this.interrupt, this, !1))
                }, r.prototype.cleanUpRows = function() {
                    var e;
                    1 < this.options.rows && ((e = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(e))
                }, r.prototype.clickHandler = function(e) {
                    !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault())
                }, r.prototype.destroy = function(e) {
                    var t = this;
                    t.autoPlayClear(), t.touchObject = {}, t.cleanUpEvents(), c(".slick-cloned", t.$slider).detach(), t.$dots && t.$dots.remove(), t.$prevArrow && t.$prevArrow.length && (t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()), t.$nextArrow && t.$nextArrow.length && (t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()), t.$slides && (t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
                        c(this).attr("style", c(this).data("originalStyling"))
                    }), t.$slideTrack.children(this.options.slide).detach(), t.$slideTrack.detach(), t.$list.detach(), t.$slider.append(t.$slides)), t.cleanUpRows(), t.$slider.removeClass("slick-slider"), t.$slider.removeClass("slick-initialized"), t.$slider.removeClass("slick-dotted"), t.unslicked = !0, e || t.$slider.trigger("destroy", [t])
                }, r.prototype.disableTransition = function(e) {
                    var t = {};
                    t[this.transitionType] = "", !1 === this.options.fade ? this.$slideTrack.css(t) : this.$slides.eq(e).css(t)
                }, r.prototype.fadeSlide = function(e, t) {
                    var n = this;
                    !1 === n.cssTransitions ? (n.$slides.eq(e).css({
                        zIndex: n.options.zIndex
                    }), n.$slides.eq(e).animate({
                        opacity: 1
                    }, n.options.speed, n.options.easing, t)) : (n.applyTransition(e), n.$slides.eq(e).css({
                        opacity: 1,
                        zIndex: n.options.zIndex
                    }), t && setTimeout(function() {
                        n.disableTransition(e), t.call()
                    }, n.options.speed))
                }, r.prototype.fadeSlideOut = function(e) {
                    !1 === this.cssTransitions ? this.$slides.eq(e).animate({
                        opacity: 0,
                        zIndex: this.options.zIndex - 2
                    }, this.options.speed, this.options.easing) : (this.applyTransition(e), this.$slides.eq(e).css({
                        opacity: 0,
                        zIndex: this.options.zIndex - 2
                    }))
                }, r.prototype.filterSlides = r.prototype.slickFilter = function(e) {
                    null !== e && (this.$slidesCache = this.$slides, this.unload(), this.$slideTrack.children(this.options.slide).detach(), this.$slidesCache.filter(e).appendTo(this.$slideTrack), this.reinit())
                }, r.prototype.focusHandler = function() {
                    var n = this;
                    n.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*:not(.slick-arrow)", function(e) {
                        var t = c(this);
                        setTimeout(function() {
                            n.options.pauseOnFocus && (n.focussed = t.is(":focus"), n.autoPlay())
                        }, 0)
                    })
                }, r.prototype.getCurrent = r.prototype.slickCurrentSlide = function() {
                    return this.currentSlide
                }, r.prototype.getDotCount = function() {
                    var e = this,
                        t = 0,
                        n = 0,
                        i = 0;
                    if (!0 === e.options.infinite)
                        for (; t < e.slideCount;) ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
                    else if (!0 === e.options.centerMode) i = e.slideCount;
                    else if (e.options.asNavFor)
                        for (; t < e.slideCount;) ++i, t = n + e.options.slidesToScroll, n += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
                    else i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
                    return i - 1
                }, r.prototype.getLeft = function(e) {
                    var t, n, i, o = this,
                        r = 0;
                    return o.slideOffset = 0, n = o.$slides.first().outerHeight(!0), !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = o.slideWidth * o.options.slidesToShow * -1, r = n * o.options.slidesToShow * -1), o.slideCount % o.options.slidesToScroll != 0 && e + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (r = e > o.slideCount ? (o.slideOffset = (o.options.slidesToShow - (e - o.slideCount)) * o.slideWidth * -1, (o.options.slidesToShow - (e - o.slideCount)) * n * -1) : (o.slideOffset = o.slideCount % o.options.slidesToScroll * o.slideWidth * -1, o.slideCount % o.options.slidesToScroll * n * -1))) : e + o.options.slidesToShow > o.slideCount && (o.slideOffset = (e + o.options.slidesToShow - o.slideCount) * o.slideWidth, r = (e + o.options.slidesToShow - o.slideCount) * n), o.slideCount <= o.options.slidesToShow && (r = o.slideOffset = 0), !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0, o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)), t = !1 === o.options.vertical ? e * o.slideWidth * -1 + o.slideOffset : e * n * -1 + r, !0 === o.options.variableWidth && (i = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow), t = !0 === o.options.rtl ? i[0] ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, !0 === o.options.centerMode && (i = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow + 1), t = !0 === o.options.rtl ? i[0] ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, t += (o.$list.width() - i.outerWidth()) / 2)), t
                }, r.prototype.getOption = r.prototype.slickGetOption = function(e) {
                    return this.options[e]
                }, r.prototype.getNavigableIndexes = function() {
                    var e, t = this,
                        n = 0,
                        i = 0,
                        o = [];
                    for (e = !1 === t.options.infinite ? t.slideCount : (n = -1 * t.options.slidesToScroll, i = -1 * t.options.slidesToScroll, 2 * t.slideCount); n < e;) o.push(n), n = i + t.options.slidesToScroll, i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
                    return o
                }, r.prototype.getSlick = function() {
                    return this
                }, r.prototype.getSlideCount = function() {
                    var n, i, o = this;
                    return i = !0 === o.options.centerMode ? o.slideWidth * Math.floor(o.options.slidesToShow / 2) : 0, !0 === o.options.swipeToSlide ? (o.$slideTrack.find(".slick-slide").each(function(e, t) {
                        return t.offsetLeft - i + c(t).outerWidth() / 2 > -1 * o.swipeLeft ? (n = t, !1) : void 0
                    }), Math.abs(c(n).attr("data-slick-index") - o.currentSlide) || 1) : o.options.slidesToScroll
                }, r.prototype.goTo = r.prototype.slickGoTo = function(e, t) {
                    this.changeSlide({
                        data: {
                            message: "index",
                            index: parseInt(e)
                        }
                    }, t)
                }, r.prototype.init = function(e) {
                    var t = this;
                    c(t.$slider).hasClass("slick-initialized") || (c(t.$slider).addClass("slick-initialized"), t.buildRows(), t.buildOut(), t.setProps(), t.startLoad(), t.loadSlider(), t.initializeEvents(), t.updateArrows(), t.updateDots(), t.checkResponsive(!0), t.focusHandler()), e && t.$slider.trigger("init", [t]), !0 === t.options.accessibility && t.initADA(), t.options.autoplay && (t.paused = !1, t.autoPlay())
                }, r.prototype.initADA = function() {
                    var t = this;
                    t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({
                        "aria-hidden": "true",
                        tabindex: "-1"
                    }).find("a, input, button, select").attr({
                        tabindex: "-1"
                    }), t.$slideTrack.attr("role", "listbox"), t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function(e) {
                        c(this).attr({
                            role: "option"
                        })
                    }), null !== t.$dots && t.$dots.attr("aria-hidden", "true").find("li").each(function(e) {
                        c(this).attr({
                            role: "presentation",
                            "aria-selected": "false",
                            "aria-controls": "navigation" + t.instanceUid + e,
                            id: "slick-slide" + t.instanceUid + e
                        })
                    }).first().attr("aria-selected", "true").end().find("button").attr("role", "button").end().closest("div").attr("role", "toolbar"), t.activateADA()
                }, r.prototype.initArrowEvents = function() {
                    !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.off("click.slick").on("click.slick", {
                        message: "previous"
                    }, this.changeSlide), this.$nextArrow.off("click.slick").on("click.slick", {
                        message: "next"
                    }, this.changeSlide))
                }, r.prototype.initDotEvents = function() {
                    var e = this;
                    !0 === e.options.dots && e.slideCount > e.options.slidesToShow && c("li", e.$dots).on("click.slick", {
                        message: "index"
                    }, e.changeSlide), !0 === e.options.dots && !0 === e.options.pauseOnDotsHover && c("li", e.$dots).on("mouseenter.slick", c.proxy(e.interrupt, e, !0)).on("mouseleave.slick", c.proxy(e.interrupt, e, !1))
                }, r.prototype.initSlideEvents = function() {
                    this.options.pauseOnHover && (this.$list.on("mouseenter.slick", c.proxy(this.interrupt, this, !0)), this.$list.on("mouseleave.slick", c.proxy(this.interrupt, this, !1)))
                }, r.prototype.initializeEvents = function() {
                    var e = this;
                    e.initArrowEvents(), e.initDotEvents(), e.initSlideEvents(), e.$list.on("touchstart.slick mousedown.slick", {
                        action: "start"
                    }, e.swipeHandler), e.$list.on("touchmove.slick mousemove.slick", {
                        action: "move"
                    }, e.swipeHandler), e.$list.on("touchend.slick mouseup.slick", {
                        action: "end"
                    }, e.swipeHandler), e.$list.on("touchcancel.slick mouseleave.slick", {
                        action: "end"
                    }, e.swipeHandler), e.$list.on("click.slick", e.clickHandler), c(document).on(e.visibilityChange, c.proxy(e.visibility, e)), !0 === e.options.accessibility && e.$list.on("keydown.slick", e.keyHandler), !0 === e.options.focusOnSelect && c(e.$slideTrack).children().on("click.slick", e.selectHandler), c(window).on("orientationchange.slick.slick-" + e.instanceUid, c.proxy(e.orientationChange, e)), c(window).on("resize.slick.slick-" + e.instanceUid, c.proxy(e.resize, e)), c("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault), c(window).on("load.slick.slick-" + e.instanceUid, e.setPosition), c(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition)
                }, r.prototype.initUI = function() {
                    !0 === this.options.arrows && this.slideCount > this.options.slidesToShow && (this.$prevArrow.show(), this.$nextArrow.show()), !0 === this.options.dots && this.slideCount > this.options.slidesToShow && this.$dots.show()
                }, r.prototype.keyHandler = function(e) {
                    e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === e.keyCode && !0 === this.options.accessibility ? this.changeSlide({
                        data: {
                            message: !0 === this.options.rtl ? "next" : "previous"
                        }
                    }) : 39 === e.keyCode && !0 === this.options.accessibility && this.changeSlide({
                        data: {
                            message: !0 === this.options.rtl ? "previous" : "next"
                        }
                    }))
                }, r.prototype.lazyLoad = function() {
                    function e(e) {
                        c("img[data-lazy]", e).each(function() {
                            var e = c(this),
                                t = c(this).attr("data-lazy"),
                                n = document.createElement("img");
                            n.onload = function() {
                                e.animate({
                                    opacity: 0
                                }, 100, function() {
                                    e.attr("src", t).animate({
                                        opacity: 1
                                    }, 200, function() {
                                        e.removeAttr("data-lazy").removeClass("slick-loading")
                                    }), i.$slider.trigger("lazyLoaded", [i, e, t])
                                })
                            }, n.onerror = function() {
                                e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), i.$slider.trigger("lazyLoadError", [i, e, t])
                            }, n.src = t
                        })
                    }
                    var t, n, i = this;
                    !0 === i.options.centerMode ? n = !0 === i.options.infinite ? (t = i.currentSlide + (i.options.slidesToShow / 2 + 1)) + i.options.slidesToShow + 2 : (t = Math.max(0, i.currentSlide - (i.options.slidesToShow / 2 + 1)), i.options.slidesToShow / 2 + 1 + 2 + i.currentSlide) : (t = i.options.infinite ? i.options.slidesToShow + i.currentSlide : i.currentSlide, n = Math.ceil(t + i.options.slidesToShow), !0 === i.options.fade && (0 < t && t--, n <= i.slideCount && n++)), e(i.$slider.find(".slick-slide").slice(t, n)), i.slideCount <= i.options.slidesToShow ? e(i.$slider.find(".slick-slide")) : i.currentSlide >= i.slideCount - i.options.slidesToShow ? e(i.$slider.find(".slick-cloned").slice(0, i.options.slidesToShow)) : 0 === i.currentSlide && e(i.$slider.find(".slick-cloned").slice(-1 * i.options.slidesToShow))
                }, r.prototype.loadSlider = function() {
                    this.setPosition(), this.$slideTrack.css({
                        opacity: 1
                    }), this.$slider.removeClass("slick-loading"), this.initUI(), "progressive" === this.options.lazyLoad && this.progressiveLazyLoad()
                }, r.prototype.next = r.prototype.slickNext = function() {
                    this.changeSlide({
                        data: {
                            message: "next"
                        }
                    })
                }, r.prototype.orientationChange = function() {
                    this.checkResponsive(), this.setPosition()
                }, r.prototype.pause = r.prototype.slickPause = function() {
                    this.autoPlayClear(), this.paused = !0
                }, r.prototype.play = r.prototype.slickPlay = function() {
                    this.autoPlay(), this.options.autoplay = !0, this.paused = !1, this.focussed = !1, this.interrupted = !1
                }, r.prototype.postSlide = function(e) {
                    var t = this;
                    t.unslicked || (t.$slider.trigger("afterChange", [t, e]), t.animating = !1, t.setPosition(), t.swipeLeft = null, t.options.autoplay && t.autoPlay(), !0 === t.options.accessibility && t.initADA())
                }, r.prototype.prev = r.prototype.slickPrev = function() {
                    this.changeSlide({
                        data: {
                            message: "previous"
                        }
                    })
                }, r.prototype.preventDefault = function(e) {
                    e.preventDefault()
                }, r.prototype.progressiveLazyLoad = function(e) {
                    e = e || 1;
                    var t, n, i, o = this,
                        r = c("img[data-lazy]", o.$slider);
                    r.length ? (t = r.first(), n = t.attr("data-lazy"), (i = document.createElement("img")).onload = function() {
                        t.attr("src", n).removeAttr("data-lazy").removeClass("slick-loading"), !0 === o.options.adaptiveHeight && o.setPosition(), o.$slider.trigger("lazyLoaded", [o, t, n]), o.progressiveLazyLoad()
                    }, i.onerror = function() {
                        e < 3 ? setTimeout(function() {
                            o.progressiveLazyLoad(e + 1)
                        }, 500) : (t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), o.$slider.trigger("lazyLoadError", [o, t, n]), o.progressiveLazyLoad())
                    }, i.src = n) : o.$slider.trigger("allImagesLoaded", [o])
                }, r.prototype.refresh = function(e) {
                    var t, n, i = this;
                    n = i.slideCount - i.options.slidesToShow, !i.options.infinite && i.currentSlide > n && (i.currentSlide = n), i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0), t = i.currentSlide, i.destroy(!0), c.extend(i, i.initials, {
                        currentSlide: t
                    }), i.init(), e || i.changeSlide({
                        data: {
                            message: "index",
                            index: t
                        }
                    }, !1)
                }, r.prototype.registerBreakpoints = function() {
                    var e, t, n, i = this,
                        o = i.options.responsive || null;
                    if ("array" === c.type(o) && o.length) {
                        for (e in i.respondTo = i.options.respondTo || "window", o)
                            if (n = i.breakpoints.length - 1, t = o[e].breakpoint, o.hasOwnProperty(e)) {
                                for (; 0 <= n;) i.breakpoints[n] && i.breakpoints[n] === t && i.breakpoints.splice(n, 1), n--;
                                i.breakpoints.push(t), i.breakpointSettings[t] = o[e].settings
                            } i.breakpoints.sort(function(e, t) {
                            return i.options.mobileFirst ? e - t : t - e
                        })
                    }
                }, r.prototype.reinit = function() {
                    var e = this;
                    e.$slides = e.$slideTrack.children(e.options.slide).addClass("slick-slide"), e.slideCount = e.$slides.length, e.currentSlide >= e.slideCount && 0 !== e.currentSlide && (e.currentSlide = e.currentSlide - e.options.slidesToScroll), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), e.registerBreakpoints(), e.setProps(), e.setupInfinite(), e.buildArrows(), e.updateArrows(), e.initArrowEvents(), e.buildDots(), e.updateDots(), e.initDotEvents(), e.cleanUpSlideEvents(), e.initSlideEvents(), e.checkResponsive(!1, !0), !0 === e.options.focusOnSelect && c(e.$slideTrack).children().on("click.slick", e.selectHandler), e.setSlideClasses("number" == typeof e.currentSlide ? e.currentSlide : 0), e.setPosition(), e.focusHandler(), e.paused = !e.options.autoplay, e.autoPlay(), e.$slider.trigger("reInit", [e])
                }, r.prototype.resize = function() {
                    var e = this;
                    c(window).width() !== e.windowWidth && (clearTimeout(e.windowDelay), e.windowDelay = window.setTimeout(function() {
                        e.windowWidth = c(window).width(), e.checkResponsive(), e.unslicked || e.setPosition()
                    }, 50))
                }, r.prototype.removeSlide = r.prototype.slickRemove = function(e, t, n) {
                    var i = this;
                    return e = "boolean" == typeof e ? !0 === (t = e) ? 0 : i.slideCount - 1 : !0 === t ? --e : e, !(i.slideCount < 1 || e < 0 || e > i.slideCount - 1) && (i.unload(), !0 === n ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(), i.$slides = i.$slideTrack.children(this.options.slide), i.$slideTrack.children(this.options.slide).detach(), i.$slideTrack.append(i.$slides), i.$slidesCache = i.$slides, void i.reinit())
                }, r.prototype.setCSS = function(e) {
                    var t, n, i = this,
                        o = {};
                    !0 === i.options.rtl && (e = -e), t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px", n = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px", o[i.positionProp] = e, !1 === i.transformsEnabled || (!(o = {}) === i.cssTransitions ? o[i.animType] = "translate(" + t + ", " + n + ")" : o[i.animType] = "translate3d(" + t + ", " + n + ", 0px)"), i.$slideTrack.css(o)
                }, r.prototype.setDimensions = function() {
                    var e = this;
                    !1 === e.options.vertical ? !0 === e.options.centerMode && e.$list.css({
                        padding: "0px " + e.options.centerPadding
                    }) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({
                        padding: e.options.centerPadding + " 0px"
                    })), e.listWidth = e.$list.width(), e.listHeight = e.$list.height(), !1 === e.options.vertical && !1 === e.options.variableWidth ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : !0 === e.options.variableWidth ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
                    var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
                    !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t)
                }, r.prototype.setFade = function() {
                    var n, i = this;
                    i.$slides.each(function(e, t) {
                        n = i.slideWidth * e * -1, !0 === i.options.rtl ? c(t).css({
                            position: "relative",
                            right: n,
                            top: 0,
                            zIndex: i.options.zIndex - 2,
                            opacity: 0
                        }) : c(t).css({
                            position: "relative",
                            left: n,
                            top: 0,
                            zIndex: i.options.zIndex - 2,
                            opacity: 0
                        })
                    }), i.$slides.eq(i.currentSlide).css({
                        zIndex: i.options.zIndex - 1,
                        opacity: 1
                    })
                }, r.prototype.setHeight = function() {
                    if (1 === this.options.slidesToShow && !0 === this.options.adaptiveHeight && !1 === this.options.vertical) {
                        var e = this.$slides.eq(this.currentSlide).outerHeight(!0);
                        this.$list.css("height", e)
                    }
                }, r.prototype.setOption = r.prototype.slickSetOption = function() {
                    var e, t, n, i, o, r = this,
                        s = !1;
                    if ("object" === c.type(arguments[0]) ? (n = arguments[0], s = arguments[1], o = "multiple") : "string" === c.type(arguments[0]) && (i = arguments[1], s = arguments[2], "responsive" === (n = arguments[0]) && "array" === c.type(arguments[1]) ? o = "responsive" : void 0 !== arguments[1] && (o = "single")), "single" === o) r.options[n] = i;
                    else if ("multiple" === o) c.each(n, function(e, t) {
                        r.options[e] = t
                    });
                    else if ("responsive" === o)
                        for (t in i)
                            if ("array" !== c.type(r.options.responsive)) r.options.responsive = [i[t]];
                            else {
                                for (e = r.options.responsive.length - 1; 0 <= e;) r.options.responsive[e].breakpoint === i[t].breakpoint && r.options.responsive.splice(e, 1), e--;
                                r.options.responsive.push(i[t])
                            } s && (r.unload(), r.reinit())
                }, r.prototype.setPosition = function() {
                    this.setDimensions(), this.setHeight(), !1 === this.options.fade ? this.setCSS(this.getLeft(this.currentSlide)) : this.setFade(), this.$slider.trigger("setPosition", [this])
                }, r.prototype.setProps = function() {
                    var e = this,
                        t = document.body.style;
                    e.positionProp = !0 === e.options.vertical ? "top" : "left", "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"), void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition || !0 !== e.options.useCSS || (e.cssTransitions = !0), e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex), void 0 !== t.OTransform && (e.animType = "OTransform", e.transformType = "-o-transform", e.transitionType = "OTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.MozTransform && (e.animType = "MozTransform", e.transformType = "-moz-transform", e.transitionType = "MozTransition", void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)), void 0 !== t.webkitTransform && (e.animType = "webkitTransform", e.transformType = "-webkit-transform", e.transitionType = "webkitTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)), void 0 !== t.msTransform && (e.animType = "msTransform", e.transformType = "-ms-transform", e.transitionType = "msTransition", void 0 === t.msTransform && (e.animType = !1)), void 0 !== t.transform && !1 !== e.animType && (e.animType = "transform", e.transformType = "transform", e.transitionType = "transition"), e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType
                }, r.prototype.setSlideClasses = function(e) {
                    var t, n, i, o, r = this;
                    n = r.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), r.$slides.eq(e).addClass("slick-current"), !0 === r.options.centerMode ? (t = Math.floor(r.options.slidesToShow / 2), !0 === r.options.infinite && (t <= e && e <= r.slideCount - 1 - t ? r.$slides.slice(e - t, e + t + 1).addClass("slick-active").attr("aria-hidden", "false") : (i = r.options.slidesToShow + e, n.slice(i - t + 1, i + t + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === e ? n.eq(n.length - 1 - r.options.slidesToShow).addClass("slick-center") : e === r.slideCount - 1 && n.eq(r.options.slidesToShow).addClass("slick-center")), r.$slides.eq(e).addClass("slick-center")) : 0 <= e && e <= r.slideCount - r.options.slidesToShow ? r.$slides.slice(e, e + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : n.length <= r.options.slidesToShow ? n.addClass("slick-active").attr("aria-hidden", "false") : (o = r.slideCount % r.options.slidesToShow, i = !0 === r.options.infinite ? r.options.slidesToShow + e : e, r.options.slidesToShow == r.options.slidesToScroll && r.slideCount - e < r.options.slidesToShow ? n.slice(i - (r.options.slidesToShow - o), i + o).addClass("slick-active").attr("aria-hidden", "false") : n.slice(i, i + r.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" === r.options.lazyLoad && r.lazyLoad()
                }, r.prototype.setupInfinite = function() {
                    var e, t, n, i = this;
                    if (!0 === i.options.fade && (i.options.centerMode = !1), !0 === i.options.infinite && !1 === i.options.fade && (t = null, i.slideCount > i.options.slidesToShow)) {
                        for (n = !0 === i.options.centerMode ? i.options.slidesToShow + 1 : i.options.slidesToShow, e = i.slideCount; e > i.slideCount - n; --e) t = e - 1, c(i.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t - i.slideCount).prependTo(i.$slideTrack).addClass("slick-cloned");
                        for (e = 0; e < n; e += 1) t = e, c(i.$slides[t]).clone(!0).attr("id", "").attr("data-slick-index", t + i.slideCount).appendTo(i.$slideTrack).addClass("slick-cloned");
                        i.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
                            c(this).attr("id", "")
                        })
                    }
                }, r.prototype.interrupt = function(e) {
                    e || this.autoPlay(), this.interrupted = e
                }, r.prototype.selectHandler = function(e) {
                    var t = c(e.target).is(".slick-slide") ? c(e.target) : c(e.target).parents(".slick-slide"),
                        n = parseInt(t.attr("data-slick-index"));
                    return n = n || 0, this.slideCount <= this.options.slidesToShow ? (this.setSlideClasses(n), void this.asNavFor(n)) : void this.slideHandler(n)
                }, r.prototype.slideHandler = function(e, t, n) {
                    var i, o, r, s, a, l = null,
                        c = this;
                    return t = t || !1, !0 === c.animating && !0 === c.options.waitForAnimate || !0 === c.options.fade && c.currentSlide === e || c.slideCount <= c.options.slidesToShow ? void 0 : (!1 === t && c.asNavFor(e), i = e, l = c.getLeft(i), s = c.getLeft(c.currentSlide), c.currentLeft = null === c.swipeLeft ? s : c.swipeLeft, !1 === c.options.infinite && !1 === c.options.centerMode && (e < 0 || e > c.getDotCount() * c.options.slidesToScroll) || !1 === c.options.infinite && !0 === c.options.centerMode && (e < 0 || e > c.slideCount - c.options.slidesToScroll) ? void(!1 === c.options.fade && (i = c.currentSlide, !0 !== n ? c.animateSlide(s, function() {
                        c.postSlide(i)
                    }) : c.postSlide(i))) : (c.options.autoplay && clearInterval(c.autoPlayTimer), o = i < 0 ? c.slideCount % c.options.slidesToScroll != 0 ? c.slideCount - c.slideCount % c.options.slidesToScroll : c.slideCount + i : i >= c.slideCount ? c.slideCount % c.options.slidesToScroll != 0 ? 0 : i - c.slideCount : i, c.animating = !0, c.$slider.trigger("beforeChange", [c, c.currentSlide, o]), r = c.currentSlide, c.currentSlide = o, c.setSlideClasses(c.currentSlide), c.options.asNavFor && ((a = (a = c.getNavTarget()).slick("getSlick")).slideCount <= a.options.slidesToShow && a.setSlideClasses(c.currentSlide)), c.updateDots(), c.updateArrows(), !0 === c.options.fade ? (!0 !== n ? (c.fadeSlideOut(r), c.fadeSlide(o, function() {
                        c.postSlide(o)
                    })) : c.postSlide(o), void c.animateHeight()) : void(!0 !== n ? c.animateSlide(l, function() {
                        c.postSlide(o)
                    }) : c.postSlide(o))))
                }, r.prototype.startLoad = function() {
                    var e = this;
                    !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()), !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(), e.$slider.addClass("slick-loading")
                }, r.prototype.swipeDirection = function() {
                    var e, t, n, i;
                    return e = this.touchObject.startX - this.touchObject.curX, t = this.touchObject.startY - this.touchObject.curY, n = Math.atan2(t, e), (i = Math.round(180 * n / Math.PI)) < 0 && (i = 360 - Math.abs(i)), i <= 45 && 0 <= i || i <= 360 && 315 <= i ? !1 === this.options.rtl ? "left" : "right" : 135 <= i && i <= 225 ? !1 === this.options.rtl ? "right" : "left" : !0 === this.options.verticalSwiping ? 35 <= i && i <= 135 ? "down" : "up" : "vertical"
                }, r.prototype.swipeEnd = function(e) {
                    var t, n, i = this;
                    if (i.dragging = !1, i.interrupted = !1, i.shouldClick = !(10 < i.touchObject.swipeLength), void 0 === i.touchObject.curX) return !1;
                    if (!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe) {
                        switch (n = i.swipeDirection()) {
                            case "left":
                            case "down":
                                t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount(), i.currentDirection = 0;
                                break;
                            case "right":
                            case "up":
                                t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount(), i.currentDirection = 1
                        }
                        "vertical" != n && (i.slideHandler(t), i.touchObject = {}, i.$slider.trigger("swipe", [i, n]))
                    } else i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), i.touchObject = {})
                }, r.prototype.swipeHandler = function(e) {
                    var t = this;
                    if (!(!1 === t.options.swipe || "ontouchend" in document && !1 === t.options.swipe || !1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))) switch (t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1, t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold, !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold), e.data.action) {
                        case "start":
                            t.swipeStart(e);
                            break;
                        case "move":
                            t.swipeMove(e);
                            break;
                        case "end":
                            t.swipeEnd(e)
                    }
                }, r.prototype.swipeMove = function(e) {
                    var t, n, i, o, r, s = this;
                    return r = void 0 !== e.originalEvent ? e.originalEvent.touches : null, !(!s.dragging || r && 1 !== r.length) && (t = s.getLeft(s.currentSlide), s.touchObject.curX = void 0 !== r ? r[0].pageX : e.clientX, s.touchObject.curY = void 0 !== r ? r[0].pageY : e.clientY, s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))), !0 === s.options.verticalSwiping && (s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2)))), "vertical" !== (n = s.swipeDirection()) ? (void 0 !== e.originalEvent && 4 < s.touchObject.swipeLength && e.preventDefault(), o = (!1 === s.options.rtl ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1), !0 === s.options.verticalSwiping && (o = s.touchObject.curY > s.touchObject.startY ? 1 : -1), i = s.touchObject.swipeLength, (s.touchObject.edgeHit = !1) === s.options.infinite && (0 === s.currentSlide && "right" === n || s.currentSlide >= s.getDotCount() && "left" === n) && (i = s.touchObject.swipeLength * s.options.edgeFriction, s.touchObject.edgeHit = !0), !1 === s.options.vertical ? s.swipeLeft = t + i * o : s.swipeLeft = t + i * (s.$list.height() / s.listWidth) * o, !0 === s.options.verticalSwiping && (s.swipeLeft = t + i * o), !0 !== s.options.fade && !1 !== s.options.touchMove && (!0 === s.animating ? (s.swipeLeft = null, !1) : void s.setCSS(s.swipeLeft))) : void 0)
                }, r.prototype.swipeStart = function(e) {
                    var t, n = this;
                    return n.interrupted = !0, 1 !== n.touchObject.fingerCount || n.slideCount <= n.options.slidesToShow ? !(n.touchObject = {}) : (void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]), n.touchObject.startX = n.touchObject.curX = void 0 !== t ? t.pageX : e.clientX, n.touchObject.startY = n.touchObject.curY = void 0 !== t ? t.pageY : e.clientY, void(n.dragging = !0))
                }, r.prototype.unfilterSlides = r.prototype.slickUnfilter = function() {
                    null !== this.$slidesCache && (this.unload(), this.$slideTrack.children(this.options.slide).detach(), this.$slidesCache.appendTo(this.$slideTrack), this.reinit())
                }, r.prototype.unload = function() {
                    var e = this;
                    c(".slick-cloned", e.$slider).remove(), e.$dots && e.$dots.remove(), e.$prevArrow && e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove(), e.$nextArrow && e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove(), e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
                }, r.prototype.unslick = function(e) {
                    this.$slider.trigger("unslick", [this, e]), this.destroy()
                }, r.prototype.updateArrows = function() {
                    var e = this;
                    Math.floor(e.options.slidesToShow / 2), !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : (e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode || e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode) && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
                }, r.prototype.updateDots = function() {
                    null !== this.$dots && (this.$dots.find("li").removeClass("slick-active").attr("aria-hidden", "true"), this.$dots.find("li").eq(Math.floor(this.currentSlide / this.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden", "false"))
                }, r.prototype.visibility = function() {
                    this.options.autoplay && (document[this.hidden] ? this.interrupted = !0 : this.interrupted = !1)
                }, c.fn.slick = function() {
                    var e, t, n = arguments[0],
                        i = Array.prototype.slice.call(arguments, 1),
                        o = this.length;
                    for (e = 0; e < o; e++)
                        if ("object" == _typeof(n) || void 0 === n ? this[e].slick = new r(this[e], n) : t = this[e].slick[n].apply(this[e].slick, i), void 0 !== t) return t;
                    return this
                }
            }), v = jQuery, y = document, w = window, ie = {
                html: !1,
                photo: !1,
                iframe: !1,
                inline: !1,
                transition: "elastic",
                speed: 300,
                fadeOut: 300,
                width: !1,
                initialWidth: "600",
                innerWidth: !1,
                maxWidth: !1,
                height: !1,
                initialHeight: "450",
                innerHeight: !1,
                maxHeight: !1,
                scalePhotos: !0,
                scrolling: !0,
                opacity: .9,
                preloading: !0,
                className: !1,
                overlayClose: !0,
                escKey: !0,
                arrowKey: !0,
                top: !1,
                bottom: !1,
                left: !1,
                right: !1,
                fixed: !1,
                data: void 0,
                closeButton: !0,
                fastIframe: !0,
                open: !1,
                reposition: !0,
                loop: !0,
                slideshow: !1,
                slideshowAuto: !0,
                slideshowSpeed: 2500,
                slideshowStart: "start slideshow",
                slideshowStop: "stop slideshow",
                photoRegex: /\.(gif|png|jp(e|g|eg)|bmp|ico|webp|jxr|svg)((#|\?).*)?$/i,
                retinaImage: !1,
                retinaUrl: !1,
                retinaSuffix: "@2x.$1",
                current: "image {current} of {total}",
                previous: "previous",
                next: "next",
                close: "close",
                xhrError: "This content failed to load.",
                imgError: "This image failed to load.",
                returnFocus: !0,
                trapFocus: !0,
                onOpen: !1,
                onLoad: !1,
                onComplete: !1,
                onCleanup: !1,
                onClosed: !1,
                rel: function() {
                    return this.rel
                },
                href: function() {
                    return v(this).attr("href")
                },
                title: function() {
                    return this.title
                },
                createImg: function() {
                    var n = new Image,
                        e = v(this).data("cbox-img-attrs");
                    return "object" == _typeof(e) && v.each(e, function(e, t) {
                        n[e] = t
                    }), n
                },
                createIframe: function() {
                    var n = y.createElement("iframe"),
                        e = v(this).data("cbox-iframe-attrs");
                    return "object" == _typeof(e) && v.each(e, function(e, t) {
                        n[e] = t
                    }), "frameBorder" in n && (n.frameBorder = 0), "allowTransparency" in n && (n.allowTransparency = "true"), n.name = (new Date).getTime(), n.allowFullscreen = !0, n
                }
            }, oe = "colorbox", se = (re = "cbox") + "Element", ae = re + "_open", le = re + "_load", ce = re + "_complete", ue = re + "_cleanup", de = re + "_closed", pe = re + "_purge", fe = v("<a/>"), he = "div", me = 0, ge = {}, te = re + "Slideshow_", ne = "click." + re, ve = function() {
                J ? H.get("slideshow") || (fe.unbind(ue, Ue), Ue()) : H.get("slideshow") && $[1] && (J = !0, fe.one(ue, Ue), (H.get("slideshowAuto") ? Fe : We)(), P.show())
            }, v[oe] || (v(qe), (V = v.fn[oe] = v[oe] = function(t, e) {
                var n = this;
                return t = t || {}, v.isFunction(n) && (n = v("<a/>"), t.open = !0), n[0] && (qe(), x && (Q || (Q = !0, M.click(function() {
                    V.next()
                }), j.click(function() {
                    V.prev()
                }), N.click(function() {
                    V.close()
                }), b.click(function() {
                    H.get("overlayClose") && V.close()
                }), v(y).bind("keydown." + re, function(e) {
                    var t = e.keyCode;
                    G && H.get("escKey") && 27 === t && (e.preventDefault(), V.close()), G && H.get("arrowKey") && $[1] && !e.altKey && (37 === t ? (e.preventDefault(), j.click()) : 39 === t && (e.preventDefault(), M.click()))
                }), v.isFunction(v.fn.on) ? v(y).on("click." + re, "." + se, i) : v("." + se).live("click." + re, i)), 1) && (e && (t.onComplete = e), n.each(function() {
                    var e = v.data(this, oe) || {};
                    v.data(this, oe, v.extend(e, t))
                }).addClass(se), new De(n[0], t).get("open") && Ne(n[0]))), n;

                function i(e) {
                    1 < e.which || e.shiftKey || e.altKey || e.metaKey || e.ctrlKey || (e.preventDefault(), Ne(this))
                }
            }).position = function(t, e) {
                function n() {
                    S[0].style.width = _[0].style.width = C[0].style.width = parseInt(x[0].style.width, 10) - F + "px", C[0].style.height = k[0].style.height = A[0].style.height = parseInt(x[0].style.height, 10) - R + "px"
                }
                var i, o, r, s = 0,
                    a = 0,
                    l = x.offset();
                if (E.unbind("resize." + re), x.css({
                        top: -9e4,
                        left: -9e4
                    }), o = E.scrollTop(), r = E.scrollLeft(), H.get("fixed") ? (l.top -= o, l.left -= r, x.css({
                        position: "fixed"
                    })) : (s = o, a = r, x.css({
                        position: "absolute"
                    })), a += !1 !== H.get("right") ? Math.max(E.width() - H.w - U - F - Oe(H.get("right"), "x"), 0) : !1 !== H.get("left") ? Oe(H.get("left"), "x") : Math.round(Math.max(E.width() - H.w - U - F, 0) / 2), s += !1 !== H.get("bottom") ? Math.max(Ee() - H.h - W - R - Oe(H.get("bottom"), "y"), 0) : !1 !== H.get("top") ? Oe(H.get("top"), "y") : Math.round(Math.max(Ee() - H.h - W - R, 0) / 2), x.css({
                        top: l.top,
                        left: l.left,
                        visibility: "visible"
                    }), T[0].style.width = T[0].style.height = "9999px", i = {
                        width: H.w + U + F,
                        height: H.h + W + R,
                        top: s,
                        left: a
                    }, t) {
                    var c = 0;
                    v.each(i, function(e) {
                        return i[e] !== ge[e] ? void(c = t) : void 0
                    }), t = c
                }
                ge = i, t || x.css(i), x.dequeue().animate(i, {
                    duration: t || 0,
                    complete: function() {
                        n(), X = !1, T[0].style.width = H.w + U + F + "px", T[0].style.height = H.h + W + R + "px", H.get("reposition") && setTimeout(function() {
                            E.bind("resize." + re, V.position)
                        }, 1), v.isFunction(e) && e()
                    },
                    step: n
                })
            }, V.resize = function(e) {
                var t;
                G && ((e = e || {}).width && (H.w = Oe(e.width, "x") - U - F), e.innerWidth && (H.w = Oe(e.innerWidth, "x")), D.css({
                    width: H.w
                }), e.height && (H.h = Oe(e.height, "y") - W - R), e.innerHeight && (H.h = Oe(e.innerHeight, "y")), e.innerHeight || e.height || (t = D.scrollTop(), D.css({
                    height: "auto"
                }), H.h = D.height()), D.css({
                    height: H.h
                }), t && D.scrollTop(t), V.position("none" === H.get("transition") ? 0 : H.get("speed")))
            }, V.prep = function(e) {
                if (G) {
                    var t, o = "none" === H.get("transition") ? 0 : H.get("speed");
                    D.remove(), (D = $e(he, "LoadedContent").append(e)).hide().appendTo(z.show()).css({
                        width: (H.w = H.w || D.width(), H.w = H.mw && H.mw < H.w ? H.mw : H.w, H.w),
                        overflow: H.get("scrolling") ? "auto" : "hidden"
                    }).css({
                        height: (H.h = H.h || D.height(), H.h = H.mh && H.mh < H.h ? H.mh : H.h, H.h)
                    }).prependTo(C), z.hide(), v(Z).css({
                        float: "none"
                    }), Me(H.get("className")), t = function() {
                        function e() {
                            !1 === v.support.opacity && x[0].style.removeAttribute("filter")
                        }
                        var t, n, i = $.length;
                        G && (n = function() {
                            clearTimeout(K), O.hide(), je(ce), H.get("onComplete")
                        }, L.html(H.get("title")).show(), D.show(), 1 < i ? ("string" == typeof H.get("current") && I.html(H.get("current").replace("{current}", B + 1).replace("{total}", i)).show(), M[H.get("loop") || B < i - 1 ? "show" : "hide"]().html(H.get("next")), j[H.get("loop") || B ? "show" : "hide"]().html(H.get("previous")), ve(), H.get("preloading") && v.each([ze(-1), ze(1)], function() {
                            var e = $[this],
                                t = new De(e, v.data(e, oe)),
                                n = t.get("href");
                            n && Le(t, n) && (n = Ie(t, n), y.createElement("img").src = n)
                        })) : q.hide(), H.get("iframe") ? (t = H.get("createIframe"), H.get("scrolling") || (t.scrolling = "no"), v(t).attr({
                            src: H.get("href"),
                            class: re + "Iframe"
                        }).one("load", n).appendTo(D), fe.one(pe, function() {
                            t.src = "//about:blank"
                        }), H.get("fastIframe") && v(t).trigger("load")) : n(), "fade" === H.get("transition") ? x.fadeTo(o, 1, e) : e())
                    }, "fade" === H.get("transition") ? x.fadeTo(o, 0, function() {
                        V.position(0, t)
                    }) : V.position(o, t)
                }
            }, V.next = function() {
                !X && $[1] && (H.get("loop") || $[B + 1]) && (B = ze(1), Ne($[B]))
            }, V.prev = function() {
                !X && $[1] && (H.get("loop") || B) && (B = ze(-1), Ne($[B]))
            }, V.close = function() {
                G && !Y && (G = !(Y = !0), je(ue), H.get("onCleanup"), E.unbind("." + re), b.fadeTo(H.get("fadeOut") || 0, 0), x.stop().fadeTo(H.get("fadeOut") || 0, 0, function() {
                    x.hide(), b.hide(), je(pe), D.remove(), setTimeout(function() {
                        Y = !1, je(de), H.get("onClosed")
                    }, 1)
                }))
            }, V.remove = function() {
                x && (x.stop(), v[oe].close(), x.stop(!1, !0).remove(), b.remove(), Y = !1, x = null, v("." + se).removeData(oe).removeClass(se), v(y).unbind("click." + re).unbind("keydown." + re))
            }, V.element = function() {
                return v(H.el)
            }, V.settings = ie), ye = function(d) {
                var e = function() {
                        if (d && d.fn && d.fn.select2 && d.fn.select2.amd) var e = d.fn.select2.amd;
                        var t, n, i, f, r, s, h, m, g, v, y, w, o, a, b, l;

                        function x(e, t) {
                            return o.call(e, t)
                        }

                        function c(e, t) {
                            var n, i, o, r, s, a, l, c, u, d, p, f = t && t.split("/"),
                                h = y.map,
                                m = h && h["*"] || {};
                            if (e) {
                                for (s = (e = e.split("/")).length - 1, y.nodeIdCompat && b.test(e[s]) && (e[s] = e[s].replace(b, "")), "." === e[0].charAt(0) && f && (e = f.slice(0, f.length - 1).concat(e)), u = 0; u < e.length; u++)
                                    if ("." === (p = e[u])) e.splice(u, 1), --u;
                                    else if (".." === p) {
                                    if (0 === u || 1 === u && ".." === e[2] || ".." === e[u - 1]) continue;
                                    0 < u && (e.splice(u - 1, 2), u -= 2)
                                }
                                e = e.join("/")
                            }
                            if ((f || m) && h) {
                                for (u = (n = e.split("/")).length; 0 < u; --u) {
                                    if (i = n.slice(0, u).join("/"), f)
                                        for (d = f.length; 0 < d; --d)
                                            if (o = (o = h[f.slice(0, d).join("/")]) && o[i]) {
                                                r = o, a = u;
                                                break
                                            } if (r) break;
                                    !l && m && m[i] && (l = m[i], c = u)
                                }!r && l && (r = l, a = c), r && (n.splice(0, a, r), e = n.join("/"))
                            }
                            return e
                        }

                        function T(t, n) {
                            return function() {
                                var e = a.call(arguments, 0);
                                return "string" != typeof e[0] && 1 === e.length && e.push(null), s.apply(f, e.concat([t, n]))
                            }
                        }

                        function C(t) {
                            return function(e) {
                                g[t] = e
                            }
                        }

                        function S(e) {
                            if (x(v, e)) {
                                var t = v[e];
                                delete v[e], w[e] = !0, r.apply(f, t)
                            }
                            if (!x(g, e) && !x(w, e)) throw new Error("No " + e);
                            return g[e]
                        }

                        function u(e) {
                            var t, n = e ? e.indexOf("!") : -1;
                            return -1 < n && (t = e.substring(0, n), e = e.substring(n + 1, e.length)), [t, e]
                        }

                        function k(e) {
                            return e ? u(e) : []
                        }
                        return e && e.requirejs || (e ? n = e : e = {}, g = {}, v = {}, y = {}, w = {}, o = Object.prototype.hasOwnProperty, a = [].slice, b = /\.js$/, h = function(e, t) {
                            var n, i, o = u(e),
                                r = o[0],
                                s = t[1];
                            return e = o[1], r && (n = S(r = c(r, s))), r ? e = n && n.normalize ? n.normalize(e, (i = s, function(e) {
                                return c(e, i)
                            })) : c(e, s) : (r = (o = u(e = c(e, s)))[0], e = o[1], r && (n = S(r))), {
                                f: r ? r + "!" + e : e,
                                n: e,
                                pr: r,
                                p: n
                            }
                        }, m = {
                            require: function(e) {
                                return T(e)
                            },
                            exports: function(e) {
                                var t = g[e];
                                return void 0 !== t ? t : g[e] = {}
                            },
                            module: function(e) {
                                return {
                                    id: e,
                                    uri: "",
                                    exports: g[e],
                                    config: (t = e, function() {
                                        return y && y.config && y.config[t] || {}
                                    })
                                };
                                var t
                            }
                        }, r = function(e, t, n, i) {
                            var o, r, s, a, l, c, u, d = [],
                                p = _typeof(n);
                            if (c = k(i = i || e), "undefined" == p || "function" == p) {
                                for (t = !t.length && n.length ? ["require", "exports", "module"] : t, l = 0; l < t.length; l += 1)
                                    if ("require" === (r = (a = h(t[l], c)).f)) d[l] = m.require(e);
                                    else if ("exports" === r) d[l] = m.exports(e), u = !0;
                                else if ("module" === r) o = d[l] = m.module(e);
                                else if (x(g, r) || x(v, r) || x(w, r)) d[l] = S(r);
                                else {
                                    if (!a.p) throw new Error(e + " missing " + r);
                                    a.p.load(a.n, T(i, !0), C(r), {}), d[l] = g[r]
                                }
                                s = n ? n.apply(g[e], d) : void 0, e && (o && o.exports !== f && o.exports !== g[e] ? g[e] = o.exports : s === f && u || (g[e] = s))
                            } else e && (g[e] = n)
                        }, t = n = s = function(e, t, n, i, o) {
                            if ("string" == typeof e) return m[e] ? m[e](t) : S(h(e, k(t)).f);
                            if (!e.splice) {
                                if ((y = e).deps && s(y.deps, y.callback), !t) return;
                                t.splice ? (e = t, t = n, n = null) : e = f
                            }
                            return t = t || function() {}, "function" == typeof n && (n = i, i = o), i ? r(f, e, t, n) : setTimeout(function() {
                                r(f, e, t, n)
                            }, 4), s
                        }, s.config = function(e) {
                            return s(e)
                        }, t._defined = g, (i = function(e, t, n) {
                            if ("string" != typeof e) throw new Error("See almond README: incorrect module build, no module name");
                            t.splice || (n = t, t = []), x(g, e) || x(v, e) || (v[e] = [e, t, n])
                        }).amd = {
                            jQuery: !0
                        }, e.requirejs = t, e.require = n, e.define = i), e.define("almond", function() {}), e.define("jquery", [], function() {
                            var e = d || p;
                            return null == e && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."), e
                        }), e.define("select2/utils", ["jquery"], function(r) {
                            var o = {};

                            function u(e) {
                                var t = e.prototype,
                                    n = [];
                                for (var i in t) "function" == typeof t[i] && "constructor" !== i && n.push(i);
                                return n
                            }

                            function e() {
                                this.listeners = {}
                            }
                            o.Extend = function(e, t) {
                                var n = {}.hasOwnProperty;

                                function i() {
                                    this.constructor = e
                                }
                                for (var o in t) n.call(t, o) && (e[o] = t[o]);
                                return i.prototype = t.prototype, e.prototype = new i, e.__super__ = t.prototype, e
                            }, o.Decorate = function(i, o) {
                                var e = u(o),
                                    t = u(i);

                                function r() {
                                    var e = Array.prototype.unshift,
                                        t = o.prototype.constructor.length,
                                        n = i.prototype.constructor;
                                    0 < t && (e.call(arguments, i.prototype.constructor), n = o.prototype.constructor), n.apply(this, arguments)
                                }
                                o.displayName = i.displayName, r.prototype = new function() {
                                    this.constructor = r
                                };
                                for (var n = 0; n < t.length; n++) {
                                    var s = t[n];
                                    r.prototype[s] = i.prototype[s]
                                }

                                function a(e) {
                                    var t = function() {};
                                    e in r.prototype && (t = r.prototype[e]);
                                    var n = o.prototype[e];
                                    return function() {
                                        return Array.prototype.unshift.call(arguments, t), n.apply(this, arguments)
                                    }
                                }
                                for (var l = 0; l < e.length; l++) {
                                    var c = e[l];
                                    r.prototype[c] = a(c)
                                }
                                return r
                            }, e.prototype.on = function(e, t) {
                                this.listeners = this.listeners || {}, e in this.listeners ? this.listeners[e].push(t) : this.listeners[e] = [t]
                            }, e.prototype.trigger = function(e) {
                                var t = Array.prototype.slice,
                                    n = t.call(arguments, 1);
                                this.listeners = this.listeners || {}, null == n && (n = []), 0 === n.length && n.push({}), (n[0]._type = e) in this.listeners && this.invoke(this.listeners[e], t.call(arguments, 1)), "*" in this.listeners && this.invoke(this.listeners["*"], arguments)
                            }, e.prototype.invoke = function(e, t) {
                                for (var n = 0, i = e.length; n < i; n++) e[n].apply(this, t)
                            }, o.Observable = e, o.generateChars = function(e) {
                                for (var t = "", n = 0; n < e; n++) t += Math.floor(36 * Math.random()).toString(36);
                                return t
                            }, o.bind = function(e, t) {
                                return function() {
                                    e.apply(t, arguments)
                                }
                            }, o._convertData = function(e) {
                                for (var t in e) {
                                    var n = t.split("-"),
                                        i = e;
                                    if (1 !== n.length) {
                                        for (var o = 0; o < n.length; o++) {
                                            var r = n[o];
                                            (r = r.substring(0, 1).toLowerCase() + r.substring(1)) in i || (i[r] = {}), o == n.length - 1 && (i[r] = e[t]), i = i[r]
                                        }
                                        delete e[t]
                                    }
                                }
                                return e
                            }, o.hasScroll = function(e, t) {
                                var n = r(t),
                                    i = t.style.overflowX,
                                    o = t.style.overflowY;
                                return (i !== o || "hidden" !== o && "visible" !== o) && ("scroll" === i || "scroll" === o || n.innerHeight() < t.scrollHeight || n.innerWidth() < t.scrollWidth)
                            }, o.escapeMarkup = function(e) {
                                var t = {
                                    "\\": "&#92;",
                                    "&": "&amp;",
                                    "<": "&lt;",
                                    ">": "&gt;",
                                    '"': "&quot;",
                                    "'": "&#39;",
                                    "/": "&#47;"
                                };
                                return "string" != typeof e ? e : String(e).replace(/[&<>"'\/\\]/g, function(e) {
                                    return t[e]
                                })
                            }, o.appendMany = function(e, t) {
                                if ("1.7" === r.fn.jquery.substr(0, 3)) {
                                    var n = r();
                                    r.map(t, function(e) {
                                        n = n.add(e)
                                    }), t = n
                                }
                                e.append(t)
                            }, o.__cache = {};
                            var n = 0;
                            return o.GetUniqueElementId = function(e) {
                                var t = e.getAttribute("data-select2-id");
                                return null == t && (e.id ? (t = e.id, e.setAttribute("data-select2-id", t)) : (e.setAttribute("data-select2-id", ++n), t = n.toString())), t
                            }, o.StoreData = function(e, t, n) {
                                var i = o.GetUniqueElementId(e);
                                o.__cache[i] || (o.__cache[i] = {}), o.__cache[i][t] = n
                            }, o.GetData = function(e, t) {
                                var n = o.GetUniqueElementId(e);
                                return t ? o.__cache[n] && null != o.__cache[n][t] ? o.__cache[n][t] : r(e).data(t) : o.__cache[n]
                            }, o.RemoveData = function(e) {
                                var t = o.GetUniqueElementId(e);
                                null != o.__cache[t] && delete o.__cache[t], e.removeAttribute("data-select2-id")
                            }, o
                        }), e.define("select2/results", ["jquery", "./utils"], function(f, h) {
                            function i(e, t, n) {
                                this.$element = e, this.data = n, this.options = t, i.__super__.constructor.call(this)
                            }
                            return h.Extend(i, h.Observable), i.prototype.render = function() {
                                var e = f('<ul class="select2-results__options" role="listbox"></ul>');
                                return this.options.get("multiple") && e.attr("aria-multiselectable", "true"), this.$results = e
                            }, i.prototype.clear = function() {
                                this.$results.empty()
                            }, i.prototype.displayMessage = function(e) {
                                var t = this.options.get("escapeMarkup");
                                this.clear(), this.hideLoading();
                                var n = f('<li role="alert" aria-live="assertive" class="select2-results__option"></li>'),
                                    i = this.options.get("translations").get(e.message);
                                n.append(t(i(e.args))), n[0].className += " select2-results__message", this.$results.append(n)
                            }, i.prototype.hideMessages = function() {
                                this.$results.find(".select2-results__message").remove()
                            }, i.prototype.append = function(e) {
                                this.hideLoading();
                                var t = [];
                                if (null != e.results && 0 !== e.results.length) {
                                    e.results = this.sort(e.results);
                                    for (var n = 0; n < e.results.length; n++) {
                                        var i = e.results[n],
                                            o = this.option(i);
                                        t.push(o)
                                    }
                                    this.$results.append(t)
                                } else 0 === this.$results.children().length && this.trigger("results:message", {
                                    message: "noResults"
                                })
                            }, i.prototype.position = function(e, t) {
                                t.find(".select2-results").append(e)
                            }, i.prototype.sort = function(e) {
                                return this.options.get("sorter")(e)
                            }, i.prototype.highlightFirstItem = function() {
                                var e = this.$results.find(".select2-results__option[aria-selected]"),
                                    t = e.filter("[aria-selected=true]");
                                0 < t.length ? t.first().trigger("mouseenter") : e.first().trigger("mouseenter"), this.ensureHighlightVisible()
                            }, i.prototype.setClasses = function() {
                                var t = this;
                                this.data.current(function(e) {
                                    var i = f.map(e, function(e) {
                                        return e.id.toString()
                                    });
                                    t.$results.find(".select2-results__option[aria-selected]").each(function() {
                                        var e = f(this),
                                            t = h.GetData(this, "data"),
                                            n = "" + t.id;
                                        null != t.element && t.element.selected || null == t.element && -1 < f.inArray(n, i) ? e.attr("aria-selected", "true") : e.attr("aria-selected", "false")
                                    })
                                })
                            }, i.prototype.showLoading = function(e) {
                                this.hideLoading();
                                var t = {
                                        disabled: !0,
                                        loading: !0,
                                        text: this.options.get("translations").get("searching")(e)
                                    },
                                    n = this.option(t);
                                n.className += " loading-results", this.$results.prepend(n)
                            }, i.prototype.hideLoading = function() {
                                this.$results.find(".loading-results").remove()
                            }, i.prototype.option = function(e) {
                                var t = document.createElement("li");
                                t.className = "select2-results__option";
                                var n = {
                                        role: "option",
                                        "aria-selected": "false"
                                    },
                                    i = window.Element.prototype.matches || window.Element.prototype.msMatchesSelector || window.Element.prototype.webkitMatchesSelector;
                                for (var o in (null != e.element && i.call(e.element, ":disabled") || null == e.element && e.disabled) && (delete n["aria-selected"], n["aria-disabled"] = "true"), null == e.id && delete n["aria-selected"], null != e._resultId && (t.id = e._resultId), e.title && (t.title = e.title), e.children && (n.role = "group", n["aria-label"] = e.text, delete n["aria-selected"]), n) {
                                    var r = n[o];
                                    t.setAttribute(o, r)
                                }
                                if (e.children) {
                                    var s = f(t),
                                        a = document.createElement("strong");
                                    a.className = "select2-results__group", f(a), this.template(e, a);
                                    for (var l = [], c = 0; c < e.children.length; c++) {
                                        var u = e.children[c],
                                            d = this.option(u);
                                        l.push(d)
                                    }
                                    var p = f("<ul></ul>", {
                                        class: "select2-results__options select2-results__options--nested"
                                    });
                                    p.append(l), s.append(a), s.append(p)
                                } else this.template(e, t);
                                return h.StoreData(t, "data", e), t
                            }, i.prototype.bind = function(t, e) {
                                var l = this,
                                    n = t.id + "-results";
                                this.$results.attr("id", n), t.on("results:all", function(e) {
                                    l.clear(), l.append(e.data), t.isOpen() && (l.setClasses(), l.highlightFirstItem())
                                }), t.on("results:append", function(e) {
                                    l.append(e.data), t.isOpen() && l.setClasses()
                                }), t.on("query", function(e) {
                                    l.hideMessages(), l.showLoading(e)
                                }), t.on("select", function() {
                                    t.isOpen() && (l.setClasses(), l.options.get("scrollAfterSelect") && l.highlightFirstItem())
                                }), t.on("unselect", function() {
                                    t.isOpen() && (l.setClasses(), l.options.get("scrollAfterSelect") && l.highlightFirstItem())
                                }), t.on("open", function() {
                                    l.$results.attr("aria-expanded", "true"), l.$results.attr("aria-hidden", "false"), l.setClasses(), l.ensureHighlightVisible()
                                }), t.on("close", function() {
                                    l.$results.attr("aria-expanded", "false"), l.$results.attr("aria-hidden", "true"), l.$results.removeAttr("aria-activedescendant")
                                }), t.on("results:toggle", function() {
                                    var e = l.getHighlightedResults();
                                    0 !== e.length && e.trigger("mouseup")
                                }), t.on("results:select", function() {
                                    var e = l.getHighlightedResults();
                                    if (0 !== e.length) {
                                        var t = h.GetData(e[0], "data");
                                        "true" == e.attr("aria-selected") ? l.trigger("close", {}) : l.trigger("select", {
                                            data: t
                                        })
                                    }
                                }), t.on("results:previous", function() {
                                    var e = l.getHighlightedResults(),
                                        t = l.$results.find("[aria-selected]"),
                                        n = t.index(e);
                                    if (!(n <= 0)) {
                                        var i = n - 1;
                                        0 === e.length && (i = 0);
                                        var o = t.eq(i);
                                        o.trigger("mouseenter");
                                        var r = l.$results.offset().top,
                                            s = o.offset().top,
                                            a = l.$results.scrollTop() + (s - r);
                                        0 === i ? l.$results.scrollTop(0) : s - r < 0 && l.$results.scrollTop(a)
                                    }
                                }), t.on("results:next", function() {
                                    var e = l.getHighlightedResults(),
                                        t = l.$results.find("[aria-selected]"),
                                        n = t.index(e) + 1;
                                    if (!(n >= t.length)) {
                                        var i = t.eq(n);
                                        i.trigger("mouseenter");
                                        var o = l.$results.offset().top + l.$results.outerHeight(!1),
                                            r = i.offset().top + i.outerHeight(!1),
                                            s = l.$results.scrollTop() + r - o;
                                        0 === n ? l.$results.scrollTop(0) : o < r && l.$results.scrollTop(s)
                                    }
                                }), t.on("results:focus", function(e) {
                                    e.element.addClass("select2-results__option--highlighted")
                                }), t.on("results:message", function(e) {
                                    l.displayMessage(e)
                                }), f.fn.mousewheel && this.$results.on("mousewheel", function(e) {
                                    var t = l.$results.scrollTop(),
                                        n = l.$results.get(0).scrollHeight - t + e.deltaY,
                                        i = 0 < e.deltaY && t - e.deltaY <= 0,
                                        o = e.deltaY < 0 && n <= l.$results.height();
                                    i ? (l.$results.scrollTop(0), e.preventDefault(), e.stopPropagation()) : o && (l.$results.scrollTop(l.$results.get(0).scrollHeight - l.$results.height()), e.preventDefault(), e.stopPropagation())
                                }), this.$results.on("mouseup", ".select2-results__option[aria-selected]", function(e) {
                                    var t = f(this),
                                        n = h.GetData(this, "data");
                                    "true" !== t.attr("aria-selected") ? l.trigger("select", {
                                        originalEvent: e,
                                        data: n
                                    }) : l.options.get("multiple") ? l.trigger("unselect", {
                                        originalEvent: e,
                                        data: n
                                    }) : l.trigger("close", {})
                                }), this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function(e) {
                                    var t = h.GetData(this, "data");
                                    l.getHighlightedResults().removeClass("select2-results__option--highlighted"), l.trigger("results:focus", {
                                        data: t,
                                        element: f(this)
                                    })
                                })
                            }, i.prototype.getHighlightedResults = function() {
                                return this.$results.find(".select2-results__option--highlighted")
                            }, i.prototype.destroy = function() {
                                this.$results.remove()
                            }, i.prototype.ensureHighlightVisible = function() {
                                var e = this.getHighlightedResults();
                                if (0 !== e.length) {
                                    var t = this.$results.find("[aria-selected]").index(e),
                                        n = this.$results.offset().top,
                                        i = e.offset().top,
                                        o = this.$results.scrollTop() + (i - n),
                                        r = i - n;
                                    o -= 2 * e.outerHeight(!1), t <= 2 ? this.$results.scrollTop(0) : (r > this.$results.outerHeight() || r < 0) && this.$results.scrollTop(o)
                                }
                            }, i.prototype.template = function(e, t) {
                                var n = this.options.get("templateResult"),
                                    i = this.options.get("escapeMarkup"),
                                    o = n(e, t);
                                null == o ? t.style.display = "none" : "string" == typeof o ? t.innerHTML = i(o) : f(t).append(o)
                            }, i
                        }), e.define("select2/keys", [], function() {
                            return {
                                BACKSPACE: 8,
                                TAB: 9,
                                ENTER: 13,
                                SHIFT: 16,
                                CTRL: 17,
                                ALT: 18,
                                ESC: 27,
                                SPACE: 32,
                                PAGE_UP: 33,
                                PAGE_DOWN: 34,
                                END: 35,
                                HOME: 36,
                                LEFT: 37,
                                UP: 38,
                                RIGHT: 39,
                                DOWN: 40,
                                DELETE: 46
                            }
                        }), e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function(n, i, o) {
                            function r(e, t) {
                                this.$element = e, this.options = t, r.__super__.constructor.call(this)
                            }
                            return i.Extend(r, i.Observable), r.prototype.render = function() {
                                var e = n('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
                                return this._tabindex = 0, null != i.GetData(this.$element[0], "old-tabindex") ? this._tabindex = i.GetData(this.$element[0], "old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")), e.attr("title", this.$element.attr("title")), e.attr("tabindex", this._tabindex), e.attr("aria-disabled", "false"), this.$selection = e
                            }, r.prototype.bind = function(e, t) {
                                var n = this,
                                    i = e.id + "-results";
                                this.container = e, this.$selection.on("focus", function(e) {
                                    n.trigger("focus", e)
                                }), this.$selection.on("blur", function(e) {
                                    n._handleBlur(e)
                                }), this.$selection.on("keydown", function(e) {
                                    n.trigger("keypress", e), e.which === o.SPACE && e.preventDefault()
                                }), e.on("results:focus", function(e) {
                                    n.$selection.attr("aria-activedescendant", e.data._resultId)
                                }), e.on("selection:update", function(e) {
                                    n.update(e.data)
                                }), e.on("open", function() {
                                    n.$selection.attr("aria-expanded", "true"), n.$selection.attr("aria-owns", i), n._attachCloseHandler(e)
                                }), e.on("close", function() {
                                    n.$selection.attr("aria-expanded", "false"), n.$selection.removeAttr("aria-activedescendant"), n.$selection.removeAttr("aria-owns"), n.$selection.trigger("focus"), n._detachCloseHandler(e)
                                }), e.on("enable", function() {
                                    n.$selection.attr("tabindex", n._tabindex), n.$selection.attr("aria-disabled", "false")
                                }), e.on("disable", function() {
                                    n.$selection.attr("tabindex", "-1"), n.$selection.attr("aria-disabled", "true")
                                })
                            }, r.prototype._handleBlur = function(e) {
                                var t = this;
                                window.setTimeout(function() {
                                    document.activeElement == t.$selection[0] || n.contains(t.$selection[0], document.activeElement) || t.trigger("blur", e)
                                }, 1)
                            }, r.prototype._attachCloseHandler = function(e) {
                                n(document.body).on("mousedown.select2." + e.id, function(e) {
                                    var t = n(e.target).closest(".select2");
                                    n(".select2.select2-container--open").each(function() {
                                        this != t[0] && i.GetData(this, "element").select2("close")
                                    })
                                })
                            }, r.prototype._detachCloseHandler = function(e) {
                                n(document.body).off("mousedown.select2." + e.id)
                            }, r.prototype.position = function(e, t) {
                                t.find(".selection").append(e)
                            }, r.prototype.destroy = function() {
                                this._detachCloseHandler(this.container)
                            }, r.prototype.update = function(e) {
                                throw new Error("The `update` method must be defined in child classes.")
                            }, r
                        }), e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function(e, t, n, i) {
                            function o() {
                                o.__super__.constructor.apply(this, arguments)
                            }
                            return n.Extend(o, t), o.prototype.render = function() {
                                var e = o.__super__.render.call(this);
                                return e.addClass("select2-selection--single"), e.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), e
                            }, o.prototype.bind = function(t, e) {
                                var n = this;
                                o.__super__.bind.apply(this, arguments);
                                var i = t.id + "-container";
                                this.$selection.find(".select2-selection__rendered").attr("id", i).attr("role", "textbox").attr("aria-readonly", "true"), this.$selection.attr("aria-labelledby", i), this.$selection.on("mousedown", function(e) {
                                    1 === e.which && n.trigger("toggle", {
                                        originalEvent: e
                                    })
                                }), this.$selection.on("focus", function(e) {}), this.$selection.on("blur", function(e) {}), t.on("focus", function(e) {
                                    t.isOpen() || n.$selection.trigger("focus")
                                })
                            }, o.prototype.clear = function() {
                                var e = this.$selection.find(".select2-selection__rendered");
                                e.empty(), e.removeAttr("title")
                            }, o.prototype.display = function(e, t) {
                                var n = this.options.get("templateSelection");
                                return this.options.get("escapeMarkup")(n(e, t))
                            }, o.prototype.selectionContainer = function() {
                                return e("<span></span>")
                            }, o.prototype.update = function(e) {
                                if (0 !== e.length) {
                                    var t = e[0],
                                        n = this.$selection.find(".select2-selection__rendered"),
                                        i = this.display(t, n);
                                    n.empty().append(i);
                                    var o = t.title || t.text;
                                    o ? n.attr("title", o) : n.removeAttr("title")
                                } else this.clear()
                            }, o
                        }), e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function(o, e, l) {
                            function n(e, t) {
                                n.__super__.constructor.apply(this, arguments)
                            }
                            return l.Extend(n, e), n.prototype.render = function() {
                                var e = n.__super__.render.call(this);
                                return e.addClass("select2-selection--multiple"), e.html('<ul class="select2-selection__rendered"></ul>'), e
                            }, n.prototype.bind = function(e, t) {
                                var i = this;
                                n.__super__.bind.apply(this, arguments), this.$selection.on("click", function(e) {
                                    i.trigger("toggle", {
                                        originalEvent: e
                                    })
                                }), this.$selection.on("click", ".select2-selection__choice__remove", function(e) {
                                    if (!i.options.get("disabled")) {
                                        var t = o(this).parent(),
                                            n = l.GetData(t[0], "data");
                                        i.trigger("unselect", {
                                            originalEvent: e,
                                            data: n
                                        })
                                    }
                                })
                            }, n.prototype.clear = function() {
                                var e = this.$selection.find(".select2-selection__rendered");
                                e.empty(), e.removeAttr("title")
                            }, n.prototype.display = function(e, t) {
                                var n = this.options.get("templateSelection");
                                return this.options.get("escapeMarkup")(n(e, t))
                            }, n.prototype.selectionContainer = function() {
                                return o('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>')
                            }, n.prototype.update = function(e) {
                                if (this.clear(), 0 !== e.length) {
                                    for (var t = [], n = 0; n < e.length; n++) {
                                        var i = e[n],
                                            o = this.selectionContainer(),
                                            r = this.display(i, o);
                                        o.append(r);
                                        var s = i.title || i.text;
                                        s && o.attr("title", s), l.StoreData(o[0], "data", i), t.push(o)
                                    }
                                    var a = this.$selection.find(".select2-selection__rendered");
                                    l.appendMany(a, t)
                                }
                            }, n
                        }), e.define("select2/selection/placeholder", ["../utils"], function(e) {
                            function t(e, t, n) {
                                this.placeholder = this.normalizePlaceholder(n.get("placeholder")), e.call(this, t, n)
                            }
                            return t.prototype.normalizePlaceholder = function(e, t) {
                                return "string" == typeof t && (t = {
                                    id: "",
                                    text: t
                                }), t
                            }, t.prototype.createPlaceholder = function(e, t) {
                                var n = this.selectionContainer();
                                return n.html(this.display(t)), n.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), n
                            }, t.prototype.update = function(e, t) {
                                var n = 1 == t.length && t[0].id != this.placeholder.id;
                                if (1 < t.length || n) return e.call(this, t);
                                this.clear();
                                var i = this.createPlaceholder(this.placeholder);
                                this.$selection.find(".select2-selection__rendered").append(i)
                            }, t
                        }), e.define("select2/selection/allowClear", ["jquery", "../keys", "../utils"], function(o, i, a) {
                            function e() {}
                            return e.prototype.bind = function(e, t, n) {
                                var i = this;
                                e.call(this, t, n), null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."), this.$selection.on("mousedown", ".select2-selection__clear", function(e) {
                                    i._handleClear(e)
                                }), t.on("keypress", function(e) {
                                    i._handleKeyboardClear(e, t)
                                })
                            }, e.prototype._handleClear = function(e, t) {
                                if (!this.options.get("disabled")) {
                                    var n = this.$selection.find(".select2-selection__clear");
                                    if (0 !== n.length) {
                                        t.stopPropagation();
                                        var i = a.GetData(n[0], "data"),
                                            o = this.$element.val();
                                        this.$element.val(this.placeholder.id);
                                        var r = {
                                            data: i
                                        };
                                        if (this.trigger("clear", r), r.prevented) this.$element.val(o);
                                        else {
                                            for (var s = 0; s < i.length; s++)
                                                if (r = {
                                                        data: i[s]
                                                    }, this.trigger("unselect", r), r.prevented) return void this.$element.val(o);
                                            this.$element.trigger("change"), this.trigger("toggle", {})
                                        }
                                    }
                                }
                            }, e.prototype._handleKeyboardClear = function(e, t, n) {
                                n.isOpen() || t.which != i.DELETE && t.which != i.BACKSPACE || this._handleClear(t)
                            }, e.prototype.update = function(e, t) {
                                if (e.call(this, t), !(0 < this.$selection.find(".select2-selection__placeholder").length || 0 === t.length)) {
                                    var n = this.options.get("translations").get("removeAllItems"),
                                        i = o('<span class="select2-selection__clear" title="' + n() + '">&times;</span>');
                                    a.StoreData(i[0], "data", t), this.$selection.find(".select2-selection__rendered").prepend(i)
                                }
                            }, e
                        }), e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function(i, a, l) {
                            function e(e, t, n) {
                                e.call(this, t, n)
                            }
                            return e.prototype.render = function(e) {
                                var t = i('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>');
                                this.$searchContainer = t, this.$search = t.find("input");
                                var n = e.call(this);
                                return this._transferTabIndex(), n
                            }, e.prototype.bind = function(e, t, n) {
                                var i = this,
                                    o = t.id + "-results";
                                e.call(this, t, n), t.on("open", function() {
                                    i.$search.attr("aria-controls", o), i.$search.trigger("focus")
                                }), t.on("close", function() {
                                    i.$search.val(""), i.$search.removeAttr("aria-controls"), i.$search.removeAttr("aria-activedescendant"), i.$search.trigger("focus")
                                }), t.on("enable", function() {
                                    i.$search.prop("disabled", !1), i._transferTabIndex()
                                }), t.on("disable", function() {
                                    i.$search.prop("disabled", !0)
                                }), t.on("focus", function(e) {
                                    i.$search.trigger("focus")
                                }), t.on("results:focus", function(e) {
                                    e.data._resultId ? i.$search.attr("aria-activedescendant", e.data._resultId) : i.$search.removeAttr("aria-activedescendant")
                                }), this.$selection.on("focusin", ".select2-search--inline", function(e) {
                                    i.trigger("focus", e)
                                }), this.$selection.on("focusout", ".select2-search--inline", function(e) {
                                    i._handleBlur(e)
                                }), this.$selection.on("keydown", ".select2-search--inline", function(e) {
                                    if (e.stopPropagation(), i.trigger("keypress", e), i._keyUpPrevented = e.isDefaultPrevented(), e.which === l.BACKSPACE && "" === i.$search.val()) {
                                        var t = i.$searchContainer.prev(".select2-selection__choice");
                                        if (0 < t.length) {
                                            var n = a.GetData(t[0], "data");
                                            i.searchRemoveChoice(n), e.preventDefault()
                                        }
                                    }
                                }), this.$selection.on("click", ".select2-search--inline", function(e) {
                                    i.$search.val() && e.stopPropagation()
                                });
                                var r = document.documentMode,
                                    s = r && r <= 11;
                                this.$selection.on("input.searchcheck", ".select2-search--inline", function(e) {
                                    s ? i.$selection.off("input.search input.searchcheck") : i.$selection.off("keyup.search")
                                }), this.$selection.on("keyup.search input.search", ".select2-search--inline", function(e) {
                                    if (s && "input" === e.type) i.$selection.off("input.search input.searchcheck");
                                    else {
                                        var t = e.which;
                                        t != l.SHIFT && t != l.CTRL && t != l.ALT && t != l.TAB && i.handleSearch(e)
                                    }
                                })
                            }, e.prototype._transferTabIndex = function(e) {
                                this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1")
                            }, e.prototype.createPlaceholder = function(e, t) {
                                this.$search.attr("placeholder", t.text)
                            }, e.prototype.update = function(e, t) {
                                var n = this.$search[0] == document.activeElement;
                                this.$search.attr("placeholder", ""), e.call(this, t), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), n && this.$search.trigger("focus")
                            }, e.prototype.handleSearch = function() {
                                if (this.resizeSearch(), !this._keyUpPrevented) {
                                    var e = this.$search.val();
                                    this.trigger("query", {
                                        term: e
                                    })
                                }
                                this._keyUpPrevented = !1
                            }, e.prototype.searchRemoveChoice = function(e, t) {
                                this.trigger("unselect", {
                                    data: t
                                }), this.$search.val(t.text), this.handleSearch()
                            }, e.prototype.resizeSearch = function() {
                                this.$search.css("width", "25px");
                                var e = "";
                                e = "" !== this.$search.attr("placeholder") ? this.$selection.find(".select2-selection__rendered").width() : .75 * (this.$search.val().length + 1) + "em", this.$search.css("width", e)
                            }, e
                        }), e.define("select2/selection/eventRelay", ["jquery"], function(s) {
                            function e() {}
                            return e.prototype.bind = function(e, t, n) {
                                var i = this,
                                    o = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting", "clear", "clearing"],
                                    r = ["opening", "closing", "selecting", "unselecting", "clearing"];
                                e.call(this, t, n), t.on("*", function(e, t) {
                                    if (-1 !== s.inArray(e, o)) {
                                        t = t || {};
                                        var n = s.Event("select2:" + e, {
                                            params: t
                                        });
                                        i.$element.trigger(n), -1 !== s.inArray(e, r) && (t.prevented = n.isDefaultPrevented())
                                    }
                                })
                            }, e
                        }), e.define("select2/translation", ["jquery", "require"], function(t, n) {
                            function i(e) {
                                this.dict = e || {}
                            }
                            return i.prototype.all = function() {
                                return this.dict
                            }, i.prototype.get = function(e) {
                                return this.dict[e]
                            }, i.prototype.extend = function(e) {
                                this.dict = t.extend({}, e.all(), this.dict)
                            }, i._cache = {}, i.loadPath = function(e) {
                                if (!(e in i._cache)) {
                                    var t = n(e);
                                    i._cache[e] = t
                                }
                                return new i(i._cache[e])
                            }, i
                        }), e.define("select2/diacritics", [], function() {
                            return {
                                "Ⓐ": "A",
                                "Ａ": "A",
                                "À": "A",
                                "Á": "A",
                                "Â": "A",
                                "Ầ": "A",
                                "Ấ": "A",
                                "Ẫ": "A",
                                "Ẩ": "A",
                                "Ã": "A",
                                "Ā": "A",
                                "Ă": "A",
                                "Ằ": "A",
                                "Ắ": "A",
                                "Ẵ": "A",
                                "Ẳ": "A",
                                "Ȧ": "A",
                                "Ǡ": "A",
                                "Ä": "A",
                                "Ǟ": "A",
                                "Ả": "A",
                                "Å": "A",
                                "Ǻ": "A",
                                "Ǎ": "A",
                                "Ȁ": "A",
                                "Ȃ": "A",
                                "Ạ": "A",
                                "Ậ": "A",
                                "Ặ": "A",
                                "Ḁ": "A",
                                "Ą": "A",
                                "Ⱥ": "A",
                                "Ɐ": "A",
                                "Ꜳ": "AA",
                                "Æ": "AE",
                                "Ǽ": "AE",
                                "Ǣ": "AE",
                                "Ꜵ": "AO",
                                "Ꜷ": "AU",
                                "Ꜹ": "AV",
                                "Ꜻ": "AV",
                                "Ꜽ": "AY",
                                "Ⓑ": "B",
                                "Ｂ": "B",
                                "Ḃ": "B",
                                "Ḅ": "B",
                                "Ḇ": "B",
                                "Ƀ": "B",
                                "Ƃ": "B",
                                "Ɓ": "B",
                                "Ⓒ": "C",
                                "Ｃ": "C",
                                "Ć": "C",
                                "Ĉ": "C",
                                "Ċ": "C",
                                "Č": "C",
                                "Ç": "C",
                                "Ḉ": "C",
                                "Ƈ": "C",
                                "Ȼ": "C",
                                "Ꜿ": "C",
                                "Ⓓ": "D",
                                "Ｄ": "D",
                                "Ḋ": "D",
                                "Ď": "D",
                                "Ḍ": "D",
                                "Ḑ": "D",
                                "Ḓ": "D",
                                "Ḏ": "D",
                                "Đ": "D",
                                "Ƌ": "D",
                                "Ɗ": "D",
                                "Ɖ": "D",
                                "Ꝺ": "D",
                                "Ǳ": "DZ",
                                "Ǆ": "DZ",
                                "ǲ": "Dz",
                                "ǅ": "Dz",
                                "Ⓔ": "E",
                                "Ｅ": "E",
                                "È": "E",
                                "É": "E",
                                "Ê": "E",
                                "Ề": "E",
                                "Ế": "E",
                                "Ễ": "E",
                                "Ể": "E",
                                "Ẽ": "E",
                                "Ē": "E",
                                "Ḕ": "E",
                                "Ḗ": "E",
                                "Ĕ": "E",
                                "Ė": "E",
                                "Ë": "E",
                                "Ẻ": "E",
                                "Ě": "E",
                                "Ȅ": "E",
                                "Ȇ": "E",
                                "Ẹ": "E",
                                "Ệ": "E",
                                "Ȩ": "E",
                                "Ḝ": "E",
                                "Ę": "E",
                                "Ḙ": "E",
                                "Ḛ": "E",
                                "Ɛ": "E",
                                "Ǝ": "E",
                                "Ⓕ": "F",
                                "Ｆ": "F",
                                "Ḟ": "F",
                                "Ƒ": "F",
                                "Ꝼ": "F",
                                "Ⓖ": "G",
                                "Ｇ": "G",
                                "Ǵ": "G",
                                "Ĝ": "G",
                                "Ḡ": "G",
                                "Ğ": "G",
                                "Ġ": "G",
                                "Ǧ": "G",
                                "Ģ": "G",
                                "Ǥ": "G",
                                "Ɠ": "G",
                                "Ꞡ": "G",
                                "Ᵹ": "G",
                                "Ꝿ": "G",
                                "Ⓗ": "H",
                                "Ｈ": "H",
                                "Ĥ": "H",
                                "Ḣ": "H",
                                "Ḧ": "H",
                                "Ȟ": "H",
                                "Ḥ": "H",
                                "Ḩ": "H",
                                "Ḫ": "H",
                                "Ħ": "H",
                                "Ⱨ": "H",
                                "Ⱶ": "H",
                                "Ɥ": "H",
                                "Ⓘ": "I",
                                "Ｉ": "I",
                                "Ì": "I",
                                "Í": "I",
                                "Î": "I",
                                "Ĩ": "I",
                                "Ī": "I",
                                "Ĭ": "I",
                                "İ": "I",
                                "Ï": "I",
                                "Ḯ": "I",
                                "Ỉ": "I",
                                "Ǐ": "I",
                                "Ȉ": "I",
                                "Ȋ": "I",
                                "Ị": "I",
                                "Į": "I",
                                "Ḭ": "I",
                                "Ɨ": "I",
                                "Ⓙ": "J",
                                "Ｊ": "J",
                                "Ĵ": "J",
                                "Ɉ": "J",
                                "Ⓚ": "K",
                                "Ｋ": "K",
                                "Ḱ": "K",
                                "Ǩ": "K",
                                "Ḳ": "K",
                                "Ķ": "K",
                                "Ḵ": "K",
                                "Ƙ": "K",
                                "Ⱪ": "K",
                                "Ꝁ": "K",
                                "Ꝃ": "K",
                                "Ꝅ": "K",
                                "Ꞣ": "K",
                                "Ⓛ": "L",
                                "Ｌ": "L",
                                "Ŀ": "L",
                                "Ĺ": "L",
                                "Ľ": "L",
                                "Ḷ": "L",
                                "Ḹ": "L",
                                "Ļ": "L",
                                "Ḽ": "L",
                                "Ḻ": "L",
                                "Ł": "L",
                                "Ƚ": "L",
                                "Ɫ": "L",
                                "Ⱡ": "L",
                                "Ꝉ": "L",
                                "Ꝇ": "L",
                                "Ꞁ": "L",
                                "Ǉ": "LJ",
                                "ǈ": "Lj",
                                "Ⓜ": "M",
                                "Ｍ": "M",
                                "Ḿ": "M",
                                "Ṁ": "M",
                                "Ṃ": "M",
                                "Ɱ": "M",
                                "Ɯ": "M",
                                "Ⓝ": "N",
                                "Ｎ": "N",
                                "Ǹ": "N",
                                "Ń": "N",
                                "Ñ": "N",
                                "Ṅ": "N",
                                "Ň": "N",
                                "Ṇ": "N",
                                "Ņ": "N",
                                "Ṋ": "N",
                                "Ṉ": "N",
                                "Ƞ": "N",
                                "Ɲ": "N",
                                "Ꞑ": "N",
                                "Ꞥ": "N",
                                "Ǌ": "NJ",
                                "ǋ": "Nj",
                                "Ⓞ": "O",
                                "Ｏ": "O",
                                "Ò": "O",
                                "Ó": "O",
                                "Ô": "O",
                                "Ồ": "O",
                                "Ố": "O",
                                "Ỗ": "O",
                                "Ổ": "O",
                                "Õ": "O",
                                "Ṍ": "O",
                                "Ȭ": "O",
                                "Ṏ": "O",
                                "Ō": "O",
                                "Ṑ": "O",
                                "Ṓ": "O",
                                "Ŏ": "O",
                                "Ȯ": "O",
                                "Ȱ": "O",
                                "Ö": "O",
                                "Ȫ": "O",
                                "Ỏ": "O",
                                "Ő": "O",
                                "Ǒ": "O",
                                "Ȍ": "O",
                                "Ȏ": "O",
                                "Ơ": "O",
                                "Ờ": "O",
                                "Ớ": "O",
                                "Ỡ": "O",
                                "Ở": "O",
                                "Ợ": "O",
                                "Ọ": "O",
                                "Ộ": "O",
                                "Ǫ": "O",
                                "Ǭ": "O",
                                "Ø": "O",
                                "Ǿ": "O",
                                "Ɔ": "O",
                                "Ɵ": "O",
                                "Ꝋ": "O",
                                "Ꝍ": "O",
                                "Œ": "OE",
                                "Ƣ": "OI",
                                "Ꝏ": "OO",
                                "Ȣ": "OU",
                                "Ⓟ": "P",
                                "Ｐ": "P",
                                "Ṕ": "P",
                                "Ṗ": "P",
                                "Ƥ": "P",
                                "Ᵽ": "P",
                                "Ꝑ": "P",
                                "Ꝓ": "P",
                                "Ꝕ": "P",
                                "Ⓠ": "Q",
                                "Ｑ": "Q",
                                "Ꝗ": "Q",
                                "Ꝙ": "Q",
                                "Ɋ": "Q",
                                "Ⓡ": "R",
                                "Ｒ": "R",
                                "Ŕ": "R",
                                "Ṙ": "R",
                                "Ř": "R",
                                "Ȑ": "R",
                                "Ȓ": "R",
                                "Ṛ": "R",
                                "Ṝ": "R",
                                "Ŗ": "R",
                                "Ṟ": "R",
                                "Ɍ": "R",
                                "Ɽ": "R",
                                "Ꝛ": "R",
                                "Ꞧ": "R",
                                "Ꞃ": "R",
                                "Ⓢ": "S",
                                "Ｓ": "S",
                                "ẞ": "S",
                                "Ś": "S",
                                "Ṥ": "S",
                                "Ŝ": "S",
                                "Ṡ": "S",
                                "Š": "S",
                                "Ṧ": "S",
                                "Ṣ": "S",
                                "Ṩ": "S",
                                "Ș": "S",
                                "Ş": "S",
                                "Ȿ": "S",
                                "Ꞩ": "S",
                                "Ꞅ": "S",
                                "Ⓣ": "T",
                                "Ｔ": "T",
                                "Ṫ": "T",
                                "Ť": "T",
                                "Ṭ": "T",
                                "Ț": "T",
                                "Ţ": "T",
                                "Ṱ": "T",
                                "Ṯ": "T",
                                "Ŧ": "T",
                                "Ƭ": "T",
                                "Ʈ": "T",
                                "Ⱦ": "T",
                                "Ꞇ": "T",
                                "Ꜩ": "TZ",
                                "Ⓤ": "U",
                                "Ｕ": "U",
                                "Ù": "U",
                                "Ú": "U",
                                "Û": "U",
                                "Ũ": "U",
                                "Ṹ": "U",
                                "Ū": "U",
                                "Ṻ": "U",
                                "Ŭ": "U",
                                "Ü": "U",
                                "Ǜ": "U",
                                "Ǘ": "U",
                                "Ǖ": "U",
                                "Ǚ": "U",
                                "Ủ": "U",
                                "Ů": "U",
                                "Ű": "U",
                                "Ǔ": "U",
                                "Ȕ": "U",
                                "Ȗ": "U",
                                "Ư": "U",
                                "Ừ": "U",
                                "Ứ": "U",
                                "Ữ": "U",
                                "Ử": "U",
                                "Ự": "U",
                                "Ụ": "U",
                                "Ṳ": "U",
                                "Ų": "U",
                                "Ṷ": "U",
                                "Ṵ": "U",
                                "Ʉ": "U",
                                "Ⓥ": "V",
                                "Ｖ": "V",
                                "Ṽ": "V",
                                "Ṿ": "V",
                                "Ʋ": "V",
                                "Ꝟ": "V",
                                "Ʌ": "V",
                                "Ꝡ": "VY",
                                "Ⓦ": "W",
                                "Ｗ": "W",
                                "Ẁ": "W",
                                "Ẃ": "W",
                                "Ŵ": "W",
                                "Ẇ": "W",
                                "Ẅ": "W",
                                "Ẉ": "W",
                                "Ⱳ": "W",
                                "Ⓧ": "X",
                                "Ｘ": "X",
                                "Ẋ": "X",
                                "Ẍ": "X",
                                "Ⓨ": "Y",
                                "Ｙ": "Y",
                                "Ỳ": "Y",
                                "Ý": "Y",
                                "Ŷ": "Y",
                                "Ỹ": "Y",
                                "Ȳ": "Y",
                                "Ẏ": "Y",
                                "Ÿ": "Y",
                                "Ỷ": "Y",
                                "Ỵ": "Y",
                                "Ƴ": "Y",
                                "Ɏ": "Y",
                                "Ỿ": "Y",
                                "Ⓩ": "Z",
                                "Ｚ": "Z",
                                "Ź": "Z",
                                "Ẑ": "Z",
                                "Ż": "Z",
                                "Ž": "Z",
                                "Ẓ": "Z",
                                "Ẕ": "Z",
                                "Ƶ": "Z",
                                "Ȥ": "Z",
                                "Ɀ": "Z",
                                "Ⱬ": "Z",
                                "Ꝣ": "Z",
                                "ⓐ": "a",
                                "ａ": "a",
                                "ẚ": "a",
                                "à": "a",
                                "á": "a",
                                "â": "a",
                                "ầ": "a",
                                "ấ": "a",
                                "ẫ": "a",
                                "ẩ": "a",
                                "ã": "a",
                                "ā": "a",
                                "ă": "a",
                                "ằ": "a",
                                "ắ": "a",
                                "ẵ": "a",
                                "ẳ": "a",
                                "ȧ": "a",
                                "ǡ": "a",
                                "ä": "a",
                                "ǟ": "a",
                                "ả": "a",
                                "å": "a",
                                "ǻ": "a",
                                "ǎ": "a",
                                "ȁ": "a",
                                "ȃ": "a",
                                "ạ": "a",
                                "ậ": "a",
                                "ặ": "a",
                                "ḁ": "a",
                                "ą": "a",
                                "ⱥ": "a",
                                "ɐ": "a",
                                "ꜳ": "aa",
                                "æ": "ae",
                                "ǽ": "ae",
                                "ǣ": "ae",
                                "ꜵ": "ao",
                                "ꜷ": "au",
                                "ꜹ": "av",
                                "ꜻ": "av",
                                "ꜽ": "ay",
                                "ⓑ": "b",
                                "ｂ": "b",
                                "ḃ": "b",
                                "ḅ": "b",
                                "ḇ": "b",
                                "ƀ": "b",
                                "ƃ": "b",
                                "ɓ": "b",
                                "ⓒ": "c",
                                "ｃ": "c",
                                "ć": "c",
                                "ĉ": "c",
                                "ċ": "c",
                                "č": "c",
                                "ç": "c",
                                "ḉ": "c",
                                "ƈ": "c",
                                "ȼ": "c",
                                "ꜿ": "c",
                                "ↄ": "c",
                                "ⓓ": "d",
                                "ｄ": "d",
                                "ḋ": "d",
                                "ď": "d",
                                "ḍ": "d",
                                "ḑ": "d",
                                "ḓ": "d",
                                "ḏ": "d",
                                "đ": "d",
                                "ƌ": "d",
                                "ɖ": "d",
                                "ɗ": "d",
                                "ꝺ": "d",
                                "ǳ": "dz",
                                "ǆ": "dz",
                                "ⓔ": "e",
                                "ｅ": "e",
                                "è": "e",
                                "é": "e",
                                "ê": "e",
                                "ề": "e",
                                "ế": "e",
                                "ễ": "e",
                                "ể": "e",
                                "ẽ": "e",
                                "ē": "e",
                                "ḕ": "e",
                                "ḗ": "e",
                                "ĕ": "e",
                                "ė": "e",
                                "ë": "e",
                                "ẻ": "e",
                                "ě": "e",
                                "ȅ": "e",
                                "ȇ": "e",
                                "ẹ": "e",
                                "ệ": "e",
                                "ȩ": "e",
                                "ḝ": "e",
                                "ę": "e",
                                "ḙ": "e",
                                "ḛ": "e",
                                "ɇ": "e",
                                "ɛ": "e",
                                "ǝ": "e",
                                "ⓕ": "f",
                                "ｆ": "f",
                                "ḟ": "f",
                                "ƒ": "f",
                                "ꝼ": "f",
                                "ⓖ": "g",
                                "ｇ": "g",
                                "ǵ": "g",
                                "ĝ": "g",
                                "ḡ": "g",
                                "ğ": "g",
                                "ġ": "g",
                                "ǧ": "g",
                                "ģ": "g",
                                "ǥ": "g",
                                "ɠ": "g",
                                "ꞡ": "g",
                                "ᵹ": "g",
                                "ꝿ": "g",
                                "ⓗ": "h",
                                "ｈ": "h",
                                "ĥ": "h",
                                "ḣ": "h",
                                "ḧ": "h",
                                "ȟ": "h",
                                "ḥ": "h",
                                "ḩ": "h",
                                "ḫ": "h",
                                "ẖ": "h",
                                "ħ": "h",
                                "ⱨ": "h",
                                "ⱶ": "h",
                                "ɥ": "h",
                                "ƕ": "hv",
                                "ⓘ": "i",
                                "ｉ": "i",
                                "ì": "i",
                                "í": "i",
                                "î": "i",
                                "ĩ": "i",
                                "ī": "i",
                                "ĭ": "i",
                                "ï": "i",
                                "ḯ": "i",
                                "ỉ": "i",
                                "ǐ": "i",
                                "ȉ": "i",
                                "ȋ": "i",
                                "ị": "i",
                                "į": "i",
                                "ḭ": "i",
                                "ɨ": "i",
                                "ı": "i",
                                "ⓙ": "j",
                                "ｊ": "j",
                                "ĵ": "j",
                                "ǰ": "j",
                                "ɉ": "j",
                                "ⓚ": "k",
                                "ｋ": "k",
                                "ḱ": "k",
                                "ǩ": "k",
                                "ḳ": "k",
                                "ķ": "k",
                                "ḵ": "k",
                                "ƙ": "k",
                                "ⱪ": "k",
                                "ꝁ": "k",
                                "ꝃ": "k",
                                "ꝅ": "k",
                                "ꞣ": "k",
                                "ⓛ": "l",
                                "ｌ": "l",
                                "ŀ": "l",
                                "ĺ": "l",
                                "ľ": "l",
                                "ḷ": "l",
                                "ḹ": "l",
                                "ļ": "l",
                                "ḽ": "l",
                                "ḻ": "l",
                                "ſ": "l",
                                "ł": "l",
                                "ƚ": "l",
                                "ɫ": "l",
                                "ⱡ": "l",
                                "ꝉ": "l",
                                "ꞁ": "l",
                                "ꝇ": "l",
                                "ǉ": "lj",
                                "ⓜ": "m",
                                "ｍ": "m",
                                "ḿ": "m",
                                "ṁ": "m",
                                "ṃ": "m",
                                "ɱ": "m",
                                "ɯ": "m",
                                "ⓝ": "n",
                                "ｎ": "n",
                                "ǹ": "n",
                                "ń": "n",
                                "ñ": "n",
                                "ṅ": "n",
                                "ň": "n",
                                "ṇ": "n",
                                "ņ": "n",
                                "ṋ": "n",
                                "ṉ": "n",
                                "ƞ": "n",
                                "ɲ": "n",
                                "ŉ": "n",
                                "ꞑ": "n",
                                "ꞥ": "n",
                                "ǌ": "nj",
                                "ⓞ": "o",
                                "ｏ": "o",
                                "ò": "o",
                                "ó": "o",
                                "ô": "o",
                                "ồ": "o",
                                "ố": "o",
                                "ỗ": "o",
                                "ổ": "o",
                                "õ": "o",
                                "ṍ": "o",
                                "ȭ": "o",
                                "ṏ": "o",
                                "ō": "o",
                                "ṑ": "o",
                                "ṓ": "o",
                                "ŏ": "o",
                                "ȯ": "o",
                                "ȱ": "o",
                                "ö": "o",
                                "ȫ": "o",
                                "ỏ": "o",
                                "ő": "o",
                                "ǒ": "o",
                                "ȍ": "o",
                                "ȏ": "o",
                                "ơ": "o",
                                "ờ": "o",
                                "ớ": "o",
                                "ỡ": "o",
                                "ở": "o",
                                "ợ": "o",
                                "ọ": "o",
                                "ộ": "o",
                                "ǫ": "o",
                                "ǭ": "o",
                                "ø": "o",
                                "ǿ": "o",
                                "ɔ": "o",
                                "ꝋ": "o",
                                "ꝍ": "o",
                                "ɵ": "o",
                                "œ": "oe",
                                "ƣ": "oi",
                                "ȣ": "ou",
                                "ꝏ": "oo",
                                "ⓟ": "p",
                                "ｐ": "p",
                                "ṕ": "p",
                                "ṗ": "p",
                                "ƥ": "p",
                                "ᵽ": "p",
                                "ꝑ": "p",
                                "ꝓ": "p",
                                "ꝕ": "p",
                                "ⓠ": "q",
                                "ｑ": "q",
                                "ɋ": "q",
                                "ꝗ": "q",
                                "ꝙ": "q",
                                "ⓡ": "r",
                                "ｒ": "r",
                                "ŕ": "r",
                                "ṙ": "r",
                                "ř": "r",
                                "ȑ": "r",
                                "ȓ": "r",
                                "ṛ": "r",
                                "ṝ": "r",
                                "ŗ": "r",
                                "ṟ": "r",
                                "ɍ": "r",
                                "ɽ": "r",
                                "ꝛ": "r",
                                "ꞧ": "r",
                                "ꞃ": "r",
                                "ⓢ": "s",
                                "ｓ": "s",
                                "ß": "s",
                                "ś": "s",
                                "ṥ": "s",
                                "ŝ": "s",
                                "ṡ": "s",
                                "š": "s",
                                "ṧ": "s",
                                "ṣ": "s",
                                "ṩ": "s",
                                "ș": "s",
                                "ş": "s",
                                "ȿ": "s",
                                "ꞩ": "s",
                                "ꞅ": "s",
                                "ẛ": "s",
                                "ⓣ": "t",
                                "ｔ": "t",
                                "ṫ": "t",
                                "ẗ": "t",
                                "ť": "t",
                                "ṭ": "t",
                                "ț": "t",
                                "ţ": "t",
                                "ṱ": "t",
                                "ṯ": "t",
                                "ŧ": "t",
                                "ƭ": "t",
                                "ʈ": "t",
                                "ⱦ": "t",
                                "ꞇ": "t",
                                "ꜩ": "tz",
                                "ⓤ": "u",
                                "ｕ": "u",
                                "ù": "u",
                                "ú": "u",
                                "û": "u",
                                "ũ": "u",
                                "ṹ": "u",
                                "ū": "u",
                                "ṻ": "u",
                                "ŭ": "u",
                                "ü": "u",
                                "ǜ": "u",
                                "ǘ": "u",
                                "ǖ": "u",
                                "ǚ": "u",
                                "ủ": "u",
                                "ů": "u",
                                "ű": "u",
                                "ǔ": "u",
                                "ȕ": "u",
                                "ȗ": "u",
                                "ư": "u",
                                "ừ": "u",
                                "ứ": "u",
                                "ữ": "u",
                                "ử": "u",
                                "ự": "u",
                                "ụ": "u",
                                "ṳ": "u",
                                "ų": "u",
                                "ṷ": "u",
                                "ṵ": "u",
                                "ʉ": "u",
                                "ⓥ": "v",
                                "ｖ": "v",
                                "ṽ": "v",
                                "ṿ": "v",
                                "ʋ": "v",
                                "ꝟ": "v",
                                "ʌ": "v",
                                "ꝡ": "vy",
                                "ⓦ": "w",
                                "ｗ": "w",
                                "ẁ": "w",
                                "ẃ": "w",
                                "ŵ": "w",
                                "ẇ": "w",
                                "ẅ": "w",
                                "ẘ": "w",
                                "ẉ": "w",
                                "ⱳ": "w",
                                "ⓧ": "x",
                                "ｘ": "x",
                                "ẋ": "x",
                                "ẍ": "x",
                                "ⓨ": "y",
                                "ｙ": "y",
                                "ỳ": "y",
                                "ý": "y",
                                "ŷ": "y",
                                "ỹ": "y",
                                "ȳ": "y",
                                "ẏ": "y",
                                "ÿ": "y",
                                "ỷ": "y",
                                "ẙ": "y",
                                "ỵ": "y",
                                "ƴ": "y",
                                "ɏ": "y",
                                "ỿ": "y",
                                "ⓩ": "z",
                                "ｚ": "z",
                                "ź": "z",
                                "ẑ": "z",
                                "ż": "z",
                                "ž": "z",
                                "ẓ": "z",
                                "ẕ": "z",
                                "ƶ": "z",
                                "ȥ": "z",
                                "ɀ": "z",
                                "ⱬ": "z",
                                "ꝣ": "z",
                                "Ά": "Α",
                                "Έ": "Ε",
                                "Ή": "Η",
                                "Ί": "Ι",
                                "Ϊ": "Ι",
                                "Ό": "Ο",
                                "Ύ": "Υ",
                                "Ϋ": "Υ",
                                "Ώ": "Ω",
                                "ά": "α",
                                "έ": "ε",
                                "ή": "η",
                                "ί": "ι",
                                "ϊ": "ι",
                                "ΐ": "ι",
                                "ό": "ο",
                                "ύ": "υ",
                                "ϋ": "υ",
                                "ΰ": "υ",
                                "ώ": "ω",
                                "ς": "σ",
                                "’": "'"
                            }
                        }), e.define("select2/data/base", ["../utils"], function(i) {
                            function n(e, t) {
                                n.__super__.constructor.call(this)
                            }
                            return i.Extend(n, i.Observable), n.prototype.current = function(e) {
                                throw new Error("The `current` method must be defined in child classes.")
                            }, n.prototype.query = function(e, t) {
                                throw new Error("The `query` method must be defined in child classes.")
                            }, n.prototype.bind = function(e, t) {}, n.prototype.destroy = function() {}, n.prototype.generateResultId = function(e, t) {
                                var n = e.id + "-result-";
                                return n += i.generateChars(4), null != t.id ? n += "-" + t.id.toString() : n += "-" + i.generateChars(4), n
                            }, n
                        }), e.define("select2/data/select", ["./base", "../utils", "jquery"], function(e, a, l) {
                            function n(e, t) {
                                this.$element = e, this.options = t, n.__super__.constructor.call(this)
                            }
                            return a.Extend(n, e), n.prototype.current = function(e) {
                                var n = [],
                                    i = this;
                                this.$element.find(":selected").each(function() {
                                    var e = l(this),
                                        t = i.item(e);
                                    n.push(t)
                                }), e(n)
                            }, n.prototype.select = function(o) {
                                var r = this;
                                if (o.selected = !0, l(o.element).is("option")) return o.element.selected = !0, void this.$element.trigger("change");
                                if (this.$element.prop("multiple")) this.current(function(e) {
                                    var t = [];
                                    (o = [o]).push.apply(o, e);
                                    for (var n = 0; n < o.length; n++) {
                                        var i = o[n].id; - 1 === l.inArray(i, t) && t.push(i)
                                    }
                                    r.$element.val(t), r.$element.trigger("change")
                                });
                                else {
                                    var e = o.id;
                                    this.$element.val(e), this.$element.trigger("change")
                                }
                            }, n.prototype.unselect = function(o) {
                                var r = this;
                                if (this.$element.prop("multiple")) {
                                    if (o.selected = !1, l(o.element).is("option")) return o.element.selected = !1, void this.$element.trigger("change");
                                    this.current(function(e) {
                                        for (var t = [], n = 0; n < e.length; n++) {
                                            var i = e[n].id;
                                            i !== o.id && -1 === l.inArray(i, t) && t.push(i)
                                        }
                                        r.$element.val(t), r.$element.trigger("change")
                                    })
                                }
                            }, n.prototype.bind = function(e, t) {
                                var n = this;
                                (this.container = e).on("select", function(e) {
                                    n.select(e.data)
                                }), e.on("unselect", function(e) {
                                    n.unselect(e.data)
                                })
                            }, n.prototype.destroy = function() {
                                this.$element.find("*").each(function() {
                                    a.RemoveData(this)
                                })
                            }, n.prototype.query = function(i, e) {
                                var o = [],
                                    r = this;
                                this.$element.children().each(function() {
                                    var e = l(this);
                                    if (e.is("option") || e.is("optgroup")) {
                                        var t = r.item(e),
                                            n = r.matches(i, t);
                                        null !== n && o.push(n)
                                    }
                                }), e({
                                    results: o
                                })
                            }, n.prototype.addOptions = function(e) {
                                a.appendMany(this.$element, e)
                            }, n.prototype.option = function(e) {
                                var t;
                                e.children ? (t = document.createElement("optgroup")).label = e.text : void 0 !== (t = document.createElement("option")).textContent ? t.textContent = e.text : t.innerText = e.text, void 0 !== e.id && (t.value = e.id), e.disabled && (t.disabled = !0), e.selected && (t.selected = !0), e.title && (t.title = e.title);
                                var n = l(t),
                                    i = this._normalizeItem(e);
                                return i.element = t, a.StoreData(t, "data", i), n
                            }, n.prototype.item = function(e) {
                                var t = {};
                                if (null != (t = a.GetData(e[0], "data"))) return t;
                                if (e.is("option")) t = {
                                    id: e.val(),
                                    text: e.text(),
                                    disabled: e.prop("disabled"),
                                    selected: e.prop("selected"),
                                    title: e.prop("title")
                                };
                                else if (e.is("optgroup")) {
                                    t = {
                                        text: e.prop("label"),
                                        children: [],
                                        title: e.prop("title")
                                    };
                                    for (var n = e.children("option"), i = [], o = 0; o < n.length; o++) {
                                        var r = l(n[o]),
                                            s = this.item(r);
                                        i.push(s)
                                    }
                                    t.children = i
                                }
                                return (t = this._normalizeItem(t)).element = e[0], a.StoreData(e[0], "data", t), t
                            }, n.prototype._normalizeItem = function(e) {
                                return e !== Object(e) && (e = {
                                    id: e,
                                    text: e
                                }), null != (e = l.extend({}, {
                                    text: ""
                                }, e)).id && (e.id = e.id.toString()), null != e.text && (e.text = e.text.toString()), null == e._resultId && e.id && null != this.container && (e._resultId = this.generateResultId(this.container, e)), l.extend({}, {
                                    selected: !1,
                                    disabled: !1
                                }, e)
                            }, n.prototype.matches = function(e, t) {
                                return this.options.get("matcher")(e, t)
                            }, n
                        }), e.define("select2/data/array", ["./select", "../utils", "jquery"], function(e, h, m) {
                            function i(e, t) {
                                this._dataToConvert = t.get("data") || [], i.__super__.constructor.call(this, e, t)
                            }
                            return h.Extend(i, e), i.prototype.bind = function(e, t) {
                                i.__super__.bind.call(this, e, t), this.addOptions(this.convertToOptions(this._dataToConvert))
                            }, i.prototype.select = function(n) {
                                var e = this.$element.find("option").filter(function(e, t) {
                                    return t.value == n.id.toString()
                                });
                                0 === e.length && (e = this.option(n), this.addOptions(e)), i.__super__.select.call(this, n)
                            }, i.prototype.convertToOptions = function(e) {
                                var t = this,
                                    n = this.$element.find("option"),
                                    i = n.map(function() {
                                        return t.item(m(this)).id
                                    }).get(),
                                    o = [];

                                function r(e) {
                                    return function() {
                                        return m(this).val() == e.id
                                    }
                                }
                                for (var s = 0; s < e.length; s++) {
                                    var a = this._normalizeItem(e[s]);
                                    if (0 <= m.inArray(a.id, i)) {
                                        var l = n.filter(r(a)),
                                            c = this.item(l),
                                            u = m.extend(!0, {}, a, c),
                                            d = this.option(u);
                                        l.replaceWith(d)
                                    } else {
                                        var p = this.option(a);
                                        if (a.children) {
                                            var f = this.convertToOptions(a.children);
                                            h.appendMany(p, f)
                                        }
                                        o.push(p)
                                    }
                                }
                                return o
                            }, i
                        }), e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function(e, t, r) {
                            function n(e, t) {
                                this.ajaxOptions = this._applyDefaults(t.get("ajax")), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), n.__super__.constructor.call(this, e, t)
                            }
                            return t.Extend(n, e), n.prototype._applyDefaults = function(e) {
                                var t = {
                                    data: function(e) {
                                        return r.extend({}, e, {
                                            q: e.term
                                        })
                                    },
                                    transport: function(e, t, n) {
                                        var i = r.ajax(e);
                                        return i.then(t), i.fail(n), i
                                    }
                                };
                                return r.extend({}, t, e, !0)
                            }, n.prototype.processResults = function(e) {
                                return e
                            }, n.prototype.query = function(n, i) {
                                var o = this;
                                null != this._request && (r.isFunction(this._request.abort) && this._request.abort(), this._request = null);
                                var t = r.extend({
                                    type: "GET"
                                }, this.ajaxOptions);

                                function e() {
                                    var e = t.transport(t, function(e) {
                                        var t = o.processResults(e, n);
                                        o.options.get("debug") && window.console && console.error && (t && t.results && r.isArray(t.results) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")), i(t)
                                    }, function() {
                                        "status" in e && (0 === e.status || "0" === e.status) || o.trigger("results:message", {
                                            message: "errorLoading"
                                        })
                                    });
                                    o._request = e
                                }
                                "function" == typeof t.url && (t.url = t.url.call(this.$element, n)), "function" == typeof t.data && (t.data = t.data.call(this.$element, n)), this.ajaxOptions.delay && null != n.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), this._queryTimeout = window.setTimeout(e, this.ajaxOptions.delay)) : e()
                            }, n
                        }), e.define("select2/data/tags", ["jquery"], function(u) {
                            function e(e, t, n) {
                                var i = n.get("tags"),
                                    o = n.get("createTag");
                                void 0 !== o && (this.createTag = o);
                                var r = n.get("insertTag");
                                if (void 0 !== r && (this.insertTag = r), e.call(this, t, n), u.isArray(i))
                                    for (var s = 0; s < i.length; s++) {
                                        var a = i[s],
                                            l = this._normalizeItem(a),
                                            c = this.option(l);
                                        this.$element.append(c)
                                    }
                            }
                            return e.prototype.query = function(e, c, u) {
                                var d = this;
                                this._removeOldTags(), null != c.term && null == c.page ? e.call(this, c, function e(t, n) {
                                    for (var i = t.results, o = 0; o < i.length; o++) {
                                        var r = i[o],
                                            s = null != r.children && !e({
                                                results: r.children
                                            }, !0);
                                        if ((r.text || "").toUpperCase() === (c.term || "").toUpperCase() || s) return !n && (t.data = i, void u(t))
                                    }
                                    if (n) return !0;
                                    var a = d.createTag(c);
                                    if (null != a) {
                                        var l = d.option(a);
                                        l.attr("data-select2-tag", !0), d.addOptions([l]), d.insertTag(i, a)
                                    }
                                    t.results = i, u(t)
                                }) : e.call(this, c, u)
                            }, e.prototype.createTag = function(e, t) {
                                var n = u.trim(t.term);
                                return "" === n ? null : {
                                    id: n,
                                    text: n
                                }
                            }, e.prototype.insertTag = function(e, t, n) {
                                t.unshift(n)
                            }, e.prototype._removeOldTags = function(e) {
                                this.$element.find("option[data-select2-tag]").each(function() {
                                    this.selected || u(this).remove()
                                })
                            }, e
                        }), e.define("select2/data/tokenizer", ["jquery"], function(d) {
                            function e(e, t, n) {
                                var i = n.get("tokenizer");
                                void 0 !== i && (this.tokenizer = i), e.call(this, t, n)
                            }
                            return e.prototype.bind = function(e, t, n) {
                                e.call(this, t, n), this.$search = t.dropdown.$search || t.selection.$search || n.find(".select2-search__field")
                            }, e.prototype.query = function(e, t, n) {
                                var o = this;
                                t.term = t.term || "";
                                var i = this.tokenizer(t, this.options, function(e) {
                                    var t, n = o._normalizeItem(e);
                                    if (!o.$element.find("option").filter(function() {
                                            return d(this).val() === n.id
                                        }).length) {
                                        var i = o.option(n);
                                        i.attr("data-select2-tag", !0), o._removeOldTags(), o.addOptions([i])
                                    }
                                    t = n, o.trigger("select", {
                                        data: t
                                    })
                                });
                                i.term !== t.term && (this.$search.length && (this.$search.val(i.term), this.$search.trigger("focus")), t.term = i.term), e.call(this, t, n)
                            }, e.prototype.tokenizer = function(e, t, n, i) {
                                for (var o = n.get("tokenSeparators") || [], r = t.term, s = 0, a = this.createTag || function(e) {
                                        return {
                                            id: e.term,
                                            text: e.term
                                        }
                                    }; s < r.length;) {
                                    var l = r[s];
                                    if (-1 !== d.inArray(l, o)) {
                                        var c = r.substr(0, s),
                                            u = a(d.extend({}, t, {
                                                term: c
                                            }));
                                        null != u ? (i(u), r = r.substr(s + 1) || "", s = 0) : s++
                                    } else s++
                                }
                                return {
                                    term: r
                                }
                            }, e
                        }), e.define("select2/data/minimumInputLength", [], function() {
                            function e(e, t, n) {
                                this.minimumInputLength = n.get("minimumInputLength"), e.call(this, t, n)
                            }
                            return e.prototype.query = function(e, t, n) {
                                t.term = t.term || "", t.term.length < this.minimumInputLength ? this.trigger("results:message", {
                                    message: "inputTooShort",
                                    args: {
                                        minimum: this.minimumInputLength,
                                        input: t.term,
                                        params: t
                                    }
                                }) : e.call(this, t, n)
                            }, e
                        }), e.define("select2/data/maximumInputLength", [], function() {
                            function e(e, t, n) {
                                this.maximumInputLength = n.get("maximumInputLength"), e.call(this, t, n)
                            }
                            return e.prototype.query = function(e, t, n) {
                                t.term = t.term || "", 0 < this.maximumInputLength && t.term.length > this.maximumInputLength ? this.trigger("results:message", {
                                    message: "inputTooLong",
                                    args: {
                                        maximum: this.maximumInputLength,
                                        input: t.term,
                                        params: t
                                    }
                                }) : e.call(this, t, n)
                            }, e
                        }), e.define("select2/data/maximumSelectionLength", [], function() {
                            function e(e, t, n) {
                                this.maximumSelectionLength = n.get("maximumSelectionLength"), e.call(this, t, n)
                            }
                            return e.prototype.bind = function(e, t, n) {
                                var i = this;
                                e.call(this, t, n), t.on("select", function() {
                                    i._checkIfMaximumSelected()
                                })
                            }, e.prototype.query = function(e, t, n) {
                                var i = this;
                                this._checkIfMaximumSelected(function() {
                                    e.call(i, t, n)
                                })
                            }, e.prototype._checkIfMaximumSelected = function(e, n) {
                                var i = this;
                                this.current(function(e) {
                                    var t = null != e ? e.length : 0;
                                    0 < i.maximumSelectionLength && t >= i.maximumSelectionLength ? i.trigger("results:message", {
                                        message: "maximumSelected",
                                        args: {
                                            maximum: i.maximumSelectionLength
                                        }
                                    }) : n && n()
                                })
                            }, e
                        }), e.define("select2/dropdown", ["jquery", "./utils"], function(t, e) {
                            function n(e, t) {
                                this.$element = e, this.options = t, n.__super__.constructor.call(this)
                            }
                            return e.Extend(n, e.Observable), n.prototype.render = function() {
                                var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>');
                                return e.attr("dir", this.options.get("dir")), this.$dropdown = e
                            }, n.prototype.bind = function() {}, n.prototype.position = function(e, t) {}, n.prototype.destroy = function() {
                                this.$dropdown.remove()
                            }, n
                        }), e.define("select2/dropdown/search", ["jquery", "../utils"], function(r, e) {
                            function t() {}
                            return t.prototype.render = function(e) {
                                var t = e.call(this),
                                    n = r('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>');
                                return this.$searchContainer = n, this.$search = n.find("input"), t.prepend(n), t
                            }, t.prototype.bind = function(e, t, n) {
                                var i = this,
                                    o = t.id + "-results";
                                e.call(this, t, n), this.$search.on("keydown", function(e) {
                                    i.trigger("keypress", e), i._keyUpPrevented = e.isDefaultPrevented()
                                }), this.$search.on("input", function(e) {
                                    r(this).off("keyup")
                                }), this.$search.on("keyup input", function(e) {
                                    i.handleSearch(e)
                                }), t.on("open", function() {
                                    i.$search.attr("tabindex", 0), i.$search.attr("aria-controls", o), i.$search.trigger("focus"), window.setTimeout(function() {
                                        i.$search.trigger("focus")
                                    }, 0)
                                }), t.on("close", function() {
                                    i.$search.attr("tabindex", -1), i.$search.removeAttr("aria-controls"), i.$search.removeAttr("aria-activedescendant"), i.$search.val(""), i.$search.trigger("blur")
                                }), t.on("focus", function() {
                                    t.isOpen() || i.$search.trigger("focus")
                                }), t.on("results:all", function(e) {
                                    null != e.query.term && "" !== e.query.term || (i.showSearch(e) ? i.$searchContainer.removeClass("select2-search--hide") : i.$searchContainer.addClass("select2-search--hide"))
                                }), t.on("results:focus", function(e) {
                                    e.data._resultId ? i.$search.attr("aria-activedescendant", e.data._resultId) : i.$search.removeAttr("aria-activedescendant")
                                })
                            }, t.prototype.handleSearch = function(e) {
                                if (!this._keyUpPrevented) {
                                    var t = this.$search.val();
                                    this.trigger("query", {
                                        term: t
                                    })
                                }
                                this._keyUpPrevented = !1
                            }, t.prototype.showSearch = function(e, t) {
                                return !0
                            }, t
                        }), e.define("select2/dropdown/hidePlaceholder", [], function() {
                            function e(e, t, n, i) {
                                this.placeholder = this.normalizePlaceholder(n.get("placeholder")), e.call(this, t, n, i)
                            }
                            return e.prototype.append = function(e, t) {
                                t.results = this.removePlaceholder(t.results), e.call(this, t)
                            }, e.prototype.normalizePlaceholder = function(e, t) {
                                return "string" == typeof t && (t = {
                                    id: "",
                                    text: t
                                }), t
                            }, e.prototype.removePlaceholder = function(e, t) {
                                for (var n = t.slice(0), i = t.length - 1; 0 <= i; i--) {
                                    var o = t[i];
                                    this.placeholder.id === o.id && n.splice(i, 1)
                                }
                                return n
                            }, e
                        }), e.define("select2/dropdown/infiniteScroll", ["jquery"], function(n) {
                            function e(e, t, n, i) {
                                this.lastParams = {}, e.call(this, t, n, i), this.$loadingMore = this.createLoadingMore(), this.loading = !1
                            }
                            return e.prototype.append = function(e, t) {
                                this.$loadingMore.remove(), this.loading = !1, e.call(this, t), this.showLoadingMore(t) && (this.$results.append(this.$loadingMore), this.loadMoreIfNeeded())
                            }, e.prototype.bind = function(e, t, n) {
                                var i = this;
                                e.call(this, t, n), t.on("query", function(e) {
                                    i.lastParams = e, i.loading = !0
                                }), t.on("query:append", function(e) {
                                    i.lastParams = e, i.loading = !0
                                }), this.$results.on("scroll", this.loadMoreIfNeeded.bind(this))
                            }, e.prototype.loadMoreIfNeeded = function() {
                                var e = n.contains(document.documentElement, this.$loadingMore[0]);
                                if (!this.loading && e) {
                                    var t = this.$results.offset().top + this.$results.outerHeight(!1);
                                    this.$loadingMore.offset().top + this.$loadingMore.outerHeight(!1) <= t + 50 && this.loadMore()
                                }
                            }, e.prototype.loadMore = function() {
                                this.loading = !0;
                                var e = n.extend({}, {
                                    page: 1
                                }, this.lastParams);
                                e.page++, this.trigger("query:append", e)
                            }, e.prototype.showLoadingMore = function(e, t) {
                                return t.pagination && t.pagination.more
                            }, e.prototype.createLoadingMore = function() {
                                var e = n('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'),
                                    t = this.options.get("translations").get("loadingMore");
                                return e.html(t(this.lastParams)), e
                            }, e
                        }), e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function(h, a) {
                            function e(e, t, n) {
                                this.$dropdownParent = h(n.get("dropdownParent") || document.body), e.call(this, t, n)
                            }
                            return e.prototype.bind = function(e, t, n) {
                                var i = this;
                                e.call(this, t, n), t.on("open", function() {
                                    i._showDropdown(), i._attachPositioningHandler(t), i._bindContainerResultHandlers(t)
                                }), t.on("close", function() {
                                    i._hideDropdown(), i._detachPositioningHandler(t)
                                }), this.$dropdownContainer.on("mousedown", function(e) {
                                    e.stopPropagation()
                                })
                            }, e.prototype.destroy = function(e) {
                                e.call(this), this.$dropdownContainer.remove()
                            }, e.prototype.position = function(e, t, n) {
                                t.attr("class", n.attr("class")), t.removeClass("select2"), t.addClass("select2-container--open"), t.css({
                                    position: "absolute",
                                    top: -999999
                                }), this.$container = n
                            }, e.prototype.render = function(e) {
                                var t = h("<span></span>"),
                                    n = e.call(this);
                                return t.append(n), this.$dropdownContainer = t
                            }, e.prototype._hideDropdown = function(e) {
                                this.$dropdownContainer.detach()
                            }, e.prototype._bindContainerResultHandlers = function(e, t) {
                                if (!this._containerResultsHandlersBound) {
                                    var n = this;
                                    t.on("results:all", function() {
                                        n._positionDropdown(), n._resizeDropdown()
                                    }), t.on("results:append", function() {
                                        n._positionDropdown(), n._resizeDropdown()
                                    }), t.on("results:message", function() {
                                        n._positionDropdown(), n._resizeDropdown()
                                    }), t.on("select", function() {
                                        n._positionDropdown(), n._resizeDropdown()
                                    }), t.on("unselect", function() {
                                        n._positionDropdown(), n._resizeDropdown()
                                    }), this._containerResultsHandlersBound = !0
                                }
                            }, e.prototype._attachPositioningHandler = function(e, t) {
                                var n = this,
                                    i = "scroll.select2." + t.id,
                                    o = "resize.select2." + t.id,
                                    r = "orientationchange.select2." + t.id,
                                    s = this.$container.parents().filter(a.hasScroll);
                                s.each(function() {
                                    a.StoreData(this, "select2-scroll-position", {
                                        x: h(this).scrollLeft(),
                                        y: h(this).scrollTop()
                                    })
                                }), s.on(i, function(e) {
                                    var t = a.GetData(this, "select2-scroll-position");
                                    h(this).scrollTop(t.y)
                                }), h(window).on(i + " " + o + " " + r, function(e) {
                                    n._positionDropdown(), n._resizeDropdown()
                                })
                            }, e.prototype._detachPositioningHandler = function(e, t) {
                                var n = "scroll.select2." + t.id,
                                    i = "resize.select2." + t.id,
                                    o = "orientationchange.select2." + t.id;
                                this.$container.parents().filter(a.hasScroll).off(n), h(window).off(n + " " + i + " " + o)
                            }, e.prototype._positionDropdown = function() {
                                var e = h(window),
                                    t = this.$dropdown.hasClass("select2-dropdown--above"),
                                    n = this.$dropdown.hasClass("select2-dropdown--below"),
                                    i = null,
                                    o = this.$container.offset();
                                o.bottom = o.top + this.$container.outerHeight(!1);
                                var r = {
                                    height: this.$container.outerHeight(!1)
                                };
                                r.top = o.top, r.bottom = o.top + r.height;
                                var s = this.$dropdown.outerHeight(!1),
                                    a = e.scrollTop(),
                                    l = e.scrollTop() + e.height(),
                                    c = a < o.top - s,
                                    u = l > o.bottom + s,
                                    d = {
                                        left: o.left,
                                        top: r.bottom
                                    },
                                    p = this.$dropdownParent;
                                "static" === p.css("position") && (p = p.offsetParent());
                                var f = {
                                    top: 0,
                                    left: 0
                                };
                                (h.contains(document.body, p[0]) || p[0].isConnected) && (f = p.offset()), d.top -= f.top, d.left -= f.left, t || n || (i = "below"), u || !c || t ? !c && u && t && (i = "below") : i = "above", ("above" == i || t && "below" !== i) && (d.top = r.top - f.top - s), null != i && (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + i), this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + i)), this.$dropdownContainer.css(d)
                            }, e.prototype._resizeDropdown = function() {
                                var e = {
                                    width: this.$container.outerWidth(!1) + "px"
                                };
                                this.options.get("dropdownAutoWidth") && (e.minWidth = e.width, e.position = "relative", e.width = "auto"), this.$dropdown.css(e)
                            }, e.prototype._showDropdown = function(e) {
                                this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown()
                            }, e
                        }), e.define("select2/dropdown/minimumResultsForSearch", [], function() {
                            function e(e, t, n, i) {
                                this.minimumResultsForSearch = n.get("minimumResultsForSearch"), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), e.call(this, t, n, i)
                            }
                            return e.prototype.showSearch = function(e, t) {
                                return !(function e(t) {
                                    for (var n = 0, i = 0; i < t.length; i++) {
                                        var o = t[i];
                                        o.children ? n += e(o.children) : n++
                                    }
                                    return n
                                }(t.data.results) < this.minimumResultsForSearch) && e.call(this, t)
                            }, e
                        }), e.define("select2/dropdown/selectOnClose", ["../utils"], function(r) {
                            function e() {}
                            return e.prototype.bind = function(e, t, n) {
                                var i = this;
                                e.call(this, t, n), t.on("close", function(e) {
                                    i._handleSelectOnClose(e)
                                })
                            }, e.prototype._handleSelectOnClose = function(e, t) {
                                if (t && null != t.originalSelect2Event) {
                                    var n = t.originalSelect2Event;
                                    if ("select" === n._type || "unselect" === n._type) return
                                }
                                var i = this.getHighlightedResults();
                                if (!(i.length < 1)) {
                                    var o = r.GetData(i[0], "data");
                                    null != o.element && o.element.selected || null == o.element && o.selected || this.trigger("select", {
                                        data: o
                                    })
                                }
                            }, e
                        }), e.define("select2/dropdown/closeOnSelect", [], function() {
                            function e() {}
                            return e.prototype.bind = function(e, t, n) {
                                var i = this;
                                e.call(this, t, n), t.on("select", function(e) {
                                    i._selectTriggered(e)
                                }), t.on("unselect", function(e) {
                                    i._selectTriggered(e)
                                })
                            }, e.prototype._selectTriggered = function(e, t) {
                                var n = t.originalEvent;
                                n && (n.ctrlKey || n.metaKey) || this.trigger("close", {
                                    originalEvent: n,
                                    originalSelect2Event: t
                                })
                            }, e
                        }), e.define("select2/i18n/en", [], function() {
                            return {
                                errorLoading: function() {
                                    return "The results could not be loaded."
                                },
                                inputTooLong: function(e) {
                                    var t = e.input.length - e.maximum,
                                        n = "Please delete " + t + " character";
                                    return 1 != t && (n += "s"), n
                                },
                                inputTooShort: function(e) {
                                    return "Please enter " + (e.minimum - e.input.length) + " or more characters"
                                },
                                loadingMore: function() {
                                    return "Loading more results…"
                                },
                                maximumSelected: function(e) {
                                    var t = "You can only select " + e.maximum + " item";
                                    return 1 != e.maximum && (t += "s"), t
                                },
                                noResults: function() {
                                    return "No results found"
                                },
                                searching: function() {
                                    return "Searching…"
                                },
                                removeAllItems: function() {
                                    return "Remove all items"
                                }
                            }
                        }), e.define("select2/defaults", ["jquery", "require", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./i18n/en"], function(c, u, d, p, f, h, m, g, v, y, s, t, w, b, x, T, C, S, k, A, _, $, E, D, z, O, L, I, e) {
                            function n() {
                                this.reset()
                            }
                            return n.prototype.apply = function(e) {
                                if (null == (e = c.extend(!0, {}, this.defaults, e)).dataAdapter) {
                                    if (null != e.ajax ? e.dataAdapter = x : null != e.data ? e.dataAdapter = b : e.dataAdapter = w, 0 < e.minimumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, S)), 0 < e.maximumInputLength && (e.dataAdapter = y.Decorate(e.dataAdapter, k)), 0 < e.maximumSelectionLength && (e.dataAdapter = y.Decorate(e.dataAdapter, A)), e.tags && (e.dataAdapter = y.Decorate(e.dataAdapter, T)), null == e.tokenSeparators && null == e.tokenizer || (e.dataAdapter = y.Decorate(e.dataAdapter, C)), null != e.query) {
                                        var t = u(e.amdBase + "compat/query");
                                        e.dataAdapter = y.Decorate(e.dataAdapter, t)
                                    }
                                    if (null != e.initSelection) {
                                        var n = u(e.amdBase + "compat/initSelection");
                                        e.dataAdapter = y.Decorate(e.dataAdapter, n)
                                    }
                                }
                                if (null == e.resultsAdapter && (e.resultsAdapter = d, null != e.ajax && (e.resultsAdapter = y.Decorate(e.resultsAdapter, D)), null != e.placeholder && (e.resultsAdapter = y.Decorate(e.resultsAdapter, E)), e.selectOnClose && (e.resultsAdapter = y.Decorate(e.resultsAdapter, L))), null == e.dropdownAdapter) {
                                    if (e.multiple) e.dropdownAdapter = _;
                                    else {
                                        var i = y.Decorate(_, $);
                                        e.dropdownAdapter = i
                                    }
                                    if (0 !== e.minimumResultsForSearch && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, O)), e.closeOnSelect && (e.dropdownAdapter = y.Decorate(e.dropdownAdapter, I)), null != e.dropdownCssClass || null != e.dropdownCss || null != e.adaptDropdownCssClass) {
                                        var o = u(e.amdBase + "compat/dropdownCss");
                                        e.dropdownAdapter = y.Decorate(e.dropdownAdapter, o)
                                    }
                                    e.dropdownAdapter = y.Decorate(e.dropdownAdapter, z)
                                }
                                if (null == e.selectionAdapter) {
                                    if (e.multiple ? e.selectionAdapter = f : e.selectionAdapter = p, null != e.placeholder && (e.selectionAdapter = y.Decorate(e.selectionAdapter, h)), e.allowClear && (e.selectionAdapter = y.Decorate(e.selectionAdapter, m)), e.multiple && (e.selectionAdapter = y.Decorate(e.selectionAdapter, g)), null != e.containerCssClass || null != e.containerCss || null != e.adaptContainerCssClass) {
                                        var r = u(e.amdBase + "compat/containerCss");
                                        e.selectionAdapter = y.Decorate(e.selectionAdapter, r)
                                    }
                                    e.selectionAdapter = y.Decorate(e.selectionAdapter, v)
                                }
                                e.language = this._resolveLanguage(e.language), e.language.push("en");
                                for (var s = [], a = 0; a < e.language.length; a++) {
                                    var l = e.language[a]; - 1 === s.indexOf(l) && s.push(l)
                                }
                                return e.language = s, e.translations = this._processTranslations(e.language, e.debug), e
                            }, n.prototype.reset = function() {
                                function a(e) {
                                    return e.replace(/[^\u0000-\u007E]/g, function(e) {
                                        return t[e] || e
                                    })
                                }
                                this.defaults = {
                                    amdBase: "./",
                                    amdLanguageBase: "./i18n/",
                                    closeOnSelect: !0,
                                    debug: !1,
                                    dropdownAutoWidth: !1,
                                    escapeMarkup: y.escapeMarkup,
                                    language: {},
                                    matcher: function e(t, n) {
                                        if ("" === c.trim(t.term)) return n;
                                        if (n.children && 0 < n.children.length) {
                                            for (var i = c.extend(!0, {}, n), o = n.children.length - 1; 0 <= o; o--) null == e(t, n.children[o]) && i.children.splice(o, 1);
                                            return 0 < i.children.length ? i : e(t, i)
                                        }
                                        var r = a(n.text).toUpperCase(),
                                            s = a(t.term).toUpperCase();
                                        return -1 < r.indexOf(s) ? n : null
                                    },
                                    minimumInputLength: 0,
                                    maximumInputLength: 0,
                                    maximumSelectionLength: 0,
                                    minimumResultsForSearch: 0,
                                    selectOnClose: !1,
                                    scrollAfterSelect: !1,
                                    sorter: function(e) {
                                        return e
                                    },
                                    templateResult: function(e) {
                                        return e.text
                                    },
                                    templateSelection: function(e) {
                                        return e.text
                                    },
                                    theme: "default",
                                    width: "resolve"
                                }
                            }, n.prototype.applyFromElement = function(e, t) {
                                var n = e.language,
                                    i = this.defaults.language,
                                    o = t.prop("lang"),
                                    r = t.closest("[lang]").prop("lang"),
                                    s = Array.prototype.concat.call(this._resolveLanguage(o), this._resolveLanguage(n), this._resolveLanguage(i), this._resolveLanguage(r));
                                return e.language = s, e
                            }, n.prototype._resolveLanguage = function(e) {
                                if (!e) return [];
                                if (c.isEmptyObject(e)) return [];
                                if (c.isPlainObject(e)) return [e];
                                var t;
                                t = c.isArray(e) ? e : [e];
                                for (var n = [], i = 0; i < t.length; i++)
                                    if (n.push(t[i]), "string" == typeof t[i] && 0 < t[i].indexOf("-")) {
                                        var o = t[i].split("-")[0];
                                        n.push(o)
                                    } return n
                            }, n.prototype._processTranslations = function(e, t) {
                                for (var n = new s, i = 0; i < e.length; i++) {
                                    var o = new s,
                                        r = e[i];
                                    if ("string" == typeof r) try {
                                        o = s.loadPath(r)
                                    } catch (e) {
                                        try {
                                            r = this.defaults.amdLanguageBase + r, o = s.loadPath(r)
                                        } catch (e) {
                                            t && window.console && console.warn && console.warn('Select2: The language file for "' + r + '" could not be automatically loaded. A fallback will be used instead.')
                                        }
                                    } else o = c.isPlainObject(r) ? new s(r) : r;
                                    n.extend(o)
                                }
                                return n
                            }, n.prototype.set = function(e, t) {
                                var n = {};
                                n[c.camelCase(e)] = t;
                                var i = y._convertData(n);
                                c.extend(!0, this.defaults, i)
                            }, new n
                        }), e.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function(i, u, o, d) {
                            function e(e, t) {
                                if (this.options = e, null != t && this.fromElement(t), null != t && (this.options = o.applyFromElement(this.options, t)), this.options = o.apply(this.options), t && t.is("input")) {
                                    var n = i(this.get("amdBase") + "compat/inputData");
                                    this.options.dataAdapter = d.Decorate(this.options.dataAdapter, n)
                                }
                            }
                            return e.prototype.fromElement = function(e) {
                                var t = ["select2"];
                                null == this.options.multiple && (this.options.multiple = e.prop("multiple")), null == this.options.disabled && (this.options.disabled = e.prop("disabled")), null == this.options.dir && (e.prop("dir") ? this.options.dir = e.prop("dir") : e.closest("[dir]").prop("dir") ? this.options.dir = e.closest("[dir]").prop("dir") : this.options.dir = "ltr"), e.prop("disabled", this.options.disabled), e.prop("multiple", this.options.multiple), d.GetData(e[0], "select2Tags") && (this.options.debug && window.console && console.warn && console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'), d.StoreData(e[0], "data", d.GetData(e[0], "select2Tags")), d.StoreData(e[0], "tags", !0)), d.GetData(e[0], "ajaxUrl") && (this.options.debug && window.console && console.warn && console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."), e.attr("ajax--url", d.GetData(e[0], "ajaxUrl")), d.StoreData(e[0], "ajax-Url", d.GetData(e[0], "ajaxUrl")));
                                var n = {};

                                function i(e, t) {
                                    return t.toUpperCase()
                                }
                                for (var o = 0; o < e[0].attributes.length; o++) {
                                    var r = e[0].attributes[o].name;
                                    if ("data-" == r.substr(0, "data-".length)) {
                                        var s = r.substring("data-".length),
                                            a = d.GetData(e[0], s);
                                        n[s.replace(/-([a-z])/g, i)] = a
                                    }
                                }
                                u.fn.jquery && "1." == u.fn.jquery.substr(0, 2) && e[0].dataset && (n = u.extend(!0, {}, e[0].dataset, n));
                                var l = u.extend(!0, {}, d.GetData(e[0]), n);
                                for (var c in l = d._convertData(l)) - 1 < u.inArray(c, t) || (u.isPlainObject(this.options[c]) ? u.extend(this.options[c], l[c]) : this.options[c] = l[c]);
                                return this
                            }, e.prototype.get = function(e) {
                                return this.options[e]
                            }, e.prototype.set = function(e, t) {
                                this.options[e] = t
                            }, e
                        }), e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function(o, c, u, i) {
                            function d(e, t) {
                                null != u.GetData(e[0], "select2") && u.GetData(e[0], "select2").destroy(), this.$element = e, this.id = this._generateId(e), t = t || {}, this.options = new c(t, e), d.__super__.constructor.call(this);
                                var n = e.attr("tabindex") || 0;
                                u.StoreData(e[0], "old-tabindex", n), e.attr("tabindex", "-1");
                                var i = this.options.get("dataAdapter");
                                this.dataAdapter = new i(e, this.options);
                                var o = this.render();
                                this._placeContainer(o);
                                var r = this.options.get("selectionAdapter");
                                this.selection = new r(e, this.options), this.$selection = this.selection.render(), this.selection.position(this.$selection, o);
                                var s = this.options.get("dropdownAdapter");
                                this.dropdown = new s(e, this.options), this.$dropdown = this.dropdown.render(), this.dropdown.position(this.$dropdown, o);
                                var a = this.options.get("resultsAdapter");
                                this.results = new a(e, this.options, this.dataAdapter), this.$results = this.results.render(), this.results.position(this.$results, this.$dropdown);
                                var l = this;
                                this._bindAdapters(), this._registerDomEvents(), this._registerDataEvents(), this._registerSelectionEvents(), this._registerDropdownEvents(), this._registerResultsEvents(), this._registerEvents(), this.dataAdapter.current(function(e) {
                                    l.trigger("selection:update", {
                                        data: e
                                    })
                                }), e.addClass("select2-hidden-accessible"), e.attr("aria-hidden", "true"), this._syncAttributes(), u.StoreData(e[0], "select2", this), e.data("select2", this)
                            }
                            return u.Extend(d, u.Observable), d.prototype._generateId = function(e) {
                                return "select2-" + (null != e.attr("id") ? e.attr("id") : null != e.attr("name") ? e.attr("name") + "-" + u.generateChars(2) : u.generateChars(4)).replace(/(:|\.|\[|\]|,)/g, "")
                            }, d.prototype._placeContainer = function(e) {
                                e.insertAfter(this.$element);
                                var t = this._resolveWidth(this.$element, this.options.get("width"));
                                null != t && e.css("width", t)
                            }, d.prototype._resolveWidth = function(e, t) {
                                var n = /^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;
                                if ("resolve" == t) {
                                    var i = this._resolveWidth(e, "style");
                                    return null != i ? i : this._resolveWidth(e, "element")
                                }
                                if ("element" == t) {
                                    var o = e.outerWidth(!1);
                                    return o <= 0 ? "auto" : o + "px"
                                }
                                if ("style" != t) return "computedstyle" != t ? t : window.getComputedStyle(e[0]).width;
                                var r = e.attr("style");
                                if ("string" != typeof r) return null;
                                for (var s = r.split(";"), a = 0, l = s.length; a < l; a += 1) {
                                    var c = s[a].replace(/\s/g, "").match(n);
                                    if (null !== c && 1 <= c.length) return c[1]
                                }
                                return null
                            }, d.prototype._bindAdapters = function() {
                                this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container)
                            }, d.prototype._registerDomEvents = function() {
                                var t = this;
                                this.$element.on("change.select2", function() {
                                    t.dataAdapter.current(function(e) {
                                        t.trigger("selection:update", {
                                            data: e
                                        })
                                    })
                                }), this.$element.on("focus.select2", function(e) {
                                    t.trigger("focus", e)
                                }), this._syncA = u.bind(this._syncAttributes, this), this._syncS = u.bind(this._syncSubtree, this), this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
                                var e = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                                null != e ? (this._observer = new e(function(e) {
                                    o.each(e, t._syncA), o.each(e, t._syncS)
                                }), this._observer.observe(this.$element[0], {
                                    attributes: !0,
                                    childList: !0,
                                    subtree: !1
                                })) : this.$element[0].addEventListener && (this.$element[0].addEventListener("DOMAttrModified", t._syncA, !1), this.$element[0].addEventListener("DOMNodeInserted", t._syncS, !1), this.$element[0].addEventListener("DOMNodeRemoved", t._syncS, !1))
                            }, d.prototype._registerDataEvents = function() {
                                var n = this;
                                this.dataAdapter.on("*", function(e, t) {
                                    n.trigger(e, t)
                                })
                            }, d.prototype._registerSelectionEvents = function() {
                                var n = this,
                                    i = ["toggle", "focus"];
                                this.selection.on("toggle", function() {
                                    n.toggleDropdown()
                                }), this.selection.on("focus", function(e) {
                                    n.focus(e)
                                }), this.selection.on("*", function(e, t) {
                                    -1 === o.inArray(e, i) && n.trigger(e, t)
                                })
                            }, d.prototype._registerDropdownEvents = function() {
                                var n = this;
                                this.dropdown.on("*", function(e, t) {
                                    n.trigger(e, t)
                                })
                            }, d.prototype._registerResultsEvents = function() {
                                var n = this;
                                this.results.on("*", function(e, t) {
                                    n.trigger(e, t)
                                })
                            }, d.prototype._registerEvents = function() {
                                var n = this;
                                this.on("open", function() {
                                    n.$container.addClass("select2-container--open")
                                }), this.on("close", function() {
                                    n.$container.removeClass("select2-container--open")
                                }), this.on("enable", function() {
                                    n.$container.removeClass("select2-container--disabled")
                                }), this.on("disable", function() {
                                    n.$container.addClass("select2-container--disabled")
                                }), this.on("blur", function() {
                                    n.$container.removeClass("select2-container--focus")
                                }), this.on("query", function(t) {
                                    n.isOpen() || n.trigger("open", {}), this.dataAdapter.query(t, function(e) {
                                        n.trigger("results:all", {
                                            data: e,
                                            query: t
                                        })
                                    })
                                }), this.on("query:append", function(t) {
                                    this.dataAdapter.query(t, function(e) {
                                        n.trigger("results:append", {
                                            data: e,
                                            query: t
                                        })
                                    })
                                }), this.on("keypress", function(e) {
                                    var t = e.which;
                                    n.isOpen() ? t === i.ESC || t === i.TAB || t === i.UP && e.altKey ? (n.close(), e.preventDefault()) : t === i.ENTER ? (n.trigger("results:select", {}), e.preventDefault()) : t === i.SPACE && e.ctrlKey ? (n.trigger("results:toggle", {}), e.preventDefault()) : t === i.UP ? (n.trigger("results:previous", {}), e.preventDefault()) : t === i.DOWN && (n.trigger("results:next", {}), e.preventDefault()) : (t === i.ENTER || t === i.SPACE || t === i.DOWN && e.altKey) && (n.open(), e.preventDefault())
                                })
                            }, d.prototype._syncAttributes = function() {
                                this.options.set("disabled", this.$element.prop("disabled")), this.options.get("disabled") ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {})
                            }, d.prototype._syncSubtree = function(e, t) {
                                var n = !1,
                                    i = this;
                                if (!e || !e.target || "OPTION" === e.target.nodeName || "OPTGROUP" === e.target.nodeName) {
                                    if (t)
                                        if (t.addedNodes && 0 < t.addedNodes.length)
                                            for (var o = 0; o < t.addedNodes.length; o++) t.addedNodes[o].selected && (n = !0);
                                        else t.removedNodes && 0 < t.removedNodes.length && (n = !0);
                                    else n = !0;
                                    n && this.dataAdapter.current(function(e) {
                                        i.trigger("selection:update", {
                                            data: e
                                        })
                                    })
                                }
                            }, d.prototype.trigger = function(e, t) {
                                var n = d.__super__.trigger,
                                    i = {
                                        open: "opening",
                                        close: "closing",
                                        select: "selecting",
                                        unselect: "unselecting",
                                        clear: "clearing"
                                    };
                                if (void 0 === t && (t = {}), e in i) {
                                    var o = i[e],
                                        r = {
                                            prevented: !1,
                                            name: e,
                                            args: t
                                        };
                                    if (n.call(this, o, r), r.prevented) return void(t.prevented = !0)
                                }
                                n.call(this, e, t)
                            }, d.prototype.toggleDropdown = function() {
                                this.options.get("disabled") || (this.isOpen() ? this.close() : this.open())
                            }, d.prototype.open = function() {
                                this.isOpen() || this.trigger("query", {})
                            }, d.prototype.close = function() {
                                this.isOpen() && this.trigger("close", {})
                            }, d.prototype.isOpen = function() {
                                return this.$container.hasClass("select2-container--open")
                            }, d.prototype.hasFocus = function() {
                                return this.$container.hasClass("select2-container--focus")
                            }, d.prototype.focus = function(e) {
                                this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}))
                            }, d.prototype.enable = function(e) {
                                this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'), null != e && 0 !== e.length || (e = [!0]);
                                var t = !e[0];
                                this.$element.prop("disabled", t)
                            }, d.prototype.data = function() {
                                this.options.get("debug") && 0 < arguments.length && window.console && console.warn && console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
                                var t = [];
                                return this.dataAdapter.current(function(e) {
                                    t = e
                                }), t
                            }, d.prototype.val = function(e) {
                                if (this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'), null == e || 0 === e.length) return this.$element.val();
                                var t = e[0];
                                o.isArray(t) && (t = o.map(t, function(e) {
                                    return e.toString()
                                })), this.$element.val(t).trigger("change")
                            }, d.prototype.destroy = function() {
                                this.$container.remove(), this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA), null != this._observer ? (this._observer.disconnect(), this._observer = null) : this.$element[0].removeEventListener && (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1), this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1), this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)), this._syncA = null, this._syncS = null, this.$element.off(".select2"), this.$element.attr("tabindex", u.GetData(this.$element[0], "old-tabindex")), this.$element.removeClass("select2-hidden-accessible"), this.$element.attr("aria-hidden", "false"), u.RemoveData(this.$element[0]), this.$element.removeData("select2"), this.dataAdapter.destroy(), this.selection.destroy(), this.dropdown.destroy(), this.results.destroy(), this.dataAdapter = null, this.selection = null, this.dropdown = null, this.results = null
                            }, d.prototype.render = function() {
                                var e = o('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
                                return e.attr("dir", this.options.get("dir")), this.$container = e, this.$container.addClass("select2-container--" + this.options.get("theme")), u.StoreData(e[0], "element", this.$element), e
                            }, d
                        }), e.define("select2/compat/utils", ["jquery"], function(s) {
                            return {
                                syncCssClasses: function(e, t, n) {
                                    var i, o, r = [];
                                    (i = s.trim(e.attr("class"))) && s((i = "" + i).split(/\s+/)).each(function() {
                                        0 === this.indexOf("select2-") && r.push(this)
                                    }), (i = s.trim(t.attr("class"))) && s((i = "" + i).split(/\s+/)).each(function() {
                                        0 !== this.indexOf("select2-") && null != (o = n(this)) && r.push(o)
                                    }), e.attr("class", r.join(" "))
                                }
                            }
                        }), e.define("select2/compat/containerCss", ["jquery", "./utils"], function(s, a) {
                            function l(e) {
                                return null
                            }

                            function e() {}
                            return e.prototype.render = function(e) {
                                var t = e.call(this),
                                    n = this.options.get("containerCssClass") || "";
                                s.isFunction(n) && (n = n(this.$element));
                                var i = this.options.get("adaptContainerCssClass");
                                if (i = i || l, -1 !== n.indexOf(":all:")) {
                                    n = n.replace(":all:", "");
                                    var o = i;
                                    i = function(e) {
                                        var t = o(e);
                                        return null != t ? t + " " + e : e
                                    }
                                }
                                var r = this.options.get("containerCss") || {};
                                return s.isFunction(r) && (r = r(this.$element)), a.syncCssClasses(t, this.$element, i), t.css(r), t.addClass(n), t
                            }, e
                        }), e.define("select2/compat/dropdownCss", ["jquery", "./utils"], function(s, a) {
                            function l(e) {
                                return null
                            }

                            function e() {}
                            return e.prototype.render = function(e) {
                                var t = e.call(this),
                                    n = this.options.get("dropdownCssClass") || "";
                                s.isFunction(n) && (n = n(this.$element));
                                var i = this.options.get("adaptDropdownCssClass");
                                if (i = i || l, -1 !== n.indexOf(":all:")) {
                                    n = n.replace(":all:", "");
                                    var o = i;
                                    i = function(e) {
                                        var t = o(e);
                                        return null != t ? t + " " + e : e
                                    }
                                }
                                var r = this.options.get("dropdownCss") || {};
                                return s.isFunction(r) && (r = r(this.$element)), a.syncCssClasses(t, this.$element, i), t.css(r), t.addClass(n), t
                            }, e
                        }), e.define("select2/compat/initSelection", ["jquery"], function(i) {
                            function e(e, t, n) {
                                n.get("debug") && window.console && console.warn && console.warn("Select2: The `initSelection` option has been deprecated in favor of a custom data adapter that overrides the `current` method. This method is now called multiple times instead of a single time when the instance is initialized. Support will be removed for the `initSelection` option in future versions of Select2"), this.initSelection = n.get("initSelection"), this._isInitialized = !1, e.call(this, t, n)
                            }
                            return e.prototype.current = function(e, t) {
                                var n = this;
                                this._isInitialized ? e.call(this, t) : this.initSelection.call(null, this.$element, function(e) {
                                    n._isInitialized = !0, i.isArray(e) || (e = [e]), t(e)
                                })
                            }, e
                        }), e.define("select2/compat/inputData", ["jquery", "../utils"], function(s, i) {
                            function e(e, t, n) {
                                this._currentData = [], this._valueSeparator = n.get("valueSeparator") || ",", "hidden" === t.prop("type") && n.get("debug") && console && console.warn && console.warn("Select2: Using a hidden input with Select2 is no longer supported and may stop working in the future. It is recommended to use a `<select>` element instead."), e.call(this, t, n)
                            }
                            return e.prototype.current = function(e, t) {
                                function i(e, t) {
                                    var n = [];
                                    return e.selected || -1 !== s.inArray(e.id, t) ? (e.selected = !0, n.push(e)) : e.selected = !1, e.children && n.push.apply(n, i(e.children, t)), n
                                }
                                for (var n = [], o = 0; o < this._currentData.length; o++) {
                                    var r = this._currentData[o];
                                    n.push.apply(n, i(r, this.$element.val().split(this._valueSeparator)))
                                }
                                t(n)
                            }, e.prototype.select = function(e, t) {
                                if (this.options.get("multiple")) {
                                    var n = this.$element.val();
                                    n += this._valueSeparator + t.id, this.$element.val(n), this.$element.trigger("change")
                                } else this.current(function(e) {
                                    s.map(e, function(e) {
                                        e.selected = !1
                                    })
                                }), this.$element.val(t.id), this.$element.trigger("change")
                            }, e.prototype.unselect = function(e, o) {
                                var r = this;
                                o.selected = !1, this.current(function(e) {
                                    for (var t = [], n = 0; n < e.length; n++) {
                                        var i = e[n];
                                        o.id != i.id && t.push(i.id)
                                    }
                                    r.$element.val(t.join(r._valueSeparator)), r.$element.trigger("change")
                                })
                            }, e.prototype.query = function(e, t, n) {
                                for (var i = [], o = 0; o < this._currentData.length; o++) {
                                    var r = this._currentData[o],
                                        s = this.matches(t, r);
                                    null !== s && i.push(s)
                                }
                                n({
                                    results: i
                                })
                            }, e.prototype.addOptions = function(e, t) {
                                var n = s.map(t, function(e) {
                                    return i.GetData(e[0], "data")
                                });
                                this._currentData.push.apply(this._currentData, n)
                            }, e
                        }), e.define("select2/compat/matcher", ["jquery"], function(s) {
                            return function(r) {
                                return function(e, t) {
                                    var n = s.extend(!0, {}, t);
                                    if (null == e.term || "" === s.trim(e.term)) return n;
                                    if (t.children) {
                                        for (var i = t.children.length - 1; 0 <= i; i--) {
                                            var o = t.children[i];
                                            r(e.term, o.text, o) || n.children.splice(i, 1)
                                        }
                                        if (0 < n.children.length) return n
                                    }
                                    return r(e.term, t.text, t) ? n : null
                                }
                            }
                        }), e.define("select2/compat/query", [], function() {
                            function e(e, t, n) {
                                n.get("debug") && window.console && console.warn && console.warn("Select2: The `query` option has been deprecated in favor of a custom data adapter that overrides the `query` method. Support will be removed for the `query` option in future versions of Select2."), e.call(this, t, n)
                            }
                            return e.prototype.query = function(e, t, n) {
                                t.callback = n, this.options.get("query").call(null, t)
                            }, e
                        }), e.define("select2/dropdown/attachContainer", [], function() {
                            function e(e, t, n) {
                                e.call(this, t, n)
                            }
                            return e.prototype.position = function(e, t, n) {
                                n.find(".dropdown-wrapper").append(t), t.addClass("select2-dropdown--below"), n.addClass("select2-container--below")
                            }, e
                        }), e.define("select2/dropdown/stopPropagation", [], function() {
                            function e() {}
                            return e.prototype.bind = function(e, t, n) {
                                e.call(this, t, n), this.$dropdown.on(["blur", "change", "click", "dblclick", "focus", "focusin", "focusout", "input", "keydown", "keyup", "keypress", "mousedown", "mouseenter", "mouseleave", "mousemove", "mouseover", "mouseup", "search", "touchend", "touchstart"].join(" "), function(e) {
                                    e.stopPropagation()
                                })
                            }, e
                        }), e.define("select2/selection/stopPropagation", [], function() {
                            function e() {}
                            return e.prototype.bind = function(e, t, n) {
                                e.call(this, t, n), this.$selection.on(["blur", "change", "click", "dblclick", "focus", "focusin", "focusout", "input", "keydown", "keyup", "keypress", "mousedown", "mouseenter", "mouseleave", "mousemove", "mouseover", "mouseup", "search", "touchend", "touchstart"].join(" "), function(e) {
                                    e.stopPropagation()
                                })
                            }, e
                        }), l = function(p) {
                            var f, h, e = ["wheel", "mousewheel", "DOMMouseScroll", "MozMousePixelScroll"],
                                t = "onwheel" in document || 9 <= document.documentMode ? ["wheel"] : ["mousewheel", "DomMouseScroll", "MozMousePixelScroll"],
                                m = Array.prototype.slice;
                            if (p.event.fixHooks)
                                for (var n = e.length; n;) p.event.fixHooks[e[--n]] = p.event.mouseHooks;
                            var g = p.event.special.mousewheel = {
                                version: "3.1.12",
                                setup: function() {
                                    if (this.addEventListener)
                                        for (var e = t.length; e;) this.addEventListener(t[--e], i, !1);
                                    else this.onmousewheel = i;
                                    p.data(this, "mousewheel-line-height", g.getLineHeight(this)), p.data(this, "mousewheel-page-height", g.getPageHeight(this))
                                },
                                teardown: function() {
                                    if (this.removeEventListener)
                                        for (var e = t.length; e;) this.removeEventListener(t[--e], i, !1);
                                    else this.onmousewheel = null;
                                    p.removeData(this, "mousewheel-line-height"), p.removeData(this, "mousewheel-page-height")
                                },
                                getLineHeight: function(e) {
                                    var t = p(e),
                                        n = t["offsetParent" in p.fn ? "offsetParent" : "parent"]();
                                    return n.length || (n = p("body")), parseInt(n.css("fontSize"), 10) || parseInt(t.css("fontSize"), 10) || 16
                                },
                                getPageHeight: function(e) {
                                    return p(e).height()
                                },
                                settings: {
                                    adjustOldDeltas: !0,
                                    normalizeOffset: !0
                                }
                            };

                            function i(e) {
                                var t, n = e || window.event,
                                    i = m.call(arguments, 1),
                                    o = 0,
                                    r = 0,
                                    s = 0,
                                    a = 0,
                                    l = 0;
                                if ((e = p.event.fix(n)).type = "mousewheel", "detail" in n && (s = -1 * n.detail), "wheelDelta" in n && (s = n.wheelDelta), "wheelDeltaY" in n && (s = n.wheelDeltaY), "wheelDeltaX" in n && (r = -1 * n.wheelDeltaX), "axis" in n && n.axis === n.HORIZONTAL_AXIS && (r = -1 * s, s = 0), o = 0 === s ? r : s, "deltaY" in n && (o = s = -1 * n.deltaY), "deltaX" in n && (r = n.deltaX, 0 === s && (o = -1 * r)), 0 !== s || 0 !== r) {
                                    if (1 === n.deltaMode) {
                                        var c = p.data(this, "mousewheel-line-height");
                                        o *= c, s *= c, r *= c
                                    } else if (2 === n.deltaMode) {
                                        var u = p.data(this, "mousewheel-page-height");
                                        o *= u, s *= u, r *= u
                                    }
                                    if (t = Math.max(Math.abs(s), Math.abs(r)), (!h || t < h) && y(n, h = t) && (h /= 40), y(n, t) && (o /= 40, r /= 40, s /= 40), o = Math[1 <= o ? "floor" : "ceil"](o / h), r = Math[1 <= r ? "floor" : "ceil"](r / h), s = Math[1 <= s ? "floor" : "ceil"](s / h), g.settings.normalizeOffset && this.getBoundingClientRect) {
                                        var d = this.getBoundingClientRect();
                                        a = e.clientX - d.left, l = e.clientY - d.top
                                    }
                                    return e.deltaX = r, e.deltaY = s, e.deltaFactor = h, e.offsetX = a, e.offsetY = l, e.deltaMode = 0, i.unshift(e, o, r, s), f && clearTimeout(f), f = setTimeout(v, 200), (p.event.dispatch || p.event.handle).apply(this, i)
                                }
                            }

                            function v() {
                                h = null
                            }

                            function y(e, t) {
                                return g.settings.adjustOldDeltas && "mousewheel" === e.type && t % 120 == 0
                            }
                            p.fn.extend({
                                mousewheel: function(e) {
                                    return e ? this.bind("mousewheel", e) : this.trigger("mousewheel")
                                },
                                unmousewheel: function(e) {
                                    return this.unbind("mousewheel", e)
                                }
                            })
                        }, "function" == typeof e.define && e.define.amd ? e.define("jquery-mousewheel", ["jquery"], l) : "object" == ("undefined" == typeof exports ? "undefined" : _typeof(exports)) ? module.exports = l : l(d), e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults", "./select2/utils"], function(o, e, r, t, s) {
                            if (null == o.fn.select2) {
                                var a = ["open", "close", "destroy"];
                                o.fn.select2 = function(t) {
                                    if ("object" == _typeof(t = t || {})) return this.each(function() {
                                        var e = o.extend(!0, {}, t);
                                        new r(o(this), e)
                                    }), this;
                                    if ("string" != typeof t) throw new Error("Invalid arguments for Select2: " + t);
                                    var n, i = Array.prototype.slice.call(arguments, 1);
                                    return this.each(function() {
                                        var e = s.GetData(this, "select2");
                                        null == e && window.console && console.error && console.error("The select2('" + t + "') method was called on an element that is not using Select2."), n = e[t].apply(e, i)
                                    }), -1 < o.inArray(t, a) ? this : n
                                }
                            }
                            return null == o.fn.select2.defaults && (o.fn.select2.defaults = t), r
                        }), {
                            define: e.define,
                            require: e.require
                        }
                    }(),
                    t = e.require("jquery.select2");
                return d.fn.select2.amd = e, t
            }, "object" == ("undefined" == typeof module ? "undefined" : _typeof(module)) && module.exports ? module.exports = function(e, t) {
                return void 0 === t && (t = "undefined" != typeof window ? require("jquery") : require("jquery")(e)), ye(t), t
            } : ye(jQuery), xe = p.event, Te = window.innerWidth, we = xe.special.debouncedresize = {
                setup: function() {
                    p(this).on("resize", we.handler)
                },
                teardown: function() {
                    p(this).off("resize", we.handler)
                },
                handler: function(e, t) {
                    function n() {
                        e.type = "debouncedresize", xe.dispatch.apply(i, o), Te !== window.innerWidth && (e.type = "debouncedresizewidth", xe.dispatch.apply(i, o), Te = window.innerWidth)
                    }
                    var i = this,
                        o = arguments;
                    be && clearTimeout(be), t ? n() : be = setTimeout(n, we.threshold)
                },
                threshold: 150
            },
            function() {
                for (var e = [{
                        base: "A",
                        letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
                    }, {
                        base: "AA",
                        letters: "Ꜳ"
                    }, {
                        base: "AE",
                        letters: "ÆǼǢ"
                    }, {
                        base: "AO",
                        letters: "Ꜵ"
                    }, {
                        base: "AU",
                        letters: "Ꜷ"
                    }, {
                        base: "AV",
                        letters: "ꜸꜺ"
                    }, {
                        base: "AY",
                        letters: "Ꜽ"
                    }, {
                        base: "B",
                        letters: "BⒷＢḂḄḆɃƂƁ"
                    }, {
                        base: "C",
                        letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
                    }, {
                        base: "D",
                        letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹÐ"
                    }, {
                        base: "DZ",
                        letters: "ǱǄ"
                    }, {
                        base: "Dz",
                        letters: "ǲǅ"
                    }, {
                        base: "E",
                        letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
                    }, {
                        base: "F",
                        letters: "FⒻＦḞƑꝻ"
                    }, {
                        base: "G",
                        letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
                    }, {
                        base: "H",
                        letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
                    }, {
                        base: "I",
                        letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
                    }, {
                        base: "J",
                        letters: "JⒿＪĴɈ"
                    }, {
                        base: "K",
                        letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
                    }, {
                        base: "L",
                        letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
                    }, {
                        base: "LJ",
                        letters: "Ǉ"
                    }, {
                        base: "Lj",
                        letters: "ǈ"
                    }, {
                        base: "M",
                        letters: "MⓂＭḾṀṂⱮƜ"
                    }, {
                        base: "N",
                        letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
                    }, {
                        base: "NJ",
                        letters: "Ǌ"
                    }, {
                        base: "Nj",
                        letters: "ǋ"
                    }, {
                        base: "O",
                        letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
                    }, {
                        base: "OI",
                        letters: "Ƣ"
                    }, {
                        base: "OO",
                        letters: "Ꝏ"
                    }, {
                        base: "OU",
                        letters: "Ȣ"
                    }, {
                        base: "OE",
                        letters: "Œ"
                    }, {
                        base: "oe",
                        letters: "œ"
                    }, {
                        base: "P",
                        letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
                    }, {
                        base: "Q",
                        letters: "QⓆＱꝖꝘɊ"
                    }, {
                        base: "R",
                        letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
                    }, {
                        base: "S",
                        letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
                    }, {
                        base: "T",
                        letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
                    }, {
                        base: "TZ",
                        letters: "Ꜩ"
                    }, {
                        base: "U",
                        letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
                    }, {
                        base: "V",
                        letters: "VⓋＶṼṾƲꝞɅ"
                    }, {
                        base: "VY",
                        letters: "Ꝡ"
                    }, {
                        base: "W",
                        letters: "WⓌＷẀẂŴẆẄẈⱲ"
                    }, {
                        base: "X",
                        letters: "XⓍＸẊẌ"
                    }, {
                        base: "Y",
                        letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
                    }, {
                        base: "Z",
                        letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
                    }, {
                        base: "a",
                        letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
                    }, {
                        base: "aa",
                        letters: "ꜳ"
                    }, {
                        base: "ae",
                        letters: "æǽǣ"
                    }, {
                        base: "ao",
                        letters: "ꜵ"
                    }, {
                        base: "au",
                        letters: "ꜷ"
                    }, {
                        base: "av",
                        letters: "ꜹꜻ"
                    }, {
                        base: "ay",
                        letters: "ꜽ"
                    }, {
                        base: "b",
                        letters: "bⓑｂḃḅḇƀƃɓ"
                    }, {
                        base: "c",
                        letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
                    }, {
                        base: "d",
                        letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
                    }, {
                        base: "dz",
                        letters: "ǳǆ"
                    }, {
                        base: "e",
                        letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
                    }, {
                        base: "f",
                        letters: "fⓕｆḟƒꝼ"
                    }, {
                        base: "g",
                        letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
                    }, {
                        base: "h",
                        letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
                    }, {
                        base: "hv",
                        letters: "ƕ"
                    }, {
                        base: "i",
                        letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
                    }, {
                        base: "j",
                        letters: "jⓙｊĵǰɉ"
                    }, {
                        base: "k",
                        letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
                    }, {
                        base: "l",
                        letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
                    }, {
                        base: "lj",
                        letters: "ǉ"
                    }, {
                        base: "m",
                        letters: "mⓜｍḿṁṃɱɯ"
                    }, {
                        base: "n",
                        letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
                    }, {
                        base: "nj",
                        letters: "ǌ"
                    }, {
                        base: "o",
                        letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
                    }, {
                        base: "oi",
                        letters: "ƣ"
                    }, {
                        base: "ou",
                        letters: "ȣ"
                    }, {
                        base: "oo",
                        letters: "ꝏ"
                    }, {
                        base: "p",
                        letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
                    }, {
                        base: "q",
                        letters: "qⓠｑɋꝗꝙ"
                    }, {
                        base: "r",
                        letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
                    }, {
                        base: "s",
                        letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
                    }, {
                        base: "t",
                        letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
                    }, {
                        base: "tz",
                        letters: "ꜩ"
                    }, {
                        base: "u",
                        letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
                    }, {
                        base: "v",
                        letters: "vⓥｖṽṿʋꝟʌ"
                    }, {
                        base: "vy",
                        letters: "ꝡ"
                    }, {
                        base: "w",
                        letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
                    }, {
                        base: "x",
                        letters: "xⓧｘẋẍ"
                    }, {
                        base: "y",
                        letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
                    }, {
                        base: "z",
                        letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
                    }], t = {}, n = 0; n < e.length; n++)
                    for (var i = e[n].letters, o = 0; o < i.length; o++) t[i[o]] = e[n].base;
                window.removeDiacritics = function(e) {
                    return "string" != typeof e ? (console.warn("Invalid parameter passed to window.removeDiacritics (".concat(_typeof(e), ")"), e), e) : e.replace(/[^\u0000-\u007E]/g, function(e) {
                        return t[e] || e
                    })
                }
            }(), jQuery.cookie = function(e, t, n) {
                if (void 0 === t) {
                    var i = null;
                    if (document.cookie && "" != document.cookie)
                        for (var o = document.cookie.split(";"), r = 0; r < o.length; r++) {
                            var s = jQuery.trim(o[r]);
                            if (s.substring(0, e.length + 1) == e + "=") {
                                i = decodeURIComponent(s.substring(e.length + 1));
                                break
                            }
                        }
                    return i
                }
                n = n || {}, null === t && (t = "", n.expires = -1);
                var a, l = "";
                n.expires && ("number" == typeof n.expires || n.expires.toUTCString) && ("number" == typeof n.expires ? (a = new Date).setTime(a.getTime() + 24 * n.expires * 60 * 60 * 1e3) : a = n.expires, l = "; expires=" + a.toUTCString());
                var c = n.path ? "; path=" + n.path : "",
                    u = n.domain ? "; domain=" + n.domain : "",
                    d = n.secure ? "; secure" : "";
                document.cookie = [e, "=", encodeURIComponent(t), l, c, u, d].join("")
            }
    }(theme.jQuery);